import React, { useState, Component, Fragment, useEffect, useRef, useContext, PureComponent } from 'react';
import classNames from 'classnames';
import { Transition, CSSTransition } from 'react-transition-group';
import ReactDOM from 'react-dom';
import { Manager, Popper as Popper$1, Reference } from 'react-popper';
import NumericInput from 'react-numeric-input';
import { NavLink as NavLink$1 } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker as DatePicker$1 } from 'material-ui-pickers';
import moment from 'moment';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Link } from 'react-scroll';
import raf from 'raf';
export { toast as MDBToast, ToastContainer as MDBToastContainer, cssTransition as MDBcssTransition, ToastContainer, cssTransition, toast } from 'react-toastify';
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
    return arr2;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var Alert = function Alert(props) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var closeAlert = function closeAlert() {
    setIsOpen(false);
  };
  var handleOnExit = function handleOnExit(node) {
    node.classList.add("fade");
    props.onClose && props.onClose();
  };
  var handleOnExited = function handleOnExited(node) {
    props.onClosed && props.onClosed();
  };
  var className = props.className,
    color = props.color,
    children = props.children,
    dismiss = props.dismiss;
  var alertClasses = classNames("alert", color && "alert-".concat(color), className);
  var alertComponent;
  if (dismiss) {
    alertComponent = React.createElement(Transition, {
      "in": isOpen,
      timeout: 150,
      unmountOnExit: true,
      onExit: function onExit(node) {
        return handleOnExit(node);
      },
      onExited: function onExited(node) {
        return handleOnExited();
      }
    }, React.createElement("div", {
      "data-test": "alert",
      className: alertClasses,
      role: "alert"
    }, children, React.createElement("button", {
      onClick: closeAlert,
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }, React.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))));
  } else {
    alertComponent = React.createElement("div", {
      "data-test": "alert",
      className: alertClasses,
      role: "alert"
    }, children);
  }
  return alertComponent;
};
Alert.defaultProps = {
  color: "primary"
};
Alert.propTypes = {
  className: propTypes.string,
  color: propTypes.oneOf(["primary", "secondary", "success", "danger", "warning", "info", "light", "dark"]),
  onClose: propTypes.func,
  onClosed: propTypes.func
};
var Animation = /*#__PURE__*/
function (_Component) {
  _inherits(Animation, _Component);
  function Animation(props) {
    var _this;
    _classCallCheck(this, Animation);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animation).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "updatePredicate", function () {
      var windowHeight = window.innerHeight;
      var scroll = window.scrollY;
      var docHeight = document.documentElement.offsetHeight;
      if (windowHeight + scroll - 100 > _this.getOffset(_this.elemRef.current) && scroll < _this.getOffset(_this.elemRef.current) || windowHeight + scroll - 100 > _this.getOffset(_this.elemRef.current) + _this.elemRef.current.clientHeight && scroll < _this.getOffset(_this.elemRef.current) + _this.elemRef.current.clientHeight || windowHeight + scroll === docHeight && _this.getOffset(_this.elemRef.current) + 100 > docHeight) {
        // if the predicate is true, change state
        _this.setState({
          isVisible: true,
          revealed: true
        });
      } else {
        //  was the "revealing" fired at least once?
        if (_this.state.revealed) {
          return;
        } else {
          // if it wasn't, hide
          _this.setState({
            isVisible: false,
            revealed: true
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleStart", function (e) {
      _this.setState({
        countIterations: _this.state.countIterations + 1
      });
      if (_this.props.onAnimationStart) {
        _this.props.onAnimationStart();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleIteration", function (e) {
      if (_this.props.onAnimationIteration) {
        _this.setState({
          countIterations: _this.state.countIterations + 1
        });
        _this.props.onAnimationIteration();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleEnd", function (e) {
      _this.setState({
        countIterations: _this.state.countIterations + 1
      });
      if (_this.props.onAnimationEnd && _this.props.count === _this.state.countIterations) {
        _this.props.onAnimationEnd();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getOffset", function (elem) {
      var box = elem.getBoundingClientRect();
      var body = document.body;
      var docEl = document.documentElement;
      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      var clientTop = docEl.clientTop || body.clientTop || 0;
      var top = box.top + scrollTop - clientTop;
      return Math.round(top);
    });
    _this.state = {
      isVisible: _this.props.reveal ? false : true,
      revealed: _this.props.reveal ? false : true,
      countIterations: 0
    };
    _this.elemRef = React.createRef();
    return _this;
  }
  _createClass(Animation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // add EL on window if the animation is to "reveal"
      if (this.props.reveal) {
        window.addEventListener('scroll', this.updatePredicate);
        this.updatePredicate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.reveal) {
        window.removeEventListener('scroll', this.updatePredicate);
      }
    } // the function to judge whether the animation should be started
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        Tag = _this$props.tag,
        type = _this$props.type,
        duration = _this$props.duration,
        delay = _this$props.delay,
        count = _this$props.count,
        reveal = _this$props.reveal,
        infinite = _this$props.infinite,
        style = _this$props.style,
        children = _this$props.children,
        attributes = _objectWithoutProperties(_this$props, ["className", "tag", "type", "duration", "delay", "count", "reveal", "infinite", "style", "children"]);
      var _this$state = this.state,
        isVisible = _this$state.isVisible,
        revealed = _this$state.revealed;
      var styleObject = {
        animationDuration: duration,
        animationDelay: delay,
        animationIterationCount: infinite ? false : count,
        visibility: isVisible ? 'visible' : 'hidden',
        animationName: type
      };
      var hiddenStyles = {
        animationName: 'none',
        visibility: 'hidden'
      };
      var getAllStyles = Object.assign(styleObject, style);
      var classes = classNames(this.state.isVisible && 'animated',
      // will this work?
      type && type, infinite && 'infinite', className);
      return React.createElement(Tag, _extends({
        "data-test": "animation"
      }, attributes, {
        className: classes,
        style: isVisible && revealed ? getAllStyles : hiddenStyles,
        ref: this.elemRef,
        onAnimationStart: this.handleStart,
        onAnimationIteration: this.handleIteration,
        onAnimationEnd: this.handleEnd
      }), children);
    }
  }]);
  return Animation;
}(Component);
Animation.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  type: propTypes.string,
  delay: propTypes.string,
  count: propTypes.number,
  onAnimationEnd: propTypes.func,
  onAnimationStart: propTypes.func
};
Animation.defaultProps = {
  tag: 'div',
  reveal: false,
  duration: 1,
  count: 1
};
var Badge = function Badge(props) {
  var Tag = props.tag,
    className = props.className,
    children = props.children,
    color = props.color,
    pill = props.pill,
    attributes = _objectWithoutProperties(props, ["tag", "className", "children", "color", "pill"]);
  var classes = classNames('badge', color, 'badge-' + color, pill ? 'badge-pill' : false, className);
  return React.createElement(Tag, _extends({
    "data-test": "badge"
  }, attributes, {
    className: classes
  }), children);
};
Badge.defaultProps = {
  tag: 'span',
  color: 'default',
  pill: false
};
Badge.propTypes = {
  color: propTypes.string,
  pill: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string
};
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};
var returnAttributes = function returnAttributes(attributes) {
  var newAttributesObject = Object.keys(attributes).reduce(function (previousValue, currentElement) {
    if (attributes[currentElement]) previousValue[currentElement] = attributes[currentElement];
    return previousValue;
  }, {});
  return newAttributesObject;
};
var getColorClass = function getColorClass(color) {
  var colorArray = color.split(" ");
  var specialColors = ["danger", "warning", "success", "info", "default", "primary", "secondary", "elegant", "stylish", "unique", "special"];
  var colorClasses = "";
  colorArray.forEach(function (color) {
    if (specialColors.includes(color)) {
      if (color.includes('dark')) {
        color.replace('-', '-color-');
        colorClasses += "".concat(color, " ");
      } else {
        colorClasses += "".concat(color, "-color");
      }
    } else {
      colorClasses += "".concat(color, " ");
    }
  });
  return colorClasses;
};
var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
    color = props.color,
    light = props.light,
    uppercase = props.uppercase,
    bold = props.bold,
    attributes = _objectWithoutProperties(props, ["className", "color", "light", "uppercase", "bold"]);
  var classes = classNames('breadcrumb', uppercase && 'text-uppercase', bold && 'font-up-bold', light && 'white-text', color && getColorClass(color), className);
  var children;
  if (bold) {
    children = React.Children.map(props.children, function (child) {
      return React.cloneElement(child, {
        bold: true
      });
    });
  } else {
    children = props.children;
  }
  return React.createElement("nav", {
    "data-test": "breadcrumb"
  }, React.createElement("ol", _extends({}, attributes, {
    className: classes
  }), children));
};
Breadcrumb.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  color: propTypes.string,
  light: propTypes.bool,
  uppercase: propTypes.bool,
  bold: propTypes.bool
};
var Fa = function Fa(props) {
  var border = props.border,
    brand = props.brand,
    className = props.className,
    fab = props.fab,
    fal = props.fal,
    far = props.far,
    fixed = props.fixed,
    flip = props.flip,
    icon = props.icon,
    inverse = props.inverse,
    light = props.light,
    list = props.list,
    pull = props.pull,
    pulse = props.pulse,
    regular = props.regular,
    rotate = props.rotate,
    size = props.size,
    spin = props.spin,
    stack = props.stack,
    attributes = _objectWithoutProperties(props, ["border", "brand", "className", "fab", "fal", "far", "fixed", "flip", "icon", "inverse", "light", "list", "pull", "pulse", "regular", "rotate", "size", "spin", "stack"]);
  var iconPrefix = brand || fab ? "fab" : light || fal ? "fal" : regular || far ? "far" : "fa";
  var classes = classNames(iconPrefix, list ? "fa-li" : false, icon ? "fa-".concat(icon) : false, size ? "fa-".concat(size) : false, fixed ? "fa-fw" : false, pull ? "fa-pull-".concat(pull) : false, border ? "fa-border" : false, spin ? "fa-spin" : false, pulse ? "fa-pulse" : false, rotate ? "fa-rotate-".concat(rotate) : false, flip ? "fa-flip-".concat(flip) : false, inverse ? "fa-inverse" : false, stack ? "fa-".concat(stack) : false, className);
  return React.createElement("i", _extends({
    "data-test": "fa"
  }, attributes, {
    className: classes
  }));
};
Fa.propTypes = {
  icon: propTypes.string.isRequired,
  border: propTypes.bool,
  brand: propTypes.bool,
  className: propTypes.string,
  fab: propTypes.bool,
  fal: propTypes.bool,
  far: propTypes.bool,
  fixed: propTypes.bool,
  flip: propTypes.string,
  inverse: propTypes.bool,
  light: propTypes.bool,
  list: propTypes.bool,
  pull: propTypes.string,
  pulse: propTypes.bool,
  regular: propTypes.bool,
  rotate: propTypes.string,
  spin: propTypes.bool,
  size: propTypes.string,
  stack: propTypes.string
};
Fa.defaultProps = {
  border: false,
  brand: false,
  className: "",
  fab: false,
  fal: false,
  far: false,
  fixed: false,
  flip: "",
  inverse: false,
  light: false,
  list: false,
  pull: "",
  pulse: false,
  regular: false,
  rotate: "",
  spin: false,
  size: "",
  stack: ""
};
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css = ".bc-icons.breadcrumb-item::before,\n.bc-icons.breadcrumb-item::after {\n  content: none;\n}\n\n.bc-icons.breadcrumb-item + .active.breadcrumb-item::before,\n.bc-icons.breadcrumb-item + .active.breadcrumb-item::after{\n  content: none;\n}\n\n.bc-icons.breadcrumb-item.active {\n  color: #eeeeee;\n}\n";
styleInject(css);
var BreadcrumbItem = function BreadcrumbItem(props) {
  var active = props.active,
    appendIcon = props.appendIcon,
    children = props.children,
    className = props.className,
    bold = props.bold,
    icon = props.icon,
    iconBrand = props.iconBrand,
    iconClassName = props.iconClassName,
    iconLight = props.iconLight,
    iconRegular = props.iconRegular,
    iconSize = props.iconSize,
    attributes = _objectWithoutProperties(props, ["active", "appendIcon", "children", "className", "bold", "icon", "iconBrand", "iconClassName", "iconLight", "iconRegular", "iconSize"]);
  var classes = classNames(active ? "active" : false, icon && "bc-icons", "breadcrumb-item", className);
  var iconClasses = classNames(appendIcon ? "mx-2" : "mr-2", iconClassName);
  var WithBold = function WithBold(_ref) {
    var children = _ref.children;
    return bold ? React.createElement("strong", null, children) : children;
  };
  var WithIcon = function WithIcon() {
    if (icon) {
      return React.createElement(Fragment, null, appendIcon && children, React.createElement(Fa, {
        brand: iconBrand,
        className: iconClasses,
        icon: icon,
        light: iconLight,
        regular: iconRegular,
        size: iconSize
      }), !appendIcon && children);
    }
    return children;
  };
  return React.createElement("li", _extends({
    "data-test": "breadcrumb-item"
  }, attributes, {
    className: classes
  }), React.createElement(WithBold, null, React.createElement(WithIcon, null)));
};
BreadcrumbItem.propTypes = {
  active: propTypes.bool,
  appendIcon: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  bold: propTypes.bool,
  icon: propTypes.string,
  iconBrand: propTypes.bool,
  iconClassName: propTypes.string,
  iconLight: propTypes.bool,
  iconRegular: propTypes.bool,
  iconSize: propTypes.string
};
BreadcrumbItem.defaultProps = {
  active: false,
  appendIcon: false,
  className: "",
  bold: false,
  icon: "",
  iconBrand: false,
  iconClassName: "",
  iconLight: false,
  iconRegular: false,
  iconSize: ""
};
var css$1 = ".Ripple {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  opacity: 1;\n  transform: scale(0);\n}\n\n.Ripple-outline {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.Ripple.is-reppling {\n  animation: ripple 0.5s linear;\n}\n\n.Ripple-parent {\n  position: relative;\n  overflow: hidden;\n  touch-action: none;\n}\n\n@keyframes ripple {\n  100% {\n    opacity: 0;\n    transform: scale(3);\n  }\n}\n";
styleInject(css$1);
var Waves = /*#__PURE__*/
function (_React$Component) {
  _inherits(Waves, _React$Component);
  function Waves(props) {
    var _this;
    _classCallCheck(this, Waves);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Waves).call(this, props));
    _this.state = {
      animate: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      cursorPos: props.cursorPos
    };
    return _this;
  }
  _createClass(Waves, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      if (prevState.cursorPos.time !== this.props.cursorPos.time) {
        if (prevState.animate) {
          this.setState({
            animate: false,
            cursorPos: this.props.cursorPos
          }, function () {
            _this2.reppling();
          });
        } else this.reppling();
      }
    }
  }, {
    key: "reppling",
    value: function reppling() {
      // Get the element
      var $ripple = ReactDOM.findDOMNode(this);
      var $button = $ripple.parentNode;
      var buttonPos = $button.getBoundingClientRect();
      var buttonWidth = $button.offsetWidth;
      var buttonHeight = $button.offsetHeight; // Make a Square Ripple

      var rippleWidthShouldBe = Math.max(buttonHeight, buttonWidth); // Make Ripple Position to be center

      var centerize = rippleWidthShouldBe / 2;
      this.setState({
        animate: true,
        width: rippleWidthShouldBe,
        height: rippleWidthShouldBe,
        top: this.state.cursorPos.top - buttonPos.top - centerize,
        left: this.state.cursorPos.left - buttonPos.left - centerize
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        "data-test": "waves",
        className: 'Ripple ' + (this.props.outline || this.props.flat || this.props.dark ? 'Ripple-outline ' : '') + (this.state.animate ? 'is-reppling' : ''),
        style: {
          top: this.state.top + 'px',
          left: this.state.left + 'px',
          width: this.state.width + 'px',
          height: this.state.height + 'px'
        }
      });
    }
  }]);
  return Waves;
}(React.Component);
Waves.propTypes = {
  outline: propTypes.bool,
  flat: propTypes.bool,
  animate: propTypes.bool,
  cursorPos: propTypes.object,
  children: propTypes.node
};
var Button = function Button(props) {
  var _classNames;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    e.stopPropagation(); // Waves - Get Cursor Position

    var cursorPos = {
      top: e.clientY,
      left: e.clientX,
      time: Date.now()
    };
    setCursorPos(cursorPos);
  };
  var active = props.active,
    block = props.block,
    circle = props.circle,
    className = props.className,
    color = props.color,
    disabled = props.disabled,
    download = props.download,
    outline = props.outline,
    size = props.size,
    rounded = props.rounded,
    gradient = props.gradient,
    floating = props.floating,
    flat = props.flat,
    role = props.role,
    type = props.type,
    social = props.social,
    action = props.action,
    Tag = props.tag,
    target = props.target,
    innerRef = props.innerRef,
    attributes = _objectWithoutProperties(props, ["active", "block", "circle", "className", "color", "disabled", "download", "outline", "size", "rounded", "gradient", "floating", "flat", "role", "type", "social", "action", "tag", "target", "innerRef"]);
  var classes = classNames(flat ? 'btn-flat' : gradient ? "".concat(gradient, "-gradient") : "btn".concat(outline ? '-outline' : '', "-").concat(color), 'btn', 'Ripple-parent', className, (_classNames = {
    active: active,
    'btn-floating': floating,
    'btn-rounded': rounded,
    'btn-circle': circle,
    'btn-block': block,
    'btn-action': action
  }, _defineProperty(_classNames, "btn-".concat(social), social), _defineProperty(_classNames, "btn-".concat(size), size), _defineProperty(_classNames, "disabled", disabled), _classNames));
  if (attributes.href && Tag === 'button') {
    Tag = 'a';
  }
  return React.createElement(Tag, _extends({
    "data-test": "button",
    type: Tag === 'button' && !type ? 'button' : type,
    target: target,
    role: Tag === 'a' && !role ? 'button' : role,
    className: classes,
    ref: innerRef,
    onMouseUp: handleClick,
    onTouchStart: handleClick
  }, attributes, {
    download: download,
    disabled: disabled
  }), props.children, !disabled && React.createElement(Waves, {
    cursorPos: cursorPos,
    outline: outline,
    flat: flat
  }));
};
Button.defaultProps = {
  color: 'default',
  tag: 'button'
};
Button.propTypes = {
  active: propTypes.bool,
  action: propTypes.bool,
  block: propTypes.bool,
  color: propTypes.string,
  disabled: propTypes.bool,
  download: propTypes.string,
  gradient: propTypes.string,
  role: propTypes.string,
  type: propTypes.string,
  outline: propTypes.bool,
  rounded: propTypes.bool,
  circle: propTypes.bool,
  floating: propTypes.bool,
  flat: propTypes.bool,
  innerRef: propTypes.oneOfType([propTypes.func, propTypes.string]),
  onClick: propTypes.func,
  size: propTypes.string,
  social: propTypes.string,
  children: propTypes.node,
  tag: propTypes.string,
  target: propTypes.string,
  className: propTypes.string
};
var css$2 = ".btn-group-vertical>.btn,\n.btn-group-vertical>.btn+.btn-group,\n.btn-group-vertical>.btn-group+.btn,\n.btn-group-vertical>.btn-group+.btn-group {\n  margin-left: 0px;\n}\n\n.btn-group-lg>.btn {\n  font-size: 0.9rem;\n  padding: 1rem 2.4rem;\n}\n\n.btn-group-sm>.btn {\n  font-size: 0.6rem;\n  padding: 0.5rem 1.6rem;\n}\n\n.btn-floating.btn.btn-sm,\n.btn-floating.btn.btn-lg {\n  padding: 0;\n}\n";
styleInject(css$2);
var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
    size = props.size,
    vertical = props.vertical,
    attributes = _objectWithoutProperties(props, ["className", "size", "vertical"]);
  var classes = classNames(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group');
  return React.createElement("div", _extends({
    "data-test": "button-group"
  }, attributes, {
    className: classes
  }), props.children);
};
ButtonGroup.propTypes = {
  'aria-label': propTypes.string,
  className: propTypes.string,
  role: propTypes.string,
  size: propTypes.string,
  children: propTypes.node,
  vertical: propTypes.bool
};
ButtonGroup.defaultProps = {
  role: 'group'
};
var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
    attributes = _objectWithoutProperties(props, ["className"]);
  var classes = classNames(className, "btn-toolbar");
  return React.createElement("div", _extends({
    "data-test": "button-toolbar"
  }, attributes, {
    className: classes
  }), props.children);
};
ButtonToolbar.propTypes = {
  "aria-label": propTypes.string,
  className: propTypes.string,
  children: propTypes.node,
  role: propTypes.string
};
ButtonToolbar.defaultProps = {
  role: "toolbar"
};
var Card = function Card(props) {
  var _classNames;
  var className = props.className,
    Tag = props.tag,
    cascade = props.cascade,
    wide = props.wide,
    narrow = props.narrow,
    reverse = props.reverse,
    testimonial = props.testimonial,
    ecommerce = props.ecommerce,
    collection = props.collection,
    pricing = props.pricing,
    personal = props.personal,
    news = props.news,
    color = props.color,
    text = props.text,
    border = props.border,
    attributes = _objectWithoutProperties(props, ["className", "tag", "cascade", "wide", "narrow", "reverse", "testimonial", "ecommerce", "collection", "pricing", "personal", "news", "color", "text", "border"]);
  var classes = classNames((_classNames = {
    "card-cascade": cascade,
    "card-cascade wider": wide,
    "card-cascade narrower": narrow,
    "card-cascade wider reverse": reverse,
    "testimonial-card": testimonial,
    "card-ecommerce": ecommerce,
    "collection-card": collection,
    "pricing-card": pricing,
    "card-personal": personal,
    "news-card": news
  }, _defineProperty(_classNames, "".concat(text, "-text"), text), _defineProperty(_classNames, "border-".concat(border), border), _classNames), "card", color, className);
  return React.createElement(Tag, _extends({
    "data-test": "card"
  }, attributes, {
    className: classes
  }));
};
Card.propTypes = {
  border: propTypes.string,
  cascade: propTypes.bool,
  className: propTypes.string,
  color: propTypes.string,
  collection: propTypes.bool,
  ecommerce: propTypes.bool,
  narrow: propTypes.bool,
  news: propTypes.bool,
  pricing: propTypes.bool,
  personal: propTypes.bool,
  reverse: propTypes.bool,
  tag: propTypes.string,
  testimonial: propTypes.bool,
  text: propTypes.string,
  wide: propTypes.bool
};
Card.defaultProps = {
  tag: "div"
};
var CardBody = function CardBody(props) {
  var className = props.className,
    Tag = props.tag,
    cascade = props.cascade,
    attributes = _objectWithoutProperties(props, ["className", "tag", "cascade"]);
  var classes = classNames('card-body', cascade && 'card-body-cascade', className);
  return React.createElement(Tag, _extends({
    "data-test": "card-body"
  }, attributes, {
    className: classes
  }));
};
CardBody.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  cascade: propTypes.bool
};
CardBody.defaultProps = {
  tag: 'div'
};
var CardFooter = function CardFooter(props) {
  var _classNames;
  var className = props.className,
    Tag = props.tag,
    color = props.color,
    text = props.text,
    border = props.border,
    transparent = props.transparent,
    small = props.small,
    muted = props.muted,
    attributes = _objectWithoutProperties(props, ["className", "tag", "color", "text", "border", "transparent", "small", "muted"]);
  var classes = classNames((_classNames = {
    'white-text': color && !text
  }, _defineProperty(_classNames, "border-".concat(border), border), _defineProperty(_classNames, 'bg-transparent', transparent), _defineProperty(_classNames, 'text-muted', muted), _defineProperty(_classNames, "".concat(text, "-text"), text), _classNames), 'card-footer', color, className);
  var component = React.createElement(Tag, _extends({
    "data-test": "card-footer"
  }, attributes, {
    className: classes
  }));
  if (small) {
    component = React.createElement(Tag, _extends({}, attributes, {
      className: classes
    }), React.createElement("small", null, " ", props.children, " "));
  }
  return component;
};
CardFooter.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  color: propTypes.string,
  text: propTypes.string,
  border: propTypes.string,
  transparent: propTypes.bool,
  small: propTypes.bool,
  muted: propTypes.bool
};
CardFooter.defaultProps = {
  tag: 'div'
};
var CardGroup = function CardGroup(props) {
  var className = props.className,
    Tag = props.tag,
    deck = props.deck,
    column = props.column,
    attributes = _objectWithoutProperties(props, ["className", "tag", "deck", "column"]);
  var classes = classNames(deck ? 'card-deck' : column ? 'card-columns' : 'card-group', className);
  return React.createElement(Tag, _extends({
    "data-test": "card-group"
  }, attributes, {
    className: classes
  }));
};
CardGroup.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  deck: propTypes.bool,
  column: propTypes.bool
};
CardGroup.defaultProps = {
  tag: 'div'
};
var CardHeader = function CardHeader(props) {
  var _classNames;
  var className = props.className,
    Tag = props.tag,
    color = props.color,
    text = props.text,
    border = props.border,
    transparent = props.transparent,
    attributes = _objectWithoutProperties(props, ["className", "tag", "color", "text", "border", "transparent"]);
  var classes = classNames((_classNames = {
    'white-text': color && !text
  }, _defineProperty(_classNames, "border-".concat(border), border), _defineProperty(_classNames, 'bg-transparent', transparent), _defineProperty(_classNames, "".concat(text, "-text"), text), _classNames), 'card-header', className, color);
  return React.createElement(Tag, _extends({
    "data-test": "card-header"
  }, attributes, {
    className: classes
  }));
};
CardHeader.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  color: propTypes.string,
  text: propTypes.string,
  border: propTypes.string,
  transparent: propTypes.bool
};
CardHeader.defaultProps = {
  tag: 'div'
};
var Mask = function Mask(props) {
  var children = props.children,
    className = props.className,
    overlay = props.overlay,
    pattern = props.pattern,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["children", "className", "overlay", "pattern", "tag"]);
  var classes = classNames('mask', pattern && "pattern-".concat(pattern), overlay && "rgba-".concat(overlay), className);
  return React.createElement(Tag, _extends({
    "data-test": "mask"
  }, attributes, {
    className: classes
  }), children);
};
Mask.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  overlay: propTypes.string,
  pattern: propTypes.oneOfType([propTypes.string, propTypes.number]),
  tag: propTypes.string
};
Mask.defaultProps = {
  className: '',
  overlay: '',
  pattern: '',
  tag: 'div'
};
var View = function View(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    // Get Cursor Position
    var cursorPos = {
      top: e.clientY,
      left: e.clientX,
      time: Date.now()
    };
    setCursorPos(cursorPos);
  };
  var cascade = props.cascade,
    children = props.children,
    className = props.className,
    hover = props.hover,
    rounded = props.rounded,
    src = props.src,
    Tag = props.tag,
    waves = props.waves,
    zoom = props.zoom,
    fixed = props.fixed,
    attributes = _objectWithoutProperties(props, ["cascade", "children", "className", "hover", "rounded", "src", "tag", "waves", "zoom", "fixed"]);
  var classes = classNames("view", rounded && "rounded", zoom && "zoom", hover && "overlay", cascade && "view-cascade", waves ? "Ripple-parent" : false, className);
  var viewStyle = src ? {
    backgroundImage: "url(\"".concat(src, "\")"),
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "100vh",
    backgroundAttachment: fixed ? "fixed" : null
  } : {};
  return React.createElement(Tag, _extends({
    "data-test": "view"
  }, attributes, {
    className: classes,
    onMouseDown: handleClick,
    onTouchStart: handleClick,
    style: viewStyle
  }), children, waves && React.createElement(Waves, {
    cursorPos: cursorPos
  }));
};
View.defaultProps = {
  cascade: false,
  className: "",
  hover: false,
  rounded: false,
  src: "",
  tag: "div",
  waves: false,
  zoom: false
};
View.propTypes = {
  cascade: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  hover: propTypes.bool,
  rounded: propTypes.bool,
  src: propTypes.string,
  tag: propTypes.string,
  waves: propTypes.bool,
  zoom: propTypes.bool
};
var CardImage = function CardImage(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    // Get Cursor Position
    var cursorPos = {
      top: e.clientY,
      left: e.clientX,
      time: Date.now()
    };
    setCursorPos(cursorPos);
  };
  var className = props.className,
    overlay = props.overlay,
    top = props.top,
    waves = props.waves,
    hover = props.hover,
    cascade = props.cascade,
    tag = props.tag,
    zoom = props.zoom,
    attributes = _objectWithoutProperties(props, ["className", "overlay", "top", "waves", "hover", "cascade", "tag", "zoom"]);
  var classes = classNames(top && 'card-img-top', className);
  var Tag = tag;
  var innerContent = React.createElement(Tag, _extends({
    "data-test": "card-image"
  }, attributes, {
    className: classes
  }), props.children);
  if (props.src) {
    return React.createElement(View, {
      zoom: zoom,
      hover: hover,
      cascade: cascade
    }, React.createElement("div", {
      className: "Ripple-parent",
      onMouseDown: handleClick,
      style: {
        touchAction: 'unset'
      }
    }, innerContent, React.createElement(Mask, {
      overlay: overlay
    }), waves && React.createElement(Waves, {
      cursorPos: cursorPos
    })));
  } else {
    return React.createElement("div", null, innerContent);
  }
};
CardImage.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  zoom: propTypes.bool,
  waves: propTypes.bool,
  className: propTypes.string,
  cascade: propTypes.bool,
  hover: propTypes.bool,
  overlay: propTypes.string,
  top: propTypes.bool,
  src: propTypes.string,
  children: propTypes.node
};
CardImage.defaultProps = {
  tag: 'img',
  overlay: 'white-slight',
  waves: true,
  hover: false,
  cascade: false,
  zoom: false
};
var CardText = function CardText(props) {
  var className = props.className,
    Tag = props.tag,
    textNode = props.children,
    muted = props.muted,
    small = props.small,
    attributes = _objectWithoutProperties(props, ["className", "tag", "children", "muted", "small"]);
  var classes = classNames('card-text', muted && 'text-muted', className);
  var children = small ? React.createElement("small", null, textNode) : textNode;
  return React.createElement(Tag, _extends({
    "data-test": "card-text"
  }, attributes, {
    className: classes
  }), children);
};
CardText.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  muted: propTypes.bool,
  small: propTypes.bool
};
CardText.defaultProps = {
  tag: 'p'
};
var CardTitle = function CardTitle(props) {
  var className = props.className,
    Tag = props.tag,
    sub = props.sub,
    attributes = _objectWithoutProperties(props, ["className", "tag", "sub"]);
  var classes = classNames(sub ? 'card-subtitle' : 'card-title', className);
  return React.createElement(Tag, _extends({
    "data-test": "card-title"
  }, attributes, {
    className: classes
  }));
};
CardTitle.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  sub: propTypes.bool,
  className: propTypes.string
};
CardTitle.defaultProps = {
  tag: 'h4',
  sub: false
};
var Control = function Control(props) {
  var direction = props.direction,
    className = props.className,
    onClick = props.onClick,
    Tag = props.tag,
    iconLeft = props.iconLeft,
    iconRight = props.iconRight,
    testimonial = props.testimonial,
    multiItem = props.multiItem;
  var text;
  if (direction === 'prev') {
    text = 'Previous';
  } else if (direction === 'next') {
    text = 'Next';
  }
  var classes = classNames('carousel-control-' + direction, className);
  var caretClasses = classNames('carousel-control-' + direction + '-icon');
  if (testimonial) {
    var arrow = direction === 'prev' ? 'left' : 'right';
    classes = classNames('carousel-control-' + direction, arrow, 'carousel-control', className);
    caretClasses = classNames('icon-' + direction);
  }
  if (multiItem) {
    classes = classNames('btn-floating');
  }
  return React.createElement(Tag, {
    "data-test": "carousel-control",
    className: classes,
    "data-slide": direction,
    onClick: onClick
  }, iconLeft ? React.createElement(Fa, {
    icon: "chevron-left"
  }) : iconRight ? React.createElement(Fa, {
    icon: "chevron-right"
  }) : React.createElement("div", null, React.createElement("span", {
    className: caretClasses,
    "aria-hidden": "true"
  }), React.createElement("span", {
    className: "sr-only"
  }, text)));
};
Control.propTypes = {
  onClick: propTypes.any,
  direction: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  iconLeft: propTypes.bool,
  iconRight: propTypes.bool,
  testimonial: propTypes.bool,
  multiItem: propTypes.bool
};
Control.defaultProps = {
  tag: 'a'
};
var CarouselIndicator = function CarouselIndicator(props) {
  var active = props.active,
    children = props.children,
    className = props.className,
    img = props.img,
    alt = props.alt,
    attributes = _objectWithoutProperties(props, ["active", "children", "className", "img", "alt"]);
  var classes = classNames(active && 'active', className);
  return React.createElement("li", _extends({
    "data-test": "carousel-indicator"
  }, attributes, {
    className: classes
  }), img && React.createElement("img", {
    src: img,
    alt: alt,
    className: "img-fluid"
  }), children);
};
CarouselIndicator.propTypes = {
  active: propTypes.bool.isRequired,
  alt: propTypes.string,
  children: propTypes.node,
  className: propTypes.string,
  img: propTypes.string
};
CarouselIndicator.defaultProps = {
  alt: 'Carousel thumbnail',
  className: '',
  img: ''
};
var CarouselIndicators = function CarouselIndicators(props) {
  var children = props.children,
    className = props.className,
    attributes = _objectWithoutProperties(props, ["children", "className"]);
  var classes = classNames("carousel-indicators", className);
  return React.createElement("ol", _extends({
    "data-test": "carousel-indicators"
  }, attributes, {
    className: classes
  }), children);
};
CarouselIndicators.propTypes = {
  children: propTypes.node,
  className: propTypes.string
};
CarouselIndicators.defaultProps = {
  className: ""
};
var css$3 = ".carousel-inner {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n.carousel-fade .carousel-item {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: block !important;\n  opacity: 0;\n  z-index: 0;\n  transition: transform 0ms ease-in-out, opacity 0.8s ease-out;\n}\n\n.carousel-fade .carousel-item.active {\n  position: relative;\n  z-index: 1;\n  opacity: 1;\n}\n\n.carousel-multi-item .carousel-item {\n  display: inline-block !important;\n}\n\n.carousel .carousel-slide-item {\n  transition: left 0.5s;\n}\n\n.carousel-control-prev, .carousel-control-next, .carousel-item-prev, .carousel-item-next {\n  z-index: 2;\n}\n";
styleInject(css$3);
var Carousel = /*#__PURE__*/
function (_Component) {
  _inherits(Carousel, _Component);
  function Carousel(props) {
    var _this;
    _classCallCheck(this, Carousel);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "clearCycleIntervalHandler", function () {
      return clearInterval(_this.cycleInterval);
    });
    _defineProperty(_assertThisInitialized(_this), "swipeAvailableHandler", function () {
      return _this.setState({
        swipeAvailable: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "restartInterval", function () {
      if (_this.props.interval !== false) {
        _this.clearCycleIntervalHandler();
        _this.cycleInterval = setInterval(_this.next, _this.props.interval);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "next", function () {
      var nextIndex = _this.state.activeItem + 1;
      var nextItem = nextIndex > _this.state.length ? 1 : nextIndex;
      _this.goToIndex(nextItem);
    });
    _defineProperty(_assertThisInitialized(_this), "prev", function () {
      var prevIndex = _this.state.activeItem - 1;
      var prevItem = prevIndex < 1 ? _this.state.length : prevIndex;
      _this.goToIndex(prevItem);
    });
    _defineProperty(_assertThisInitialized(_this), "goToIndex", function (item) {
      _this.setState(_objectSpread({}, _this.state, {
        activeItem: item
      }));
      _this.restartInterval();
    });
    _defineProperty(_assertThisInitialized(_this), "startTouch", function (e) {
      _this.setState({
        initialX: e.touches[0].clientX,
        initialY: e.touches[0].clientY
      });
    });
    _defineProperty(_assertThisInitialized(_this), "moveTouch", function (e) {
      _this.setState({
        swipeAvailable: false
      });
      var _this$state = _this.state,
        initialX = _this$state.initialX,
        initialY = _this$state.initialY;
      if (initialX === null || initialY === null) {
        return;
      }
      var currentX = e.touches[0].clientX;
      var currentY = e.touches[0].clientY;
      var diffX = initialX - currentX;
      var diffY = initialY - currentY;
      if (Math.abs(diffX) > Math.abs(diffY)) {
        // sliding horizontally
        if (diffX > 0) {
          _this.next();
        } else {
          _this.prev();
        }
      }
      _this.setState({
        initialX: null,
        initialY: null
      });
    });
    _this.state = {
      activeItem: _this.props.activeItem,
      length: _this.props.length,
      slide: _this.props.slide,
      srcArray: [],
      swipeAvailable: true,
      initialX: null,
      initialY: null
    };
    _this.carouselRef = React.createRef();
    return _this;
  }
  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.interval === false) {
        return;
      }
      this.cycleInterval = setInterval(this.next, this.props.interval); // get images src atr

      if (this.props.thumbnails) {
        var CarouselItemsArray = this.carouselRef.current.querySelectorAll('.carousel-item img');
        var srcArray = Array.prototype.map.call(CarouselItemsArray, function (item) {
          return item.src;
        });
        this.setState(_objectSpread({}, this.state, {
          srcArray: srcArray
        }));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.interval === false) {
        return;
      }
      this.clearCycleIntervalHandler();
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        activeItem: this.state.activeItem,
        length: this.state.length,
        slide: this.state.slide
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        activeItem = _this$props.activeItem,
        children = _this$props.children,
        className = _this$props.className,
        multiItem = _this$props.multiItem,
        slide = _this$props.slide,
        thumbnails = _this$props.thumbnails,
        interval = _this$props.interval,
        testimonial = _this$props.testimonial,
        Tag = _this$props.tag,
        length = _this$props.length,
        showControls = _this$props.showControls,
        showIndicators = _this$props.showIndicators,
        onHoverStop = _this$props.onHoverStop,
        attributes = _objectWithoutProperties(_this$props, ["activeItem", "children", "className", "multiItem", "slide", "thumbnails", "interval", "testimonial", "tag", "length", "showControls", "showIndicators", "onHoverStop"]);
      var swipeAvailable = this.state.swipeAvailable;
      var ariaLabel = 'carousel';
      var classes = classNames('carousel', multiItem ? 'carousel-multi-item' : 'carousel-fade', thumbnails ? 'carousel-thumbnails' : '', testimonial ? 'testimonial-carousel' : '', className);
      var CarouselIndicatorsArray = [];
      var _loop = function _loop(i) {
        CarouselIndicatorsArray.push(React.createElement(CarouselIndicator, {
          img: thumbnails ? _this2.state.srcArray[i - 1] : null,
          key: i,
          active: _this2.state.activeItem === i,
          onClick: function onClick() {
            return _this2.goToIndex(i);
          }
        }));
      };
      for (var i = 1; i <= this.state.length; i++) {
        _loop(i);
      }
      var isMultiItem = multiItem ? true : false;
      var isTestimonial = testimonial ? true : false;
      return React.createElement(Tag, _extends({
        "data-test": "carousel",
        ref: this.carouselRef
      }, attributes, {
        className: classes,
        "aria-label": ariaLabel,
        onTouchStart: this.startTouch,
        onTouchMove: swipeAvailable ? this.moveTouch : null,
        onTouchEnd: this.swipeAvailableHandler,
        onMouseEnter: onHoverStop ? this.clearCycleIntervalHandler : false,
        onMouseLeave: onHoverStop ? this.restartInterval : false
      }), showControls && multiItem && React.createElement("div", {
        className: "controls-top"
      }, React.createElement(Control, {
        testimonial: isTestimonial,
        multiItem: isMultiItem,
        iconLeft: true,
        className: "btn-floating",
        direction: "prev",
        role: "button",
        onClick: this.prev
      }), React.createElement(Control, {
        testimonial: isTestimonial,
        multiItem: isMultiItem,
        iconRight: true,
        className: "btn-floating",
        direction: "next",
        role: "button",
        onClick: this.next
      })), children, showControls && !multiItem && React.createElement(React.Fragment, null, React.createElement(Control, {
        testimonial: isTestimonial,
        multiItem: isMultiItem,
        direction: "prev",
        role: "button",
        onClick: this.prev
      }), React.createElement(Control, {
        testimonial: isTestimonial,
        multiItem: isMultiItem,
        direction: "next",
        role: "button",
        onClick: this.next
      })), showIndicators && React.createElement(CarouselIndicators, null, CarouselIndicatorsArray));
    }
  }]);
  return Carousel;
}(Component);
Carousel.propTypes = {
  activeItem: propTypes.number,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node,
  multiItem: propTypes.bool,
  interval: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  thumbnails: propTypes.bool,
  testimonial: propTypes.bool,
  showControls: propTypes.bool,
  showIndicators: propTypes.bool,
  slide: propTypes.bool,
  length: propTypes.number,
  onHoverStop: propTypes.bool
};
Carousel.defaultProps = {
  tag: 'div',
  interval: 6000,
  showControls: true,
  showIndicators: true,
  onHoverStop: true
};
Carousel.childContextTypes = {
  activeItem: propTypes.any,
  length: propTypes.any,
  slide: propTypes.any
};
var CarouselCaption = function CarouselCaption(props) {
  var children = props.children,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["children", "className", "tag"]);
  var classes = classNames('carousel-caption', className);
  return React.createElement(Tag, _extends({
    "data-test": "carousel-caption"
  }, attributes, {
    className: classes
  }), children);
};
CarouselCaption.propTypes = {
  active: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node
};
CarouselCaption.defaultProps = {
  tag: 'div'
};
var CarouselInner = function CarouselInner(props) {
  var active = props.active,
    children = props.children,
    childrenCount = props.childrenCount,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["active", "children", "childrenCount", "className", "tag"]);
  var classes = classNames('carousel-inner', active ? 'active' : '', className);
  return React.createElement(Tag, _extends({
    "data-test": "carousel-inner"
  }, attributes, {
    className: classes
  }), children);
};
CarouselInner.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  active: propTypes.bool,
  children: propTypes.node
};
CarouselInner.defaultProps = {
  tag: 'div'
};
var CarouselItem = /*#__PURE__*/
function (_Component) {
  _inherits(CarouselItem, _Component);
  function CarouselItem() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, CarouselItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CarouselItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "moveForward", function () {
      _this.style = {
        position: 'absolute',
        left: '100%'
      };
    });
    _defineProperty(_assertThisInitialized(_this), "moveBackwards", function () {
      _this.style = {
        position: 'absolute',
        left: '-100%'
      };
    });
    _defineProperty(_assertThisInitialized(_this), "makeVisible", function () {
      _this.style = {
        left: '0'
      };
    });
    return _this;
  }
  _createClass(CarouselItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        itemId = _this$props.itemId,
        Tag = _this$props.tag,
        attributes = _objectWithoutProperties(_this$props, ["active", "children", "className", "itemId", "tag"]);
      itemId = parseInt(itemId, 10);
      var classes = classNames('carousel-item', {
        'active carousel-slide-item': this.context.slide,
        'active': !this.context.slide && itemId === this.context.activeItem
      }, className);
      var slideIndex = this.context.activeItem - itemId;
      if (this.context.slide) {
        if (slideIndex < 0) {
          this.moveForward();
        } else if (slideIndex > 0) {
          this.moveBackwards();
        } else {
          this.makeVisible();
        }
      }
      return React.createElement(Tag, _extends({
        "data-test": "carousel-item"
      }, attributes, {
        className: classes,
        style: this.style
      }), children);
    }
  }]);
  return CarouselItem;
}(Component);
CarouselItem.propTypes = {
  active: propTypes.bool,
  itemId: propTypes.any,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node
};
CarouselItem.defaultProps = {
  tag: 'div'
};
CarouselItem.contextTypes = {
  activeItem: propTypes.any,
  length: propTypes.any,
  slide: propTypes.any
};
var MDBCloseIcon = function MDBCloseIcon(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    props = _objectWithoutProperties(_ref, ["onClick", "className", "ariaLabel"]);
  var onClickHandler = function onClickHandler(e) {
    onClick && onClick(e);
  };
  var btnClasses = className ? ['close'].concat(_toConsumableArray(className.split(' '))) : ['close'];
  return React.createElement("button", _extends({
    "data-test": "close-button",
    type: "button"
  }, props, {
    className: btnClasses.join(' '),
    onClick: onClickHandler,
    "aria-label": ariaLabel
  }), React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"));
};
MDBCloseIcon.defaultProps = {
  ariaLabel: 'Close'
};
MDBCloseIcon.propTypes = {
  className: propTypes.string,
  ariaLabel: propTypes.string,
  onClick: propTypes.func
};
var Col = function Col(props) {
  var xs = props.xs,
    sm = props.sm,
    md = props.md,
    lg = props.lg,
    xl = props.xl,
    top = props.top,
    bottom = props.bottom,
    middle = props.middle,
    size = props.size,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["xs", "sm", "md", "lg", "xl", "top", "bottom", "middle", "size", "className", "tag"]);
  var classes = classNames(size && "col-" + size, xs && "col-xs-" + xs, sm && "col-sm-" + sm, md && "col-md-" + md, lg && "col-lg-" + lg, xl && "col-xl-" + xl, !size && !xs && !sm && !md && !lg && !xl ? "col" : "", top && "align-self-start", middle && "align-self-center", bottom && "align-self-end", className);
  return React.createElement(Tag, _extends({
    "data-test": "col"
  }, attributes, {
    className: classes
  }));
};
Col.propTypes = {
  size: propTypes.string,
  xs: propTypes.string,
  sm: propTypes.string,
  md: propTypes.string,
  lg: propTypes.string,
  xl: propTypes.string,
  top: propTypes.bool,
  bottom: propTypes.bool,
  middle: propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string
};
Col.defaultProps = {
  tag: "div",
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null
};
var SHOW = 'SHOW';
var SHOWN = 'SHOWN';
var HIDE = 'HIDE';
var HIDDEN = 'HIDDEN';
var DEFAULT_DELAYS = {
  show: 350,
  hide: 350
};
var Collapse = /*#__PURE__*/
function (_Component) {
  _inherits(Collapse, _Component);
  function Collapse(props) {
    var _this;
    _classCallCheck(this, Collapse);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapse).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "setTransitionTag", function (collapse, callback, delayType) {
      _this.transitionTag = setTimeout(function () {
        _this.setState({
          collapse: collapse,
          height: null
        }, callback());
      }, _this.getDelay(delayType));
    });
    _defineProperty(_assertThisInitialized(_this), "openCollapse", function () {
      _this.setState({
        collapse: SHOW
      }, function () {
        _this.setState({
          height: _this.getHeight()
        });
        _this.setTransitionTag(SHOWN, _this.props.onOpened, 'show');
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeCollapse", function () {
      _this.setState({
        height: _this.getHeight()
      }, function () {
        _this.setState({
          collapse: HIDE,
          height: _this.getHeight()
        }, function () {
          _this.setState({
            height: 0
          });
        });
      });
      _this.setTransitionTag(HIDDEN, _this.props.onClosed, 'hide');
    });
    _this.state = {
      id: props.id,
      collapse: HIDDEN,
      height: null
    };
    _this.element = null;
    return _this;
  }
  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((this.props.isOpen === this.state.id || this.props.isOpen === true) && this.state.collapse === HIDDEN) {
        this.openCollapse();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var collapse = prevState.collapse;
      var willOpen = typeof this.props.isOpen !== 'boolean' ? this.props.isOpen === prevState.id : this.props.isOpen;
      if (willOpen && this.state.collapse === HIDDEN) {
        this.openCollapse();
      } else if (!willOpen && collapse === SHOWN) {
        this.closeCollapse();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.transitionTag);
    }
  }, {
    key: "getDelay",
    value: function getDelay(key) {
      var delay = this.props.delay;
      if (_typeof(delay) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.element.scrollHeight;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        navbar = _this$props.navbar,
        children = _this$props.children,
        className = _this$props.className,
        isOpen = _this$props.isOpen,
        delay = _this$props.delay,
        onOpened = _this$props.onOpened,
        onClosed = _this$props.onClosed,
        attributes = _objectWithoutProperties(_this$props, ["navbar", "children", "className", "isOpen", "delay", "onOpened", "onClosed"]);
      var _this$state = this.state,
        collapse = _this$state.collapse,
        height = _this$state.height;
      var collapseClass;
      switch (collapse) {
        case SHOW:
          collapseClass = 'collapsing';
          break;
        case SHOWN:
          collapseClass = 'collapse show';
          break;
        case HIDE:
          collapseClass = 'collapsing';
          break;
        case HIDDEN:
          collapseClass = 'collapse';
          break;
        default:
          // HIDDEN
          collapseClass = 'collapse';
      }
      var classes = classNames(collapseClass, navbar ? 'navbar-collapse' : false, className);
      var style = height === null ? null : {
        height: height
      };
      return React.createElement("div", _extends({
        "data-test": "collapse"
      }, attributes, {
        style: _objectSpread({}, attributes.style, style),
        className: classes,
        ref: function ref(c) {
          _this2.element = c;
        }
      }), children);
    }
  }]);
  return Collapse;
}(Component);
Collapse.propTypes = {
  isOpen: propTypes.oneOfType([propTypes.string, propTypes.bool]),
  id: propTypes.string,
  className: propTypes.node,
  children: propTypes.node,
  navbar: propTypes.bool,
  delay: propTypes.oneOfType([propTypes.shape({
    show: propTypes.number,
    hide: propTypes.number
  }), propTypes.number]),
  onOpened: propTypes.func,
  onClosed: propTypes.func
};
Collapse.defaultProps = {
  isOpen: '',
  delay: DEFAULT_DELAYS,
  onOpened: function onOpened() {},
  onClosed: function onClosed() {}
};
var Container = function Container(props) {
  var fluid = props.fluid,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["fluid", "className", "tag"]);
  var classes = classNames(fluid ? 'container-fluid' : 'container', className);
  return React.createElement(Tag, _extends({
    "data-test": "container"
  }, attributes, {
    className: classes
  }));
};
Container.propTypes = {
  fluid: propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string
};
Container.defaultProps = {
  tag: 'div',
  fluid: false
};
var DataTableHead = function DataTableHead(props) {
  var color = props.color,
    columns = props.columns,
    handleSort = props.handleSort,
    scrollX = props.scrollX,
    scrollY = props.scrollY,
    sortable = props.sortable,
    sorted = props.sorted,
    textWhite = props.textWhite;
  var theadClasses = classNames(color && (color !== "dark" && color !== "light" ? color : "thead-".concat(color)), textWhite && "text-white");
  return React.createElement(Fragment, null, (scrollY || scrollX) && React.createElement("colgroup", null, columns.map(function (col) {
    return React.createElement("col", {
      key: col.field,
      style: {
        width: "".concat(col.width, "px") || "auto",
        minWidth: "".concat(col.width, "px") || "auto"
      }
    });
  })), React.createElement("thead", {
    "data-test": "datatable-head",
    className: theadClasses || undefined
  }, React.createElement("tr", null, columns.map(function (col) {
    return React.createElement("th", _extends({
      onClick: function onClick() {
        return sortable && handleSort(col.field, col.sort);
      },
      key: col.field,
      className: classNames(col.hasOwnProperty("minimal") ? "th-".concat(col.minimal) : null, sortable && col.sort !== 'disabled' && (sorted && col.sort ? "sorting_".concat(col.sort === 'asc' ? 'desc' : 'asc') : 'sorting'))
    }, col.attributes), col.label);
  }))));
};
DataTableHead.propTypes = {
  sorted: propTypes.bool.isRequired,
  color: propTypes.string,
  columns: propTypes.arrayOf(propTypes.object),
  handleSort: propTypes.func,
  scrollX: propTypes.bool,
  scrollY: propTypes.bool,
  sortable: propTypes.bool,
  textWhite: propTypes.bool
};
DataTableHead.defaultProps = {
  scrollX: false,
  scrollY: false,
  sortable: true,
  textWhite: false
};
var css$4 = ".table-wrapper-scroll-y {\n  display: block;\n  max-height: 200px;\n  overflow-y: auto;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n";
styleInject(css$4);
var Table = function Table(props) {
  var autoWidth = props.autoWidth,
    bordered = props.bordered,
    borderless = props.borderless,
    btn = props.btn,
    children = props.children,
    dark = props.dark,
    fixed = props.fixed,
    theadColor = props.theadColor,
    hover = props.hover,
    maxHeight = props.maxHeight,
    responsive = props.responsive,
    responsiveSm = props.responsiveSm,
    responsiveMd = props.responsiveMd,
    responsiveLg = props.responsiveLg,
    responsiveXl = props.responsiveXl,
    scrollY = props.scrollY,
    small = props.small,
    striped = props.striped,
    className = props.className,
    attributes = _objectWithoutProperties(props, ["autoWidth", "bordered", "borderless", "btn", "children", "dark", "fixed", "theadColor", "hover", "maxHeight", "responsive", "responsiveSm", "responsiveMd", "responsiveLg", "responsiveXl", "scrollY", "small", "striped", "className"]);
  var tableClasses = classNames('table', {
    'w-auto': autoWidth,
    'table-bordered': bordered,
    'table-borderless': borderless,
    'btn-table': btn,
    'table-fixed': fixed,
    'table-hover': hover,
    'table-sm': small,
    'table-striped': striped
  }, className);
  var wrapperClasses = classNames({
    'table-dark': dark,
    'table-responsive': responsive,
    'table-responsive-sm': responsiveSm,
    'table-responsive-md': responsiveMd,
    'table-responsive-lg': responsiveLg,
    'table-responsive-xl': responsiveXl,
    'table-wrapper-scroll-y': scrollY
  });
  var wrapperStyles = {
    maxHeight: maxHeight ? "".concat(maxHeight) : null
  };
  return React.createElement("div", {
    "data-test": "table",
    className: wrapperClasses,
    style: wrapperStyles
  }, React.createElement("table", _extends({}, attributes, {
    className: tableClasses
  }), children));
};
Table.propTypes = {
  autoWidth: propTypes.bool,
  bordered: propTypes.bool,
  borderless: propTypes.bool,
  btn: propTypes.bool,
  children: propTypes.node,
  dark: propTypes.bool,
  fixed: propTypes.bool,
  theadColor: propTypes.string,
  hover: propTypes.bool,
  maxHeight: propTypes.string,
  responsive: propTypes.bool,
  responsiveSm: propTypes.bool,
  responsiveMd: propTypes.bool,
  responsiveLg: propTypes.bool,
  responsiveXl: propTypes.bool,
  scrollY: propTypes.bool,
  small: propTypes.bool,
  striped: propTypes.bool,
  className: propTypes.string
};
var TableBody = function TableBody(props) {
  var children = props.children,
    color = props.color,
    rows = props.rows,
    textWhite = props.textWhite,
    attributes = _objectWithoutProperties(props, ["children", "color", "rows", "textWhite"]);
  var classes = classNames(color, {
    "text-white": textWhite
  });
  return React.createElement("tbody", _extends({
    "data-test": "table-body"
  }, attributes, {
    className: classes || undefined
  }), rows && rows.map(function (row, index) {
    return React.createElement("tr", {
      onClick: row.hasOwnProperty("clickEvent") ? row.clickEvent : undefined,
      key: index
    }, Object.keys(row).map(function (key, index, array) {
      if (key === "clickEvent") return null;
      if (key !== "colspan") {
        return array[index + 1] !== "colspan" ? React.createElement("td", {
          key: key
        }, row[key]) : null;
      } else {
        return React.createElement("td", {
          key: key,
          colSpan: row[key]
        }, row[array[index - 1]]);
      }
    }));
  }), children);
};
TableBody.propTypes = {
  children: propTypes.node,
  color: propTypes.string,
  rows: propTypes.arrayOf(propTypes.object),
  textWhite: propTypes.bool
};
TableBody.defaultProps = {
  textWhite: false
};
var TableFoot = function TableFoot(props) {
  var _classNames;
  var children = props.children,
    color = props.color,
    columns = props.columns,
    textWhite = props.textWhite,
    attributes = _objectWithoutProperties(props, ["children", "color", "columns", "textWhite"]);
  var isTheadColor = color === 'dark' || color === 'light';
  var classes = classNames((_classNames = {
    'text-white': textWhite
  }, _defineProperty(_classNames, "thead-".concat(color), color && isTheadColor), _defineProperty(_classNames, "".concat(color), color && !isTheadColor), _classNames));
  return React.createElement("thead", _extends({
    "data-test": "table-foot"
  }, attributes, {
    className: classes || undefined
  }), columns && React.createElement("tr", null, columns.map(function (col) {
    return React.createElement("th", {
      key: col.field,
      className: col.hasOwnProperty('minimal') ? "th-".concat(col.minimal) : undefined
    }, col.label);
  })), children);
};
TableFoot.propTypes = {
  children: propTypes.node,
  color: propTypes.string,
  columns: propTypes.arrayOf(propTypes.object),
  textWhite: propTypes.bool
};
TableFoot.defaultProps = {
  textWhite: false
};
var DataTableTable = function DataTableTable(props) {
  var autoWidth = props.autoWidth,
    bordered = props.bordered,
    borderless = props.borderless,
    btn = props.btn,
    children = props.children,
    columns = props.columns,
    dark = props.dark,
    fixed = props.fixed,
    hover = props.hover,
    handleSort = props.handleSort,
    responsive = props.responsive,
    responsiveSm = props.responsiveSm,
    responsiveMd = props.responsiveMd,
    responsiveLg = props.responsiveLg,
    responsiveXl = props.responsiveXl,
    rows = props.rows,
    small = props.small,
    sortable = props.sortable,
    sorted = props.sorted,
    striped = props.striped,
    tbodyColor = props.tbodyColor,
    tbodyTextWhite = props.tbodyTextWhite,
    theadColor = props.theadColor,
    theadTextWhite = props.theadTextWhite,
    attributes = _objectWithoutProperties(props, ["autoWidth", "bordered", "borderless", "btn", "children", "columns", "dark", "fixed", "hover", "handleSort", "responsive", "responsiveSm", "responsiveMd", "responsiveLg", "responsiveXl", "rows", "small", "sortable", "sorted", "striped", "tbodyColor", "tbodyTextWhite", "theadColor", "theadTextWhite"]);
  return React.createElement("div", {
    "data-test": "datatable-table",
    className: "col-sm-12"
  }, React.createElement(Table, _extends({
    autoWidth: autoWidth,
    bordered: bordered,
    borderless: borderless,
    btn: btn,
    dark: dark,
    fixed: fixed,
    hover: hover,
    responsive: responsive,
    responsiveSm: responsiveSm,
    responsiveMd: responsiveMd,
    responsiveLg: responsiveLg,
    responsiveXl: responsiveXl,
    small: small,
    striped: striped,
    className: "dataTable"
  }, attributes), React.createElement(DataTableHead, {
    color: theadColor,
    textWhite: theadTextWhite,
    columns: columns,
    handleSort: handleSort,
    sortable: sortable,
    sorted: sorted
  }), React.createElement(TableBody, {
    color: tbodyColor,
    textWhite: tbodyTextWhite,
    rows: rows
  }), React.createElement(TableFoot, {
    color: theadColor,
    textWhite: theadTextWhite,
    columns: columns
  }), children));
};
DataTableTable.propTypes = {
  autoWidth: propTypes.bool.isRequired,
  bordered: propTypes.bool.isRequired,
  borderless: propTypes.bool.isRequired,
  btn: propTypes.bool.isRequired,
  dark: propTypes.bool.isRequired,
  fixed: propTypes.bool.isRequired,
  hover: propTypes.bool.isRequired,
  handleSort: propTypes.func.isRequired,
  responsive: propTypes.bool.isRequired,
  responsiveSm: propTypes.bool.isRequired,
  responsiveMd: propTypes.bool.isRequired,
  responsiveLg: propTypes.bool.isRequired,
  responsiveXl: propTypes.bool.isRequired,
  sortable: propTypes.bool.isRequired,
  sorted: propTypes.bool.isRequired,
  small: propTypes.bool.isRequired,
  striped: propTypes.bool.isRequired,
  theadColor: propTypes.string.isRequired,
  theadTextWhite: propTypes.bool.isRequired,
  tbodyColor: propTypes.string.isRequired,
  tbodyTextWhite: propTypes.bool.isRequired,
  columns: propTypes.arrayOf(propTypes.object),
  rows: propTypes.arrayOf(propTypes.object),
  children: propTypes.node
};
var DataTableTableScroll = function DataTableTableScroll(props) {
  var autoWidth = props.autoWidth,
    bordered = props.bordered,
    borderless = props.borderless,
    btn = props.btn,
    children = props.children,
    columns = props.columns,
    dark = props.dark,
    fixed = props.fixed,
    hover = props.hover,
    handleSort = props.handleSort,
    handleTableBodyScroll = props.handleTableBodyScroll,
    maxHeight = props.maxHeight,
    responsive = props.responsive,
    responsiveSm = props.responsiveSm,
    responsiveMd = props.responsiveMd,
    responsiveLg = props.responsiveLg,
    responsiveXl = props.responsiveXl,
    rows = props.rows,
    scrollX = props.scrollX,
    scrollY = props.scrollY,
    small = props.small,
    sortable = props.sortable,
    sorted = props.sorted,
    striped = props.striped,
    tbodyColor = props.tbodyColor,
    tbodyTextWhite = props.tbodyTextWhite,
    theadColor = props.theadColor,
    theadTextWhite = props.theadTextWhite,
    translateScrollHead = props.translateScrollHead,
    attributes = _objectWithoutProperties(props, ["autoWidth", "bordered", "borderless", "btn", "children", "columns", "dark", "fixed", "hover", "handleSort", "handleTableBodyScroll", "maxHeight", "responsive", "responsiveSm", "responsiveMd", "responsiveLg", "responsiveXl", "rows", "scrollX", "scrollY", "small", "sortable", "sorted", "striped", "tbodyColor", "tbodyTextWhite", "theadColor", "theadTextWhite", "translateScrollHead"]);
  var minWidth = scrollX ? columns.map(function (col) {
    return col.width;
  }).reduce(function (prev, curr) {
    return prev + curr;
  }, 0) + 'px' : 'auto';
  return React.createElement("div", {
    "data-test": "datatable-table-scroll",
    className: "col-sm-12"
  }, React.createElement("div", {
    className: "dataTables_scroll"
  }, React.createElement("div", {
    className: "dataTables_scrollHead",
    style: {
      overflow: 'hidden'
    }
  }, React.createElement("div", {
    className: "dataTables_scrollHeadInner",
    style: {
      position: 'relative',
      transform: "translateX(-".concat(translateScrollHead, "px)"),
      boxSizing: 'content-box',
      paddingRight: scrollY ? '15px' : null,
      minWidth: minWidth
    }
  }, React.createElement(Table, _extends({
    autoWidth: autoWidth,
    bordered: bordered,
    borderless: borderless,
    btn: btn,
    dark: dark,
    fixed: fixed,
    hover: hover,
    responsive: responsive,
    responsiveSm: responsiveSm,
    responsiveMd: responsiveMd,
    responsiveLg: responsiveLg,
    responsiveXl: responsiveXl,
    small: small,
    striped: striped,
    className: "dataTable"
  }, attributes), React.createElement(DataTableHead, {
    color: theadColor,
    textWhite: theadTextWhite,
    columns: columns,
    handleSort: handleSort,
    scrollX: scrollX,
    scrollY: scrollY,
    sortable: sortable,
    sorted: sorted
  })))), React.createElement("div", {
    className: "dataTable_scrollBody",
    style: {
      overflow: 'auto'
    },
    onScroll: handleTableBodyScroll
  }, React.createElement(Table, _extends({
    style: {
      minWidth: minWidth
    },
    autoWidth: autoWidth,
    bordered: bordered,
    borderless: borderless,
    btn: btn,
    dark: dark,
    fixed: fixed,
    hover: hover,
    maxHeight: maxHeight,
    responsive: responsive,
    responsiveSm: responsiveSm,
    responsiveMd: responsiveMd,
    responsiveLg: responsiveLg,
    responsiveXl: responsiveXl,
    scrollY: scrollY,
    small: small,
    striped: striped,
    className: "dataTable"
  }, attributes), React.createElement("colgroup", null, columns.map(function (col) {
    return React.createElement("col", {
      key: col.field,
      style: {
        width: "".concat(col.width, "px") || 'auto',
        minWidth: "".concat(col.width, "px") || 'auto'
      }
    });
  })), React.createElement(TableBody, {
    color: tbodyColor,
    textWhite: tbodyTextWhite,
    rows: rows
  }), children))));
};
DataTableTableScroll.propTypes = {
  autoWidth: propTypes.bool.isRequired,
  bordered: propTypes.bool.isRequired,
  borderless: propTypes.bool.isRequired,
  btn: propTypes.bool.isRequired,
  dark: propTypes.bool.isRequired,
  fixed: propTypes.bool.isRequired,
  hover: propTypes.bool.isRequired,
  handleSort: propTypes.func.isRequired,
  handleTableBodyScroll: propTypes.func.isRequired,
  responsive: propTypes.bool.isRequired,
  responsiveSm: propTypes.bool.isRequired,
  responsiveMd: propTypes.bool.isRequired,
  responsiveLg: propTypes.bool.isRequired,
  responsiveXl: propTypes.bool.isRequired,
  sortable: propTypes.bool.isRequired,
  sorted: propTypes.bool.isRequired,
  small: propTypes.bool.isRequired,
  striped: propTypes.bool.isRequired,
  theadColor: propTypes.string.isRequired,
  theadTextWhite: propTypes.bool.isRequired,
  tbodyColor: propTypes.string.isRequired,
  tbodyTextWhite: propTypes.bool.isRequired,
  translateScrollHead: propTypes.number.isRequired,
  columns: propTypes.arrayOf(propTypes.object),
  rows: propTypes.arrayOf(propTypes.object),
  children: propTypes.node,
  maxHeight: propTypes.string,
  scrollX: propTypes.bool,
  scrollY: propTypes.bool
};
var ControlledSelectInput = React.forwardRef(function (_ref, inputRef) {
  var value = _ref.value,
    required = _ref.required;
  return React.createElement("input", {
    "data-test": "controlled-select-input",
    type: "text",
    ref: inputRef,
    required: required,
    readOnly: true,
    value: value,
    onChange: function onChange() {},
    className: "select-dropdown",
    onFocus: function onFocus(e) {
      return e.target.style.caretColor = 'transparent';
    }
  });
});
ControlledSelectInput.propTypes = {
  required: propTypes.bool,
  value: propTypes.string
};
ControlledSelectInput.defaultProps = {
  required: false
};
var Input = /*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);
  function Input(props) {
    var _this;
    _classCallCheck(this, Input);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      event.stopPropagation();
      _this.setState({
        isFocused: false
      });
      _this.props.onBlur && _this.props.onBlur(event);
    });
    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
      event.stopPropagation();
      _this.setState({
        isFocused: true
      });
      _this.props.onFocus && _this.props.onFocus(event);
    });
    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      event.stopPropagation();
      if (_this.props.type !== "checkbox" && _this.props.type !== "radio") {
        _this.setState({
          innerValue: event.target.value,
          isPristine: false
        });
      }
      _this.props.onChange && _this.props.onChange(event);
      _this.props.getValue && _this.props.getValue(event.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "onInput", function (event) {
      event.stopPropagation();
      if (_this.props.type !== "checkbox" && _this.props.type !== "radio") {
        _this.setState({
          innerValue: event.target.value,
          isPristine: false
        });
      }
      _this.props.onInput && _this.props.onInput(event);
    });
    _defineProperty(_assertThisInitialized(_this), "setFocus", function () {
      _this.inputElementRef.current.focus();
    });
    _this.state = {
      innerValue: props.value || props.valueDefault,
      isFocused: false,
      isPristine: true
    };
    _this.inputElementRef = React.createRef();
    return _this;
  }
  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // User wants to access the input ref, but we have to use it intenrally to.
      // Return Ref instance to share ref with parent
      // then user sets ref as a callback -> inputRef={ref => this.myInputRef = ref}
      this.props.inputRef && this.props.inputRef(this.inputElementRef.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        background = _this$props.background,
        children = _this$props.children,
        className = _this$props.className,
        containerClass = _this$props.containerClass,
        disabled = _this$props.disabled,
        error = _this$props.error,
        filled = _this$props.filled,
        gap = _this$props.gap,
        getValue = _this$props.getValue,
        group = _this$props.group,
        hint = _this$props.hint,
        icon = _this$props.icon,
        iconBrand = _this$props.iconBrand,
        iconClass = _this$props.iconClass,
        iconLight = _this$props.iconLight,
        onIconClick = _this$props.onIconClick,
        onIconMouseEnter = _this$props.onIconMouseEnter,
        onIconMouseLeave = _this$props.onIconMouseLeave,
        iconRegular = _this$props.iconRegular,
        iconSize = _this$props.iconSize,
        id = _this$props.id,
        inputRef = _this$props.inputRef,
        noTag = _this$props.noTag,
        outline = _this$props.outline,
        label = _this$props.label,
        labelClass = _this$props.labelClass,
        size = _this$props.size,
        success = _this$props.success,
        Tag = _this$props.tag,
        type = _this$props.type,
        validate = _this$props.validate,
        value = _this$props.value,
        valueDefault = _this$props.valueDefault,
        attributes = _objectWithoutProperties(_this$props, ["background", "children", "className", "containerClass", "disabled", "error", "filled", "gap", "getValue", "group", "hint", "icon", "iconBrand", "iconClass", "iconLight", "onIconClick", "onIconMouseEnter", "onIconMouseLeave", "iconRegular", "iconSize", "id", "inputRef", "noTag", "outline", "label", "labelClass", "size", "success", "tag", "type", "validate", "value", "valueDefault"]);
      var isNotEmpty = (!!this.state.innerValue || !!hint || this.state.isFocused || this.state.innerValue === 0) && type !== "checkbox" && type !== "radio";
      var TagInput = "";
      var formControlClass = "";
      if (type === "textarea") {
        formControlClass = outline ? "form-control" : "md-textarea form-control";
        TagInput = "textarea";
      } else {
        formControlClass = "form-control";
        TagInput = "input";
        attributes.type = type;
      }
      attributes.disabled = disabled;
      var classes = classNames(formControlClass, size ? "form-control-".concat(size) : false, validate ? "validate" : false, filled ? "filled-in" : false, gap ? "with-gap" : false, type === "checkbox" ? gap ? false : "form-check-input" : false, type === "radio" ? "form-check-input" : false, className);
      var containerClassFix = classNames(type === "checkbox" || type === "radio" ? typeof label === "boolean" && label ? "d-flex" : "form-check" : "md-form", group ? "form-group" : false, size ? "form-".concat(size) : false, outline && "md-outline", background && "md-bg", containerClass);
      var iconClassFix = classNames(isNotEmpty && this.state.isFocused ? "active" : false, iconClass, "prefix");
      var labelClassFix = classNames(isNotEmpty ? "active" : false, disabled ? "disabled" : false, type === "checkbox" ? typeof label === "boolean" && label ? "form-check-label" : "form-check-label mr-5" : false, type === "radio" ? typeof label === "boolean" && label ? "form-check-label" : "form-check-label mr-5" : false, labelClass);
      var renderFunction = function renderFunction() {
        return React.createElement(React.Fragment, null, icon && React.createElement(Fa, {
          icon: icon,
          size: iconSize,
          brand: iconBrand,
          light: iconLight,
          regular: iconRegular,
          className: iconClassFix,
          onClick: onIconClick ? onIconClick : _this2.setFocus,
          onMouseEnter: onIconMouseEnter,
          onMouseLeave: onIconMouseLeave
        }), React.createElement(TagInput, _extends({
          "data-test": "input"
        }, attributes, {
          className: classes,
          id: id,
          placeholder: hint,
          ref: _this2.inputElementRef,
          value: _this2.state.innerValue,
          onBlur: _this2.onBlur,
          onChange: _this2.onChange,
          onInput: _this2.onInput,
          onFocus: _this2.onFocus
        })), label && React.createElement("label", {
          className: labelClassFix,
          htmlFor: id,
          "data-error": error,
          "data-success": success,
          id: id,
          onClick: _this2.setFocus
        }, label), children);
      };
      return noTag ? renderFunction() : React.createElement(Tag, {
        className: containerClassFix
      }, renderFunction());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.value !== prevState.value) {
        return {
          innerValue: nextProps.value
        };
      }
      return null;
    }
  }]);
  return Input;
}(React.Component);
Input.propTypes = {
  className: propTypes.string,
  children: propTypes.node,
  containerClass: propTypes.string,
  disabled: propTypes.bool,
  error: propTypes.string,
  filled: propTypes.bool,
  gap: propTypes.bool,
  getValue: propTypes.func,
  group: propTypes.bool,
  hint: propTypes.string,
  icon: propTypes.string,
  iconBrand: propTypes.bool,
  iconClass: propTypes.string,
  iconLight: propTypes.bool,
  onIconClick: propTypes.func,
  onIconMouseEnter: propTypes.func,
  onIconMouseLeave: propTypes.func,
  iconRegular: propTypes.bool,
  iconSize: propTypes.string,
  id: propTypes.string,
  inputRef: propTypes.oneOfType([propTypes.object, propTypes.func]),
  label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object, propTypes.bool]),
  labelClass: propTypes.string,
  noTag: propTypes.bool,
  onBlur: propTypes.func,
  onChange: propTypes.func,
  onFocus: propTypes.func,
  onInput: propTypes.func,
  outline: propTypes.bool,
  size: propTypes.string,
  success: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  type: propTypes.string,
  validate: propTypes.bool,
  value: propTypes.oneOfType([propTypes.number, propTypes.string]),
  valueDefault: propTypes.oneOfType([propTypes.number, propTypes.string])
};
Input.defaultProps = {
  className: "",
  containerClass: "",
  disabled: false,
  error: "",
  filled: false,
  gap: false,
  group: false,
  hint: undefined,
  icon: "",
  iconBrand: false,
  iconClass: "",
  iconLight: false,
  onIconMouseEnter: function onIconMouseEnter() {},
  onIconMouseLeave: function onIconMouseLeave() {},
  iconRegular: false,
  iconSize: undefined,
  id: undefined,
  noTag: false,
  outline: false,
  label: "",
  labelClass: "",
  size: "",
  success: "",
  tag: "div",
  type: "text",
  validate: false,
  valueDefault: ""
};
var ControlledSelectOption = function ControlledSelectOption(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    icon = _ref.icon,
    multiple = _ref.multiple,
    selectOption = _ref.selectOption,
    text = _ref.text,
    value = _ref.value,
    separator = _ref.separator,
    isFocused = _ref.isFocused,
    focusShadow = _ref.focusShadow,
    focusBackgroundColor = _ref.focusBackgroundColor,
    selectAllClassName = _ref.selectAllClassName;
  var classes = classNames((disabled || separator) && 'disabled', separator && 'optgroup', checked && 'active');
  var spanClasses = classNames('filtrable', selectAllClassName && selectAllClassName);
  var focusedStyles = {
    backgroundColor: isFocused ? focusBackgroundColor : null,
    boxShadow: isFocused ? focusShadow : null
  };
  return React.createElement("li", {
    "data-test": "controlled-select-option",
    "data-multiple": multiple,
    className: classes,
    onClick: function onClick() {
      return selectOption(value);
    },
    style: focusedStyles
  }, icon && React.createElement("img", {
    src: icon,
    alt: "",
    className: "rounded-circle"
  }), React.createElement("span", {
    "data-multiple": multiple,
    className: spanClasses
  }, multiple && React.createElement(React.Fragment, null, React.createElement("input", {
    type: "checkbox",
    value: value,
    className: "form-check-input",
    checked: checked,
    disabled: disabled,
    onChange: function onChange() {}
  }), !separator && React.createElement("label", {
    style: {
      height: '10px'
    },
    "data-multiple": multiple
  })), text ? text : value));
};
ControlledSelectOption.propTypes = {
  checked: propTypes.bool,
  disabled: propTypes.bool,
  focusShadow: propTypes.string,
  focusBackgroundColor: propTypes.string,
  icon: propTypes.string,
  isFocused: propTypes.bool,
  multiple: propTypes.bool,
  selectAllClassName: propTypes.string,
  separator: propTypes.bool,
  text: propTypes.oneOfType([propTypes.object, propTypes.string]),
  value: propTypes.string,
  selectOption: propTypes.func
};
ControlledSelectOption.defaultProps = {
  checked: false,
  disabled: false,
  focusShadow: 'inset 0px -17px 15px -16px rgba(0, 0, 0, 0.35)',
  focusBackgroundColor: '#eee',
  icon: '',
  isFocused: false,
  multiple: false,
  separator: false
};
var ControlledSelectOptions = /*#__PURE__*/
function (_Component) {
  _inherits(ControlledSelectOptions, _Component);
  function ControlledSelectOptions(props) {
    var _this;
    _classCallCheck(this, ControlledSelectOptions);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ControlledSelectOptions).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "search", function (value) {
      var filteredOptions = _this.state.options.filter(function (option) {
        if (option.text) {
          return option.text.toLowerCase().match(value.toLowerCase().trim());
        } else {
          return option.value.toLowerCase().match(value.toLowerCase().trim());
        }
      });
      _this.props.changeFocus(null);
      _this.setState({
        filteredOptions: filteredOptions
      }, function () {
        return _this.props.setFilteredOptions(_this.state.filteredOptions);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var _this$props = _this.props,
        focused = _this$props.focused,
        selectOption = _this$props.selectOption,
        selectAllValue = _this$props.selectAllValue,
        changeFocus = _this$props.changeFocus,
        selectAll = _this$props.selectAll;
      var filteredOptions = _this.state.filteredOptions;
      var ENTER = e.keyCode === 13;
      var ESC = e.keyCode === 27;
      var UP = e.keyCode === 38;
      var DOWN = e.keyCode === 40;
      (DOWN || UP || ENTER) && e.preventDefault();
      if (ENTER && focused !== null) {
        focused === -1 ? selectOption(selectAllValue) : selectOption(filteredOptions[focused].value);
      }
      ESC && changeFocus(null);
      if (DOWN) {
        if (focused === null) {
          selectAll && filteredOptions.length !== 1 ? changeFocus(-1) : changeFocus(0);
        } else {
          focused < filteredOptions.length - 1 && changeFocus(1);
        }
      }
      if (UP) {
        focused >= (selectAll ? 0 : 1) && filteredOptions.length > 1 && changeFocus(-1);
      }
    });
    _this.state = {
      filteredOptions: _this.props.options || [],
      options: _this.props.options || [],
      searchValue: ''
    };
    _this.inputRef = null;
    return _this;
  }
  _createClass(ControlledSelectOptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.inputRef.current) this.inputRef = this.props.inputRef.current;
      this.inputRef.addEventListener('keydown', this.handleFocus);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.inputRef.removeEventListener('keydown', this.handleFocus);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.options !== this.props.options) {
        this.setState({
          filteredOptions: this.props.options,
          options: this.props.options
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        allChecked = _this$props2.allChecked,
        focused = _this$props2.focused,
        focusShadow = _this$props2.focusShadow,
        focusBackgroundColor = _this$props2.focusBackgroundColor,
        multiple = _this$props2.multiple,
        search = _this$props2.search,
        searchLabel = _this$props2.searchLabel,
        searchId = _this$props2.searchId,
        selected = _this$props2.selected,
        selectOption = _this$props2.selectOption,
        selectAll = _this$props2.selectAll,
        selectAllLabel = _this$props2.selectAllLabel,
        selectAllValue = _this$props2.selectAllValue,
        selectAllClassName = _this$props2.selectAllClassName;
      var classes = classNames('dropdown-content', 'select-dropdown', 'fadeElement');
      return React.createElement("ul", {
        "data-test": "controlled-select-options",
        className: classes
      }, search && React.createElement(Input, {
        label: searchLabel,
        id: searchId,
        getValue: this.search,
        "data-search": "true",
        onKeyDown: this.handleFocus
      }), React.createElement(ControlledSelectOption, {
        checked: false,
        disabled: true,
        icon: null,
        value: selected
      }), selectAll && multiple && this.state.filteredOptions.length > 1 && React.createElement(ControlledSelectOption, {
        text: selectAllLabel,
        value: selectAllValue,
        selectAllClassName: selectAllClassName,
        checked: allChecked,
        multiple: true,
        selectOption: selectOption,
        isFocused: focused === -1,
        focusShadow: focusShadow,
        focusBackgroundColor: focusBackgroundColor
      }), this.state.filteredOptions.map(function (option, index) {
        return React.createElement(ControlledSelectOption, {
          key: "".concat(option.value, "-").concat(index),
          checked: option.checked,
          disabled: option.disabled,
          multiple: multiple,
          icon: option.icon,
          text: option.text,
          value: option.value,
          separator: option.separator,
          selectOption: selectOption,
          isFocused: index === focused,
          focusShadow: focusShadow,
          focusBackgroundColor: focusBackgroundColor
        });
      }));
    }
  }]);
  return ControlledSelectOptions;
}(Component);
ControlledSelectOptions.propTypes = {
  allChecked: propTypes.bool,
  changeFocus: propTypes.func,
  focused: propTypes.number,
  focusShadow: propTypes.string,
  focusBackgroundColor: propTypes.string,
  inputRef: propTypes.shape({
    current: propTypes.instanceOf(typeof Element === 'undefined' ? function () {} : Element)
  }),
  multiple: propTypes.bool,
  options: propTypes.arrayOf(propTypes.shape({
    checked: propTypes.bool,
    separator: propTypes.bool,
    disabled: propTypes.bool,
    icon: propTypes.string,
    image: propTypes.string,
    text: propTypes.oneOfType([propTypes.object, propTypes.string]),
    value: propTypes.string
  })),
  selected: propTypes.string.isRequired,
  selectOption: propTypes.func.isRequired,
  search: propTypes.bool,
  searchLabel: propTypes.string,
  searchId: propTypes.string,
  selectAllClassName: propTypes.string,
  selectAllLabel: propTypes.string,
  selectAllValue: propTypes.string,
  setFilteredOptions: propTypes.func
};
ControlledSelectOptions.defaultProps = {
  focused: null,
  multiple: false,
  options: [],
  search: false,
  selectAllLabel: 'Select All',
  searchId: 'selectSearchInput',
  searchLabel: 'Search'
};
var SelectContext = React.createContext();
var Select = /*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "onInputClick", function (_ref) {
      var input = _ref.target;
      var dropdown = input.nextElementSibling;
      dropdown.classList.add("fadeIn");
      !_this.props.outline && (dropdown.style.top = ".6rem");
      _this.setState({
        dropdown: dropdown,
        input: input
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onDocumentClick", function (_ref2) {
      var target = _ref2.target;
      var _this$state = _this.state,
        dropdown = _this$state.dropdown,
        input = _this$state.input;
      if (dropdown) {
        var isMultiple = target.dataset.multiple === "true";
        var isSearchLabel = target.id === "selectSearchInput";
        if (target === input || isMultiple || isSearchLabel) {
          return;
        } else {
          dropdown.classList.remove("fadeIn");
          _this.changeFocus(null);
          _this.setState({
            dropdown: null
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "computeValuesAndText", function (options) {
      var checkedOptions = options.filter(function (option) {
        return option.checked;
      });
      var checkedValues = checkedOptions.map(function (opt) {
        return opt.value;
      });
      var checkedTexts = checkedOptions.map(function (opt) {
        return opt.text ? opt.text : opt.value;
      });
      var selectTextContent = checkedTexts.length ? checkedTexts.join(", ") : _this.props.selected;
      var allChecked = checkedOptions.length === options.filter(function (option) {
        return !option.disabled;
      }).length;
      return {
        isControlledEmpty: !checkedOptions.length,
        selectValue: checkedValues,
        selectTextContent: selectTextContent,
        allChecked: allChecked
      };
    });
    _defineProperty(_assertThisInitialized(_this), "setFilteredOptions", function (filteredOptions) {
      _this.setState({
        filteredOptions: filteredOptions
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setOptionStatus", function (option, status) {
      if (!option.disabled) {
        option.checked = status;
      }
      return option;
    });
    _defineProperty(_assertThisInitialized(_this), "applyFilteredOptionsChanges", function (options, filteredOptions) {
      filteredOptions.forEach(function (filteredOption) {
        var index = options.findIndex(function (option) {
          return option.value === filteredOption.value;
        });
        filteredOption.checked !== options[index].checked && _this.setOptionStatus(options[index], filteredOption.checked);
      });
      return options;
    });
    _defineProperty(_assertThisInitialized(_this), "changeFocus", function (value) {
      switch (value) {
        case null:
          _this.setState(function (prevState) {
            return prevState.focused !== value ? {
              focused: null
            } : null;
          });
          break;
        case 0:
          _this.setState({
            focused: 0
          });
          break;
        default:
          _this.setState(function (prevState) {
            return {
              focused: prevState.focused + value
            };
          });
          break;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "selectOneOption", function (value) {
      _this.setState(function (prevState) {
        var options = _toConsumableArray(prevState.options);
        var optionIndex = options.findIndex(function (option) {
          return option.value === value;
        });
        options.forEach(function (option, index) {
          return index !== optionIndex ? _this.setOptionStatus(option, false) : _this.setOptionStatus(option, !option.checked);
        });
        return _this.computeValuesAndText(options);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectMultipleOption", function (value) {
      _this.setState(function (prevState) {
        var options = _toConsumableArray(prevState.options);
        var optionIndex = options.findIndex(function (option) {
          return option.value === value;
        });
        options[optionIndex].checked = !options[optionIndex].checked;
        return _this.computeValuesAndText(options);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectAllOptions", function () {
      _this.setState(function (prevState) {
        var options = _toConsumableArray(prevState.options);
        var filteredOptions = _toConsumableArray(prevState.filteredOptions).filter(function (option) {
          return !option.disabled;
        });
        var areSomeUnchecked = filteredOptions.some(function (option) {
          return !option.checked;
        });
        areSomeUnchecked ? filteredOptions.map(function (option) {
          return !option.checked && _this.setOptionStatus(option, true);
        }) : filteredOptions.map(function (option) {
          return _this.setOptionStatus(option, false);
        });
        if (filteredOptions.length !== options.length) {
          options = _this.applyFilteredOptionsChanges(options, filteredOptions);
        }
        return _this.computeValuesAndText(options);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectOption", function (value) {
      if (_this.props.multiple) {
        value === _this.props.selectAllValue ? _this.selectAllOptions() : _this.selectMultipleOption(value);
      } else {
        _this.selectOneOption(value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "triggerOptionChange", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedValue;
      Array.isArray(text) && (text = text.join(", "));
      _this.setState({
        selectValue: value,
        selectTextContent: text,
        isEmpty: value.length ? false : true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setSelected", function (selectedValue) {
      return _this.setState({
        selectedValue: selectedValue
      });
    });
    _defineProperty(_assertThisInitialized(_this), "returnComponentContent", function () {
      var _this$props = _this.props,
        className = _this$props.className,
        color = _this$props.color,
        children = _this$props.children,
        getTextContent = _this$props.getTextContent,
        getValue = _this$props.getValue,
        label = _this$props.label,
        labelClass = _this$props.labelClass,
        multiple = _this$props.multiple,
        outline = _this$props.outline,
        required = _this$props.required,
        search = _this$props.search,
        searchLabel = _this$props.searchLabel,
        searchId = _this$props.searchId,
        selected = _this$props.selected,
        selectAll = _this$props.selectAll,
        selectAllClassName = _this$props.selectAllClassName,
        selectAllLabel = _this$props.selectAllLabel,
        selectAllValue = _this$props.selectAllValue,
        focusShadow = _this$props.focusShadow,
        focusBackgroundColor = _this$props.focusBackgroundColor,
        attributes = _objectWithoutProperties(_this$props, ["className", "color", "children", "getTextContent", "getValue", "label", "labelClass", "multiple", "outline", "required", "search", "searchLabel", "searchId", "selected", "selectAll", "selectAllClassName", "selectAllLabel", "selectAllValue", "focusShadow", "focusBackgroundColor"]);
      var _this$state2 = _this.state,
        isEmpty = _this$state2.isEmpty,
        isControlledEmpty = _this$state2.isControlledEmpty,
        isOpened = _this$state2.dropdown,
        selectTextContent = _this$state2.selectTextContent;
      var classes = classNames("select-wrapper mdb-select md-form", color ? "colorful-select dropdown-" + color : "", outline ? "md-outline" : className);
      var labelClasses = classNames(!outline && "mdb-main-label", labelClass, children ? (!isEmpty || isOpened) && "active text-primary" : (!isControlledEmpty || isOpened) && "active text-primary");
      var needToMoveOutline = outline && isEmpty && !isOpened;
      var uncontrolledLabelStyles = {
        transform: needToMoveOutline && "translateY(7px)",
        fontSize: needToMoveOutline && "1rem",
        fontWeight: needToMoveOutline && "300",
        zIndex: isEmpty && !isOpened ? 1 : 2
      };
      var controlledLabelStyles = {
        zIndex: outline && (!isControlledEmpty || isOpened) && 4,
        transform: isControlledEmpty && !isOpened && "translateY(7px)"
      };
      if (!children) {
        var controlledValue = isControlledEmpty ? selected && !label ? selected : "" : selectTextContent;
        return React.createElement(React.Fragment, null, React.createElement("div", _extends({}, attributes, {
          "data-color": color,
          "data-multiple": multiple,
          className: classes
        }), React.createElement("span", {
          className: "caret"
        }, "\u25BC"), React.createElement(ControlledSelectInput, {
          value: controlledValue,
          ref: _this.inputRef,
          required: required
        }), React.createElement(ControlledSelectOptions, {
          multiple: multiple,
          options: _this.state.options,
          search: search,
          searchLabel: searchLabel,
          selected: selected,
          selectOption: _this.selectOption,
          selectAll: selectAll,
          selectAllClassName: selectAllClassName,
          selectAllLabel: selectAllLabel,
          selectAllValue: selectAllValue,
          allChecked: _this.state.allChecked,
          inputRef: _this.inputRef,
          setFilteredOptions: _this.setFilteredOptions,
          focused: _this.state.focused,
          changeFocus: _this.changeFocus,
          focusShadow: focusShadow,
          focusBackgroundColor: focusBackgroundColor
        }), label && React.createElement("label", {
          className: labelClasses,
          style: controlledLabelStyles
        }, label)));
      } else {
        return React.createElement(SelectContext.Provider, {
          value: {
            state: _this.state,
            multiple: multiple,
            triggerOptionChange: _this.triggerOptionChange,
            label: label,
            setSelected: _this.setSelected,
            onInputClick: _this.onInputClick
          }
        }, React.createElement("div", _extends({}, attributes, {
          "data-color": color,
          "data-multiple": multiple,
          className: classes
        }), React.createElement("span", {
          className: "caret"
        }, "\u25BC"), children, label && React.createElement("label", {
          className: labelClasses,
          style: uncontrolledLabelStyles
        }, label)));
      }
    });
    _this.state = {
      selectedValue: "",
      isEmpty: true,
      isControlledEmpty: true,
      selectValue: [],
      selectTextContent: "",
      options: _this.props.options || [],
      allChecked: false,
      focused: null,
      filteredOptions: _this.props.options || [],
      input: null,
      dropdown: null
    };
    _this.inputRef = React.createRef();
    if (_this.props.options && _this.props.options.length) {
      Object.assign(_this.state, _this.computeValuesAndText(_this.props.options));
    }
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.onDocumentClick);
      if (this.inputRef && this.inputRef.current) {
        this.inputRef.current.addEventListener("click", this.onInputClick);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.selectValue !== this.state.selectValue) {
        if (typeof this.props.getValue === "function") {
          this.props.getValue(this.state.selectValue);
        }
        if (typeof this.props.getTextContent === "function") {
          this.props.getTextContent(this.state.selectTextContent);
        }
        if (!this.props.children) {
          this.setState({
            isControlledEmpty: !this.state.options.some(function (option) {
              return option.checked;
            })
          });
        }
      }
      if (this.props.options !== prevProps.options) {
        var _this$computeValuesAn = this.computeValuesAndText(this.props.options),
          selectValue = _this$computeValuesAn.selectValue,
          selectTextContent = _this$computeValuesAn.selectTextContent,
          allChecked = _this$computeValuesAn.allChecked;
        this.setState({
          options: this.props.options,
          filteredOptions: this.props.options,
          selectValue: selectValue,
          selectTextContent: selectTextContent,
          allChecked: allChecked
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.onDocumentClick);
      if (this.inputRef && this.inputRef.current) {
        this.inputRef.current.removeEventListener("click", this.onInputClick);
      }
    } // open nieghbour ul of clicked input
  }, {
    key: "render",
    value: function render() {
      return this.returnComponentContent();
    }
  }]);
  return Select;
}(React.Component);
Select.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  color: propTypes.string,
  focusShadow: propTypes.string,
  focusBackgroundColor: propTypes.string,
  getTextContent: propTypes.func,
  getValue: propTypes.func,
  label: propTypes.string,
  labelClass: propTypes.string,
  multiple: propTypes.bool,
  options: propTypes.arrayOf(propTypes.shape({
    checked: propTypes.bool,
    disabled: propTypes.bool,
    icon: propTypes.string,
    text: propTypes.oneOfType([propTypes.object, propTypes.string]),
    value: propTypes.string
  })),
  outline: propTypes.bool,
  required: propTypes.bool,
  search: propTypes.bool,
  searchLabel: propTypes.string,
  searchId: propTypes.string,
  selected: propTypes.string,
  selectAllClassName: propTypes.string,
  selectAllLabel: propTypes.string,
  selectAllValue: propTypes.string
};
Select.defaultProps = {
  label: "",
  labelClass: "",
  outline: false,
  required: false,
  selected: "",
  selectAllValue: "0"
};
var selectContextHOC = function selectContextHOC(Component) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);
    function HOC() {
      _classCallCheck(this, HOC);
      return _possibleConstructorReturn(this, _getPrototypeOf(HOC).apply(this, arguments));
    }
    _createClass(HOC, [{
      key: "render",
      value: function render() {
        var _this = this;
        return React.createElement(SelectContext.Consumer, null, function (context) {
          return React.createElement(Component, _extends({}, _this.props, {
            context: context
          }));
        });
      }
    }]);
    return HOC;
  }(React.Component);
};
var SelectInput = /*#__PURE__*/
function (_React$Component) {
  _inherits(SelectInput, _React$Component);
  function SelectInput() {
    _classCallCheck(this, SelectInput);
    return _possibleConstructorReturn(this, _getPrototypeOf(SelectInput).apply(this, arguments));
  }
  _createClass(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.selected && this.props.context.setSelected(this.props.selected);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.context.state.isEmpty !== this.props.context.state.isEmpty) {
        this.props.selected && this.props.context.setSelected(this.props.selected);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classes = classNames("select-dropdown", this.props.className);
      var _this$props = this.props,
        attributes = _this$props.attributes,
        context = _this$props.context;
      var value = context.state.isEmpty ? this.props.selected && !context.label ? this.props.selected : "" : context.state.selectTextContent;
      return React.createElement("input", _extends({
        type: "text",
        readOnly: true,
        onClick: function onClick(e) {
          return context.onInputClick(e);
        },
        value: value
      }, attributes, {
        className: classes
      }));
    }
  }]);
  return SelectInput;
}(React.Component);
SelectInput.propTypes = {
  context: propTypes.object.isRequired,
  className: propTypes.string,
  selected: propTypes.oneOfType([propTypes.string, propTypes.number])
};
SelectInput.defaultProps = {
  className: ""
};
var SelectInput$1 = SelectInput = selectContextHOC(SelectInput);
var css$5 = ".fadeElement {\n  -webkit-transition: 0.5s;\n  -moz-transition: 0.5s;\n  -o-transition: 0.5s;\n  transition: 0.5s;\n  display: block;\n  width: 100%;\n  top: 0;\n  opacity: 0;\n  transform-origin:top;\n  transform:scaleY(0.7);\n  visibility: hidden;\n  pointer-events: none;\n}\n.fadeElement.fadeIn {\n  transform:scaleY(1);\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n";
styleInject(css$5);
var Options = /*#__PURE__*/
function (_React$Component) {
  _inherits(Options, _React$Component);
  function Options(props) {
    var _this;
    _classCallCheck(this, Options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Options).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "search", function (value) {
      _this.state.options.forEach(function (option) {
        if (!option.children[0].innerText.toLowerCase().includes(value.toLowerCase())) {
          option.style.display = 'none';
        } else {
          option.style.display = 'flex';
        }
      });
    });
    _this.state = {
      options: [],
      searchValue: ""
    };
    _this.optionsRef = React.createRef();
    return _this;
  }
  _createClass(Options, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.search) {
        var options = Array.from(this.optionsRef.current.children).filter(function (child) {
          return child.tagName === 'LI';
        });
        this.setState({
          options: options
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        search = _this$props.search,
        searchLabel = _this$props.searchLabel,
        searchId = _this$props.searchId,
        attributes = _objectWithoutProperties(_this$props, ["className", "children", "search", "searchLabel", "searchId"]);
      var classes = classNames('dropdown-content', 'select-dropdown', 'fadeElement', className);
      return React.createElement("ul", _extends({}, attributes, {
        className: classes,
        ref: this.optionsRef
      }), search && React.createElement("div", {
        className: "mx-2"
      }, React.createElement(Input, {
        label: searchLabel,
        id: searchId,
        getValue: this.search,
        "data-search": "true"
      })), children);
    }
  }]);
  return Options;
}(React.Component);
Options.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  search: propTypes.bool,
  searchLabel: propTypes.string,
  searchId: propTypes.string
};
Options.defaultProps = {
  className: '',
  search: false,
  searchLabel: 'Search',
  searchId: 'selectSearchInput'
};
var Option = /*#__PURE__*/
function (_React$Component) {
  _inherits(Option, _React$Component);
  function Option(props) {
    var _this;
    _classCallCheck(this, Option);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Option).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "selectOption", function () {
      if (!_this.props.disabled) {
        var selectedOption = _this.optionRef.current;
        var value = [];
        var text;
        var options = selectedOption.parentNode.children;
        if (_this.state.multiple) {
          text = [];
          if (selectedOption.classList.contains("active")) {
            selectedOption.classList.remove("active");
            _this.setState({
              checked: false
            });
          } else {
            selectedOption.classList.add("active");
            _this.setState({
              checked: true
            });
          } // iterate throught child nodes options and add checked to arr

          Array.from(options).forEach(function (option) {
            if (option.classList.contains("active")) {
              text.push(option.textContent);
              option.getElementsByTagName("input")[0].value ? value.push(option.getElementsByTagName("input")[0].value) : value.push(option.textContent);
            }
          });
        } else {
          Array.from(selectedOption.children).forEach(function (child) {
            if (child.nodeName === "SPAN") {
              text = child.textContent;
              _this.props.value ? value.push(_this.props.value) : value.push(text);
            }
          });
          Array.from(options).forEach(function (option) {
            return option.classList.remove("active");
          });
          selectedOption.classList.add("active");
        }
        value.length ? _this.props.context.triggerOptionChange(value, text) : _this.props.context.triggerOptionChange();
      }
    });
    _this.state = {
      multiple: _this.props.context.multiple || false,
      checked: _this.props.checked || _this.props.selected || false
    };
    _this.optionRef = React.createRef();
    return _this;
  }
  _createClass(Option, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.multiple) {
        this.state.checked && this.optionRef.current.click();
      } else {
        if (!this.props.disabled) {
          !this.state.checked && this.optionRef.current.classList.add("active");
          this.selectOption();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        disabled = _this$props.disabled,
        separator = _this$props.separator,
        icon = _this$props.icon,
        triggerOptionClick = _this$props.triggerOptionClick,
        value = _this$props.value,
        attributes = _objectWithoutProperties(_this$props, ["className", "children", "disabled", "separator", "icon", "triggerOptionClick", "value"]);
      var classes = classNames(disabled || separator ? "disabled" : "", separator ? "optgroup" : "", className, "justify-content-between align-items-center");
      var input = null;
      var label = null;
      if (this.state.multiple) {
        if (!disabled) {
          input = React.createElement("input", {
            type: "checkbox",
            value: value,
            onChange: function onChange() {
              return false;
            },
            className: "form-check-input",
            checked: this.state.checked
          });
          label = React.createElement("label", {
            style: {
              height: "10px"
            },
            "data-multiple": this.state.multiple
          });
        } else {
          input = React.createElement("input", {
            type: "checkbox",
            className: "form-check-input",
            disabled: true
          });
          label = React.createElement("label", {
            style: {
              height: "10px"
            },
            "data-multiple": this.state.multiple
          });
        }
      }
      return React.createElement("li", _extends({
        ref: this.optionRef
      }, attributes, {
        "data-multiple": this.state.multiple,
        className: classes,
        onClick: this.selectOption,
        style: {
          display: "flex"
        }
      }), React.createElement("span", {
        "data-multiple": this.state.multiple,
        className: "filtrable",
        style: {
          flex: "1"
        }
      }, !separator ? input : null, label, children), icon && React.createElement("img", {
        src: this.props.icon,
        alt: "icon",
        className: "rounded-circle"
      }));
    }
  }]);
  return Option;
}(React.Component);
Option.propTypes = {
  children: propTypes.node,
  checked: propTypes.bool,
  className: propTypes.string,
  disabled: propTypes.bool,
  icon: propTypes.string,
  triggerOptionClick: propTypes.func,
  value: propTypes.any,
  separator: propTypes.bool
};
Option.defaultProps = {
  children: "span",
  checked: false,
  className: "",
  disabled: false,
  separator: false,
  icon: "",
  triggerOptionClick: function triggerOptionClick() {},
  value: ""
};
var SelectOption = Option = selectContextHOC(Option);
var DataTableSelect = function DataTableSelect(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    entries = _ref.entries,
    label = _ref.label,
    barReverse = _ref.barReverse;
  return React.createElement("div", {
    "data-test": "datatable-select",
    className: classNames('dataTables_length', 'd-flex', 'flex-row', barReverse && 'justify-content-end')
  }, React.createElement("label", {
    className: "mt-4"
  }, label), React.createElement(Select, {
    getValue: onChange,
    className: "my-0"
  }, React.createElement(SelectInput$1, {
    selected: value
  }), React.createElement(Options, null, entries.map(function (entry, index) {
    return React.createElement(SelectOption, {
      checked: index === 0,
      key: entry,
      value: entry
    }, entry);
  }))));
};
DataTableSelect.propTypes = {
  barReverse: propTypes.bool,
  entries: propTypes.arrayOf(propTypes.number).isRequired,
  label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object]).isRequired,
  onChange: propTypes.func.isRequired,
  value: propTypes.number.isRequired
};

// FREE START
// import DataTableSelect from '../DataTableSelect';
// FREE-END

var DataTableEntries = function DataTableEntries(props) {
  var handleEntriesChange = props.handleEntriesChange,
    displayEntries = props.displayEntries,
    entries = props.entries,
    entriesArr = props.entriesArr,
    paging = props.paging,
    label = props.label,
    barReverse = props.barReverse;
  return React.createElement("div", {
    "data-test": "datatable-entries",
    className: "col-sm-12 col-md-6"
  }, paging && displayEntries && React.createElement(DataTableSelect, {
    value: entries,
    onChange: handleEntriesChange,
    entries: entriesArr,
    label: label,
    barReverse: barReverse
  }));
};
DataTableEntries.propTypes = {
  barReverse: propTypes.bool,
  handleEntriesChange: propTypes.func.isRequired,
  displayEntries: propTypes.bool.isRequired,
  entries: propTypes.number.isRequired,
  entriesArr: propTypes.arrayOf(propTypes.number).isRequired,
  paging: propTypes.bool.isRequired,
  label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object]).isRequired
};
var DataTableInput = function DataTableInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label,
    barReverse = _ref.barReverse;
  return React.createElement("div", {
    "data-test": "datatable-input",
    className: classNames("dataTables_filter", "md-form", "flex-row", barReverse && "text-left")
  }, React.createElement("input", {
    value: value,
    onChange: onChange,
    type: "search",
    className: "form-control form-control-sm",
    placeholder: label || "Search"
  }));
};
DataTableInput.propTypes = {
  barReverse: propTypes.bool,
  label: propTypes.string,
  onChange: propTypes.func,
  value: propTypes.string
};

// FREE START
// import DataTableInput from '../DataTableInput';
// FREE END

var DataTableSearch = function DataTableSearch(props) {
  var handleSearchChange = props.handleSearchChange,
    search = props.search,
    searching = props.searching,
    label = props.label,
    barReverse = props.barReverse;
  return React.createElement("div", {
    "data-test": "datatable-search",
    className: "col-sm-12 col-md-6"
  }, searching && React.createElement(DataTableInput, {
    value: search,
    onChange: handleSearchChange,
    label: label,
    barReverse: barReverse
  }));
};
DataTableSearch.propTypes = {
  barReverse: propTypes.bool,
  handleSearchChange: propTypes.func.isRequired,
  search: propTypes.string.isRequired,
  searching: propTypes.bool.isRequired,
  label: propTypes.string
};
var DataTableInfo = function DataTableInfo(props) {
  var activePage = props.activePage,
    entries = props.entries,
    filteredRows = props.filteredRows,
    info = props.info,
    pages = props.pages,
    label = props.label;
  return React.createElement("div", {
    "data-test": "datatable-info",
    className: "col-sm-12 col-md-5"
  }, info && React.createElement("div", {
    className: "dataTables_info",
    role: "status",
    "aria-live": "polite"
  }, label[0], ' ', activePage > 0 ? activePage * entries + 1 : activePage + 1, ' ', label[1], ' ', pages.length - 1 > activePage ? pages[activePage].length * (activePage + 1) : filteredRows.length, ' ', label[2], " ", filteredRows.length, " ", label[3]));
};
DataTableInfo.propTypes = {
  activePage: propTypes.number.isRequired,
  entries: propTypes.number.isRequired,
  filteredRows: propTypes.array.isRequired,
  info: propTypes.bool.isRequired,
  pages: propTypes.array.isRequired,
  label: propTypes.arrayOf(propTypes.string)
};
DataTableInfo.defaultProps = {
  label: ['Showing', 'to', 'of', 'entries']
};
var Pagination = function Pagination(props) {
  var _classNames;
  var children = props.children,
    circle = props.circle,
    className = props.className,
    color = props.color,
    Tag = props.tag,
    size = props.size,
    attributes = _objectWithoutProperties(props, ["children", "circle", "className", "color", "tag", "size"]);
  var classes = classNames((_classNames = {
    'pagination-circle': circle
  }, _defineProperty(_classNames, "pg-".concat(color), color), _defineProperty(_classNames, "pagination-".concat(size), size), _classNames), 'pagination', className);
  return React.createElement(Tag, _extends({
    "data-test": "pagination"
  }, attributes, {
    className: classes
  }), children);
};
Pagination.propTypes = {
  children: propTypes.node,
  circle: propTypes.bool,
  className: propTypes.string,
  color: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  size: propTypes.oneOf(['lg', 'sm'])
};
Pagination.defaultProps = {
  circle: false,
  className: '',
  color: '',
  tag: 'ul'
};
var PageItem = function PageItem(props) {
  var active = props.active,
    className = props.className,
    children = props.children,
    disabled = props.disabled,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["active", "className", "children", "disabled", "tag"]);
  var classes = classNames({
    'disabled': disabled,
    'active': active
  }, 'page-item', className);
  return React.createElement(Tag, _extends({
    "data-test": "page-item"
  }, attributes, {
    className: classes
  }), children);
};
PageItem.propTypes = {
  active: propTypes.bool,
  className: propTypes.string,
  children: propTypes.node,
  disabled: propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string])
};
PageItem.defaultProps = {
  active: false,
  className: '',
  disabled: false,
  tag: 'li'
};
var PageLink = function PageLink(props) {
  var children = props.children,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["children", "className", "tag"]);
  var classes = classNames('page-link', className);
  return React.createElement(Tag, _extends({
    "data-test": "page-link"
  }, attributes, {
    className: classes
  }), children);
};
PageLink.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node
};
PageLink.defaultProps = {
  tag: 'a'
};
var DataTablePagination = /*#__PURE__*/
function (_Component) {
  _inherits(DataTablePagination, _Component);
  function DataTablePagination() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, DataTablePagination);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataTablePagination)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      pages: _this.props.pages,
      pGroups: []
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.pages !== _this.props.pages) {
        _this.setState({
          pages: _this.props.pages
        }, function () {
          return _this.groupPages();
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "pagesIndexify", function () {
      var mutablePages = _toConsumableArray(_this.state.pages);
      mutablePages.forEach(function (page, index) {
        return page.index = index;
      });
      return mutablePages;
    });
    _defineProperty(_assertThisInitialized(_this), "groupPages", function () {
      var pGroups = [];
      var pages = _this.pagesIndexify();
      while (pages.length > 0) {
        pGroups.push(pages.splice(0, _this.props.pagesAmount));
      }
      _this.setState({
        pGroups: pGroups
      });
    });
    _defineProperty(_assertThisInitialized(_this), "choosePagesGroup", function () {
      var pGroupNumber = Math.floor(_this.props.activePage / _this.props.pagesAmount);
      return _this.state.pGroups.length ? _this.state.pGroups[pGroupNumber] : [];
    });
    return _this;
  }
  _createClass(DataTablePagination, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.groupPages();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        activePage = _this$props.activePage,
        changeActivePage = _this$props.changeActivePage,
        pages = _this$props.pages,
        label = _this$props.label;
      return React.createElement("div", {
        "data-test": "datatable-pagination",
        className: "col-sm-12 col-md-7"
      }, React.createElement("div", {
        className: "dataTables_paginate"
      }, React.createElement(Pagination, null, React.createElement(PageItem, {
        disabled: activePage <= 0
      }, React.createElement(PageLink, {
        className: "page-link",
        "aria-label": label[0],
        onClick: function onClick() {
          return changeActivePage(activePage - 1);
        }
      }, React.createElement("span", null, label[0]))), this.choosePagesGroup().map(function (page) {
        return React.createElement(PageItem, {
          key: Object.keys(page[0])[0] + page.index,
          active: page.index === activePage
        }, React.createElement(PageLink, {
          className: "page-link",
          onClick: function onClick() {
            return changeActivePage(page.index);
          }
        }, page.index + 1, page.index === activePage && React.createElement("span", {
          className: "sr-only"
        }, "(current)")));
      }), React.createElement(PageItem, {
        disabled: !pages.length || activePage === pages.length - 1
      }, React.createElement(PageLink, {
        className: "page-link",
        "aria-label": label[1],
        onClick: function onClick() {
          return changeActivePage(activePage + 1);
        }
      }, React.createElement("span", null, label[1]))))));
    }
  }]);
  return DataTablePagination;
}(Component);
DataTablePagination.propTypes = {
  activePage: propTypes.number.isRequired,
  changeActivePage: propTypes.func.isRequired,
  pages: propTypes.array.isRequired,
  pagesAmount: propTypes.number.isRequired,
  label: propTypes.arrayOf(propTypes.string).isRequired
};
var ExportToCSV = /*#__PURE__*/
function (_Component) {
  _inherits(ExportToCSV, _Component);
  function ExportToCSV(props) {
    var _this;
    _classCallCheck(this, ExportToCSV);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportToCSV).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "computeDataToLink", function () {
      _this.setState(function (prevState) {
        return {
          href: encodeURI("data:text/csv;charset=utf-8," + [prevState.columns.map(function (col) {
            return col.field;
          }).join(","), [].concat.apply([], prevState.data).map(function (row) {
            return Object.values(row).join(",");
          }).join("\n")].join("\n"))
        };
      });
    });
    _this.state = {
      columns: _this.props.columns,
      data: _this.props.data,
      href: ""
    };
    return _this;
  }
  _createClass(ExportToCSV, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.computeDataToLink();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.data !== this.props.data || prevState.columns !== this.props.columns) {
        this.setState({
          columns: this.props.columns,
          data: this.props.data
        }, this.computeDataToLink());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        circle = _this$props.circle,
        className = _this$props.className,
        color = _this$props.color,
        children = _this$props.children,
        outline = _this$props.outline,
        size = _this$props.size,
        rounded = _this$props.rounded,
        gradient = _this$props.gradient,
        floating = _this$props.floating,
        flat = _this$props.flat,
        attributes = _objectWithoutProperties(_this$props, ["active", "block", "circle", "className", "color", "children", "outline", "size", "rounded", "gradient", "floating", "flat"]);
      return React.createElement(Button, _extends({
        active: active,
        block: block,
        circle: circle,
        className: className,
        color: color,
        outline: outline,
        size: size,
        rounded: rounded,
        gradient: gradient,
        floating: floating,
        flat: flat,
        role: "button",
        type: "link"
      }, attributes, {
        href: this.state.href,
        download: "export.csv",
        "data-test": "export-to-csv"
      }), children);
    }
  }]);
  return ExportToCSV;
}(Component);
ExportToCSV.propTypes = {
  columns: propTypes.arrayOf(propTypes.object).isRequired,
  data: propTypes.array.isRequired,
  active: propTypes.bool,
  block: propTypes.bool,
  color: propTypes.string,
  gradient: propTypes.string,
  disabled: propTypes.bool,
  outline: propTypes.bool,
  rounded: propTypes.bool,
  circle: propTypes.bool,
  floating: propTypes.bool,
  flat: propTypes.bool,
  size: propTypes.string,
  children: propTypes.node,
  className: propTypes.string
};
var DataTable = /*#__PURE__*/
function (_Component) {
  _inherits(DataTable, _Component);
  function DataTable(props) {
    var _this;
    _classCallCheck(this, DataTable);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataTable).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "setData", function () {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      _this.setState(function () {
        return {
          columns: columns,
          rows: rows,
          filteredRows: rows
        };
      }, callback && typeof callback === 'function' && function () {
        return callback();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setUnsearchable", function (columns) {
      var unsearchable = [];
      columns.forEach(function (column) {
        if (column.searchable !== undefined && column.searchable === false) {
          unsearchable.push(column.field);
        }
      });
      _this.setState({
        unsearchable: unsearchable
      });
    });
    _defineProperty(_assertThisInitialized(_this), "fetchData", function (link) {
      fetch(link).then(function (res) {
        return res.json();
      }).then(function (json) {
        return _this.setData(json.rows, json.columns);
      })["catch"](function (err) {
        return console.log(err);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "pagesAmount", function () {
      return Math.ceil(_this.state.filteredRows.length / _this.state.entries);
    });
    _defineProperty(_assertThisInitialized(_this), "paginateRowsInitialy", function () {
      var _this$state = _this.state,
        rows = _this$state.rows,
        entries = _this$state.entries,
        pages = _this$state.pages;
      var pagesAmount = _this.pagesAmount();
      for (var i = 1; i <= pagesAmount; i++) {
        var pageEndIndex = i * entries;
        pages.push(rows.slice(pageEndIndex - entries, pageEndIndex));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleEntriesChange", function (value) {
      _this.setState({
        entries: Array.isArray(value) ? value[0] : value
      }, function () {
        return _this.paginateRows();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSearchChange", function (e) {
      _this.setState({
        search: e.target.value
      }, function () {
        return _this.filterRows();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "checkFieldValue", function (array, field) {
      return array[field] && typeof array[field] !== 'string' ? array[field].props.searchValue : array[field];
    });
    _defineProperty(_assertThisInitialized(_this), "checkField", function (field, a, b, direction) {
      var _ref = [_this.checkFieldValue(a, field), _this.checkFieldValue(b, field)],
        aField = _ref[0],
        bField = _ref[1];
      return direction === 'desc' ? aField < bField : aField > bField;
    });
    _defineProperty(_assertThisInitialized(_this), "sort", function (rows, sortRows, field, direction) {
      rows.sort(function (a, b) {
        if (sortRows && sortRows.includes(field)) {
          return _this.checkField(field, a, b, direction);
        }
        return direction === 'asc' ? a[field] < b[field] ? -1 : 1 : a[field] > b[field] ? -1 : 1;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSort", function (field, sort) {
      if (sort === 'disabled') return;
      _this.setState(function (prevState) {
        var sortRows = _this.props.sortRows;
        var rows = prevState.rows,
          columns = prevState.columns;
        var direction = sort === 'desc' ? 'desc' : 'asc';
        _this.sort(rows, sortRows, field, direction);
        columns.forEach(function (col) {
          if (col.sort === 'disabled') return;
          col.sort = col.field === field ? col.sort === 'desc' ? 'asc' : 'desc' : '';
        });
        return {
          rows: rows,
          columns: columns,
          sorted: true
        };
      }, function () {
        return _this.filterRows();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "filterRows", function () {
      var _this$state2 = _this.state,
        unsearchable = _this$state2.unsearchable,
        search = _this$state2.search;
      var sortRows = _this.props.sortRows;
      _this.setState(function (prevState) {
        var filteredRows = prevState.rows.filter(function (row) {
          for (var key in row) {
            if ((!unsearchable.length || !unsearchable.includes(key)) && typeof row[key] !== 'function') {
              var stringValue = '';
              if (sortRows && typeof row[key] !== 'string') {
                stringValue = row[key].props.searchValue;
              } else {
                if (row[key]) {
                  stringValue = row[key].toString();
                }
              }
              if (stringValue.toLowerCase().includes(search.toLowerCase())) return true;
            }
          }
          return false;
        });
        if (filteredRows.length === 0) filteredRows.push({
          message: 'No matching records found',
          colspan: prevState.columns.length
        });
        return {
          filteredRows: filteredRows,
          activePage: 0
        };
      }, function () {
        return _this.paginateRows();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "paginateRows", function () {
      var pagesAmount = _this.pagesAmount();
      _this.setState(function (prevState) {
        var pages = prevState.pages,
          entries = prevState.entries,
          filteredRows = prevState.filteredRows,
          activePage = prevState.activePage;
        var paging = _this.props.paging;
        pages = [];
        if (paging) {
          for (var i = 1; i <= pagesAmount; i++) {
            var pageEndIndex = i * entries;
            pages.push(filteredRows.slice(pageEndIndex - entries, pageEndIndex));
          }
          activePage = activePage < pages.length || activePage === 0 ? activePage : pages.length - 1;
        } else {
          pages.push(filteredRows);
          activePage = 0;
        }
        return {
          pages: pages,
          filteredRows: filteredRows,
          activePage: activePage
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "changeActivePage", function (page) {
      _this.setState({
        activePage: page
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleTableBodyScroll", function (e) {
      _this.setState({
        translateScrollHead: e.target.scrollLeft
      });
    });
    _this.state = {
      activePage: 0,
      columns: props.data.columns || [],
      entries: props.entries,
      filteredRows: props.data.rows || [],
      order: props.order || [],
      pages: [],
      rows: props.data.rows || [],
      search: '',
      sorted: false,
      translateScrollHead: 0,
      unsearchable: []
    };
    if (_this.props.paging) {
      _this.paginateRowsInitialy();
    } else {
      _this.state.pages.push(_this.state.rows);
    }
    return _this;
  }
  _createClass(DataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var data = this.props.data;
      var _this$state3 = this.state,
        order = _this$state3.order,
        columns = _this$state3.columns;
      if (typeof data === 'string') {
        this.fetchData(data);
      }
      order.length && this.handleSort(order[0], order[1]);
      this.setUnsearchable(columns);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _) {
      var data = this.props.data;
      if (prevProps.data !== data) {
        typeof data === 'string' ? this.fetchData(data) : this.setData(data.rows, data.columns, this.paginateRows);
        this.setUnsearchable(this.state.columns);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        autoWidth = _this$props.autoWidth,
        bordered = _this$props.bordered,
        borderless = _this$props.borderless,
        barReverse = _this$props.barReverse,
        btn = _this$props.btn,
        className = _this$props.className,
        children = _this$props.children,
        dark = _this$props.dark,
        data = _this$props.data,
        displayEntries = _this$props.displayEntries,
        entriesOptions = _this$props.entriesOptions,
        entriesLabel = _this$props.entriesLabel,
        exportToCSV = _this$props.exportToCSV,
        fixed = _this$props.fixed,
        hover = _this$props.hover,
        info = _this$props.info,
        infoLabel = _this$props.infoLabel,
        maxHeight = _this$props.maxHeight,
        order = _this$props.order,
        pagesAmount = _this$props.pagesAmount,
        paging = _this$props.paging,
        paginationLabel = _this$props.paginationLabel,
        responsive = _this$props.responsive,
        responsiveSm = _this$props.responsiveSm,
        responsiveMd = _this$props.responsiveMd,
        responsiveLg = _this$props.responsiveLg,
        responsiveXl = _this$props.responsiveXl,
        searching = _this$props.searching,
        searchLabel = _this$props.searchLabel,
        scrollX = _this$props.scrollX,
        scrollY = _this$props.scrollY,
        small = _this$props.small,
        sortable = _this$props.sortable,
        striped = _this$props.striped,
        tbodyColor = _this$props.tbodyColor,
        tbodyTextWhite = _this$props.tbodyTextWhite,
        theadColor = _this$props.theadColor,
        theadTextWhite = _this$props.theadTextWhite,
        sortRows = _this$props.sortRows,
        attributes = _objectWithoutProperties(_this$props, ["autoWidth", "bordered", "borderless", "barReverse", "btn", "className", "children", "dark", "data", "displayEntries", "entriesOptions", "entriesLabel", "exportToCSV", "fixed", "hover", "info", "infoLabel", "maxHeight", "order", "pagesAmount", "paging", "paginationLabel", "responsive", "responsiveSm", "responsiveMd", "responsiveLg", "responsiveXl", "searching", "searchLabel", "scrollX", "scrollY", "small", "sortable", "striped", "tbodyColor", "tbodyTextWhite", "theadColor", "theadTextWhite", "sortRows"]);
      var _this$state4 = this.state,
        columns = _this$state4.columns,
        entries = _this$state4.entries,
        filteredRows = _this$state4.filteredRows,
        pages = _this$state4.pages,
        activePage = _this$state4.activePage,
        search = _this$state4.search,
        translateScrollHead = _this$state4.translateScrollHead;
      var tableClasses = classNames('dataTables_wrapper dt-bootstrap4', className);
      return React.createElement("div", {
        "data-test": "datatable",
        className: tableClasses
      }, React.createElement("div", {
        className: "row".concat(barReverse ? ' flex-row-reverse' : '')
      }, React.createElement(DataTableEntries, {
        paging: paging,
        displayEntries: displayEntries,
        entries: entries,
        handleEntriesChange: this.handleEntriesChange,
        entriesArr: entriesOptions,
        label: entriesLabel,
        barReverse: barReverse
      }), React.createElement(DataTableSearch, {
        handleSearchChange: this.handleSearchChange,
        search: search,
        searching: searching,
        label: searchLabel,
        barReverse: barReverse
      })), !scrollY && !scrollX && React.createElement("div", {
        className: "row"
      }, React.createElement(DataTableTable, _extends({
        autoWidth: autoWidth,
        bordered: bordered,
        borderless: borderless,
        btn: btn,
        dark: dark,
        fixed: fixed,
        hover: hover,
        responsive: responsive,
        responsiveSm: responsiveSm,
        responsiveMd: responsiveMd,
        responsiveLg: responsiveLg,
        responsiveXl: responsiveXl,
        small: small,
        striped: striped,
        theadColor: theadColor,
        theadTextWhite: theadTextWhite,
        columns: columns,
        handleSort: this.handleSort,
        sortable: sortable,
        tbodyColor: tbodyColor,
        tbodyTextWhite: tbodyTextWhite,
        rows: pages[activePage],
        sorted: this.state.sorted
      }, attributes))), (scrollY || scrollX) && React.createElement("div", {
        className: "row"
      }, React.createElement(DataTableTableScroll, _extends({
        autoWidth: autoWidth,
        bordered: bordered,
        borderless: borderless,
        btn: btn,
        dark: dark,
        fixed: fixed,
        handleTableBodyScroll: this.handleTableBodyScroll,
        hover: hover,
        maxHeight: maxHeight,
        responsive: responsive,
        responsiveSm: responsiveSm,
        responsiveMd: responsiveMd,
        responsiveLg: responsiveLg,
        responsiveXl: responsiveXl,
        scrollX: scrollX,
        scrollY: scrollY,
        small: small,
        striped: striped,
        theadColor: theadColor,
        theadTextWhite: theadTextWhite,
        columns: columns,
        handleSort: this.handleSort,
        sortable: sortable,
        sorted: this.state.sorted,
        tbodyColor: tbodyColor,
        tbodyTextWhite: tbodyTextWhite,
        rows: pages[activePage],
        translateScrollHead: translateScrollHead
      }, attributes))), paging && React.createElement("div", {
        className: "row"
      }, React.createElement(DataTableInfo, {
        activePage: activePage,
        entries: entries,
        filteredRows: filteredRows,
        info: info,
        pages: pages,
        label: infoLabel
      }), React.createElement(DataTablePagination, {
        activePage: activePage,
        changeActivePage: this.changeActivePage,
        pages: pages,
        pagesAmount: pagesAmount,
        label: paginationLabel
      })), exportToCSV && React.createElement("div", {
        className: "row justify-content-end"
      }, React.createElement(ExportToCSV, {
        columns: columns,
        data: pages,
        color: "primary"
      }, "Download CSV")));
    }
  }]);
  return DataTable;
}(Component);
DataTable.propTypes = {
  autoWidth: propTypes.bool,
  barReverse: propTypes.bool,
  bordered: propTypes.bool,
  borderless: propTypes.bool,
  btn: propTypes.bool,
  className: propTypes.string,
  children: propTypes.node,
  dark: propTypes.bool,
  data: propTypes.oneOfType([propTypes.object, propTypes.string]),
  displayEntries: propTypes.bool,
  entries: propTypes.number,
  entriesLabel: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object]),
  entriesOptions: propTypes.arrayOf(propTypes.number),
  exportToCSV: propTypes.bool,
  fixed: propTypes.bool,
  hover: propTypes.bool,
  info: propTypes.bool,
  infoLabel: propTypes.arrayOf(propTypes.string),
  maxHeight: propTypes.string,
  order: propTypes.arrayOf(propTypes.string),
  pagesAmount: propTypes.number,
  paging: propTypes.bool,
  paginationLabel: propTypes.arrayOf(propTypes.string),
  responsive: propTypes.bool,
  responsiveSm: propTypes.bool,
  responsiveMd: propTypes.bool,
  responsiveLg: propTypes.bool,
  responsiveXl: propTypes.bool,
  searching: propTypes.bool,
  searchLabel: propTypes.string,
  scrollX: propTypes.bool,
  scrollY: propTypes.bool,
  sortable: propTypes.bool,
  sortRows: propTypes.arrayOf(propTypes.string),
  small: propTypes.bool,
  striped: propTypes.bool,
  theadColor: propTypes.string,
  theadTextWhite: propTypes.bool,
  tbodyColor: propTypes.string,
  tbodyTextWhite: propTypes.bool
};
DataTable.defaultProps = {
  autoWidth: false,
  barReverse: false,
  bordered: false,
  borderless: false,
  btn: false,
  dark: false,
  data: {
    columns: [],
    rows: []
  },
  displayEntries: true,
  entries: 10,
  entriesLabel: 'Show entries',
  entriesOptions: [10, 20, 50, 100],
  exportToCSV: false,
  fixed: false,
  hover: false,
  info: true,
  infoLabel: ['Showing', 'to', 'of', 'entries'],
  order: [],
  pagesAmount: 8,
  paging: true,
  paginationLabel: ['Previous', 'Next'],
  responsive: false,
  responsiveSm: false,
  responsiveMd: false,
  responsiveLg: false,
  responsiveXl: false,
  searching: true,
  searchLabel: 'Search',
  scrollX: false,
  scrollY: false,
  sortable: true,
  small: false,
  striped: false,
  theadColor: '',
  theadTextWhite: false,
  tbodyColor: '',
  tbodyTextWhite: false
};
var Dropdown = /*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);
  function Dropdown() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Dropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "getContainer", function () {
      return ReactDOM.findDOMNode(_assertThisInitialized(_this));
    });
    _defineProperty(_assertThisInitialized(_this), "addEvents", function () {
      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this.handleDocumentClick, true);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "removeEvents", function () {
      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this.handleDocumentClick, true);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (e) {
      var keyCode = e.which,
        type = e.type,
        target = e.target;
      var tab = keyCodes.tab;
      var MOUSE_RIGHT_CLICK = keyCode === 3;
      var TAB = keyCode === tab;
      var KEYUP = type === 'keyup';
      if (MOUSE_RIGHT_CLICK || KEYUP && !TAB) return;
      var container = _this.getContainer();
      if (container.contains(target) && container !== target && (!KEYUP || TAB)) {
        return;
      }
      _this.toggle();
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e, items) {
      var up = keyCodes.up,
        down = keyCodes.down;
      var keyCode = e.which,
        target = e.target;
      var UP = keyCode === up;
      var DOWN = keyCode === down;
      var index = _toConsumableArray(items).findIndex(function (item) {
        return item === target;
      });
      if (UP && index > 0) {
        index -= 1;
      }
      if (DOWN && index < items.length - 1) {
        index += 1;
      }
      if (index < 0) {
        index = 0;
      }
      items[index].focus();
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var isOpen = _this.state.isOpen;
      var disabled = _this.props.disabled;
      var keyCode = e.which,
        target = e.target;
      var esc = keyCodes.esc,
        up = keyCodes.up,
        down = keyCodes.down,
        space = keyCodes.space;
      var SPACE = keyCode === space;
      var ESC = keyCode === esc;
      if (![esc, up, down, space].includes(keyCode) || /button/i.test(target.tagName) && SPACE || /input|textarea/i.test(target.tagName)) {
        return;
      }
      e.preventDefault();
      if (disabled) return;
      var container = _this.getContainer();
      if (SPACE && isOpen && container !== target) {
        target.click();
      }
      if (ESC || !isOpen) {
        _this.toggle();
        var btn = container.children[0];
        btn.focus();
        return;
      }
      var items = container.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled)");
      items.length && _this.handleFocus(e, items);
    });
    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });
    return _this;
  }
  _createClass(Dropdown, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        isOpen: this.state.isOpen,
        dropup: this.props.dropup,
        dropright: this.props.dropright,
        dropleft: this.props.dropleft,
        toggle: this.toggle
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleEventsBinding();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleEventsBinding();
    }
  }, {
    key: "handleEventsBinding",
    value: function handleEventsBinding() {
      this.state.isOpen ? this.addEvents() : this.removeEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;
      var _omit = omit(this.props, ['toggle', 'disabled']),
        className = _omit.className,
        children = _omit.children,
        dropup = _omit.dropup,
        group = _omit.group,
        size = _omit.size,
        dropright = _omit.dropright,
        dropleft = _omit.dropleft;
      var classes = classNames((_classNames = {
        'btn-group': group
      }, _defineProperty(_classNames, "btn-group-".concat(size), !!size), _defineProperty(_classNames, "dropdown", !group), _defineProperty(_classNames, "show", this.state.isOpen), _defineProperty(_classNames, "dropup", dropup), _defineProperty(_classNames, "dropright", dropright), _defineProperty(_classNames, "dropleft", dropleft), _classNames), className);
      return React.createElement(Manager, null, React.createElement("div", {
        "data-test": "dropdown",
        className: classes,
        onKeyDown: this.handleKeyDown
      }, children));
    }
  }]);
  return Dropdown;
}(React.Component);
Dropdown.propTypes = {
  disabled: propTypes.bool,
  dropup: propTypes.bool,
  dropright: propTypes.bool,
  dropleft: propTypes.bool,
  group: propTypes.bool,
  size: propTypes.string,
  tag: propTypes.string,
  toggle: propTypes.func,
  children: propTypes.node,
  className: propTypes.string
};
Dropdown.defaultProps = {
  dropup: false,
  dropright: false,
  dropleft: false,
  tag: 'div'
};
Dropdown.childContextTypes = {
  toggle: propTypes.func.isRequired,
  isOpen: propTypes.bool.isRequired,
  dropup: propTypes.bool.isRequired,
  dropright: propTypes.bool.isRequired,
  dropleft: propTypes.bool.isRequired
};
var DropdownItem = /*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownItem, _React$Component);
  function DropdownItem() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, DropdownItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropdownItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        header = _this$props.header,
        divider = _this$props.divider,
        onClick = _this$props.onClick,
        toggle = _this$props.toggle;
      if (disabled || header || divider) {
        e.preventDefault();
        return;
      }
      if (onClick) {
        onClick(e);
      }
      if (toggle) {
        _this.context.toggle(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getTabIndex", function () {
      var _this$props2 = _this.props,
        disabled = _this$props2.disabled,
        header = _this$props2.header,
        divider = _this$props2.divider;
      if (disabled || header || divider) {
        return '-1';
      }
      return '0';
    });
    return _this;
  }
  _createClass(DropdownItem, [{
    key: "render",
    value: function render() {
      var tabIndex = this.getTabIndex();
      var _omit = omit(this.props, ['toggle']),
        className = _omit.className,
        divider = _omit.divider,
        Tag = _omit.tag,
        header = _omit.header,
        href = _omit.href,
        active = _omit.active,
        disabled = _omit.disabled,
        props = _objectWithoutProperties(_omit, ["className", "divider", "tag", "header", "href", "active", "disabled"]);
      var classes = classNames({
        'active': active,
        'disabled': disabled,
        'dropdown-item': !divider && !header,
        'dropdown-header': header,
        'dropdown-divider': divider
      }, className);
      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (href) {
          Tag = 'a';
        }
      }
      var type = Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined;
      return React.createElement(Tag, _extends({
        "data-test": "dropdown-item",
        type: type
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(React.Component);
DropdownItem.propTypes = {
  children: propTypes.node,
  active: propTypes.bool,
  disabled: propTypes.bool,
  divider: propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  header: propTypes.bool,
  onClick: propTypes.func,
  className: propTypes.string,
  toggle: propTypes.bool
};
DropdownItem.defaultProps = {
  tag: 'button',
  toggle: true
};
DropdownItem.contextTypes = {
  toggle: propTypes.func
};
var css$6 = ".dropup .dropdown-menu {\n  top: auto !important;\n  bottom: 100% !important;\n  transform: translate3d(5px, 5px, 0px) !important;\n}\n\n.dropdown-menu-right {\n  left: 0 !important;\n  right: auto !important;\n}\n";
styleInject(css$6);
var DropdownMenuProComponent = function DropdownMenuProComponent(_ref) {
  var isOpen = _ref.isOpen,
    Tag = _ref.tag,
    tabIndex = _ref.tabIndex,
    role = _ref.role,
    attributes = _ref.attributes,
    aria = _ref.aria,
    d_key = _ref.d_key,
    children = _ref.children;
  return React.createElement(CSSTransition, {
    "in": isOpen,
    appear: isOpen,
    classNames: "popover",
    unmountOnExit: true,
    timeout: {
      enter: 300,
      exit: 300
    }
  }, React.createElement(Tag, _extends({
    tabIndex: tabIndex,
    role: role
  }, attributes, {
    "aria-hidden": aria,
    key: d_key
  }), children));
};
DropdownMenuProComponent.propTypes = {
  aria: propTypes.bool.isRequired,
  attributes: propTypes.object.isRequired,
  d_key: propTypes.string.isRequired,
  role: propTypes.string.isRequired,
  tabIndex: propTypes.string.isRequired,
  tag: propTypes.any.isRequired,
  isOpen: propTypes.bool.isRequired,
  children: propTypes.node.isRequired
};

/*
// PRO-END
import DropdownMenuComponent from './DropdownMenuComponent';
// PRO-START
*/
// FREE-END
// PRO-END

var noFlipModifier = {
  flip: {
    enabled: false
  }
};
var DropdownMenu = /*#__PURE__*/
function (_Component) {
  _inherits(DropdownMenu, _Component);
  function DropdownMenu() {
    _classCallCheck(this, DropdownMenu);
    return _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).apply(this, arguments));
  }
  _createClass(DropdownMenu, [{
    key: "render",
    value: function render() {
      var _classNames,
        _this = this;
      var _this$props = this.props,
        basic = _this$props.basic,
        className = _this$props.className,
        right = _this$props.right,
        children = _this$props.children,
        tag = _this$props.tag,
        flip = _this$props.flip,
        color = _this$props.color,
        attrs = _objectWithoutProperties(_this$props, ["basic", "className", "right", "children", "tag", "flip", "color"]);
      var classes = classNames((_classNames = {
        'dropdown-menu-right': right
      }, _defineProperty(_classNames, "dropdown-".concat(color), color), _defineProperty(_classNames, "show", this.context.isOpen), _defineProperty(_classNames, "basic", basic), _classNames), 'dropdown-menu', className);
      var Tag = tag;
      if (this.context.isOpen) {
        var position1 = this.context.dropup ? 'top' : this.context.dropright ? 'right' : this.context.dropleft ? 'left' : 'bottom';
        var position2 = right ? 'end' : 'start';
        attrs.placement = "".concat(position1, "-").concat(position2);
        attrs.component = tag;
        attrs.modifiers = !flip ? noFlipModifier : undefined;
      }
      return React.createElement(Popper$1, {
        modifires: attrs.modifiers,
        eventsEnabled: true,
        positionFixed: false,
        placement: attrs.placement,
        "data-test": "dropdown-menu"
      }, function (_ref) {
        var placement = _ref.placement,
          ref = _ref.ref,
          style = _ref.style;
        return React.createElement(Tag, {
          ref: ref,
          style: style,
          "data-placement": placement,
          className: classes
        }, React.createElement(DropdownMenuProComponent, {
          isOpen: _this.context.isOpen,
          tag: Tag,
          tabIndex: "-1",
          role: "menu",
          attributes: attrs,
          aria: !_this.context.isOpen,
          d_key: "dropDownMenu",
          color: color
        }, children));
      });
    }
  }]);
  return DropdownMenu;
}(Component);
DropdownMenu.propTypes = {
  children: propTypes.node.isRequired,
  basic: propTypes.bool,
  className: propTypes.string,
  flip: propTypes.bool,
  right: propTypes.bool,
  tag: propTypes.string
};
DropdownMenu.defaultProps = {
  basic: false,
  className: '',
  flip: false,
  right: false,
  tag: 'div',
  color: false
};
DropdownMenu.contextTypes = {
  isOpen: propTypes.bool.isRequired,
  dropup: propTypes.bool.isRequired,
  dropright: propTypes.bool.isRequired,
  dropleft: propTypes.bool.isRequired,
  color: propTypes.oneOfType([propTypes.oneOf(['primary', 'default', 'secondary', 'success', 'dark', 'danger', 'info', 'warning', 'ins']), propTypes.bool])
};
var DropdownToggle = /*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownToggle, _React$Component);
  function DropdownToggle() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, DropdownToggle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropdownToggle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        nav = _this$props.nav,
        tag = _this$props.tag,
        onClick = _this$props.onClick;
      if (disabled) {
        e.preventDefault();
        return;
      }
      if (nav && !tag) {
        e.preventDefault();
      }
      if (onClick) {
        onClick(e);
      }
      _this.context.toggle(e);
    });
    return _this;
  }
  _createClass(DropdownToggle, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        className = _this$props2.className,
        color = _this$props2.color,
        caret = _this$props2.caret,
        nav = _this$props2.nav,
        tag = _this$props2.tag,
        props = _objectWithoutProperties(_this$props2, ["className", "color", "caret", "nav", "tag"]);
      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = classNames({
        'dropdown-toggle': caret,
        'nav-link': nav
      }, className);
      var children = props.children || React.createElement("span", {
        className: "sr-only"
      }, ariaLabel);
      var Tag = tag;
      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
      }
      return React.createElement(Reference, {
        "data-test": "dropdown-toggle"
      }, function (_ref) {
        var ref = _ref.ref;
        return tag || nav ? React.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: _this2.onClick,
          "aria-expanded": _this2.context.isOpen,
          ref: ref
        }), children) : React.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: _this2.onClick,
          "aria-expanded": _this2.context.isOpen,
          innerRef: ref
        }), children);
      });
    }
  }]);
  return DropdownToggle;
}(React.Component);
DropdownToggle.propTypes = {
  caret: propTypes.bool,
  color: propTypes.string,
  children: propTypes.node,
  className: propTypes.string,
  disabled: propTypes.bool,
  onClick: propTypes.func,
  'aria-haspopup': propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  nav: propTypes.bool
};
DropdownToggle.defaultProps = {
  'aria-haspopup': true,
  color: 'secondary'
};
DropdownToggle.contextTypes = {
  isOpen: propTypes.bool.isRequired,
  toggle: propTypes.func.isRequired
};
var EdgeHeader = function EdgeHeader(props) {
  var color = props.color,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["color", "className", "tag"]);
  var classes = classNames("edge-header", color, className);
  return React.createElement(Tag, _extends({
    "data-test": "edgeHeader"
  }, attributes, {
    className: classes
  }));
};
EdgeHeader.propTypes = {
  color: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string
};
EdgeHeader.defaultProps = {
  color: "deep-purple",
  tag: "div"
};
var Footer = function Footer(props) {
  var color = props.color,
    children = props.children,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["color", "children", "className", "tag"]);
  var classes = classNames("page-footer", color && color, className);
  return React.createElement(Tag, _extends({
    "data-test": "footer"
  }, attributes, {
    className: classes
  }), children);
};
Footer.propTypes = {
  color: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node
};
Footer.defaultProps = {
  tag: "footer"
};
var FormInline = function FormInline(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    // Get Cursor Position
    var cursorPos = {
      top: e.clientY,
      left: e.clientX,
      time: Date.now()
    };
    setCursorPos(cursorPos);
  };
  var className = props.className,
    waves = props.waves,
    children = props.children,
    attributes = _objectWithoutProperties(props, ["className", "waves", "children"]);
  var classes = classNames('form-inline', props.waves && 'Ripple-parent', className);
  return React.createElement("form", _extends({
    "data-test": "form-inline"
  }, attributes, {
    className: classes,
    onMouseDown: handleClick,
    onTouchStart: handleClick
  }), props.children, props.waves && React.createElement(Waves, {
    cursorPos: cursorPos
  }));
};
FormInline.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  waves: propTypes.bool
};
var FreeBird = function FreeBird(props) {
  var className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["className", "tag"]);
  var classes = classNames("container free-bird", className);
  return React.createElement(Tag, _extends({
    "data-test": "freebird"
  }, attributes, {
    className: classes
  }));
};
FreeBird.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string
};
FreeBird.defaultProps = {
  tag: "div"
};
var css$7 = ".hamburger-button__checkbox {\n  display: none;\n}\n\n.hamburger-button__button {\n  background-color: transparent;\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n  top: -5px;\n}\n\nlabel.hamburger-button__button {\n  margin-bottom: 0;\n}\n\n#nav-icon1 {\n  width: 1.5em;\n  height: 1.5em;\n  position: relative;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease-in-out;\n  -moz-transition: .5s ease-in-out;\n  -o-transition: .5s ease-in-out;\n  transition: .5s ease-in-out;\n  cursor: pointer;\n}\n\n#nav-icon1 span {\n  display: block;\n  position: absolute;\n  height: 3px;\n  width: 100%;\n  border-radius: 1px;\n  background-color: #fff;\n  opacity: 1;\n  left: 0;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .25s ease-in-out;\n  -moz-transition: .25s ease-in-out;\n  -o-transition: .25s ease-in-out;\n  transition: .25s ease-in-out;\n}\n\n#nav-icon1 span:nth-child(1) {\n  top: 5px;\n}\n\n#nav-icon1 span:nth-child(2) {\n  top: 16px;\n}\n\n#nav-icon1 span:nth-child(3) {\n  top: 27px;\n}\n\n.hamburger-button__checkbox:checked+#nav-icon1 span:nth-child(1) {\n  top: 16px;\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.hamburger-button__checkbox:checked+#nav-icon1 span:nth-child(2) {\n  opacity: 0;\n  left: -60px;\n}\n\n.hamburger-button__checkbox:checked+#nav-icon1 span:nth-child(3) {\n  top: 16px;\n  -webkit-transform: rotate(-135deg);\n  -moz-transform: rotate(-135deg);\n  -o-transform: rotate(-135deg);\n  transform: rotate(-135deg);\n}\n";
styleInject(css$7);
var HamburgerToggler = function HamburgerToggler(props) {
  var id = props.id,
    color = props.color,
    className = props.className,
    isOpen = props.isOpen,
    onClick = props.onClick;
  var classes = classNames('hamburger-button__button', className);
  return React.createElement(React.Fragment, null, React.createElement("input", {
    "data-test": "hamburger-toggler",
    type: "checkbox",
    defaultChecked: isOpen || false,
    onChange: onClick,
    className: "hamburger-button__checkbox",
    id: id
  }), React.createElement("label", {
    id: "nav-icon1",
    className: classes,
    htmlFor: id
  }, React.createElement("span", {
    style: {
      background: color
    }
  }), React.createElement("span", {
    style: {
      background: color
    }
  }), React.createElement("span", {
    style: {
      background: color
    }
  })));
};
HamburgerToggler.propTypes = {
  id: propTypes.string,
  color: propTypes.string,
  className: propTypes.string
};
var Iframe = /*#__PURE__*/
function (_Component) {
  _inherits(Iframe, _Component);
  function Iframe() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Iframe);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Iframe)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      width: '',
      height: '',
      ratio: ''
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var width = _this.props.width;
      var height = _this.props.height;
      var ratio = 9 / 16;
      if (_this.props.ratio) {
        var newRatio = _this.props.ratio.split('by')[0] / _this.props.ratio.split('by')[1];
        if (typeof ratio === 'number') ratio = newRatio;
      }
      if (_this.props.width && _this.props.height) {
        return;
      } else if (_this.props.width) {
        height = _this.props.width * ratio;
      } else if (_this.props.height) {
        width = _this.props.height * (1 / ratio);
      }
      _this.setState(_objectSpread({}, _this.state, {
        width: width,
        height: height,
        ratio: ratio
      }));
    });
    return _this;
  }
  _createClass(Iframe, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        allowFullScreen = _this$props.allowFullScreen,
        className = _this$props.className,
        id = _this$props.id,
        name = _this$props.name,
        onMouseOver = _this$props.onMouseOver,
        onMouseOut = _this$props.onMouseOut,
        onLoad = _this$props.onLoad,
        sandbox = _this$props.sandbox,
        src = _this$props.src,
        style = _this$props.style,
        _this$props$title = _this$props.title,
        title = _this$props$title === void 0 ? "" : _this$props$title,
        ratio = _this$props.ratio,
        height = _this$props.height,
        width = _this$props.width;
      var classes = classNames('embed-responsive-item', className);
      var wrapperClasses = classNames(!(height || width) && 'embed-responsive', ratio ? "embed-responsive-".concat(ratio) : "embed-responsive-16by9");
      var iframeAttributes = {
        src: src,
        id: id || false,
        frameBorder: '0',
        target: '_parent',
        allowFullScreen: allowFullScreen || true,
        height: this.state.height || '100%',
        name: name || undefined,
        width: this.state.width || '100%',
        onLoad: onLoad || undefined,
        onMouseOver: onMouseOver || undefined,
        onMouseOut: onMouseOut || undefined,
        sandbox: sandbox || undefined,
        style: style || undefined
      };
      iframeAttributes = returnAttributes(iframeAttributes);
      return React.createElement("div", {
        "data-test": "iframe",
        className: wrapperClasses
      }, React.createElement("iframe", _extends({
        title: title,
        className: classes
      }, iframeAttributes)));
    }
  }]);
  return Iframe;
}(Component);
Iframe.propTypes = {
  allowFullScreen: propTypes.bool,
  className: propTypes.string,
  height: propTypes.number,
  id: propTypes.string,
  name: propTypes.string,
  onMouseOver: propTypes.func,
  onMouseOut: propTypes.func,
  onLoad: propTypes.func,
  ratio: propTypes.string,
  sandbox: propTypes.string,
  src: propTypes.string.isRequired,
  styles: propTypes.object,
  width: propTypes.number,
  title: propTypes.string
};
var InputGroup = function InputGroup(_ref) {
  var append = _ref.append,
    appendClassName = _ref.appendClassName,
    ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    containerId = _ref.containerId,
    hint = _ref.hint,
    id = _ref.id,
    inputs = _ref.inputs,
    inputTag = _ref.inputTag,
    label = _ref.label,
    labelClassName = _ref.labelClassName,
    material = _ref.material,
    prepend = _ref.prepend,
    prependClassName = _ref.prependClassName,
    size = _ref.size,
    Tag = _ref.tag,
    textClassName = _ref.textClassName,
    type = _ref.type,
    value = _ref.value,
    valueDefault = _ref.valueDefault,
    getValue = _ref.getValue,
    onChange = _ref.onChange,
    attributes = _objectWithoutProperties(_ref, ["append", "appendClassName", "ariaLabel", "children", "className", "containerClassName", "containerId", "hint", "id", "inputs", "inputTag", "label", "labelClassName", "material", "prepend", "prependClassName", "size", "tag", "textClassName", "type", "value", "valueDefault", "getValue", "onChange"]);
  var containerClassNames = classNames('input-group', material && 'md-form', size && "input-group-".concat(size), containerClassName);
  var inputClassNames = classNames(className);
  var prependClassNames = classNames('input-group-prepend', prependClassName);
  var appendClassNames = classNames('input-group-append', appendClassName);
  var textClassNames = classNames('input-group-text', material && 'md-addon', textClassName);
  var handleChange = function handleChange(event) {
    event.persist();
    onChange && onChange(event);
    getValue && getValue(event.target.value);
  };
  return React.createElement(React.Fragment, null, label && React.createElement("label", {
    htmlFor: id,
    className: labelClassName
  }, label), React.createElement(Tag, _extends({
    "data-test": "input-group"
  }, attributes, {
    className: containerClassNames,
    id: containerId
  }), prepend && React.createElement("div", {
    className: prependClassNames
  }, typeof prepend === 'string' ? React.createElement("span", {
    className: textClassNames
  }, prepend) : prepend), inputs || React.createElement(Input, {
    noTag: true,
    type: type,
    className: inputClassNames,
    id: id,
    value: value,
    valueDefault: valueDefault,
    hint: hint,
    "aria-label": ariaLabel,
    onChange: handleChange
  }), append && React.createElement("div", {
    className: appendClassNames
  }, typeof append === 'string' ? React.createElement("span", {
    className: textClassNames
  }, append) : append), children));
};
InputGroup.propTypes = {
  append: propTypes.oneOfType([propTypes.node, propTypes.string]),
  appendClassNames: propTypes.string,
  ariaLabel: propTypes.string,
  children: propTypes.node,
  className: propTypes.string,
  containerClassName: propTypes.string,
  containerId: propTypes.string,
  hint: propTypes.string,
  id: propTypes.string,
  inputs: propTypes.node,
  label: propTypes.string,
  labelClassName: propTypes.string,
  material: propTypes.bool,
  prepend: propTypes.any,
  prependClassName: propTypes.string,
  size: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  textClassName: propTypes.string,
  type: propTypes.string,
  value: propTypes.string,
  valueDefault: propTypes.string,
  getValue: propTypes.func,
  onChange: propTypes.func
};
InputGroup.defaultProps = {
  tag: 'div',
  type: 'text'
};
var InputNumeric = function InputNumeric(props) {
  var onChangeHandler = function onChangeHandler(value) {
    props.getValue && props.getValue(value);
  };
  var className = props.className,
    getValue = props.getValue,
    attributes = _objectWithoutProperties(props, ["className", "getValue"]);
  var classes = classNames('form-control', className);
  return React.createElement(NumericInput, _extends({
    "data-test": "input-numeric"
  }, attributes, {
    onChange: onChangeHandler,
    className: classes
  }));
};
InputNumeric.propTypes = {
  className: propTypes.string,
  getValue: propTypes.func
};
var Jumbotron = function Jumbotron(props) {
  var className = props.className,
    children = props.children,
    fluid = props.fluid,
    attributes = _objectWithoutProperties(props, ["className", "children", "fluid"]);
  var classes = classNames('jumbotron', fluid ? 'jumbotron-fluid' : false, className);
  return React.createElement("div", _extends({
    "data-test": "jumbotron"
  }, attributes, {
    className: classes
  }), children);
};
Jumbotron.propTypes = {
  fluid: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string
};
var ListGroup = function ListGroup(props) {
  var children = props.children,
    className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["children", "className", "tag"]);
  var classes = classNames("list-group", className);
  return React.createElement(Tag, _extends({
    "data-test": "list-group"
  }, attributes, {
    className: classes
  }), children);
};
ListGroup.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node
};
ListGroup.defaultProps = {
  tag: "ul"
};
var ListGroupItem = function ListGroupItem(props) {
  var _classNames;
  var active = props.active,
    children = props.children,
    className = props.className,
    color = props.color,
    disabled = props.disabled,
    hover = props.hover,
    success = props.success,
    info = props.info,
    warning = props.warning,
    danger = props.danger,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["active", "children", "className", "color", "disabled", "hover", "success", "info", "warning", "danger", "tag"]);
  var classes = classNames('list-group-item', className, (_classNames = {
    active: active,
    disabled: disabled
  }, _defineProperty(_classNames, "list-group-item-".concat(color), ' color'), _defineProperty(_classNames, 'list-group-item-action', hover), _classNames));
  if (attributes.href && Tag === 'li') {
    Tag = 'a';
  }
  return React.createElement(Tag, _extends({
    "data-test": "list-group-item"
  }, attributes, {
    className: classes
  }), children);
};
ListGroupItem.propTypes = {
  active: propTypes.bool,
  disabled: propTypes.bool,
  hover: propTypes.bool,
  success: propTypes.bool,
  info: propTypes.bool,
  warning: propTypes.bool,
  danger: propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node,
  color: propTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'])
};
ListGroupItem.defaultProps = {
  tag: 'li'
};
var Media = function Media(props) {
  var body = props.body,
    bottom = props.bottom,
    className = props.className,
    heading = props.heading,
    left = props.left,
    list = props.list,
    middle = props.middle,
    object = props.object,
    right = props.right,
    round = props.round,
    thumbnail = props.thumbnail,
    figure = props.figure,
    figImg = props.figImg,
    figCap = props.figCap,
    figCapRight = props.figCapRight,
    figCapLeft = props.figCapLeft,
    tag = props.tag,
    top = props.top,
    attributes = _objectWithoutProperties(props, ["body", "bottom", "className", "heading", "left", "list", "middle", "object", "right", "round", "thumbnail", "figure", "figImg", "figCap", "figCapRight", "figCapLeft", "tag", "top"]);
  var defaultTag;
  if (heading) {
    defaultTag = "h4";
  } else if (left || right) {
    defaultTag = "a";
  } else if (object || figImg) {
    defaultTag = "img";
  } else if (list) {
    defaultTag = "ul";
  } else if (figure) {
    defaultTag = "figure";
  } else if (figCap || figCapRight || figCapLeft) {
    defaultTag = "figcaption";
  } else {
    defaultTag = "div";
  }
  var Tag = tag || defaultTag;
  var classes = classNames({
    "media-body": body,
    "mt-0": heading,
    "media-left": left,
    "media-right": right,
    "align-self-start": top,
    "align-self-center": middle,
    "align-self-end": bottom,
    "media-object": object,
    "img-thumbnail": thumbnail,
    "media-list": list,
    figure: figure,
    "figure-img": figImg,
    "figure-caption text-center": figCap,
    "figure-caption text-right": figCapRight,
    "figure-caption text-left": figCapLeft,
    "rounded-circle z-depth-1-half": round
  }, !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list && !figCap && !figCapRight && !figCapRight && !figImg && !figure ? "media" : false, className);
  return React.createElement(Tag, _extends({
    "data-test": "media"
  }, attributes, {
    className: classes
  }));
};
Media.propTypes = {
  body: propTypes.bool,
  bottom: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  heading: propTypes.bool,
  figure: propTypes.bool,
  figImg: propTypes.bool,
  figCap: propTypes.bool,
  figCapRight: propTypes.bool,
  figCapLeft: propTypes.bool,
  left: propTypes.bool,
  list: propTypes.bool,
  middle: propTypes.bool,
  object: propTypes.bool,
  thumbnail: propTypes.bool,
  round: propTypes.bool,
  right: propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  top: propTypes.bool
};
var Modal = /*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);
  function Modal() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Modal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: _this.props.isOpen || false
    });
    _defineProperty(_assertThisInitialized(_this), "modalContent", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      document.body.classList.add('modal-open');
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      document.body.classList.remove('modal-open');
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (prevState.isOpen !== _this.props.isOpen) {
        _this.setState({
          isOpen: _this.props.isOpen
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnEntered", function (type, node) {
      if (type === 'backdrop' && _this.props.fade === false) {
        return;
      }
      node.classList.add('show');
      _this.props.autoFocus && node.focus();
      if (type === 'modal') {
        _this.props.showModal && _this.props.showModal();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnExit", function (type, node) {
      if (type === 'backdrop' && _this.props.fade === false) {
        return;
      }
      node.classList.remove('show');
      if (type === 'modal') {
        _this.props.hideModal && _this.props.hideModal();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnExited", function (node) {
      _this.props.hiddenModal && _this.props.hiddenModal();
    });
    _defineProperty(_assertThisInitialized(_this), "handleBackdropClick", function (e) {
      if (!_this.props.backdrop || e.target.closest('[role="dialog"]') && !e.target.classList.contains('modal')) return;
      if (!_this.modalContent.contains(e.target)) {
        _this.props.toggle();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleEscape", function (e) {
      if (e.keyCode === 27) {
        e.preventDefault();
        _this.props.toggle();
      }
    });
    return _this;
  }
  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _classNames,
        _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        backdrop = _this$props.backdrop,
        backdropClassName = _this$props.backdropClassName,
        contentClassName = _this$props.contentClassName,
        className = _this$props.className,
        size = _this$props.size,
        side = _this$props.side,
        fullHeight = _this$props.fullHeight,
        frame = _this$props.frame,
        centered = _this$props.centered,
        position = _this$props.position,
        cascading = _this$props.cascading,
        modalStyle = _this$props.modalStyle,
        wrapClassName = _this$props.wrapClassName,
        animation = _this$props.animation,
        fade = _this$props.fade,
        tabIndex = _this$props.tabIndex,
        role = _this$props.role,
        id = _this$props.id,
        inline = _this$props.inline;
      var timeout = fade ? 300 : 0;
      var modalDialogClasses = classNames((_classNames = {
        'cascading-modal': cascading,
        'modal-side': side,
        'modal-full-height': fullHeight,
        'modal-frame': frame,
        'modal-dialog-centered': centered
      }, _defineProperty(_classNames, "modal-".concat(size), size), _defineProperty(_classNames, "modal-".concat(position), position), _defineProperty(_classNames, "modal-notify white-text modal-".concat(modalStyle), modalStyle), _classNames), 'modal-dialog', className);
      var wrapperClasses = classNames(_defineProperty({
        modal: !inline,
        fade: fade,
        top: fade && !animation && !position
      }, "".concat(animation), fade && animation), fade && position && position.split('-')[1], wrapClassName);
      var backdropClasses = classNames('modal-backdrop', fade ? 'fade' : 'show', backdropClassName);
      var contentClasses = classNames('modal-content', contentClassName);
      var modalAttributes = returnAttributes({
        style: {
          display: 'block'
        },
        id: id,
        tabIndex: tabIndex,
        role: role,
        'aria-hidden': 'true'
      });
      return React.createElement(Fragment, null, backdrop && React.createElement(Transition, {
        timeout: timeout,
        "in": this.state.isOpen,
        appear: this.state.isOpen,
        mountOnEnter: true,
        unmountOnExit: true,
        onEntered: function onEntered(node) {
          return _this2.handleOnEntered('backdrop', node);
        },
        onExit: function onExit(node) {
          return _this2.handleOnExit('backdrop', node);
        },
        onExited: this.handleOnExited
      }, React.createElement("div", {
        className: backdropClasses
      })), React.createElement(Transition, {
        timeout: timeout,
        "in": this.state.isOpen,
        appear: this.state.isOpen,
        mountOnEnter: true,
        unmountOnExit: true,
        onMouseDown: this.handleBackdropClick,
        onEntered: function onEntered(node) {
          return _this2.handleOnEntered('modal', node);
        },
        onExit: function onExit(node) {
          return _this2.handleOnExit('modal', node);
        }
      }, React.createElement("div", _extends({
        "data-test": "modal",
        onKeyUp: this.handleEscape,
        className: wrapperClasses
      }, modalAttributes), React.createElement("div", {
        className: modalDialogClasses,
        role: "document"
      }, React.createElement("div", {
        ref: function ref(elem) {
          return _this2.modalContent = elem;
        },
        className: contentClasses
      }, children)))));
    }
  }]);
  return Modal;
}(Component);
Modal.defaultProps = {
  autoFocus: true,
  backdrop: true,
  backdropTransitionTimeout: 150,
  fade: true,
  isOpen: false,
  modalTransitionTimeout: 300,
  role: 'dialog',
  tabIndex: '-1',
  zIndex: 1050
};
Modal.propTypes = {
  animation: propTypes.string,
  backdrop: propTypes.bool,
  backdropClassName: propTypes.string,
  cascading: propTypes.bool,
  centered: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  contentClassName: propTypes.string,
  fade: propTypes.bool,
  frame: propTypes.bool,
  fullHeight: propTypes.bool,
  hiddenModal: propTypes.func,
  hideModal: propTypes.func,
  id: propTypes.string,
  modalClassName: propTypes.string,
  modalStyle: propTypes.string,
  position: propTypes.string,
  role: propTypes.string,
  size: propTypes.string,
  side: propTypes.bool,
  showModal: propTypes.func,
  tabIndex: propTypes.string,
  wrapClassName: propTypes.string
};
var ModalBody = function ModalBody(props) {
  var className = props.className,
    children = props.children,
    attributes = _objectWithoutProperties(props, ["className", "children"]);
  var classes = classNames('modal-body', className);
  return React.createElement("div", _extends({
    "data-test": "modal-body"
  }, attributes, {
    className: classes
  }), children);
};
ModalBody.propTypes = {
  className: propTypes.string,
  children: propTypes.node
};
var ModalFooter = function ModalFooter(props) {
  var className = props.className,
    children = props.children,
    center = props.center,
    start = props.start,
    end = props.end,
    around = props.around,
    between = props.between,
    attributes = _objectWithoutProperties(props, ["className", "children", "center", "start", "end", "around", "between"]);
  var classes = classNames('modal-footer', className, {
    'justify-content-start': start,
    'justify-content-end': end,
    'justify-content-center': center,
    'justify-content-between': between,
    'justify-content-around': around
  });
  return React.createElement("div", _extends({
    "data-test": "modal-footer"
  }, attributes, {
    className: classes
  }), children);
};
ModalFooter.propTypes = {
  className: propTypes.string,
  children: propTypes.node
};
var ModalHeader = function ModalHeader(props) {
  var closeButton;
  var className = props.className,
    children = props.children,
    toggle = props.toggle,
    Tag = props.tag,
    closeAriaLabel = props.closeAriaLabel,
    titleClass = props.titleClass,
    attributes = _objectWithoutProperties(props, ["className", "children", "toggle", "tag", "closeAriaLabel", "titleClass"]);
  var classes = classNames('modal-header', className);
  var titleClasses = classNames('modal-title', titleClass);
  if (toggle) {
    closeButton = React.createElement("button", {
      type: "button",
      onClick: toggle,
      className: "close",
      "aria-label": closeAriaLabel
    }, React.createElement("span", {
      "aria-hidden": "true"
    }, String.fromCharCode(215)));
  }
  return React.createElement("div", _extends({
    "data-test": "modal-header"
  }, attributes, {
    className: classes
  }), React.createElement(Tag, {
    className: titleClasses
  }, children), closeButton);
};
ModalHeader.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  toggle: propTypes.func,
  className: propTypes.string,
  children: propTypes.node,
  closeAriaLabel: propTypes.string
};
ModalHeader.defaultProps = {
  tag: 'h4',
  closeAriaLabel: 'Close'
};
var Nav = function Nav(props) {
  var children = props.children,
    className = props.className,
    Tag = props.tag,
    tabs = props.tabs,
    color = props.color,
    classicTabs = props.classicTabs,
    pills = props.pills,
    header = props.header,
    attributes = _objectWithoutProperties(props, ["children", "className", "tag", "tabs", "color", "classicTabs", "pills", "header"]);
  var classes = classNames('nav', tabs && 'md-tabs', pills && 'md-pills', header && 'nav-pills card-header-pills', color && !tabs && !classicTabs && !pills ? color : false, pills && color ? 'pills-' + color : false, (tabs || classicTabs) && color ? 'tabs-' + color : false, className);
  return React.createElement(Tag, _extends({
    "data-test": "nav"
  }, attributes, {
    className: classes
  }), children);
};
Nav.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node,
  color: propTypes.string,
  classicTabs: propTypes.bool,
  pills: propTypes.bool,
  tabs: propTypes.bool,
  header: propTypes.bool
};
Nav.defaultProps = {
  tag: 'ul',
  classicTabs: false,
  pills: false,
  tabs: false,
  header: false
};
var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }
  return "navbar-expand-".concat(expand);
};
var Navbar = /*#__PURE__*/
function (_Component) {
  _inherits(Navbar, _Component);
  function Navbar() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Navbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Navbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isCollapsed: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      var scrollingNavbarOffset = _this.props.scrollingNavbarOffset || 50;
      if (window.pageYOffset > scrollingNavbarOffset) {
        _this.setState({
          isCollapsed: true
        });
      } else {
        _this.setState({
          isCollapsed: false
        });
      }
    });
    return _this;
  }
  _createClass(Navbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.scrolling || this.props.scrollingNavbarOffset) {
        window.addEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.scrolling || this.props.scrollingNavbarOffset) {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;
      var _this$props = this.props,
        expand = _this$props.expand,
        light = _this$props.light,
        dark = _this$props.dark,
        sticky = _this$props.sticky,
        fixed = _this$props.fixed,
        scrolling = _this$props.scrolling,
        color = _this$props.color,
        className = _this$props.className,
        scrollingNavbarOffset = _this$props.scrollingNavbarOffset,
        Tag = _this$props.tag,
        _double = _this$props["double"],
        transparent = _this$props.transparent,
        attributes = _objectWithoutProperties(_this$props, ["expand", "light", "dark", "sticky", "fixed", "scrolling", "color", "className", "scrollingNavbarOffset", "tag", "double", "transparent"]);
      var classes = classNames((_classNames = {
        'navbar-light': light,
        'navbar-dark': dark
      }, _defineProperty(_classNames, "sticky-".concat(sticky), sticky), _defineProperty(_classNames, "fixed-".concat(fixed), fixed), _defineProperty(_classNames, 'scrolling-navbar', scrolling || scrollingNavbarOffset), _defineProperty(_classNames, 'double-nav', _double), _defineProperty(_classNames, 'top-nav-collapse', this.state.isCollapsed), _defineProperty(_classNames, "".concat(color), color && transparent ? this.state.isCollapsed : color), _classNames), 'navbar', getExpandClass(expand), className);
      return React.createElement(Tag, _extends({
        "data-test": "navbar"
      }, attributes, {
        className: classes,
        role: "navigation"
      }));
    }
  }]);
  return Navbar;
}(Component);
Navbar.propTypes = {
  light: propTypes.bool,
  dark: propTypes.bool,
  "double": propTypes.bool,
  fixed: propTypes.string,
  sticky: propTypes.string,
  scrolling: propTypes.bool,
  scrollingNavbarOffset: propTypes.number,
  color: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  expand: propTypes.oneOfType([propTypes.bool, propTypes.string]),
  transparent: propTypes.bool
};
Navbar.defaultProps = {
  tag: 'nav',
  expand: false,
  scrolling: false
};
var NavbarBrand = function NavbarBrand(_ref) {
  var className = _ref.className,
    href = _ref.href,
    attributes = _objectWithoutProperties(_ref, ["className", "href"]);
  var classes = classNames('navbar-brand', className);
  var navbarBrand = function navbarBrand() {
    if (href) {
      return React.createElement(NavLink$1, _extends({
        "data-test": "navbar-brand",
        to: href
      }, attributes, {
        className: classes
      }));
    } else {
      return React.createElement("div", _extends({
        "data-test": "navbar-brand"
      }, attributes, {
        className: classes
      }));
    }
  };
  return navbarBrand();
};
NavbarBrand.propTypes = {
  className: propTypes.string,
  href: propTypes.string
};
var NavbarNav = function NavbarNav(props) {
  var children = props.children,
    className = props.className,
    right = props.right,
    left = props.left,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["children", "className", "right", "left", "tag"]);
  var classes = classNames('navbar-nav', right ? 'ml-auto' : left ? 'mr-auto' : 'justify-content-around w-100', className);
  return React.createElement(Tag, _extends({
    "data-test": "navbar-nav"
  }, attributes, {
    className: classes
  }), children);
};
NavbarNav.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node,
  right: propTypes.bool,
  left: propTypes.bool
};
NavbarNav.defaultProps = {
  tag: 'ul'
};
var NavbarToggler = function NavbarToggler(props) {
  var right = props.right,
    left = props.left,
    children = props.children,
    className = props.className,
    Tag = props.tag,
    image = props.image,
    attributes = _objectWithoutProperties(props, ["right", "left", "children", "className", "tag", "image"]);
  var classes = classNames({
    "navbar-toggler-right": right,
    "navbar-toggler-left": left
  }, "navbar-toggler", className);
  return React.createElement(Tag, _extends({
    "data-test": "navbar-toggler"
  }, attributes, {
    className: classes
  }), children ? children : image ? React.createElement("span", {
    className: "navbar-toggler-icon",
    style: {
      backgroundImage: "url(\"".concat(image, "\")")
    }
  }) : React.createElement("span", {
    className: "navbar-toggler-icon"
  }));
};
NavbarToggler.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  type: propTypes.string,
  className: propTypes.string,
  children: propTypes.node,
  right: propTypes.bool,
  left: propTypes.bool,
  image: propTypes.string
};
NavbarToggler.defaultProps = {
  tag: "button",
  type: "button"
};
var NavItem = function NavItem(props) {
  var children = props.children,
    className = props.className,
    active = props.active,
    text = props.text,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["children", "className", "active", "text", "tag"]);
  var classes = classNames('nav-item', active && 'active', text && 'navbar-text', className);
  return React.createElement(Tag, _extends({
    "data-test": "nav-item"
  }, attributes, {
    className: classes
  }), children);
};
NavItem.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node,
  active: propTypes.bool
};
NavItem.defaultProps = {
  tag: 'li'
};
var NavLink = function NavLink(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    if (!props.disabled) {
      e.stopPropagation(); // Waves - Get Cursor Position

      var _cursorPos = {
        top: e.clientY,
        left: e.clientX,
        time: Date.now()
      };
      setCursorPos(_cursorPos);
    }
  };
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    active = props.active,
    to = props.to,
    attributes = _objectWithoutProperties(props, ["children", "className", "disabled", "active", "to"]);
  var classes = classNames('nav-link', disabled ? 'disabled' : 'Ripple-parent', active && 'active', className);
  return React.createElement(NavLink$1, _extends({
    "data-test": "nav-link",
    className: classes,
    onMouseUp: handleClick,
    onTouchStart: handleClick,
    to: to
  }, attributes), children, props.disabled ? false : React.createElement(Waves, {
    cursorPos: cursorPos
  }));
};
NavLink.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  disabled: propTypes.bool,
  to: propTypes.string,
  active: propTypes.bool
};
NavLink.defaultProps = {
  active: false,
  className: '',
  disabled: false
};
var Notification = /*#__PURE__*/
function (_React$Component) {
  _inherits(Notification, _React$Component);
  function Notification() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Notification);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Notification)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      componentState: _this.props.show ? 'show' : 'hide'
    });
    _defineProperty(_assertThisInitialized(_this), "hide", function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (_typeof(time) === 'object') time = 0;
      setTimeout(function () {
        _this.setState({
          componentState: ''
        }, function () {
          setTimeout(function () {
            _this.setState({
              componentState: 'hide'
            });
          }, 150);
        });
      }, time);
    });
    return _this;
  }
  _createClass(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autohide > 0) this.hide(this.props.autohide);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        Tag = _this$props.tag,
        className = _this$props.className,
        show = _this$props.show,
        fade = _this$props.fade,
        message = _this$props.message,
        bodyClassName = _this$props.bodyClassName,
        icon = _this$props.icon,
        iconClassName = _this$props.iconClassName,
        title = _this$props.title,
        titleClassName = _this$props.titleClassName,
        text = _this$props.text,
        closeClassName = _this$props.closeClassName,
        attributes = _objectWithoutProperties(_this$props, ["tag", "className", "show", "fade", "message", "bodyClassName", "icon", "iconClassName", "title", "titleClassName", "text", "closeClassName"]);
      var classes = classNames('toast', fade && 'fade', this.state.componentState, className);
      var headerClasses = classNames('toast-header', titleClassName);
      var iconClassNames = classNames('mr-2', iconClassName);
      var bodyClasses = classNames('toast-body', bodyClassName);
      var closeClasses = classNames('ml-2', 'mb-1', closeClassName);
      return React.createElement(Tag, _extends({
        "data-test": "notification"
      }, attributes, {
        className: classes
      }), React.createElement("div", {
        className: headerClasses
      }, React.createElement(Fa, {
        icon: icon,
        className: iconClassNames,
        size: "lg"
      }), React.createElement("strong", {
        className: "mr-auto"
      }, title), React.createElement("small", null, text), React.createElement(MDBCloseIcon, {
        className: closeClasses,
        onClick: this.hide
      })), React.createElement("div", {
        className: bodyClasses
      }, message));
    }
  }]);
  return Notification;
}(React.Component);
Notification.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  show: propTypes.bool,
  fade: propTypes.bool,
  autohide: propTypes.number,
  iconClassName: propTypes.string,
  title: propTypes.string,
  text: propTypes.string,
  titleColor: propTypes.string,
  titleClassName: propTypes.string,
  closeClassName: propTypes.string,
  bodyClassName: propTypes.string,
  bodyColor: propTypes.string,
  message: propTypes.string
};
Notification.defaultProps = {
  icon: 'square',
  tag: 'div',
  closeClassName: 'text-dark'
};
var Popper = function Popper(_ref) {
  var children = _ref.children,
    clickable = _ref.clickable,
    domElement = _ref.domElement,
    modifiers = _ref.modifiers,
    id = _ref.id,
    isVisible = _ref.isVisible,
    onChange = _ref.onChange,
    placement = _ref.placement,
    popover = _ref.popover,
    style = _ref.style,
    tag = _ref.tag;
  var _useState = useState(isVisible),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEffect(function () {
    setVisible(isVisible);
  }, [isVisible]);
  useEffect(function () {
    onChange && onChange(visible);
  }, [onChange, visible]);
  useEffect(function () {
    window.addEventListener('click', handleClick);
    return function () {
      return window.removeEventListener('click', handleClick);
    };
  });
  function handleClick(e) {
    var element = document.elementsFromPoint(e.clientX, e.clientY).find(function (el) {
      return el.dataset.popper === id;
    });
    if (element) return;
    setVisible(false);
  }
  var Wrapper = children[0];
  var Content = children[1];
  var Tag = tag;
  var tooltipClasses = classNames("fade", popover ? "popover bs-popover-".concat(placement, " popover-enter-done") : "tooltip bs-tooltip-".concat(placement), visible ? "show" : "");
  var contentClasses = classNames(!popover && "tooltip-inner");
  return React.createElement(Manager, {
    "data-test": "popper"
  }, React.createElement(Reference, null, function (_ref2) {
    var ref = _ref2.ref;
    return !domElement ? React.createElement(Wrapper.type, _extends({}, Wrapper.props, {
      onMouseEnter: function onMouseEnter() {
        return !clickable && setVisible(true);
      },
      onMouseLeave: function onMouseLeave() {
        return !clickable && setVisible(false);
      },
      onTouchStart: function onTouchStart() {
        return !clickable && setVisible(true);
      },
      onTouchEnd: function onTouchEnd() {
        return !clickable && setVisible(false);
      },
      onMouseDown: function onMouseDown() {
        return clickable && setVisible(!visible);
      },
      innerRef: ref,
      "data-popper": id
    })) : React.createElement(Wrapper.type, _extends({}, Wrapper.props, {
      onMouseEnter: function onMouseEnter() {
        return !clickable && setVisible(true);
      },
      onMouseLeave: function onMouseLeave() {
        return !clickable && setVisible(false);
      },
      onTouchStart: function onTouchStart() {
        return !clickable && setVisible(true);
      },
      onTouchEnd: function onTouchEnd() {
        return !clickable && setVisible(false);
      },
      onMouseDown: function onMouseDown() {
        return clickable && setVisible(!visible);
      },
      ref: ref,
      "data-popper": id
    }));
  }), visible && Content.props.children && React.createElement(Tag, {
    style: style
  }, React.createElement(Popper$1, {
    modifiers: modifiers,
    eventsEnabled: true,
    positionFixed: false,
    placement: placement
  }, function (_ref3) {
    var placement = _ref3.placement,
      ref = _ref3.ref,
      style = _ref3.style,
      arrowProps = _ref3.arrowProps;
    return React.createElement(Tag, {
      ref: ref,
      style: style,
      "data-placement": placement,
      className: tooltipClasses,
      "data-popper": id
    }, React.createElement(Content.type, _extends({}, Content.props, {
      className: contentClasses
    }), Content.props.children), React.createElement("span", {
      ref: arrowProps.ref,
      style: arrowProps.style,
      "data-placement": placement,
      className: "arrow"
    }));
  })));
};
Popper.propTypes = {
  children: propTypes.node,
  clickable: propTypes.bool,
  domElement: propTypes.bool,
  modifiers: propTypes.object,
  id: propTypes.string,
  isVisible: propTypes.bool,
  placement: propTypes.string,
  popover: propTypes.bool,
  style: propTypes.objectOf(propTypes.string),
  tag: propTypes.string
};
Popper.defaultProps = {
  clickable: false,
  domElement: false,
  id: 'popper',
  isVisible: false,
  placement: 'top',
  popover: false,
  style: {
    display: 'inline-block'
  },
  tag: 'div'
};
var PopoverBody = function PopoverBody(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    className = _ref.className,
    Tag = _ref.tag;
  var classes = classNames('popover-body', className);
  return React.createElement(Tag, _extends({
    "data-test": "popover-body"
  }, attributes, {
    className: classes
  }), children);
};
PopoverBody.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string])
};
PopoverBody.defaultProps = {
  tag: 'div'
};
var PopoverHeader = function PopoverHeader(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    className = _ref.className,
    Tag = _ref.tag;
  var classes = classNames('popover-header', className);
  return React.createElement(Tag, _extends({
    "data-test": "popover-header"
  }, attributes, {
    className: classes
  }), children);
};
PopoverHeader.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string])
};
PopoverHeader.defaultProps = {
  className: '',
  tag: 'h3'
};
var Progress = function Progress(_ref) {
  var animated = _ref.animated,
    barClassName = _ref.barClassName,
    children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    height = _ref.height,
    material = _ref.material,
    max = _ref.max,
    min = _ref.min,
    preloader = _ref.preloader,
    striped = _ref.striped,
    wrapperStyle = _ref.wrapperStyle,
    value = _ref.value,
    attributes = _objectWithoutProperties(_ref, ["animated", "barClassName", "children", "className", "color", "height", "material", "max", "min", "preloader", "striped", "wrapperStyle", "value"]);
  var percent = (value - min) / (max - min) * 100;
  var progressClasses = classNames('progress', material && 'md-progress', preloader && (color ? color + '-color' : 'primary-color') + '-dark', className);
  var progressBarClasses = classNames(preloader ? 'indeterminate' : 'progress-bar', barClassName ? barClassName : null, animated ? 'progress-bar-animated' : null, color ? "bg-".concat(color) : null, striped || animated ? 'progress-bar-striped' : null);
  var computedHeight = height ? height : children && '1rem';
  var computedWrapperStyle = _objectSpread({}, wrapperStyle, {
    height: computedHeight
  });
  return React.createElement("div", _extends({
    "data-test": "progress"
  }, attributes, {
    className: progressClasses,
    style: computedWrapperStyle
  }), React.createElement("div", {
    className: progressBarClasses,
    style: {
      width: "".concat(percent, "%"),
      height: computedHeight
    },
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": min,
    "aria-valuemax": max
  }, children));
};
Progress.propTypes = {
  animated: propTypes.bool,
  barClassName: propTypes.string,
  children: propTypes.node,
  className: propTypes.string,
  color: propTypes.string,
  height: propTypes.string,
  material: propTypes.bool,
  max: propTypes.number,
  min: propTypes.number,
  preloader: propTypes.bool,
  striped: propTypes.bool,
  wrapperStyle: propTypes.object,
  value: propTypes.number
};
Progress.defaultProps = {
  animated: false,
  barClassName: '',
  className: '',
  color: 'indigo',
  height: '',
  material: false,
  max: 100,
  min: 0,
  preloader: false,
  striped: false,
  wrapperStyle: {},
  value: 0
};
var Row = function Row(props) {
  var className = props.className,
    Tag = props.tag,
    center = props.center,
    start = props.start,
    end = props.end,
    around = props.around,
    between = props.between,
    top = props.top,
    bottom = props.bottom,
    middle = props.middle,
    attributes = _objectWithoutProperties(props, ["className", "tag", "center", "start", "end", "around", "between", "top", "bottom", "middle"]);
  var classes = classNames("row", end && "justify-content-end", start && "justify-content-start", center && "justify-content-center", between && "justify-content-between", around && "justify-content-around", top && "align-self-start", middle && "align-self-center", bottom && "align-self-end", className);
  return React.createElement(Tag, _extends({
    "data-test": "row"
  }, attributes, {
    className: classes
  }));
};
Row.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  top: propTypes.bool,
  bottom: propTypes.bool,
  middle: propTypes.bool,
  end: propTypes.bool,
  start: propTypes.bool,
  center: propTypes.bool,
  between: propTypes.bool,
  around: propTypes.bool
};
Row.defaultProps = {
  tag: "div"
};
var propTypes$1 = {
  activeItem: propTypes.any,
  tabId: propTypes.any,
  className: propTypes.string
};
var TabContent = /*#__PURE__*/
function (_React$Component) {
  _inherits(TabContent, _React$Component);
  function TabContent() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TabContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TabContent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      activeItem: _this.props.activeItem
    });
    return _this;
  }
  _createClass(TabContent, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        activeItemId: this.state.activeItem
      };
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var attributes = omit(this.props, Object.keys(propTypes$1));
      var classes = classNames('tab-content', className);
      return React.createElement("div", _extends({
        "data-test": "tabContent"
      }, attributes, {
        className: classes
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return prevState.activeItem !== nextProps.activeItem ? {
        activeItem: nextProps.activeItem
      } : null;
    }
  }]);
  return TabContent;
}(React.Component);
TabContent.childContextTypes = {
  activeItemId: propTypes.any
};
TabContent.propTypes = propTypes$1;
var TabPane = /*#__PURE__*/
function (_React$Component) {
  _inherits(TabPane, _React$Component);
  function TabPane() {
    _classCallCheck(this, TabPane);
    return _possibleConstructorReturn(this, _getPrototypeOf(TabPane).apply(this, arguments));
  }
  _createClass(TabPane, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        tabId = _this$props.tabId,
        attributes = _objectWithoutProperties(_this$props, ["className", "tabId"]);
      var classes = classNames('tab-pane', {
        active: tabId === this.context.activeItemId
      }, className);
      return React.createElement("div", _extends({
        "data-test": "tab-pane"
      }, attributes, {
        className: classes,
        role: "tabpanel"
      }));
    }
  }]);
  return TabPane;
}(React.Component);
TabPane.contextTypes = {
  activeItemId: propTypes.any
};
TabPane.propTypes = {
  tabId: propTypes.any,
  className: propTypes.string
};
var TableHead = function TableHead(props) {
  var _classNames;
  var children = props.children,
    color = props.color,
    columns = props.columns,
    textWhite = props.textWhite,
    attributes = _objectWithoutProperties(props, ["children", "color", "columns", "textWhite"]);
  var isTheadColor = color === 'dark' || color === 'light';
  var classes = classNames((_classNames = {
    'text-white': textWhite
  }, _defineProperty(_classNames, "thead-".concat(color), color && isTheadColor), _defineProperty(_classNames, "".concat(color), color && !isTheadColor), _classNames));
  return React.createElement("thead", _extends({
    "data-test": "table-head"
  }, attributes, {
    className: classes
  }), columns && React.createElement("tr", null, columns.map(function (col) {
    return React.createElement("th", {
      key: col.field,
      className: col.hasOwnProperty('minimal') ? "th-".concat(col.minimal) : ''
    }, col.label);
  })), children);
};
TableHead.propTypes = {
  children: propTypes.node,
  color: propTypes.string,
  columns: propTypes.arrayOf(propTypes.object),
  textWhite: propTypes.bool
};
TableHead.defaultProps = {
  textWhite: false
};
var TreeviewContext = React.createContext();
var Treeview = function Treeview(props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  useEffect(function () {
    if (props.getValue) {
      props.getValue({
        item: active ? active.closest('li') : active,
        value: active ? active.closest('li').childNodes[1].textContent : active
      });
    }
  }, [active, props]);
  var getActive = function getActive(target) {
    setActive(target);
    return target;
  };
  var theme = props.theme,
    children = props.children,
    className = props.className,
    getValue = props.getValue,
    header = props.header,
    listClassName = props.listClassName,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["theme", "children", "className", "getValue", "header", "listClassName", "tag"]);
  var classes = classNames('border', theme ? "treeview-".concat(theme) : 'treeview', className);
  var ulClasses = classNames('list-unstyled', header ? 'pb-2 mb-1' : 'py-2 my-1', theme && "treeview-".concat(theme, "-list"), theme === 'animated' || !theme && 'pl-3', listClassName);
  var head = header && React.createElement(React.Fragment, null, React.createElement("h6", {
    className: "pt-3 pl-3"
  }, header), React.createElement("hr", null));
  return React.createElement(Tag, _extends({
    "data-test": "treeview"
  }, attributes, {
    className: classes
  }), head, React.createElement("ul", {
    className: ulClasses
  }, React.createElement(TreeviewContext.Provider, {
    value: {
      active: active,
      theme: theme,
      getActive: getActive
    }
  }, children)));
};
Treeview.propTypes = {
  className: propTypes.string,
  header: propTypes.string,
  listClassName: propTypes.string,
  tag: propTypes.string,
  theme: propTypes.string,
  getValue: propTypes.func
};
Treeview.defaultProps = {
  tag: 'div',
  theme: '',
  getValue: function getValue() {}
};
var TreeviewItem = function TreeviewItem(props) {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    target = _useState2[0],
    setTarget = _useState2[1];
  var targetRef = useRef(null);
  var className = props.className,
    disabled = props.disabled,
    disabledClassName = props.disabledClassName,
    fab = props.fab,
    fal = props.fal,
    far = props.far,
    icon = props.icon,
    opened = props.opened,
    Tag = props.tag,
    title = props.title,
    attributes = _objectWithoutProperties(props, ["className", "disabled", "disabledClassName", "fab", "fal", "far", "icon", "opened", "tag", "title"]);
  var _useContext = useContext(TreeviewContext),
    theme = _useContext.theme,
    active = _useContext.active,
    getActive = _useContext.getActive;
  useEffect(function () {
    if (targetRef && targetRef.current) {
      setTarget(targetRef.current);
    }
  }, []);
  var handleClick = function handleClick() {
    if (!disabled) {
      target.classList.contains('opened') ? getActive(null) : getActive(target);
    }
  };
  var classes = classNames(disabled && disabledClassName, theme && "treeview-".concat(theme, "-items treeview-").concat(theme, "-element closed mb-1"), active === target && !active.classList.contains('opened') ? 'opened' : '', className);
  return React.createElement(Tag, _extends({
    "data-test": "treeview-item"
  }, attributes, {
    className: classes,
    ref: targetRef,
    onMouseDown: handleClick,
    style: {
      transform: 'translateY(0.3em)'
    }
  }), React.createElement(Fa, {
    className: "mr-2",
    fab: fab,
    fal: fal,
    far: far,
    icon: icon
  }), React.createElement("span", null, title));
};
TreeviewItem.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  disabledClassName: propTypes.string,
  fab: propTypes.bool,
  fal: propTypes.bool,
  far: propTypes.bool,
  icon: propTypes.string,
  opened: propTypes.bool,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string])
};
TreeviewItem.defaultProps = {
  disabled: false,
  fab: false,
  fal: false,
  far: false,
  icon: 'folder-open',
  opened: false,
  tag: 'li'
};
var TreeviewList = function TreeviewList(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpen = _useState2[1];
  useEffect(function () {
    setOpen(props.opened);
  }, [props.opened]);
  var handleSwitch = function handleSwitch() {
    return setOpen(!opened);
  };
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    disabledClassName = props.disabledClassName,
    fab = props.fab,
    fal = props.fal,
    far = props.far,
    icon = props.icon,
    _ = props.opened,
    Tag = props.tag,
    title = props.title,
    attributes = _objectWithoutProperties(props, ["children", "className", "disabled", "disabledClassName", "fab", "fal", "far", "icon", "opened", "tag", "title"]);
  var _useContext = useContext(TreeviewContext),
    theme = _useContext.theme;
  var nestedClasses = classNames('nested', opened && 'active');
  var folder = classNames(theme && "closed treeview-".concat(theme, "-element d-block"), !children && 'ml-2', opened && 'opened', disabled && disabledClassName);
  var classes = classNames(theme && "treeview-".concat(theme, "-items px-0"), className);
  var iconClasses = classNames(theme ? 'mx-2' : 'mr-2');
  var child = children && React.createElement("ul", {
    className: nestedClasses,
    style: {
      height: 'calc(100% + 0.6rem)',
      marginLeft: '2px'
    }
  }, children);
  var collapse = theme && React.createElement(Collapse, {
    isOpen: opened
  }, child);
  var iconArrow = theme !== 'colorful' ? 'angle-right' : opened ? 'minus-circle' : 'plus-circle';
  var arrow = children && React.createElement(Fa, {
    icon: iconArrow,
    rotate: theme !== 'colorful' ? opened ? '90 down' : '0' : '',
    className: "rotate"
  });
  var btn = children && React.createElement(Button, {
    flat: true,
    className: "m-0 py-0 px-1 mr-1 z-depth-0",
    onClick: handleSwitch
  }, arrow);
  return React.createElement(Tag, _extends({
    "data-test": "treeview-list"
  }, attributes, {
    className: classes
  }), React.createElement("span", {
    className: folder,
    onClick: !disabled && theme ? handleSwitch : null
  }, theme ? arrow : btn, React.createElement("span", null, React.createElement(Fa, {
    className: iconClasses,
    fab: fab,
    fal: fal,
    far: far,
    icon: icon
  }), title)), collapse || child);
};
TreeviewList.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  disabledClassName: propTypes.string,
  fab: propTypes.bool,
  fal: propTypes.bool,
  far: propTypes.bool,
  icon: propTypes.string,
  opened: propTypes.bool,
  tag: propTypes.string
};
TreeviewList.defaultProps = {
  disabled: false,
  fab: false,
  fal: false,
  far: false,
  icon: 'folder-open',
  opened: false,
  tag: 'li'
};
TreeviewList.contextTypes = {
  theme: propTypes.string
};
var Autocomplete = /*#__PURE__*/
function (_Component) {
  _inherits(Autocomplete, _Component);
  function Autocomplete(props) {
    var _this;
    _classCallCheck(this, Autocomplete);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Autocomplete).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "outsideClickHandler", function (e) {
      _this.suggestionsList && e.target !== _this.suggestionsList && _this.setState({
        choosed: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "filterRepeated", function (data) {
      return data.filter(function (el, index) {
        return data.indexOf(el) === index;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleInput", function (e) {
      var value = e.target.value;
      _this.setState({
        value: value,
        choosed: false,
        focusedListItem: 0
      });
      if (value !== '') {
        _this.setSuggestions(value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setSuggestions", function (value) {
      var filteredSuggestions = _this.state.suggestions.filter(function (suggest) {
        return suggest.toLowerCase().includes(value.toLowerCase().trim());
      });
      _this.setState({
        filteredSuggestions: filteredSuggestions
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      return _this.setState({
        value: '',
        focusedListItem: 0
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelect", function () {
      var value = _this.state.filteredSuggestions[_this.state.focusedListItem];
      if (value) {
        _this.setState({
          value: value,
          focusedListItem: 0,
          choosed: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "keyDownHandler", function (e) {
      var _this$state = _this.state,
        filteredSuggestions = _this$state.filteredSuggestions,
        focusedListItem = _this$state.focusedListItem;
      if (_this.suggestionsList && _this.state.filteredSuggestions) {
        var suggestionsListNodes = _this.suggestionsList.childNodes;
        suggestionsListNodes.length >= 5 && suggestionsListNodes[_this.state.focusedListItem].scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
        if (e.keyCode === 13) {
          _this.handleSelect();
          e.target.blur();
        }
        e.keyCode === 40 && focusedListItem < filteredSuggestions.length - 1 && _this.setState({
          focusedListItem: focusedListItem + 1
        });
        e.keyCode === 38 && focusedListItem > 0 && _this.setState({
          focusedListItem: focusedListItem - 1
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateFocus", function (index) {
      return _this.setState({
        focusedListItem: index
      });
    });
    _this.state = {
      value: props.value || props.valueDefault,
      suggestions: [],
      choosed: false,
      filteredSuggestions: [],
      focusedListItem: 0
    };
    _this.suggestionsList = null;
    return _this;
  }
  _createClass(Autocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        suggestions: this.filterRepeated(this.props.data)
      });
      window.addEventListener('click', this.outsideClickHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      prevState.value !== this.state.value && this.props.getValue && this.props.getValue(this.state.value);
      prevProps.value !== this.props.value && this.setState({
        value: this.props.value
      });
      prevProps.data !== this.props.data && this.setState({
        suggestions: this.filterRepeated(this.props.data)
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.outsideClickHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state2 = this.state,
        value = _this$state2.value,
        filteredSuggestions = _this$state2.filteredSuggestions,
        choosed = _this$state2.choosed;
      var _this$props = this.props,
        clear = _this$props.clear,
        clearColor = _this$props.clearColor,
        clearSize = _this$props.clearSize,
        clearClass = _this$props.clearClass,
        disabled = _this$props.disabled,
        id = _this$props.id,
        className = _this$props.className,
        label = _this$props.label,
        icon = _this$props.icon,
        iconBrand = _this$props.iconBrand,
        iconClass = _this$props.iconClass,
        iconLight = _this$props.iconLight,
        iconRegular = _this$props.iconRegular,
        iconSize = _this$props.iconSize,
        size = _this$props.size,
        labelClass = _this$props.labelClass,
        placeholder = _this$props.placeholder,
        valueDefault = _this$props.valueDefault;
      var btnStyles = classNames(clearClass, 'mdb-autocomplete-clear');
      return React.createElement("div", {
        "data-test": "auto-complete",
        style: {
          position: 'relative'
        }
      }, React.createElement(Input, {
        icon: icon,
        iconSize: iconSize,
        iconBrand: iconBrand,
        iconLight: iconLight,
        iconRegular: iconRegular,
        iconClass: iconClass,
        id: id,
        className: className,
        label: label,
        labelClass: labelClass,
        hint: placeholder,
        disabled: disabled,
        value: value,
        valueDefault: valueDefault,
        onChange: this.handleInput,
        onKeyDown: this.keyDownHandler,
        size: size
      }, clear && value && React.createElement("button", {
        onClick: this.handleClear,
        className: btnStyles,
        style: {
          visibility: 'visible'
        }
      }, React.createElement("svg", {
        fill: clearColor,
        height: clearSize,
        viewBox: "0 0 24 24",
        width: clearSize,
        xmlns: "https://www.w3.org/2000/svg"
      }, React.createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }), React.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })))), value && !choosed && React.createElement("ul", {
        ref: function ref(list) {
          return _this2.suggestionsList = list;
        },
        className: "mdb-autocomplete-wrap",
        style: {
          marginTop: '-15px'
        },
        onClick: this.handleSelect
      }, filteredSuggestions.map(function (el, index) {
        return React.createElement("li", {
          key: el + index,
          className: "list-item",
          style: {
            background: "".concat(_this2.state.focusedListItem === index ? '#eee' : '#fff')
          },
          onMouseEnter: function onMouseEnter() {
            return _this2.updateFocus(index);
          }
        }, el);
      })));
    }
  }]);
  return Autocomplete;
}(Component);
Autocomplete.propTypes = {
  clear: propTypes.bool,
  clearColor: propTypes.string,
  clearSize: propTypes.string,
  data: propTypes.arrayOf(propTypes.string),
  disabled: propTypes.bool,
  getValue: propTypes.func,
  id: propTypes.string,
  label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object]),
  labelClass: propTypes.string,
  icon: propTypes.string,
  iconBrand: propTypes.bool,
  iconLight: propTypes.bool,
  iconRegular: propTypes.bool,
  iconSize: propTypes.string,
  iconClassName: propTypes.string,
  placeholder: propTypes.string,
  valueDefault: propTypes.string
};
Autocomplete.defaultProps = {
  clear: false,
  clearColor: '#a6a6a6',
  clearSize: '24',
  data: [],
  disabled: false,
  id: '',
  label: '',
  className: '',
  clearClass: '',
  labelClass: '',
  icon: '',
  iconBrand: false,
  iconSize: '',
  iconLight: false,
  iconRegular: false,
  iconClassName: '',
  placeholder: '',
  valueDefault: ''
};
var Avatar = function Avatar(props) {
  var className = props.className,
    Tag = props.tag,
    round = props.round,
    circle = props.circle,
    attributes = _objectWithoutProperties(props, ["className", "tag", "round", "circle"]);
  var classes = classNames('avatar', round && 'rounded', circle && 'rounded-circle', className);
  return React.createElement(Tag, _extends({
    "data-test": "avatar"
  }, attributes, {
    className: classes
  }));
};
Avatar.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  round: propTypes.bool,
  circle: propTypes.bool
};
Avatar.defaultProps = {
  tag: 'div',
  round: false,
  circle: false
};
var ButtonFixed = /*#__PURE__*/
function (_React$Component) {
  _inherits(ButtonFixed, _React$Component);
  function ButtonFixed(props) {
    var _this;
    _classCallCheck(this, ButtonFixed);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ButtonFixed).call(this, props));
    _this.state = {
      cursorPos: {}
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ButtonFixed, [{
    key: "handleClick",
    value: function handleClick(e) {
      // Get Cursor Position
      e.preventDefault();
      var cursorPos = {
        top: e.clientY,
        left: e.clientX,
        time: Date.now()
      };
      this.setState({
        cursorPos: cursorPos
      });
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        className = _this$props.className,
        color = _this$props.color,
        outline = _this$props.outline,
        size = _this$props.size,
        rounded = _this$props.rounded,
        gradient = _this$props.gradient,
        floating = _this$props.floating,
        flat = _this$props.flat,
        role = _this$props.role,
        type = _this$props.type,
        icon = _this$props.icon,
        iconBrand = _this$props.iconBrand,
        iconClass = _this$props.iconClass,
        iconLight = _this$props.iconLight,
        iconRegular = _this$props.iconRegular,
        iconSize = _this$props.iconSize,
        innerRef = _this$props.innerRef,
        topSection = _this$props.topSection,
        attributes = _objectWithoutProperties(_this$props, ["active", "block", "className", "color", "outline", "size", "rounded", "gradient", "floating", "flat", "role", "type", "icon", "iconBrand", "iconClass", "iconLight", "iconRegular", "iconSize", "innerRef", "topSection"]);
      var buttonFixedClasses = classNames('fixed-action-btn active');
      var classes = classNames(floating ? 'btn-floating' : 'btn', flat ? 'btn-flat' : gradient ? "".concat(gradient, "-gradient") : "".concat(color), size ? "btn-".concat(size) : false, rounded ? 'btn-rounded' : false, block ? 'btn-block' : false, 'Ripple-parent', className, {
        active: active,
        disabled: this.props.disabled
      });
      return React.createElement("div", _extends({
        "data-test": "button-fixed",
        className: buttonFixedClasses,
        ref: innerRef,
        style: {
          bottom: '45px',
          right: '24px'
        }
      }, attributes), React.createElement("a", {
        href: this.props.topSection ? this.props.topSection : '#',
        className: classes,
        onClick: this.onClick,
        onMouseDown: this.handleClick.bind(this),
        onTouchStart: this.handleClick.bind(this)
      }, icon && React.createElement(Fa, {
        icon: icon,
        size: iconSize,
        brand: iconBrand,
        light: iconLight,
        regular: iconRegular,
        className: iconClass
      }), this.props.disabled ? false : React.createElement(Waves, {
        cursorPos: this.state.cursorPos,
        outline: outline,
        flat: flat
      })), React.createElement("ul", {
        className: "list-unstyled"
      }, this.props.children));
    }
  }]);
  return ButtonFixed;
}(React.Component);
ButtonFixed.defaultProps = {
  color: 'default'
};
ButtonFixed.propTypes = {
  active: propTypes.bool,
  block: propTypes.bool,
  color: propTypes.string,
  gradient: propTypes.string,
  role: propTypes.string,
  type: propTypes.string,
  disabled: propTypes.bool,
  outline: propTypes.bool,
  rounded: propTypes.bool,
  floating: propTypes.bool,
  flat: propTypes.bool,
  icon: propTypes.string,
  iconBrand: propTypes.bool,
  iconClass: propTypes.string,
  iconLight: propTypes.bool,
  iconRegular: propTypes.bool,
  iconSize: propTypes.string,
  innerRef: propTypes.oneOfType([propTypes.func, propTypes.string]),
  onClick: propTypes.func,
  size: propTypes.string,
  children: propTypes.node,
  className: propTypes.string,
  topSection: propTypes.string
};
var ButtonFixed$1 = /*#__PURE__*/
function (_React$Component) {
  _inherits(ButtonFixed, _React$Component);
  function ButtonFixed(props) {
    var _this;
    _classCallCheck(this, ButtonFixed);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ButtonFixed).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }
      _this.props.onClick && _this.props.onClick();
    });
    _this.state = {
      cursorPos: {},
      buttonStyle: {
        transform: 'scaleY(0.4) scaleX(0.4) translateY(40px) translateX(0)',
        opacity: '0'
      }
    };
    return _this;
  }
  _createClass(ButtonFixed, [{
    key: "handleClick",
    value: function handleClick(e) {
      // Get Cursor Position
      var cursorPos = {
        top: e.clientY,
        left: e.clientX,
        time: Date.now()
      };
      this.setState({
        cursorPos: cursorPos
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        className = _this$props.className,
        color = _this$props.color,
        outline = _this$props.outline,
        size = _this$props.size,
        rounded = _this$props.rounded,
        gradient = _this$props.gradient,
        floating = _this$props.floating,
        flat = _this$props.flat,
        role = _this$props.role,
        type = _this$props.type,
        icon = _this$props.icon,
        iconBrand = _this$props.iconBrand,
        iconClass = _this$props.iconClass,
        iconLight = _this$props.iconLight,
        iconRegular = _this$props.iconRegular,
        iconSize = _this$props.iconSize,
        innerRef = _this$props.innerRef,
        buttonStyle = _this$props.buttonStyle,
        attributes = _objectWithoutProperties(_this$props, ["active", "block", "className", "color", "outline", "size", "rounded", "gradient", "floating", "flat", "role", "type", "icon", "iconBrand", "iconClass", "iconLight", "iconRegular", "iconSize", "innerRef", "buttonStyle"]);
      var classes = classNames(size && "btn-".concat(size), 'btn-floating', color ? color : false, 'Ripple-parent', className);
      return React.createElement("li", {
        "data-test": "button-fixed-item"
      }, React.createElement("a", _extends({}, attributes, {
        style: this.props.buttonStyle,
        onClick: this.onClick,
        onMouseDown: this.handleClick.bind(this),
        onTouchStart: this.handleClick.bind(this),
        className: classes
      }), icon && React.createElement(Fa, {
        icon: icon,
        size: iconSize,
        brand: iconBrand,
        light: iconLight,
        regular: iconRegular,
        className: iconClass
      }), this.props.disabled ? false : React.createElement(Waves, {
        cursorPos: this.state.cursorPos,
        outline: outline,
        flat: flat
      })));
    }
  }]);
  return ButtonFixed;
}(React.Component);
ButtonFixed$1.defaultProps = {
  color: 'default'
};
ButtonFixed$1.propTypes = {
  active: propTypes.bool,
  block: propTypes.bool,
  color: propTypes.string,
  gradient: propTypes.string,
  role: propTypes.string,
  type: propTypes.string,
  disabled: propTypes.bool,
  outline: propTypes.bool,
  rounded: propTypes.bool,
  floating: propTypes.bool,
  flat: propTypes.bool,
  innerRef: propTypes.oneOfType([propTypes.func, propTypes.string]),
  onClick: propTypes.func,
  size: propTypes.oneOf(['lg', 'sm']),
  children: propTypes.node,
  className: propTypes.string,
  icon: propTypes.string,
  iconBrand: propTypes.bool,
  iconClass: propTypes.string,
  iconLight: propTypes.bool,
  iconRegular: propTypes.bool,
  iconSize: propTypes.string,
  buttonStyle: propTypes.object
};
var CardUp = function CardUp(props) {
  var className = props.className,
    Tag = props.tag,
    color = props.color,
    gradient = props.gradient,
    attributes = _objectWithoutProperties(props, ["className", "tag", "color", "gradient"]);
  var classes = classNames('card-up', color && color + '-color', gradient && gradient + '-gradient', className);
  return React.createElement(Tag, _extends({
    "data-test": "card-up"
  }, attributes, {
    className: classes
  }));
};
CardUp.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string
};
CardUp.defaultProps = {
  tag: 'div'
};
var css$8 = ".chip.chip-md {\n  height: 42px;\n  line-height: 42px;\n  border-radius: 21px;\n}\n.chip.chip-md img {\n  height: 42px;\n  width: 42px;\n}\n.chip.chip-md .close {\n  height: 42px;\n  line-height: 42px;\n  border-radius: 21px;\n}\n.chip.chip-lg {\n  height: 52px;\n  line-height: 52px;\n  border-radius: 26px;\n}\n.chip.chip-lg img {\n  height: 52px;\n  width: 52px;\n}\n.chip.chip-lg .close {\n  height: 52px;\n  line-height: 52px;\n  border-radius: 26px;\n}\n";
styleInject(css$8);
var Chip = function Chip(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    // Get Cursor Position
    e.stopPropagation();
    e.preventDefault();
    var cursorPos = {
      top: e.clientY,
      left: e.clientX,
      time: Date.now()
    };
    setCursorPos(cursorPos);
  };
  var handleCloseClick = function handleCloseClick(e) {
    if (props.handleClose) {
      props.handleClose(e);
    }
  };
  var className = props.className,
    Tag = props.tag,
    size = props.size,
    bgColor = props.bgColor,
    text = props.text,
    gradient = props.gradient,
    src = props.src,
    alt = props.alt,
    close = props.close,
    waves = props.waves,
    handleClose = props.handleClose,
    attributes = _objectWithoutProperties(props, ["className", "tag", "size", "bgColor", "text", "gradient", "src", "alt", "close", "waves", "handleClose"]);
  var classes = classNames('chip', size && 'chip-' + size, bgColor && bgColor, text && text + '-text', gradient && gradient + '-gradient', waves && 'Ripple-parent', className);
  return React.createElement(Tag, _extends({
    "data-test": "chip"
  }, attributes, {
    className: classes,
    onMouseDown: handleClick,
    onTouchStart: handleClick
  }), src && React.createElement("img", {
    src: src,
    alt: alt
  }), props.children, waves && React.createElement(Waves, {
    cursorPos: cursorPos
  }), close && React.createElement(Fa, {
    icon: "times",
    className: "close",
    onClick: handleCloseClick
  }));
};
Chip.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  size: propTypes.string,
  bgColor: propTypes.string,
  text: propTypes.string,
  gradient: propTypes.string,
  src: propTypes.string,
  alt: propTypes.string,
  close: propTypes.bool,
  handleClose: propTypes.func
};
Chip.defaultProps = {
  tag: 'div'
};
var ChipsInput = /*#__PURE__*/
function (_Component) {
  _inherits(ChipsInput, _Component);
  function ChipsInput(props) {
    var _this;
    _classCallCheck(this, ChipsInput);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChipsInput).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.setState({
        isTouched: true
      });
      _this.inputRef.current.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.setState({
        inputValue: e.target.value,
        isReadyToDelete: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleEnter", function (e) {
      // 1) get the value:
      var newChipString = _this.inputRef.current.value; // 2) upon pressing Enter:

      if (e.which === 13) {
        // 3) if the string is empty or consists only of spaces: return
        if (/^ *$/.test(newChipString)) {
          return;
        } // 3.5) of the string is already in the array, delete input value and return

        if (_this.state.chipsList.includes(newChipString)) {
          _this.setState({
            inputValue: ''
          });
          return;
        } // 4) else: add the input value to the array and reset it on input:

        _this.setState({
          inputValue: '',
          chipsList: [].concat(_toConsumableArray(_this.state.chipsList), [newChipString])
        });
      } // 5) in case the keyboard events caused the input to be empty, prepare to delete chips:

      if (_this.state.inputValue === '') {
        _this.setState({
          isReadyToDelete: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleBackspace", function (e) {
      //if the input is already empty (is ready to delete chips) and Backspace is pressed:
      if (_this.state.isReadyToDelete && e.which === 8) {
        var chipsList = _this.state.chipsList;
        chipsList.pop();
        _this.setState({
          chipsList: chipsList
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function (param) {
      var chipsList = _this.state.chipsList;
      var handleClose = _this.props.handleClose;
      var index = _this.state.chipsList.indexOf(param);
      var itemToDelete = chipsList[index];
      chipsList.splice(index, 1);
      _this.setState({
        chipsList: chipsList
      }, function () {
        handleClose && handleClose(itemToDelete);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function () {
      _this.setState({
        isTouched: false
      });
    });
    _this.state = {
      chipsList: _this.props.chips,
      inputValue: '',
      isTouched: false,
      isReadyToDelete: false
    };
    _this.inputRef = React.createRef();
    return _this;
  }
  _createClass(ChipsInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        Tag = _this$props.tag,
        handleClose = _this$props.handleClose,
        placeholder = _this$props.placeholder,
        secondaryPlaceholder = _this$props.secondaryPlaceholder,
        chipSize = _this$props.chipSize,
        chipColor = _this$props.chipColor,
        chipText = _this$props.chipText,
        chipGradient = _this$props.chipGradient,
        chipWaves = _this$props.chipWaves,
        attributes = _objectWithoutProperties(_this$props, ["className", "tag", "handleClose", "placeholder", "secondaryPlaceholder", "chipSize", "chipColor", "chipText", "chipGradient", "chipWaves"]);
      var renderedChips = this.state.chipsList.map(function (chip) {
        return React.createElement(Chip, {
          close: true,
          handleClose: function handleClose() {
            return _this2.handleClose(chip);
          },
          key: chip.toString(),
          size: chipSize,
          bgColor: chipColor,
          text: chipText,
          gradient: chipGradient,
          waves: chipWaves
        }, chip);
      });
      var calculatePlaceholder;
      if (this.state.chipsList.length < 1) {
        calculatePlaceholder = placeholder;
      } else {
        calculatePlaceholder = secondaryPlaceholder;
      }
      var classes = classNames('chips', this.state.isTouched && 'focus', className);
      return React.createElement(Tag, _extends({
        "data-test": "chips-input"
      }, attributes, {
        className: classes,
        onClick: this.handleClick,
        onKeyUp: this.handleBackspace
      }), renderedChips, React.createElement("input", {
        className: "input",
        type: "text",
        placeholder: calculatePlaceholder,
        ref: this.inputRef,
        onKeyUp: this.handleEnter,
        value: this.state.inputValue,
        onChange: this.handleChange,
        onBlur: this.handleOutsideClick
      }));
    }
  }]);
  return ChipsInput;
}(Component);
ChipsInput.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  placeholder: propTypes.string,
  secondaryPlaceholder: propTypes.string,
  chipSize: propTypes.string,
  chipColor: propTypes.string,
  chipText: propTypes.string,
  chipGradient: propTypes.string
};
ChipsInput.defaultProps = {
  tag: 'div',
  chips: []
};
var CollapseHeader = function CollapseHeader(props) {
  var className = props.className,
    tagClassName = props.tagClassName,
    children = props.children,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["className", "tagClassName", "children", "tag"]);
  var classes = classNames('card-header', className);
  var tagClasses = classNames('mb-0', tagClassName);
  return React.createElement("div", _extends({
    "data-test": "collapse-header"
  }, attributes, {
    className: classes,
    style: {
      cursor: 'pointer'
    }
  }), React.createElement(Tag, {
    className: tagClasses
  }, children));
};
CollapseHeader.defaultProps = {
  tag: 'h5'
};
CollapseHeader.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  tagClassName: propTypes.string,
  tag: propTypes.string
};
var css$9 = "/* fallback */\n@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/materialicons/v41/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format('woff2');\n}\n\n.material-icons {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: 'liga';\n  -webkit-font-smoothing: antialiased;\n}\n";
styleInject(css$9);
var DatePicker = /*#__PURE__*/
function (_Component) {
  _inherits(DatePicker, _Component);
  function DatePicker(props) {
    var _this;
    _classCallCheck(this, DatePicker);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "handleDateChange", function (date) {
      _this.setState({
        selectedDate: date ? date._d : _this.props.value
      });
    });
    _this.state = {
      selectedDate: props.value || props.valueDefault,
      muiTheme: createMuiTheme(_objectSpread({}, props.theme, {
        typography: {
          useNextVariants: true
        }
      }))
    };
    return _this;
  }
  _createClass(DatePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.getValue && prevState.selectedDate !== this.state.selectedDate) {
        this.props.getValue(this.state.selectedDate);
      }
      if (this.props.value !== prevProps.value) {
        this.setState({
          selectedDate: this.props.value
        });
      }
      if (prevProps.theme !== this.props.theme) {
        this.setState({
          muiTheme: createMuiTheme(this.props.theme)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        adornmentPosition = _this$props.adornmentPosition,
        allowKeyboardControl = _this$props.allowKeyboardControl,
        animateYearScrolling = _this$props.animateYearScrolling,
        autoOk = _this$props.autoOk,
        cancelLabel = _this$props.cancelLabel,
        clearable = _this$props.clearable,
        clearLabel = _this$props.clearLabel,
        disableFuture = _this$props.disableFuture,
        disableOpenOnEnter = _this$props.disableOpenOnEnter,
        disablePast = _this$props.disablePast,
        emptyLabel = _this$props.emptyLabel,
        initialFocusedDate = _this$props.initialFocusedDate,
        InputAdornmentProps = _this$props.InputAdornmentProps,
        invalidDateMessage = _this$props.invalidDateMessage,
        invalidLabel = _this$props.invalidLabel,
        keyboard = _this$props.keyboard,
        keyboardIcon = _this$props.keyboardIcon,
        leftArrowIcon = _this$props.leftArrowIcon,
        mask = _this$props.mask,
        maxDate = _this$props.maxDate,
        maxDateMessage = _this$props.maxDateMessage,
        minDate = _this$props.minDate,
        minDateMessage = _this$props.minDateMessage,
        okLabel = _this$props.okLabel,
        onInputChange = _this$props.onInputChange,
        openToYearSelection = _this$props.openToYearSelection,
        rightArrowIcon = _this$props.rightArrowIcon,
        showTodayButton = _this$props.showTodayButton,
        TextFieldComponent = _this$props.TextFieldComponent,
        todayLabel = _this$props.todayLabel,
        locale = _this$props.locale,
        format = _this$props.format,
        className = _this$props.className,
        getValue = _this$props.getValue,
        value = _this$props.value,
        valueDefault = _this$props.valueDefault,
        Tag = _this$props.tag,
        attributes = _objectWithoutProperties(_this$props, ["theme", "adornmentPosition", "allowKeyboardControl", "animateYearScrolling", "autoOk", "cancelLabel", "clearable", "clearLabel", "disableFuture", "disableOpenOnEnter", "disablePast", "emptyLabel", "initialFocusedDate", "InputAdornmentProps", "invalidDateMessage", "invalidLabel", "keyboard", "keyboardIcon", "leftArrowIcon", "mask", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "okLabel", "onInputChange", "openToYearSelection", "rightArrowIcon", "showTodayButton", "TextFieldComponent", "todayLabel", "locale", "format", "className", "getValue", "value", "valueDefault", "tag"]);
      var classes = classNames('md-form', className);
      return React.createElement(Tag, {
        "data-test": "date-picker",
        className: classes
      }, React.createElement(MuiThemeProvider, {
        theme: this.state.muiTheme
      }, React.createElement(MuiPickersUtilsProvider, {
        locale: locale,
        moment: moment,
        utils: MomentUtils
      }, React.createElement(DatePicker$1, _extends({}, attributes, {
        adornmentPosition: adornmentPosition,
        allowKeyboardControl: allowKeyboardControl,
        animateYearScrolling: animateYearScrolling,
        autoOk: autoOk,
        cancelLabel: cancelLabel,
        clearable: clearable,
        clearLabel: clearLabel,
        disableFuture: disableFuture,
        disableOpenOnEnter: disableOpenOnEnter,
        disablePast: disablePast,
        emptyLabel: emptyLabel,
        initialFocusedDate: initialFocusedDate,
        InputAdornmentProps: InputAdornmentProps,
        invalidDateMessage: invalidDateMessage,
        invalidLabel: invalidLabel,
        keyboard: keyboard,
        keyboardIcon: keyboardIcon,
        leftArrowIcon: leftArrowIcon,
        mask: mask,
        maxDate: maxDate,
        maxDateMessage: maxDateMessage,
        minDate: minDate,
        minDateMessage: minDateMessage,
        okLabel: okLabel,
        onInputChange: onInputChange,
        openToYearSelection: openToYearSelection,
        rightArrowIcon: rightArrowIcon,
        showTodayButton: showTodayButton,
        TextFieldComponent: TextFieldComponent,
        todayLabel: todayLabel,
        format: format || 'DD MMMM, YYYY',
        value: this.state.selectedDate,
        onChange: this.handleDateChange
      })))));
    }
  }]);
  return DatePicker;
}(Component);
DatePicker.propTypes = {
  theme: propTypes.object,
  adornmentPosition: propTypes.string,
  allowKeyboardControl: propTypes.bool,
  animateYearScrolling: propTypes.bool,
  autoOk: propTypes.bool,
  cancelLabel: propTypes.node,
  clearable: propTypes.bool,
  clearLabel: propTypes.node,
  disableFuture: propTypes.object,
  disableOpenOnEnter: propTypes.bool,
  disablePast: propTypes.bool,
  emptyLabel: propTypes.string,
  initialFocusedDate: propTypes.string,
  InputAdornmentProps: propTypes.object,
  invalidDateMessage: propTypes.node,
  invalidLabel: propTypes.string,
  keyboard: propTypes.bool,
  keyboardIcon: propTypes.node,
  leftArrowIcon: propTypes.node,
  mask: propTypes.any,
  maxDate: propTypes.string,
  maxDateMessage: propTypes.node,
  minDate: propTypes.string,
  minDateMessage: propTypes.node,
  okLabel: propTypes.node,
  onInputChange: propTypes.func,
  openToYearSelection: propTypes.bool,
  rightArrowIcon: propTypes.node,
  showTodayButton: propTypes.bool,
  TextFieldComponent: propTypes.string,
  todayLabel: propTypes.string,
  locale: propTypes.string,
  format: propTypes.string,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  getValue: propTypes.func,
  value: propTypes.instanceOf(Date),
  valueDefault: propTypes.instanceOf(Date)
};
DatePicker.defaultProps = {
  theme: {},
  tag: 'div',
  value: null,
  valueDefault: new Date(),
  getValue: function getValue() {}
};
function RotatingCard(props) {
  var className = props.className,
    Tag = props.tag,
    InnerTag = props.innerTag,
    flipped = props.flipped,
    attributes = _objectWithoutProperties(props, ["className", "tag", "innerTag", "flipped"]);
  var classes = classNames('card-rotating effect__click', props.flipped && 'flipped', className);
  return React.createElement(Tag, _extends({
    "data-test": "flipping-card"
  }, attributes, {
    className: "card-wrapper"
  }), React.createElement(InnerTag, {
    className: classes
  }, props.children));
}
RotatingCard.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  innerTag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  children: propTypes.node,
  flipped: propTypes.bool
};
RotatingCard.defaultProps = {
  tag: 'div',
  innerTag: 'div',
  flipped: false
};
var css$a = ".file-field .file-field-right .file-path-wrapper {\n  padding-left: 0;\n  padding-right: 10px;\n}\n";
styleInject(css$a);
var InputFile = function InputFile(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var fileChange = function fileChange(files) {
    if (files.length > 0) {
      if (files.length > 1) {
        var filesNames = [];
        for (var i = 0; i < files.length; i++) {
          filesNames.push(files[i].name);
        }
        setFiles(filesNames);
      } else {
        setFiles(files[0].name);
      }
    } else {
      setFiles(false);
    }
  };
  var onChangeHandler = function onChangeHandler(e) {
    fileChange(e.target.files);
    props.getValue && props.getValue(e.target.files);
  };
  var resetFiles = function resetFiles() {
    files && setFiles(false);
  };
  var className = props.className,
    btnTitle = props.btnTitle,
    btnColor = props.btnColor,
    textFieldTitle = props.textFieldTitle,
    multiple = props.multiple,
    reset = props.reset,
    resetClassName = props.resetClassName,
    resetAriaLabel = props.resetAriaLabel,
    reverse = props.reverse;
  var btnClass = classNames('btn', 'btn-' + btnColor, 'btn-sm', reverse ? 'float-right' : 'float-left');
  var inputFieldClass = classNames('file-path', 'validate', files ? 'valid' : false, className);
  var wrapperClass = classNames('file-field', 'md-form', reverse && 'file-field-right');
  return React.createElement("div", {
    "data-test": "input-file",
    className: wrapperClass
  }, React.createElement("div", {
    className: btnClass
  }, React.createElement("span", null, btnTitle), React.createElement("input", {
    multiple: multiple,
    onChange: onChangeHandler,
    type: "file"
  })), React.createElement("div", {
    className: "file-path-wrapper"
  }, React.createElement("input", {
    className: inputFieldClass,
    type: "text",
    placeholder: files ? files : textFieldTitle,
    style: {
      position: reset ? 'relative' : null
    }
  })), reset && React.createElement(MDBCloseIcon, {
    onClick: resetFiles,
    className: resetClassName,
    ariaLabel: resetAriaLabel ? resetAriaLabel : null,
    style: {
      position: 'absolute',
      top: '50%',
      right: '0',
      transform: 'translateY(-50%)'
    }
  }));
};
InputFile.propTypes = {
  className: propTypes.string,
  btnTitle: propTypes.string,
  btnColor: propTypes.string,
  textFieldTitle: propTypes.string,
  multiple: propTypes.bool,
  reset: propTypes.bool,
  resetClassName: propTypes.string,
  resetAriaLabel: propTypes.string,
  reverse: propTypes.bool
};
InputFile.defaultProps = {
  btnTitle: 'Choose file',
  textFieldTitle: 'Upload your file',
  btnColor: 'primary',
  reset: false,
  reverse: false
};
var css$b = ".thumb {\n  transition: top .2s, height .2s, width .2s, margin-left .2s;\n}\n\ninput[type=\"range\"] {\n  -webkit-appearance: none;\n}\n\n/* thumb */\n\ninput[type=range]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  border: none;\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  background-color: #4285f4;\n  transform-origin: 50% 50%;\n  margin: -5px 0 0 0;\n  transition: 0.3s; }\n  input[type=range]:focus::-webkit-slider-runnable-track {\n    background: #ccc; }\n  input[type=range]::-moz-range-track {\n    /*required for proper track sizing in FF*/\n    height: 3px;\n    background: #c2c0c2;\n    border: none; }\n  input[type=range]::-moz-range-thumb {\n    border: none;\n    height: 14px;\n    width: 14px;\n    border-radius: 50%;\n    background: #4285f4;\n    margin-top: -5px; }\n  input[type=range]:-moz-focusring {\n    /*hide the outline behind the border*/\n    outline: 1px solid #ffffff;\n    outline-offset: -1px; }\n  input[type=range]:focus::-moz-range-track {\n    background: #c2c0c2; }\n  input[type=range]::-ms-track {\n    height: 3px;\n    background: transparent;\n    /*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */\n    border-color: transparent;\n    /*leave room for the larger thumb to overflow with a transparent border */\n    border-width: 6px 0;\n    color: transparent;\n    /*remove default tick marks*/ }\n  input[type=range]::-ms-fill-lower {\n    background: #c2c0c2; }\n  input[type=range]::-ms-fill-upper {\n    background: #c2c0c2; }\n  input[type=range]::-ms-thumb {\n    border: none;\n    height: 14px;\n    width: 14px;\n    border-radius: 50%;\n    background: #4285f4; }\n  input[type=range]:focus::-ms-fill-lower {\n    background: #c2c0c2; }\n  input[type=range]:focus::-ms-fill-upper {\n    background: #c2c0c2; }";
styleInject(css$b);
var InputRange = /*#__PURE__*/
function (_React$Component) {
  _inherits(InputRange, _React$Component);
  function InputRange(props) {
    var _this;
    _classCallCheck(this, InputRange);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputRange).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var input = _this.inputRef.current;
      var inputWidth = input.offsetWidth;
      var oneStep = inputWidth / (_this.props.max - _this.props.min);
      _this.setState({
        value: _this.props.value,
        leftPosition: oneStep * _this.props.value - oneStep * _this.props.min,
        oneStep: oneStep
      });
    });
    _defineProperty(_assertThisInitialized(_this), "rangeChange", function (e) {
      var newValue = e.target.value;
      _this.setState({
        value: newValue,
        leftPosition: _this.state.oneStep * newValue - _this.state.oneStep * _this.props.min
      });
      _this.props.getValue && _this.props.getValue(e.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "rangeFocus", function () {
      _this.setState({
        thumbActive: true,
        thumbHeight: "30px",
        thumbWidth: "30px",
        thumbTop: "-20px",
        thumbMarginLeft: "-15px"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "rangeMouseLeave", function () {
      var input = _this.inputRef.current;
      input.blur();
      _this.setState({
        thumbActive: false,
        thumbHeight: 0,
        thumbWidth: 0,
        thumbTop: "10px",
        thumbMarginLeft: "-6px"
      });
    });
    _this.state = {
      value: false,
      leftPosition: false,
      thumbActive: false,
      thumbHeight: 0,
      thumbWidth: 0,
      thumbTop: "10px",
      thumbMarginLeft: "-6px",
      input: "input",
      oneStep: ""
    };
    _this.inputRef = React.createRef();
    return _this;
  }
  _createClass(InputRange, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        formClassName = _this$props.formClassName,
        min = _this$props.min,
        max = _this$props.max,
        step = _this$props.step,
        Tag = _this$props.tag;
      var inputClass = classNames(className);
      var formClass = classNames("range-field", formClassName);
      var thumbClass = classNames("thumb", this.state.thumbActive ? "active" : false);
      return React.createElement(Tag, {
        className: formClass
      }, React.createElement("input", {
        ref: this.inputRef,
        className: inputClass,
        min: min,
        max: max,
        step: step,
        value: this.state.value,
        type: "range",
        onChange: this.rangeChange,
        onFocus: this.rangeFocus,
        onMouseLeave: this.rangeMouseLeave
      }), React.createElement("span", {
        className: thumbClass,
        style: {
          left: this.state.leftPosition,
          height: this.state.thumbHeight,
          width: this.state.thumbWidth,
          top: this.state.thumbTop,
          marginLeft: this.state.thumbMarginLeft
        }
      }, React.createElement("span", {
        className: "value"
      }, this.state.value)));
    }
  }]);
  return InputRange;
}(React.Component);
InputRange.propTypes = {
  className: propTypes.string,
  min: propTypes.number,
  max: propTypes.number,
  value: propTypes.number,
  getValue: propTypes.oneOfType([propTypes.func, propTypes.bool]),
  step: propTypes.number,
  tag: propTypes.oneOfType([propTypes.func, propTypes.string])
};
InputRange.defaultProps = {
  min: 0,
  max: 100,
  value: 50,
  getValue: false,
  tag: "div"
};
var InputSwitch = /*#__PURE__*/
function (_React$Component) {
  _inherits(InputSwitch, _React$Component);
  function InputSwitch(props) {
    var _this;
    _classCallCheck(this, InputSwitch);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputSwitch).call(this, props));
    _this.state = {
      value: false
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(InputSwitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        value: this.props.checked
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.checked !== this.state.value) {
        this.setState({
          value: this.props.checked
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        value: !this.state.value
      });
      this.props.getValue && this.props.getValue(event.target.checked);
      this.props.onChange && this.props.onChange(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        getValue = _this$props.getValue,
        labelLeft = _this$props.labelLeft,
        labelRight = _this$props.labelRight,
        onChange = _this$props.onChange,
        attributes = _objectWithoutProperties(_this$props, ["className", "checked", "disabled", "getValue", "labelLeft", "labelRight", "onChange"]);
      var classes = classNames("switch", className);
      return React.createElement("div", _extends({}, attributes, {
        className: classes
      }), React.createElement("label", null, labelLeft, React.createElement("input", {
        disabled: this.props.disabled,
        value: this.state.value,
        checked: this.state.value,
        onChange: this.handleChange,
        type: "checkbox"
      }), React.createElement("span", {
        className: "lever"
      }), labelRight));
    }
  }]);
  return InputSwitch;
}(React.Component);
InputSwitch.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  checked: propTypes.bool,
  getValue: propTypes.oneOfType([propTypes.func, propTypes.bool]),
  labelLeft: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object]),
  labelRight: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object]),
  onChange: propTypes.func
};
InputSwitch.defaultProps = {
  checked: false,
  getValue: false,
  labelLeft: "Off",
  labelRight: "On"
};
var css$c = ".mdb-lightbox .overlay {\n  height: 120vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: -100;\n}\n.mdb-lightbox .ui-controls {\n  width: 99vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  position: absolute;\n}\n.mdb-lightbox .ui-controls > * {\n  position: fixed;\n  z-index: 999999;\n}\n.mdb-lightbox .overlay.active {\n  z-index: 9999;\n  background-color: black;\n}\n\n.mdb-lightbox .next-img,\n.mdb-lightbox .prev-img {\n  transform-origin: center;\n}\n.mdb-lightbox .next-img {\n  left: 150% !important;\n}\n.mdb-lightbox .prev-img {\n  left: -50% !important;\n}\n\n.mdb-lightbox img:not(.zoom) {\n  transform-origin: top left;\n}\n/* transform: translate(-50%,-50%) scale(1) translate3d(0,0,0); */\n.mdb-lightbox img.zoom {\n  z-index: 9999;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1) translate3d(0, 0, 0);\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: text;\n  /* pointer-events: none; */\n  transform-origin: center;\n}\n\n.mdb-lightbox .mdb-lightbox figure img.zoom:hover {\n  opacity: 1;\n}\n\n.mdb-lightbox .block {\n  display: block;\n}\n\n.mdb-lightbox .pswp__button.lb-zoom-out {\n  background-position: -132px 0;\n}\n.mdb-lightbox .pswp__button.pswp__button--fs.fullscreen {\n  background-position: -44px 0;\n}\n\n.mdb-lightbox .arrow-container {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.mdb-lightbox .pswp__button--left,\n.mdb-lightbox .pswp__button--right {\n  width: 0px;\n  height: 0px;\n  margin-top: -100px;\n}\n";
styleInject(css$c);
var shallowEqual_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = shallowEqual;
  function shallowEqual(actual, expected) {
    const keys = Object.keys(expected);
    for (const key of keys) {
      if (actual[key] !== expected[key]) {
        return false;
      }
    }
    return true;
  }
});
unwrapExports(shallowEqual_1);
var generated = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isArrayExpression = isArrayExpression;
  exports.isAssignmentExpression = isAssignmentExpression;
  exports.isBinaryExpression = isBinaryExpression;
  exports.isInterpreterDirective = isInterpreterDirective;
  exports.isDirective = isDirective;
  exports.isDirectiveLiteral = isDirectiveLiteral;
  exports.isBlockStatement = isBlockStatement;
  exports.isBreakStatement = isBreakStatement;
  exports.isCallExpression = isCallExpression;
  exports.isCatchClause = isCatchClause;
  exports.isConditionalExpression = isConditionalExpression;
  exports.isContinueStatement = isContinueStatement;
  exports.isDebuggerStatement = isDebuggerStatement;
  exports.isDoWhileStatement = isDoWhileStatement;
  exports.isEmptyStatement = isEmptyStatement;
  exports.isExpressionStatement = isExpressionStatement;
  exports.isFile = isFile;
  exports.isForInStatement = isForInStatement;
  exports.isForStatement = isForStatement;
  exports.isFunctionDeclaration = isFunctionDeclaration;
  exports.isFunctionExpression = isFunctionExpression;
  exports.isIdentifier = isIdentifier;
  exports.isIfStatement = isIfStatement;
  exports.isLabeledStatement = isLabeledStatement;
  exports.isStringLiteral = isStringLiteral;
  exports.isNumericLiteral = isNumericLiteral;
  exports.isNullLiteral = isNullLiteral;
  exports.isBooleanLiteral = isBooleanLiteral;
  exports.isRegExpLiteral = isRegExpLiteral;
  exports.isLogicalExpression = isLogicalExpression;
  exports.isMemberExpression = isMemberExpression;
  exports.isNewExpression = isNewExpression;
  exports.isProgram = isProgram;
  exports.isObjectExpression = isObjectExpression;
  exports.isObjectMethod = isObjectMethod;
  exports.isObjectProperty = isObjectProperty;
  exports.isRestElement = isRestElement;
  exports.isReturnStatement = isReturnStatement;
  exports.isSequenceExpression = isSequenceExpression;
  exports.isSwitchCase = isSwitchCase;
  exports.isSwitchStatement = isSwitchStatement;
  exports.isThisExpression = isThisExpression;
  exports.isThrowStatement = isThrowStatement;
  exports.isTryStatement = isTryStatement;
  exports.isUnaryExpression = isUnaryExpression;
  exports.isUpdateExpression = isUpdateExpression;
  exports.isVariableDeclaration = isVariableDeclaration;
  exports.isVariableDeclarator = isVariableDeclarator;
  exports.isWhileStatement = isWhileStatement;
  exports.isWithStatement = isWithStatement;
  exports.isAssignmentPattern = isAssignmentPattern;
  exports.isArrayPattern = isArrayPattern;
  exports.isArrowFunctionExpression = isArrowFunctionExpression;
  exports.isClassBody = isClassBody;
  exports.isClassDeclaration = isClassDeclaration;
  exports.isClassExpression = isClassExpression;
  exports.isExportAllDeclaration = isExportAllDeclaration;
  exports.isExportDefaultDeclaration = isExportDefaultDeclaration;
  exports.isExportNamedDeclaration = isExportNamedDeclaration;
  exports.isExportSpecifier = isExportSpecifier;
  exports.isForOfStatement = isForOfStatement;
  exports.isImportDeclaration = isImportDeclaration;
  exports.isImportDefaultSpecifier = isImportDefaultSpecifier;
  exports.isImportNamespaceSpecifier = isImportNamespaceSpecifier;
  exports.isImportSpecifier = isImportSpecifier;
  exports.isMetaProperty = isMetaProperty;
  exports.isClassMethod = isClassMethod;
  exports.isObjectPattern = isObjectPattern;
  exports.isSpreadElement = isSpreadElement;
  exports.isSuper = isSuper;
  exports.isTaggedTemplateExpression = isTaggedTemplateExpression;
  exports.isTemplateElement = isTemplateElement;
  exports.isTemplateLiteral = isTemplateLiteral;
  exports.isYieldExpression = isYieldExpression;
  exports.isAnyTypeAnnotation = isAnyTypeAnnotation;
  exports.isArrayTypeAnnotation = isArrayTypeAnnotation;
  exports.isBooleanTypeAnnotation = isBooleanTypeAnnotation;
  exports.isBooleanLiteralTypeAnnotation = isBooleanLiteralTypeAnnotation;
  exports.isNullLiteralTypeAnnotation = isNullLiteralTypeAnnotation;
  exports.isClassImplements = isClassImplements;
  exports.isDeclareClass = isDeclareClass;
  exports.isDeclareFunction = isDeclareFunction;
  exports.isDeclareInterface = isDeclareInterface;
  exports.isDeclareModule = isDeclareModule;
  exports.isDeclareModuleExports = isDeclareModuleExports;
  exports.isDeclareTypeAlias = isDeclareTypeAlias;
  exports.isDeclareOpaqueType = isDeclareOpaqueType;
  exports.isDeclareVariable = isDeclareVariable;
  exports.isDeclareExportDeclaration = isDeclareExportDeclaration;
  exports.isDeclareExportAllDeclaration = isDeclareExportAllDeclaration;
  exports.isDeclaredPredicate = isDeclaredPredicate;
  exports.isExistsTypeAnnotation = isExistsTypeAnnotation;
  exports.isFunctionTypeAnnotation = isFunctionTypeAnnotation;
  exports.isFunctionTypeParam = isFunctionTypeParam;
  exports.isGenericTypeAnnotation = isGenericTypeAnnotation;
  exports.isInferredPredicate = isInferredPredicate;
  exports.isInterfaceExtends = isInterfaceExtends;
  exports.isInterfaceDeclaration = isInterfaceDeclaration;
  exports.isInterfaceTypeAnnotation = isInterfaceTypeAnnotation;
  exports.isIntersectionTypeAnnotation = isIntersectionTypeAnnotation;
  exports.isMixedTypeAnnotation = isMixedTypeAnnotation;
  exports.isEmptyTypeAnnotation = isEmptyTypeAnnotation;
  exports.isNullableTypeAnnotation = isNullableTypeAnnotation;
  exports.isNumberLiteralTypeAnnotation = isNumberLiteralTypeAnnotation;
  exports.isNumberTypeAnnotation = isNumberTypeAnnotation;
  exports.isObjectTypeAnnotation = isObjectTypeAnnotation;
  exports.isObjectTypeInternalSlot = isObjectTypeInternalSlot;
  exports.isObjectTypeCallProperty = isObjectTypeCallProperty;
  exports.isObjectTypeIndexer = isObjectTypeIndexer;
  exports.isObjectTypeProperty = isObjectTypeProperty;
  exports.isObjectTypeSpreadProperty = isObjectTypeSpreadProperty;
  exports.isOpaqueType = isOpaqueType;
  exports.isQualifiedTypeIdentifier = isQualifiedTypeIdentifier;
  exports.isStringLiteralTypeAnnotation = isStringLiteralTypeAnnotation;
  exports.isStringTypeAnnotation = isStringTypeAnnotation;
  exports.isThisTypeAnnotation = isThisTypeAnnotation;
  exports.isTupleTypeAnnotation = isTupleTypeAnnotation;
  exports.isTypeofTypeAnnotation = isTypeofTypeAnnotation;
  exports.isTypeAlias = isTypeAlias;
  exports.isTypeAnnotation = isTypeAnnotation;
  exports.isTypeCastExpression = isTypeCastExpression;
  exports.isTypeParameter = isTypeParameter;
  exports.isTypeParameterDeclaration = isTypeParameterDeclaration;
  exports.isTypeParameterInstantiation = isTypeParameterInstantiation;
  exports.isUnionTypeAnnotation = isUnionTypeAnnotation;
  exports.isVariance = isVariance;
  exports.isVoidTypeAnnotation = isVoidTypeAnnotation;
  exports.isJSXAttribute = isJSXAttribute;
  exports.isJSXClosingElement = isJSXClosingElement;
  exports.isJSXElement = isJSXElement;
  exports.isJSXEmptyExpression = isJSXEmptyExpression;
  exports.isJSXExpressionContainer = isJSXExpressionContainer;
  exports.isJSXSpreadChild = isJSXSpreadChild;
  exports.isJSXIdentifier = isJSXIdentifier;
  exports.isJSXMemberExpression = isJSXMemberExpression;
  exports.isJSXNamespacedName = isJSXNamespacedName;
  exports.isJSXOpeningElement = isJSXOpeningElement;
  exports.isJSXSpreadAttribute = isJSXSpreadAttribute;
  exports.isJSXText = isJSXText;
  exports.isJSXFragment = isJSXFragment;
  exports.isJSXOpeningFragment = isJSXOpeningFragment;
  exports.isJSXClosingFragment = isJSXClosingFragment;
  exports.isNoop = isNoop;
  exports.isParenthesizedExpression = isParenthesizedExpression;
  exports.isAwaitExpression = isAwaitExpression;
  exports.isBindExpression = isBindExpression;
  exports.isClassProperty = isClassProperty;
  exports.isOptionalMemberExpression = isOptionalMemberExpression;
  exports.isPipelineTopicExpression = isPipelineTopicExpression;
  exports.isPipelineBareFunction = isPipelineBareFunction;
  exports.isPipelinePrimaryTopicReference = isPipelinePrimaryTopicReference;
  exports.isOptionalCallExpression = isOptionalCallExpression;
  exports.isClassPrivateProperty = isClassPrivateProperty;
  exports.isClassPrivateMethod = isClassPrivateMethod;
  exports.isImport = isImport;
  exports.isDecorator = isDecorator;
  exports.isDoExpression = isDoExpression;
  exports.isExportDefaultSpecifier = isExportDefaultSpecifier;
  exports.isExportNamespaceSpecifier = isExportNamespaceSpecifier;
  exports.isPrivateName = isPrivateName;
  exports.isBigIntLiteral = isBigIntLiteral;
  exports.isTSParameterProperty = isTSParameterProperty;
  exports.isTSDeclareFunction = isTSDeclareFunction;
  exports.isTSDeclareMethod = isTSDeclareMethod;
  exports.isTSQualifiedName = isTSQualifiedName;
  exports.isTSCallSignatureDeclaration = isTSCallSignatureDeclaration;
  exports.isTSConstructSignatureDeclaration = isTSConstructSignatureDeclaration;
  exports.isTSPropertySignature = isTSPropertySignature;
  exports.isTSMethodSignature = isTSMethodSignature;
  exports.isTSIndexSignature = isTSIndexSignature;
  exports.isTSAnyKeyword = isTSAnyKeyword;
  exports.isTSUnknownKeyword = isTSUnknownKeyword;
  exports.isTSNumberKeyword = isTSNumberKeyword;
  exports.isTSObjectKeyword = isTSObjectKeyword;
  exports.isTSBooleanKeyword = isTSBooleanKeyword;
  exports.isTSStringKeyword = isTSStringKeyword;
  exports.isTSSymbolKeyword = isTSSymbolKeyword;
  exports.isTSVoidKeyword = isTSVoidKeyword;
  exports.isTSUndefinedKeyword = isTSUndefinedKeyword;
  exports.isTSNullKeyword = isTSNullKeyword;
  exports.isTSNeverKeyword = isTSNeverKeyword;
  exports.isTSThisType = isTSThisType;
  exports.isTSFunctionType = isTSFunctionType;
  exports.isTSConstructorType = isTSConstructorType;
  exports.isTSTypeReference = isTSTypeReference;
  exports.isTSTypePredicate = isTSTypePredicate;
  exports.isTSTypeQuery = isTSTypeQuery;
  exports.isTSTypeLiteral = isTSTypeLiteral;
  exports.isTSArrayType = isTSArrayType;
  exports.isTSTupleType = isTSTupleType;
  exports.isTSOptionalType = isTSOptionalType;
  exports.isTSRestType = isTSRestType;
  exports.isTSUnionType = isTSUnionType;
  exports.isTSIntersectionType = isTSIntersectionType;
  exports.isTSConditionalType = isTSConditionalType;
  exports.isTSInferType = isTSInferType;
  exports.isTSParenthesizedType = isTSParenthesizedType;
  exports.isTSTypeOperator = isTSTypeOperator;
  exports.isTSIndexedAccessType = isTSIndexedAccessType;
  exports.isTSMappedType = isTSMappedType;
  exports.isTSLiteralType = isTSLiteralType;
  exports.isTSExpressionWithTypeArguments = isTSExpressionWithTypeArguments;
  exports.isTSInterfaceDeclaration = isTSInterfaceDeclaration;
  exports.isTSInterfaceBody = isTSInterfaceBody;
  exports.isTSTypeAliasDeclaration = isTSTypeAliasDeclaration;
  exports.isTSAsExpression = isTSAsExpression;
  exports.isTSTypeAssertion = isTSTypeAssertion;
  exports.isTSEnumDeclaration = isTSEnumDeclaration;
  exports.isTSEnumMember = isTSEnumMember;
  exports.isTSModuleDeclaration = isTSModuleDeclaration;
  exports.isTSModuleBlock = isTSModuleBlock;
  exports.isTSImportType = isTSImportType;
  exports.isTSImportEqualsDeclaration = isTSImportEqualsDeclaration;
  exports.isTSExternalModuleReference = isTSExternalModuleReference;
  exports.isTSNonNullExpression = isTSNonNullExpression;
  exports.isTSExportAssignment = isTSExportAssignment;
  exports.isTSNamespaceExportDeclaration = isTSNamespaceExportDeclaration;
  exports.isTSTypeAnnotation = isTSTypeAnnotation;
  exports.isTSTypeParameterInstantiation = isTSTypeParameterInstantiation;
  exports.isTSTypeParameterDeclaration = isTSTypeParameterDeclaration;
  exports.isTSTypeParameter = isTSTypeParameter;
  exports.isExpression = isExpression;
  exports.isBinary = isBinary;
  exports.isScopable = isScopable;
  exports.isBlockParent = isBlockParent;
  exports.isBlock = isBlock;
  exports.isStatement = isStatement;
  exports.isTerminatorless = isTerminatorless;
  exports.isCompletionStatement = isCompletionStatement;
  exports.isConditional = isConditional;
  exports.isLoop = isLoop;
  exports.isWhile = isWhile;
  exports.isExpressionWrapper = isExpressionWrapper;
  exports.isFor = isFor;
  exports.isForXStatement = isForXStatement;
  exports.isFunction = isFunction;
  exports.isFunctionParent = isFunctionParent;
  exports.isPureish = isPureish;
  exports.isDeclaration = isDeclaration;
  exports.isPatternLike = isPatternLike;
  exports.isLVal = isLVal;
  exports.isTSEntityName = isTSEntityName;
  exports.isLiteral = isLiteral;
  exports.isImmutable = isImmutable;
  exports.isUserWhitespacable = isUserWhitespacable;
  exports.isMethod = isMethod;
  exports.isObjectMember = isObjectMember;
  exports.isProperty = isProperty;
  exports.isUnaryLike = isUnaryLike;
  exports.isPattern = isPattern;
  exports.isClass = isClass;
  exports.isModuleDeclaration = isModuleDeclaration;
  exports.isExportDeclaration = isExportDeclaration;
  exports.isModuleSpecifier = isModuleSpecifier;
  exports.isFlow = isFlow;
  exports.isFlowType = isFlowType;
  exports.isFlowBaseAnnotation = isFlowBaseAnnotation;
  exports.isFlowDeclaration = isFlowDeclaration;
  exports.isFlowPredicate = isFlowPredicate;
  exports.isJSX = isJSX;
  exports.isPrivate = isPrivate;
  exports.isTSTypeElement = isTSTypeElement;
  exports.isTSType = isTSType;
  exports.isNumberLiteral = isNumberLiteral;
  exports.isRegexLiteral = isRegexLiteral;
  exports.isRestProperty = isRestProperty;
  exports.isSpreadProperty = isSpreadProperty;
  var _shallowEqual = _interopRequireDefault(shallowEqual_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function isArrayExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ArrayExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isAssignmentExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "AssignmentExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBinaryExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BinaryExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isInterpreterDirective(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "InterpreterDirective") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDirective(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Directive") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDirectiveLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DirectiveLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBlockStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BlockStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBreakStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BreakStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isCallExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "CallExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isCatchClause(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "CatchClause") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isConditionalExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ConditionalExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isContinueStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ContinueStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDebuggerStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DebuggerStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDoWhileStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DoWhileStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isEmptyStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "EmptyStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExpressionStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExpressionStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFile(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "File") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isForInStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ForInStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isForStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ForStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFunctionDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FunctionDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFunctionExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FunctionExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isIdentifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Identifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isIfStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "IfStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isLabeledStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "LabeledStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isStringLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "StringLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNumericLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NumericLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNullLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NullLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBooleanLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BooleanLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isRegExpLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "RegExpLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isLogicalExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "LogicalExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isMemberExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "MemberExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNewExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NewExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isProgram(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Program") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectMethod(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectMethod") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isRestElement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "RestElement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isReturnStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ReturnStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isSequenceExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "SequenceExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isSwitchCase(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "SwitchCase") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isSwitchStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "SwitchStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isThisExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ThisExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isThrowStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ThrowStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTryStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TryStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isUnaryExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "UnaryExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isUpdateExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "UpdateExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isVariableDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "VariableDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isVariableDeclarator(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "VariableDeclarator") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isWhileStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "WhileStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isWithStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "WithStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isAssignmentPattern(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "AssignmentPattern") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isArrayPattern(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ArrayPattern") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isArrowFunctionExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ArrowFunctionExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassBody(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassBody") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExportAllDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExportAllDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExportDefaultDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExportDefaultDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExportNamedDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExportNamedDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExportSpecifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExportSpecifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isForOfStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ForOfStatement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isImportDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ImportDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isImportDefaultSpecifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ImportDefaultSpecifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isImportNamespaceSpecifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ImportNamespaceSpecifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isImportSpecifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ImportSpecifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isMetaProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "MetaProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassMethod(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassMethod") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectPattern(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectPattern") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isSpreadElement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "SpreadElement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isSuper(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Super") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTaggedTemplateExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TaggedTemplateExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTemplateElement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TemplateElement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTemplateLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TemplateLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isYieldExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "YieldExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isAnyTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "AnyTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isArrayTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ArrayTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBooleanTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BooleanTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBooleanLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BooleanLiteralTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNullLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NullLiteralTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassImplements(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassImplements") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareClass(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareClass") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareFunction(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareFunction") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareInterface(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareInterface") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareModule(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareModule") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareModuleExports(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareModuleExports") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareTypeAlias(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareTypeAlias") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareOpaqueType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareOpaqueType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareVariable(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareVariable") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareExportDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareExportDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclareExportAllDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclareExportAllDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclaredPredicate(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DeclaredPredicate") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExistsTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExistsTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFunctionTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FunctionTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFunctionTypeParam(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FunctionTypeParam") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isGenericTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "GenericTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isInferredPredicate(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "InferredPredicate") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isInterfaceExtends(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "InterfaceExtends") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isInterfaceDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "InterfaceDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isInterfaceTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "InterfaceTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isIntersectionTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "IntersectionTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isMixedTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "MixedTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isEmptyTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "EmptyTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNullableTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NullableTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNumberLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NumberLiteralTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNumberTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NumberTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectTypeInternalSlot(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectTypeInternalSlot") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectTypeCallProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectTypeCallProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectTypeIndexer(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectTypeIndexer") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectTypeProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectTypeProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectTypeSpreadProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectTypeSpreadProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isOpaqueType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "OpaqueType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isQualifiedTypeIdentifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "QualifiedTypeIdentifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isStringLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "StringLiteralTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isStringTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "StringTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isThisTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ThisTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTupleTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TupleTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTypeofTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TypeofTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTypeAlias(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TypeAlias") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTypeCastExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TypeCastExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTypeParameter(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TypeParameter") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTypeParameterDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TypeParameterDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTypeParameterInstantiation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TypeParameterInstantiation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isUnionTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "UnionTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isVariance(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Variance") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isVoidTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "VoidTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXAttribute(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXAttribute") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXClosingElement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXClosingElement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXElement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXElement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXEmptyExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXEmptyExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXExpressionContainer(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXExpressionContainer") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXSpreadChild(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXSpreadChild") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXIdentifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXIdentifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXMemberExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXMemberExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXNamespacedName(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXNamespacedName") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXOpeningElement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXOpeningElement") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXSpreadAttribute(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXSpreadAttribute") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXText(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXText") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXFragment(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXFragment") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXOpeningFragment(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXOpeningFragment") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSXClosingFragment(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSXClosingFragment") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNoop(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Noop") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isParenthesizedExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ParenthesizedExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isAwaitExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "AwaitExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBindExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BindExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isOptionalMemberExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "OptionalMemberExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPipelineTopicExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "PipelineTopicExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPipelineBareFunction(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "PipelineBareFunction") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPipelinePrimaryTopicReference(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "PipelinePrimaryTopicReference") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isOptionalCallExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "OptionalCallExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassPrivateProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassPrivateProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClassPrivateMethod(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ClassPrivateMethod") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isImport(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Import") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDecorator(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Decorator") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDoExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "DoExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExportDefaultSpecifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExportDefaultSpecifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExportNamespaceSpecifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExportNamespaceSpecifier") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPrivateName(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "PrivateName") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBigIntLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BigIntLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSParameterProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSParameterProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSDeclareFunction(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSDeclareFunction") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSDeclareMethod(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSDeclareMethod") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSQualifiedName(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSQualifiedName") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSCallSignatureDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSCallSignatureDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSConstructSignatureDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSConstructSignatureDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSPropertySignature(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSPropertySignature") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSMethodSignature(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSMethodSignature") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSIndexSignature(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSIndexSignature") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSAnyKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSAnyKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSUnknownKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSUnknownKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSNumberKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSNumberKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSObjectKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSObjectKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSBooleanKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSBooleanKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSStringKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSStringKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSSymbolKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSSymbolKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSVoidKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSVoidKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSUndefinedKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSUndefinedKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSNullKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSNullKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSNeverKeyword(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSNeverKeyword") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSThisType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSThisType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSFunctionType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSFunctionType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSConstructorType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSConstructorType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeReference(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeReference") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypePredicate(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypePredicate") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeQuery(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeQuery") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSArrayType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSArrayType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTupleType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTupleType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSOptionalType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSOptionalType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSRestType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSRestType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSUnionType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSUnionType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSIntersectionType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSIntersectionType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSConditionalType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSConditionalType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSInferType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSInferType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSParenthesizedType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSParenthesizedType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeOperator(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeOperator") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSIndexedAccessType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSIndexedAccessType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSMappedType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSMappedType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSLiteralType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSLiteralType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSExpressionWithTypeArguments(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSExpressionWithTypeArguments") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSInterfaceDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSInterfaceDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSInterfaceBody(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSInterfaceBody") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeAliasDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeAliasDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSAsExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSAsExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeAssertion(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeAssertion") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSEnumDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSEnumDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSEnumMember(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSEnumMember") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSModuleDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSModuleDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSModuleBlock(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSModuleBlock") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSImportType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSImportType") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSImportEqualsDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSImportEqualsDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSExternalModuleReference(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSExternalModuleReference") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSNonNullExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSNonNullExpression") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSExportAssignment(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSExportAssignment") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSNamespaceExportDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSNamespaceExportDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeAnnotation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeParameterInstantiation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeParameterInstantiation") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeParameterDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeParameterDeclaration") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeParameter(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeParameter") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExpression(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Expression" || "ArrayExpression" === nodeType || "AssignmentExpression" === nodeType || "BinaryExpression" === nodeType || "CallExpression" === nodeType || "ConditionalExpression" === nodeType || "FunctionExpression" === nodeType || "Identifier" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "LogicalExpression" === nodeType || "MemberExpression" === nodeType || "NewExpression" === nodeType || "ObjectExpression" === nodeType || "SequenceExpression" === nodeType || "ThisExpression" === nodeType || "UnaryExpression" === nodeType || "UpdateExpression" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassExpression" === nodeType || "MetaProperty" === nodeType || "Super" === nodeType || "TaggedTemplateExpression" === nodeType || "TemplateLiteral" === nodeType || "YieldExpression" === nodeType || "TypeCastExpression" === nodeType || "JSXElement" === nodeType || "JSXFragment" === nodeType || "ParenthesizedExpression" === nodeType || "AwaitExpression" === nodeType || "BindExpression" === nodeType || "OptionalMemberExpression" === nodeType || "PipelinePrimaryTopicReference" === nodeType || "OptionalCallExpression" === nodeType || "Import" === nodeType || "DoExpression" === nodeType || "BigIntLiteral" === nodeType || "TSAsExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSNonNullExpression" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBinary(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Binary" || "BinaryExpression" === nodeType || "LogicalExpression" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isScopable(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Scopable" || "BlockStatement" === nodeType || "CatchClause" === nodeType || "DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Program" === nodeType || "ObjectMethod" === nodeType || "SwitchStatement" === nodeType || "WhileStatement" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassDeclaration" === nodeType || "ClassExpression" === nodeType || "ForOfStatement" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBlockParent(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "BlockParent" || "BlockStatement" === nodeType || "CatchClause" === nodeType || "DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Program" === nodeType || "ObjectMethod" === nodeType || "SwitchStatement" === nodeType || "WhileStatement" === nodeType || "ArrowFunctionExpression" === nodeType || "ForOfStatement" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isBlock(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Block" || "BlockStatement" === nodeType || "Program" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Statement" || "BlockStatement" === nodeType || "BreakStatement" === nodeType || "ContinueStatement" === nodeType || "DebuggerStatement" === nodeType || "DoWhileStatement" === nodeType || "EmptyStatement" === nodeType || "ExpressionStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "IfStatement" === nodeType || "LabeledStatement" === nodeType || "ReturnStatement" === nodeType || "SwitchStatement" === nodeType || "ThrowStatement" === nodeType || "TryStatement" === nodeType || "VariableDeclaration" === nodeType || "WhileStatement" === nodeType || "WithStatement" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ForOfStatement" === nodeType || "ImportDeclaration" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType || "TSDeclareFunction" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSEnumDeclaration" === nodeType || "TSModuleDeclaration" === nodeType || "TSImportEqualsDeclaration" === nodeType || "TSExportAssignment" === nodeType || "TSNamespaceExportDeclaration" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTerminatorless(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Terminatorless" || "BreakStatement" === nodeType || "ContinueStatement" === nodeType || "ReturnStatement" === nodeType || "ThrowStatement" === nodeType || "YieldExpression" === nodeType || "AwaitExpression" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isCompletionStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "CompletionStatement" || "BreakStatement" === nodeType || "ContinueStatement" === nodeType || "ReturnStatement" === nodeType || "ThrowStatement" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isConditional(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Conditional" || "ConditionalExpression" === nodeType || "IfStatement" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isLoop(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Loop" || "DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "WhileStatement" === nodeType || "ForOfStatement" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isWhile(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "While" || "DoWhileStatement" === nodeType || "WhileStatement" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExpressionWrapper(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExpressionWrapper" || "ExpressionStatement" === nodeType || "TypeCastExpression" === nodeType || "ParenthesizedExpression" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFor(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "For" || "ForInStatement" === nodeType || "ForStatement" === nodeType || "ForOfStatement" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isForXStatement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ForXStatement" || "ForInStatement" === nodeType || "ForOfStatement" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFunction(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Function" || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "ObjectMethod" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFunctionParent(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FunctionParent" || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "ObjectMethod" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPureish(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Pureish" || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassDeclaration" === nodeType || "ClassExpression" === nodeType || "BigIntLiteral" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Declaration" || "FunctionDeclaration" === nodeType || "VariableDeclaration" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ImportDeclaration" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType || "TSDeclareFunction" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSEnumDeclaration" === nodeType || "TSModuleDeclaration" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPatternLike(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "PatternLike" || "Identifier" === nodeType || "RestElement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isLVal(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "LVal" || "Identifier" === nodeType || "MemberExpression" === nodeType || "RestElement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType || "TSParameterProperty" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSEntityName(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSEntityName" || "Identifier" === nodeType || "TSQualifiedName" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isLiteral(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Literal" || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "TemplateLiteral" === nodeType || "BigIntLiteral" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isImmutable(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Immutable" || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "JSXAttribute" === nodeType || "JSXClosingElement" === nodeType || "JSXElement" === nodeType || "JSXExpressionContainer" === nodeType || "JSXSpreadChild" === nodeType || "JSXOpeningElement" === nodeType || "JSXText" === nodeType || "JSXFragment" === nodeType || "JSXOpeningFragment" === nodeType || "JSXClosingFragment" === nodeType || "BigIntLiteral" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isUserWhitespacable(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "UserWhitespacable" || "ObjectMethod" === nodeType || "ObjectProperty" === nodeType || "ObjectTypeInternalSlot" === nodeType || "ObjectTypeCallProperty" === nodeType || "ObjectTypeIndexer" === nodeType || "ObjectTypeProperty" === nodeType || "ObjectTypeSpreadProperty" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isMethod(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Method" || "ObjectMethod" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isObjectMember(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ObjectMember" || "ObjectMethod" === nodeType || "ObjectProperty" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isProperty(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Property" || "ObjectProperty" === nodeType || "ClassProperty" === nodeType || "ClassPrivateProperty" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isUnaryLike(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "UnaryLike" || "UnaryExpression" === nodeType || "SpreadElement" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPattern(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Pattern" || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isClass(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Class" || "ClassDeclaration" === nodeType || "ClassExpression" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isModuleDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ModuleDeclaration" || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ImportDeclaration" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isExportDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ExportDeclaration" || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isModuleSpecifier(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "ModuleSpecifier" || "ExportSpecifier" === nodeType || "ImportDefaultSpecifier" === nodeType || "ImportNamespaceSpecifier" === nodeType || "ImportSpecifier" === nodeType || "ExportDefaultSpecifier" === nodeType || "ExportNamespaceSpecifier" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFlow(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Flow" || "AnyTypeAnnotation" === nodeType || "ArrayTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "BooleanLiteralTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "ClassImplements" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "DeclaredPredicate" === nodeType || "ExistsTypeAnnotation" === nodeType || "FunctionTypeAnnotation" === nodeType || "FunctionTypeParam" === nodeType || "GenericTypeAnnotation" === nodeType || "InferredPredicate" === nodeType || "InterfaceExtends" === nodeType || "InterfaceDeclaration" === nodeType || "InterfaceTypeAnnotation" === nodeType || "IntersectionTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NullableTypeAnnotation" === nodeType || "NumberLiteralTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "ObjectTypeAnnotation" === nodeType || "ObjectTypeInternalSlot" === nodeType || "ObjectTypeCallProperty" === nodeType || "ObjectTypeIndexer" === nodeType || "ObjectTypeProperty" === nodeType || "ObjectTypeSpreadProperty" === nodeType || "OpaqueType" === nodeType || "QualifiedTypeIdentifier" === nodeType || "StringLiteralTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "TupleTypeAnnotation" === nodeType || "TypeofTypeAnnotation" === nodeType || "TypeAlias" === nodeType || "TypeAnnotation" === nodeType || "TypeCastExpression" === nodeType || "TypeParameter" === nodeType || "TypeParameterDeclaration" === nodeType || "TypeParameterInstantiation" === nodeType || "UnionTypeAnnotation" === nodeType || "Variance" === nodeType || "VoidTypeAnnotation" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFlowType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FlowType" || "AnyTypeAnnotation" === nodeType || "ArrayTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "BooleanLiteralTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "ExistsTypeAnnotation" === nodeType || "FunctionTypeAnnotation" === nodeType || "GenericTypeAnnotation" === nodeType || "InterfaceTypeAnnotation" === nodeType || "IntersectionTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NullableTypeAnnotation" === nodeType || "NumberLiteralTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "ObjectTypeAnnotation" === nodeType || "StringLiteralTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "TupleTypeAnnotation" === nodeType || "TypeofTypeAnnotation" === nodeType || "UnionTypeAnnotation" === nodeType || "VoidTypeAnnotation" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFlowBaseAnnotation(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FlowBaseAnnotation" || "AnyTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "VoidTypeAnnotation" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFlowDeclaration(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FlowDeclaration" || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isFlowPredicate(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "FlowPredicate" || "DeclaredPredicate" === nodeType || "InferredPredicate" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isJSX(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "JSX" || "JSXAttribute" === nodeType || "JSXClosingElement" === nodeType || "JSXElement" === nodeType || "JSXEmptyExpression" === nodeType || "JSXExpressionContainer" === nodeType || "JSXSpreadChild" === nodeType || "JSXIdentifier" === nodeType || "JSXMemberExpression" === nodeType || "JSXNamespacedName" === nodeType || "JSXOpeningElement" === nodeType || "JSXSpreadAttribute" === nodeType || "JSXText" === nodeType || "JSXFragment" === nodeType || "JSXOpeningFragment" === nodeType || "JSXClosingFragment" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isPrivate(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "Private" || "ClassPrivateProperty" === nodeType || "ClassPrivateMethod" === nodeType || "PrivateName" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSTypeElement(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSTypeElement" || "TSCallSignatureDeclaration" === nodeType || "TSConstructSignatureDeclaration" === nodeType || "TSPropertySignature" === nodeType || "TSMethodSignature" === nodeType || "TSIndexSignature" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isTSType(node, opts) {
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "TSType" || "TSAnyKeyword" === nodeType || "TSUnknownKeyword" === nodeType || "TSNumberKeyword" === nodeType || "TSObjectKeyword" === nodeType || "TSBooleanKeyword" === nodeType || "TSStringKeyword" === nodeType || "TSSymbolKeyword" === nodeType || "TSVoidKeyword" === nodeType || "TSUndefinedKeyword" === nodeType || "TSNullKeyword" === nodeType || "TSNeverKeyword" === nodeType || "TSThisType" === nodeType || "TSFunctionType" === nodeType || "TSConstructorType" === nodeType || "TSTypeReference" === nodeType || "TSTypePredicate" === nodeType || "TSTypeQuery" === nodeType || "TSTypeLiteral" === nodeType || "TSArrayType" === nodeType || "TSTupleType" === nodeType || "TSOptionalType" === nodeType || "TSRestType" === nodeType || "TSUnionType" === nodeType || "TSIntersectionType" === nodeType || "TSConditionalType" === nodeType || "TSInferType" === nodeType || "TSParenthesizedType" === nodeType || "TSTypeOperator" === nodeType || "TSIndexedAccessType" === nodeType || "TSMappedType" === nodeType || "TSLiteralType" === nodeType || "TSExpressionWithTypeArguments" === nodeType || "TSImportType" === nodeType) {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isNumberLiteral(node, opts) {
    console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "NumberLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isRegexLiteral(node, opts) {
    console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "RegexLiteral") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isRestProperty(node, opts) {
    console.trace("The node type RestProperty has been renamed to RestElement");
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "RestProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
  function isSpreadProperty(node, opts) {
    console.trace("The node type SpreadProperty has been renamed to SpreadElement");
    if (!node) return false;
    const nodeType = node.type;
    if (nodeType === "SpreadProperty") {
      if (typeof opts === "undefined") {
        return true;
      } else {
        return (0, _shallowEqual.default)(node, opts);
      }
    }
    return false;
  }
});
unwrapExports(generated);
var generated_1 = generated.isArrayExpression;
var generated_2 = generated.isAssignmentExpression;
var generated_3 = generated.isBinaryExpression;
var generated_4 = generated.isInterpreterDirective;
var generated_5 = generated.isDirective;
var generated_6 = generated.isDirectiveLiteral;
var generated_7 = generated.isBlockStatement;
var generated_8 = generated.isBreakStatement;
var generated_9 = generated.isCallExpression;
var generated_10 = generated.isCatchClause;
var generated_11 = generated.isConditionalExpression;
var generated_12 = generated.isContinueStatement;
var generated_13 = generated.isDebuggerStatement;
var generated_14 = generated.isDoWhileStatement;
var generated_15 = generated.isEmptyStatement;
var generated_16 = generated.isExpressionStatement;
var generated_17 = generated.isFile;
var generated_18 = generated.isForInStatement;
var generated_19 = generated.isForStatement;
var generated_20 = generated.isFunctionDeclaration;
var generated_21 = generated.isFunctionExpression;
var generated_22 = generated.isIdentifier;
var generated_23 = generated.isIfStatement;
var generated_24 = generated.isLabeledStatement;
var generated_25 = generated.isStringLiteral;
var generated_26 = generated.isNumericLiteral;
var generated_27 = generated.isNullLiteral;
var generated_28 = generated.isBooleanLiteral;
var generated_29 = generated.isRegExpLiteral;
var generated_30 = generated.isLogicalExpression;
var generated_31 = generated.isMemberExpression;
var generated_32 = generated.isNewExpression;
var generated_33 = generated.isProgram;
var generated_34 = generated.isObjectExpression;
var generated_35 = generated.isObjectMethod;
var generated_36 = generated.isObjectProperty;
var generated_37 = generated.isRestElement;
var generated_38 = generated.isReturnStatement;
var generated_39 = generated.isSequenceExpression;
var generated_40 = generated.isSwitchCase;
var generated_41 = generated.isSwitchStatement;
var generated_42 = generated.isThisExpression;
var generated_43 = generated.isThrowStatement;
var generated_44 = generated.isTryStatement;
var generated_45 = generated.isUnaryExpression;
var generated_46 = generated.isUpdateExpression;
var generated_47 = generated.isVariableDeclaration;
var generated_48 = generated.isVariableDeclarator;
var generated_49 = generated.isWhileStatement;
var generated_50 = generated.isWithStatement;
var generated_51 = generated.isAssignmentPattern;
var generated_52 = generated.isArrayPattern;
var generated_53 = generated.isArrowFunctionExpression;
var generated_54 = generated.isClassBody;
var generated_55 = generated.isClassDeclaration;
var generated_56 = generated.isClassExpression;
var generated_57 = generated.isExportAllDeclaration;
var generated_58 = generated.isExportDefaultDeclaration;
var generated_59 = generated.isExportNamedDeclaration;
var generated_60 = generated.isExportSpecifier;
var generated_61 = generated.isForOfStatement;
var generated_62 = generated.isImportDeclaration;
var generated_63 = generated.isImportDefaultSpecifier;
var generated_64 = generated.isImportNamespaceSpecifier;
var generated_65 = generated.isImportSpecifier;
var generated_66 = generated.isMetaProperty;
var generated_67 = generated.isClassMethod;
var generated_68 = generated.isObjectPattern;
var generated_69 = generated.isSpreadElement;
var generated_70 = generated.isSuper;
var generated_71 = generated.isTaggedTemplateExpression;
var generated_72 = generated.isTemplateElement;
var generated_73 = generated.isTemplateLiteral;
var generated_74 = generated.isYieldExpression;
var generated_75 = generated.isAnyTypeAnnotation;
var generated_76 = generated.isArrayTypeAnnotation;
var generated_77 = generated.isBooleanTypeAnnotation;
var generated_78 = generated.isBooleanLiteralTypeAnnotation;
var generated_79 = generated.isNullLiteralTypeAnnotation;
var generated_80 = generated.isClassImplements;
var generated_81 = generated.isDeclareClass;
var generated_82 = generated.isDeclareFunction;
var generated_83 = generated.isDeclareInterface;
var generated_84 = generated.isDeclareModule;
var generated_85 = generated.isDeclareModuleExports;
var generated_86 = generated.isDeclareTypeAlias;
var generated_87 = generated.isDeclareOpaqueType;
var generated_88 = generated.isDeclareVariable;
var generated_89 = generated.isDeclareExportDeclaration;
var generated_90 = generated.isDeclareExportAllDeclaration;
var generated_91 = generated.isDeclaredPredicate;
var generated_92 = generated.isExistsTypeAnnotation;
var generated_93 = generated.isFunctionTypeAnnotation;
var generated_94 = generated.isFunctionTypeParam;
var generated_95 = generated.isGenericTypeAnnotation;
var generated_96 = generated.isInferredPredicate;
var generated_97 = generated.isInterfaceExtends;
var generated_98 = generated.isInterfaceDeclaration;
var generated_99 = generated.isInterfaceTypeAnnotation;
var generated_100 = generated.isIntersectionTypeAnnotation;
var generated_101 = generated.isMixedTypeAnnotation;
var generated_102 = generated.isEmptyTypeAnnotation;
var generated_103 = generated.isNullableTypeAnnotation;
var generated_104 = generated.isNumberLiteralTypeAnnotation;
var generated_105 = generated.isNumberTypeAnnotation;
var generated_106 = generated.isObjectTypeAnnotation;
var generated_107 = generated.isObjectTypeInternalSlot;
var generated_108 = generated.isObjectTypeCallProperty;
var generated_109 = generated.isObjectTypeIndexer;
var generated_110 = generated.isObjectTypeProperty;
var generated_111 = generated.isObjectTypeSpreadProperty;
var generated_112 = generated.isOpaqueType;
var generated_113 = generated.isQualifiedTypeIdentifier;
var generated_114 = generated.isStringLiteralTypeAnnotation;
var generated_115 = generated.isStringTypeAnnotation;
var generated_116 = generated.isThisTypeAnnotation;
var generated_117 = generated.isTupleTypeAnnotation;
var generated_118 = generated.isTypeofTypeAnnotation;
var generated_119 = generated.isTypeAlias;
var generated_120 = generated.isTypeAnnotation;
var generated_121 = generated.isTypeCastExpression;
var generated_122 = generated.isTypeParameter;
var generated_123 = generated.isTypeParameterDeclaration;
var generated_124 = generated.isTypeParameterInstantiation;
var generated_125 = generated.isUnionTypeAnnotation;
var generated_126 = generated.isVariance;
var generated_127 = generated.isVoidTypeAnnotation;
var generated_128 = generated.isJSXAttribute;
var generated_129 = generated.isJSXClosingElement;
var generated_130 = generated.isJSXElement;
var generated_131 = generated.isJSXEmptyExpression;
var generated_132 = generated.isJSXExpressionContainer;
var generated_133 = generated.isJSXSpreadChild;
var generated_134 = generated.isJSXIdentifier;
var generated_135 = generated.isJSXMemberExpression;
var generated_136 = generated.isJSXNamespacedName;
var generated_137 = generated.isJSXOpeningElement;
var generated_138 = generated.isJSXSpreadAttribute;
var generated_139 = generated.isJSXText;
var generated_140 = generated.isJSXFragment;
var generated_141 = generated.isJSXOpeningFragment;
var generated_142 = generated.isJSXClosingFragment;
var generated_143 = generated.isNoop;
var generated_144 = generated.isParenthesizedExpression;
var generated_145 = generated.isAwaitExpression;
var generated_146 = generated.isBindExpression;
var generated_147 = generated.isClassProperty;
var generated_148 = generated.isOptionalMemberExpression;
var generated_149 = generated.isPipelineTopicExpression;
var generated_150 = generated.isPipelineBareFunction;
var generated_151 = generated.isPipelinePrimaryTopicReference;
var generated_152 = generated.isOptionalCallExpression;
var generated_153 = generated.isClassPrivateProperty;
var generated_154 = generated.isClassPrivateMethod;
var generated_155 = generated.isImport;
var generated_156 = generated.isDecorator;
var generated_157 = generated.isDoExpression;
var generated_158 = generated.isExportDefaultSpecifier;
var generated_159 = generated.isExportNamespaceSpecifier;
var generated_160 = generated.isPrivateName;
var generated_161 = generated.isBigIntLiteral;
var generated_162 = generated.isTSParameterProperty;
var generated_163 = generated.isTSDeclareFunction;
var generated_164 = generated.isTSDeclareMethod;
var generated_165 = generated.isTSQualifiedName;
var generated_166 = generated.isTSCallSignatureDeclaration;
var generated_167 = generated.isTSConstructSignatureDeclaration;
var generated_168 = generated.isTSPropertySignature;
var generated_169 = generated.isTSMethodSignature;
var generated_170 = generated.isTSIndexSignature;
var generated_171 = generated.isTSAnyKeyword;
var generated_172 = generated.isTSUnknownKeyword;
var generated_173 = generated.isTSNumberKeyword;
var generated_174 = generated.isTSObjectKeyword;
var generated_175 = generated.isTSBooleanKeyword;
var generated_176 = generated.isTSStringKeyword;
var generated_177 = generated.isTSSymbolKeyword;
var generated_178 = generated.isTSVoidKeyword;
var generated_179 = generated.isTSUndefinedKeyword;
var generated_180 = generated.isTSNullKeyword;
var generated_181 = generated.isTSNeverKeyword;
var generated_182 = generated.isTSThisType;
var generated_183 = generated.isTSFunctionType;
var generated_184 = generated.isTSConstructorType;
var generated_185 = generated.isTSTypeReference;
var generated_186 = generated.isTSTypePredicate;
var generated_187 = generated.isTSTypeQuery;
var generated_188 = generated.isTSTypeLiteral;
var generated_189 = generated.isTSArrayType;
var generated_190 = generated.isTSTupleType;
var generated_191 = generated.isTSOptionalType;
var generated_192 = generated.isTSRestType;
var generated_193 = generated.isTSUnionType;
var generated_194 = generated.isTSIntersectionType;
var generated_195 = generated.isTSConditionalType;
var generated_196 = generated.isTSInferType;
var generated_197 = generated.isTSParenthesizedType;
var generated_198 = generated.isTSTypeOperator;
var generated_199 = generated.isTSIndexedAccessType;
var generated_200 = generated.isTSMappedType;
var generated_201 = generated.isTSLiteralType;
var generated_202 = generated.isTSExpressionWithTypeArguments;
var generated_203 = generated.isTSInterfaceDeclaration;
var generated_204 = generated.isTSInterfaceBody;
var generated_205 = generated.isTSTypeAliasDeclaration;
var generated_206 = generated.isTSAsExpression;
var generated_207 = generated.isTSTypeAssertion;
var generated_208 = generated.isTSEnumDeclaration;
var generated_209 = generated.isTSEnumMember;
var generated_210 = generated.isTSModuleDeclaration;
var generated_211 = generated.isTSModuleBlock;
var generated_212 = generated.isTSImportType;
var generated_213 = generated.isTSImportEqualsDeclaration;
var generated_214 = generated.isTSExternalModuleReference;
var generated_215 = generated.isTSNonNullExpression;
var generated_216 = generated.isTSExportAssignment;
var generated_217 = generated.isTSNamespaceExportDeclaration;
var generated_218 = generated.isTSTypeAnnotation;
var generated_219 = generated.isTSTypeParameterInstantiation;
var generated_220 = generated.isTSTypeParameterDeclaration;
var generated_221 = generated.isTSTypeParameter;
var generated_222 = generated.isExpression;
var generated_223 = generated.isBinary;
var generated_224 = generated.isScopable;
var generated_225 = generated.isBlockParent;
var generated_226 = generated.isBlock;
var generated_227 = generated.isStatement;
var generated_228 = generated.isTerminatorless;
var generated_229 = generated.isCompletionStatement;
var generated_230 = generated.isConditional;
var generated_231 = generated.isLoop;
var generated_232 = generated.isWhile;
var generated_233 = generated.isExpressionWrapper;
var generated_234 = generated.isFor;
var generated_235 = generated.isForXStatement;
var generated_236 = generated.isFunction;
var generated_237 = generated.isFunctionParent;
var generated_238 = generated.isPureish;
var generated_239 = generated.isDeclaration;
var generated_240 = generated.isPatternLike;
var generated_241 = generated.isLVal;
var generated_242 = generated.isTSEntityName;
var generated_243 = generated.isLiteral;
var generated_244 = generated.isImmutable;
var generated_245 = generated.isUserWhitespacable;
var generated_246 = generated.isMethod;
var generated_247 = generated.isObjectMember;
var generated_248 = generated.isProperty;
var generated_249 = generated.isUnaryLike;
var generated_250 = generated.isPattern;
var generated_251 = generated.isClass;
var generated_252 = generated.isModuleDeclaration;
var generated_253 = generated.isExportDeclaration;
var generated_254 = generated.isModuleSpecifier;
var generated_255 = generated.isFlow;
var generated_256 = generated.isFlowType;
var generated_257 = generated.isFlowBaseAnnotation;
var generated_258 = generated.isFlowDeclaration;
var generated_259 = generated.isFlowPredicate;
var generated_260 = generated.isJSX;
var generated_261 = generated.isPrivate;
var generated_262 = generated.isTSTypeElement;
var generated_263 = generated.isTSType;
var generated_264 = generated.isNumberLiteral;
var generated_265 = generated.isRegexLiteral;
var generated_266 = generated.isRestProperty;
var generated_267 = generated.isSpreadProperty;
var matchesPattern_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = matchesPattern;
  function matchesPattern(member, match, allowPartial) {
    if (!(0, generated.isMemberExpression)(member)) return false;
    const parts = Array.isArray(match) ? match : match.split(".");
    const nodes = [];
    let node;
    for (node = member; (0, generated.isMemberExpression)(node); node = node.object) {
      nodes.push(node.property);
    }
    nodes.push(node);
    if (nodes.length < parts.length) return false;
    if (!allowPartial && nodes.length > parts.length) return false;
    for (let i = 0, j = nodes.length - 1; i < parts.length; i++, j--) {
      const node = nodes[j];
      let value;
      if ((0, generated.isIdentifier)(node)) {
        value = node.name;
      } else if ((0, generated.isStringLiteral)(node)) {
        value = node.value;
      } else {
        return false;
      }
      if (parts[i] !== value) return false;
    }
    return true;
  }
});
unwrapExports(matchesPattern_1);
var buildMatchMemberExpression_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = buildMatchMemberExpression;
  var _matchesPattern = _interopRequireDefault(matchesPattern_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function buildMatchMemberExpression(match, allowPartial) {
    const parts = match.split(".");
    return member => (0, _matchesPattern.default)(member, parts, allowPartial);
  }
});
unwrapExports(buildMatchMemberExpression_1);
var isReactComponent_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _buildMatchMemberExpression = _interopRequireDefault(buildMatchMemberExpression_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  const isReactComponent = (0, _buildMatchMemberExpression.default)("React.Component");
  var _default = isReactComponent;
  exports.default = _default;
});
unwrapExports(isReactComponent_1);
var isCompatTag_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isCompatTag;
  function isCompatTag(tagName) {
    return !!tagName && /^[a-z]/.test(tagName);
  }
});
unwrapExports(isCompatTag_1);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}
var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}
var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}
var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
  objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}
var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}
var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');
var _Map = Map$1;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');
var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}
var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}
var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}
var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}
var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}
var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}
var _arrayEach = arrayEach;
var defineProperty = function () {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var _defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$4.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}
var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}
var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? _root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  objectTag = '[object Object]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}
var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
var _baseUnary = baseUnary;
var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && _freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
    isArg = !isArr && isArguments_1(value),
    isBuff = !isArr && !isArg && isBuffer_1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? _baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    _isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
  return value === proto;
}
var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);
var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}
var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}
var keys_1 = keys;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}
var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}
var keysIn_1 = keysIn$1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}
var _baseAssignIn = baseAssignIn;
var _cloneBuffer = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}
var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}
var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}
var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};
var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}
var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}
var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');
var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');
var _Promise = Promise;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');
var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');
var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$1 = '[object Set]',
  weakMapTag$1 = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
  mapCtorString = _toSource(_Map),
  promiseCtorString = _toSource(_Promise),
  setCtorString = _toSource(_Set),
  weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1 || _Map && getTag(new _Map()) != mapTag$1 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$1 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
  getTag = function (value) {
    var result = _baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? _toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$1;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$1;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$9.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}
var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;
var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$1 = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$2:
      return _cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return _cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag:
      return _cloneSymbol(object);
  }
}
var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
}
var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}
var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;
var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}
var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;
var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  mapTag$4 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$4 = '[object Set]',
  stringTag$2 = '[object String]',
  symbolTag$1 = '[object Symbol]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] = cloneableTags[numberTag$2] = cloneableTags[objectTag$2] = cloneableTags[regexpTag$2] = cloneableTags[setTag$4] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG,
    isFlat = bitmask & CLONE_FLAT_FLAG,
    isFull = bitmask & CLONE_SYMBOLS_FLAG;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
      isFunc = tag == funcTag$2 || tag == genTag$1;
    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || isFunc && !object) {
      result = isFlat || isFunc ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat ? _copySymbolsIn(value, _baseAssignIn(result, value)) : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet_1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? _getAllKeysIn : _getAllKeys : isFlat ? keysIn : keys_1;
  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}
var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return _baseClone(value, CLONE_SYMBOLS_FLAG$1);
}
var clone_1 = clone;
let fastProto = null;

// Creates an object with permanently fast properties in V8. See Toon Verwaest's
// post https://medium.com/@tverwaes/setting-up-prototypes-in-v8-ec9c9491dfe2#5f62
// for more details. Use %HasFastProperties(object) and the Node.js flag
// --allow-natives-syntax to check whether an object has fast properties.
function FastObject(o) {
  // A prototype object will have "fast properties" enabled once it is checked
  // against the inline property cache of a function, e.g. fastProto.property:
  // https://github.com/v8/v8/blob/6.0.122/test/mjsunit/fast-prototype.js#L48-L63
  if (fastProto !== null && typeof fastProto.property) {
    const result = fastProto;
    fastProto = FastObject.prototype = null;
    return result;
  }
  fastProto = FastObject.prototype = o == null ? Object.create(null) : o;
  return new FastObject();
}

// Initialize the inline property cache of FastObject
FastObject();
var toFastProperties = function toFastproperties(o) {
  return FastObject(o);
};
var ast = createCommonjsModule(function (module) {
  /*
    Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
  
    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are met:
  
      * Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
      * Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
  
    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS'
    AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
    IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
    ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
    DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
    (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
    LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
    ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
    THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */

  (function () {
    function isExpression(node) {
      if (node == null) {
        return false;
      }
      switch (node.type) {
        case 'ArrayExpression':
        case 'AssignmentExpression':
        case 'BinaryExpression':
        case 'CallExpression':
        case 'ConditionalExpression':
        case 'FunctionExpression':
        case 'Identifier':
        case 'Literal':
        case 'LogicalExpression':
        case 'MemberExpression':
        case 'NewExpression':
        case 'ObjectExpression':
        case 'SequenceExpression':
        case 'ThisExpression':
        case 'UnaryExpression':
        case 'UpdateExpression':
          return true;
      }
      return false;
    }
    function isIterationStatement(node) {
      if (node == null) {
        return false;
      }
      switch (node.type) {
        case 'DoWhileStatement':
        case 'ForInStatement':
        case 'ForStatement':
        case 'WhileStatement':
          return true;
      }
      return false;
    }
    function isStatement(node) {
      if (node == null) {
        return false;
      }
      switch (node.type) {
        case 'BlockStatement':
        case 'BreakStatement':
        case 'ContinueStatement':
        case 'DebuggerStatement':
        case 'DoWhileStatement':
        case 'EmptyStatement':
        case 'ExpressionStatement':
        case 'ForInStatement':
        case 'ForStatement':
        case 'IfStatement':
        case 'LabeledStatement':
        case 'ReturnStatement':
        case 'SwitchStatement':
        case 'ThrowStatement':
        case 'TryStatement':
        case 'VariableDeclaration':
        case 'WhileStatement':
        case 'WithStatement':
          return true;
      }
      return false;
    }
    function isSourceElement(node) {
      return isStatement(node) || node != null && node.type === 'FunctionDeclaration';
    }
    function trailingStatement(node) {
      switch (node.type) {
        case 'IfStatement':
          if (node.alternate != null) {
            return node.alternate;
          }
          return node.consequent;
        case 'LabeledStatement':
        case 'ForStatement':
        case 'ForInStatement':
        case 'WhileStatement':
        case 'WithStatement':
          return node.body;
      }
      return null;
    }
    function isProblematicIfStatement(node) {
      var current;
      if (node.type !== 'IfStatement') {
        return false;
      }
      if (node.alternate == null) {
        return false;
      }
      current = node.consequent;
      do {
        if (current.type === 'IfStatement') {
          if (current.alternate == null) {
            return true;
          }
        }
        current = trailingStatement(current);
      } while (current);
      return false;
    }
    module.exports = {
      isExpression: isExpression,
      isStatement: isStatement,
      isIterationStatement: isIterationStatement,
      isSourceElement: isSourceElement,
      isProblematicIfStatement: isProblematicIfStatement,
      trailingStatement: trailingStatement
    };
  })();
  /* vim: set sw=4 ts=4 et tw=80 : */
});
var ast_1 = ast.isExpression;
var ast_2 = ast.isStatement;
var ast_3 = ast.isIterationStatement;
var ast_4 = ast.isSourceElement;
var ast_5 = ast.isProblematicIfStatement;
var ast_6 = ast.trailingStatement;
var code = createCommonjsModule(function (module) {
  /*
    Copyright (C) 2013-2014 Yusuke Suzuki <utatane.tea@gmail.com>
    Copyright (C) 2014 Ivan Nikulin <ifaaan@gmail.com>
  
    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are met:
  
      * Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
      * Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
  
    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
    AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
    IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
    ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
    DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
    (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
    LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
    ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
    THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */

  (function () {
    var ES6Regex, ES5Regex, NON_ASCII_WHITESPACES, IDENTIFIER_START, IDENTIFIER_PART, ch;

    // See `tools/generate-identifier-regex.js`.
    ES5Regex = {
      // ECMAScript 5.1/Unicode v7.0.0 NonAsciiIdentifierStart:
      NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
      // ECMAScript 5.1/Unicode v7.0.0 NonAsciiIdentifierPart:
      NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
    };
    ES6Regex = {
      // ECMAScript 6/Unicode v7.0.0 NonAsciiIdentifierStart:
      NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDE00-\uDE2F\uDE44\uDE80-\uDEAA]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]/,
      // ECMAScript 6/Unicode v7.0.0 NonAsciiIdentifierPart:
      NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDD0-\uDDDA\uDE00-\uDE11\uDE13-\uDE37\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF01-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
    };
    function isDecimalDigit(ch) {
      return 0x30 <= ch && ch <= 0x39; // 0..9
    }
    function isHexDigit(ch) {
      return 0x30 <= ch && ch <= 0x39 ||
      // 0..9
      0x61 <= ch && ch <= 0x66 ||
      // a..f
      0x41 <= ch && ch <= 0x46; // A..F
    }
    function isOctalDigit(ch) {
      return ch >= 0x30 && ch <= 0x37; // 0..7
    }

    // 7.2 White Space

    NON_ASCII_WHITESPACES = [0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF];
    function isWhiteSpace(ch) {
      return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && NON_ASCII_WHITESPACES.indexOf(ch) >= 0;
    }

    // 7.3 Line Terminators

    function isLineTerminator(ch) {
      return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
    }

    // 7.6 Identifier Names and Identifiers

    function fromCodePoint(cp) {
      if (cp <= 0xFFFF) {
        return String.fromCharCode(cp);
      }
      var cu1 = String.fromCharCode(Math.floor((cp - 0x10000) / 0x400) + 0xD800);
      var cu2 = String.fromCharCode((cp - 0x10000) % 0x400 + 0xDC00);
      return cu1 + cu2;
    }
    IDENTIFIER_START = new Array(0x80);
    for (ch = 0; ch < 0x80; ++ch) {
      IDENTIFIER_START[ch] = ch >= 0x61 && ch <= 0x7A ||
      // a..z
      ch >= 0x41 && ch <= 0x5A ||
      // A..Z
      ch === 0x24 || ch === 0x5F; // $ (dollar) and _ (underscore)
    }
    IDENTIFIER_PART = new Array(0x80);
    for (ch = 0; ch < 0x80; ++ch) {
      IDENTIFIER_PART[ch] = ch >= 0x61 && ch <= 0x7A ||
      // a..z
      ch >= 0x41 && ch <= 0x5A ||
      // A..Z
      ch >= 0x30 && ch <= 0x39 ||
      // 0..9
      ch === 0x24 || ch === 0x5F; // $ (dollar) and _ (underscore)
    }
    function isIdentifierStartES5(ch) {
      return ch < 0x80 ? IDENTIFIER_START[ch] : ES5Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
    }
    function isIdentifierPartES5(ch) {
      return ch < 0x80 ? IDENTIFIER_PART[ch] : ES5Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
    }
    function isIdentifierStartES6(ch) {
      return ch < 0x80 ? IDENTIFIER_START[ch] : ES6Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
    }
    function isIdentifierPartES6(ch) {
      return ch < 0x80 ? IDENTIFIER_PART[ch] : ES6Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
    }
    module.exports = {
      isDecimalDigit: isDecimalDigit,
      isHexDigit: isHexDigit,
      isOctalDigit: isOctalDigit,
      isWhiteSpace: isWhiteSpace,
      isLineTerminator: isLineTerminator,
      isIdentifierStartES5: isIdentifierStartES5,
      isIdentifierPartES5: isIdentifierPartES5,
      isIdentifierStartES6: isIdentifierStartES6,
      isIdentifierPartES6: isIdentifierPartES6
    };
  })();
  /* vim: set sw=4 ts=4 et tw=80 : */
});
var code_1 = code.isDecimalDigit;
var code_2 = code.isHexDigit;
var code_3 = code.isOctalDigit;
var code_4 = code.isWhiteSpace;
var code_5 = code.isLineTerminator;
var code_6 = code.isIdentifierStartES5;
var code_7 = code.isIdentifierPartES5;
var code_8 = code.isIdentifierStartES6;
var code_9 = code.isIdentifierPartES6;
var keyword = createCommonjsModule(function (module) {
  /*
    Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
  
    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are met:
  
      * Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
      * Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
  
    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
    AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
    IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
    ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
    DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
    (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
    LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
    ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
    THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */

  (function () {
    var code$1 = code;
    function isStrictModeReservedWordES6(id) {
      switch (id) {
        case 'implements':
        case 'interface':
        case 'package':
        case 'private':
        case 'protected':
        case 'public':
        case 'static':
        case 'let':
          return true;
        default:
          return false;
      }
    }
    function isKeywordES5(id, strict) {
      // yield should not be treated as keyword under non-strict mode.
      if (!strict && id === 'yield') {
        return false;
      }
      return isKeywordES6(id, strict);
    }
    function isKeywordES6(id, strict) {
      if (strict && isStrictModeReservedWordES6(id)) {
        return true;
      }
      switch (id.length) {
        case 2:
          return id === 'if' || id === 'in' || id === 'do';
        case 3:
          return id === 'var' || id === 'for' || id === 'new' || id === 'try';
        case 4:
          return id === 'this' || id === 'else' || id === 'case' || id === 'void' || id === 'with' || id === 'enum';
        case 5:
          return id === 'while' || id === 'break' || id === 'catch' || id === 'throw' || id === 'const' || id === 'yield' || id === 'class' || id === 'super';
        case 6:
          return id === 'return' || id === 'typeof' || id === 'delete' || id === 'switch' || id === 'export' || id === 'import';
        case 7:
          return id === 'default' || id === 'finally' || id === 'extends';
        case 8:
          return id === 'function' || id === 'continue' || id === 'debugger';
        case 10:
          return id === 'instanceof';
        default:
          return false;
      }
    }
    function isReservedWordES5(id, strict) {
      return id === 'null' || id === 'true' || id === 'false' || isKeywordES5(id, strict);
    }
    function isReservedWordES6(id, strict) {
      return id === 'null' || id === 'true' || id === 'false' || isKeywordES6(id, strict);
    }
    function isRestrictedWord(id) {
      return id === 'eval' || id === 'arguments';
    }
    function isIdentifierNameES5(id) {
      var i, iz, ch;
      if (id.length === 0) {
        return false;
      }
      ch = id.charCodeAt(0);
      if (!code$1.isIdentifierStartES5(ch)) {
        return false;
      }
      for (i = 1, iz = id.length; i < iz; ++i) {
        ch = id.charCodeAt(i);
        if (!code$1.isIdentifierPartES5(ch)) {
          return false;
        }
      }
      return true;
    }
    function decodeUtf16(lead, trail) {
      return (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
    }
    function isIdentifierNameES6(id) {
      var i, iz, ch, lowCh, check;
      if (id.length === 0) {
        return false;
      }
      check = code$1.isIdentifierStartES6;
      for (i = 0, iz = id.length; i < iz; ++i) {
        ch = id.charCodeAt(i);
        if (0xD800 <= ch && ch <= 0xDBFF) {
          ++i;
          if (i >= iz) {
            return false;
          }
          lowCh = id.charCodeAt(i);
          if (!(0xDC00 <= lowCh && lowCh <= 0xDFFF)) {
            return false;
          }
          ch = decodeUtf16(ch, lowCh);
        }
        if (!check(ch)) {
          return false;
        }
        check = code$1.isIdentifierPartES6;
      }
      return true;
    }
    function isIdentifierES5(id, strict) {
      return isIdentifierNameES5(id) && !isReservedWordES5(id, strict);
    }
    function isIdentifierES6(id, strict) {
      return isIdentifierNameES6(id) && !isReservedWordES6(id, strict);
    }
    module.exports = {
      isKeywordES5: isKeywordES5,
      isKeywordES6: isKeywordES6,
      isReservedWordES5: isReservedWordES5,
      isReservedWordES6: isReservedWordES6,
      isRestrictedWord: isRestrictedWord,
      isIdentifierNameES5: isIdentifierNameES5,
      isIdentifierNameES6: isIdentifierNameES6,
      isIdentifierES5: isIdentifierES5,
      isIdentifierES6: isIdentifierES6
    };
  })();
  /* vim: set sw=4 ts=4 et tw=80 : */
});
var keyword_1 = keyword.isKeywordES5;
var keyword_2 = keyword.isKeywordES6;
var keyword_3 = keyword.isReservedWordES5;
var keyword_4 = keyword.isReservedWordES6;
var keyword_5 = keyword.isRestrictedWord;
var keyword_6 = keyword.isIdentifierNameES5;
var keyword_7 = keyword.isIdentifierNameES6;
var keyword_8 = keyword.isIdentifierES5;
var keyword_9 = keyword.isIdentifierES6;
var utils = createCommonjsModule(function (module, exports) {
  /*
    Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
  
    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are met:
  
      * Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
      * Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
  
    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
    AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
    IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
    ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
    DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
    (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
    LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
    ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
    THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */

  (function () {
    exports.ast = ast;
    exports.code = code;
    exports.keyword = keyword;
  })();
  /* vim: set sw=4 ts=4 et tw=80 : */
});
var utils_1 = utils.ast;
var utils_2 = utils.code;
var utils_3 = utils.keyword;
var isValidIdentifier_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isValidIdentifier;
  function _esutils() {
    const data = _interopRequireDefault(utils);
    _esutils = function () {
      return data;
    };
    return data;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function isValidIdentifier(name) {
    if (typeof name !== "string" || _esutils().default.keyword.isReservedWordES6(name, true)) {
      return false;
    } else if (name === "await") {
      return false;
    } else {
      return _esutils().default.keyword.isIdentifierNameES6(name);
    }
  }
});
unwrapExports(isValidIdentifier_1);
var constants = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NOT_LOCAL_BINDING = exports.BLOCK_SCOPED_SYMBOL = exports.INHERIT_KEYS = exports.UNARY_OPERATORS = exports.STRING_UNARY_OPERATORS = exports.NUMBER_UNARY_OPERATORS = exports.BOOLEAN_UNARY_OPERATORS = exports.BINARY_OPERATORS = exports.NUMBER_BINARY_OPERATORS = exports.BOOLEAN_BINARY_OPERATORS = exports.COMPARISON_BINARY_OPERATORS = exports.EQUALITY_BINARY_OPERATORS = exports.BOOLEAN_NUMBER_BINARY_OPERATORS = exports.UPDATE_OPERATORS = exports.LOGICAL_OPERATORS = exports.COMMENT_KEYS = exports.FOR_INIT_KEYS = exports.FLATTENABLE_KEYS = exports.STATEMENT_OR_BLOCK_KEYS = void 0;
  const STATEMENT_OR_BLOCK_KEYS = ["consequent", "body", "alternate"];
  exports.STATEMENT_OR_BLOCK_KEYS = STATEMENT_OR_BLOCK_KEYS;
  const FLATTENABLE_KEYS = ["body", "expressions"];
  exports.FLATTENABLE_KEYS = FLATTENABLE_KEYS;
  const FOR_INIT_KEYS = ["left", "init"];
  exports.FOR_INIT_KEYS = FOR_INIT_KEYS;
  const COMMENT_KEYS = ["leadingComments", "trailingComments", "innerComments"];
  exports.COMMENT_KEYS = COMMENT_KEYS;
  const LOGICAL_OPERATORS = ["||", "&&", "??"];
  exports.LOGICAL_OPERATORS = LOGICAL_OPERATORS;
  const UPDATE_OPERATORS = ["++", "--"];
  exports.UPDATE_OPERATORS = UPDATE_OPERATORS;
  const BOOLEAN_NUMBER_BINARY_OPERATORS = [">", "<", ">=", "<="];
  exports.BOOLEAN_NUMBER_BINARY_OPERATORS = BOOLEAN_NUMBER_BINARY_OPERATORS;
  const EQUALITY_BINARY_OPERATORS = ["==", "===", "!=", "!=="];
  exports.EQUALITY_BINARY_OPERATORS = EQUALITY_BINARY_OPERATORS;
  const COMPARISON_BINARY_OPERATORS = [...EQUALITY_BINARY_OPERATORS, "in", "instanceof"];
  exports.COMPARISON_BINARY_OPERATORS = COMPARISON_BINARY_OPERATORS;
  const BOOLEAN_BINARY_OPERATORS = [...COMPARISON_BINARY_OPERATORS, ...BOOLEAN_NUMBER_BINARY_OPERATORS];
  exports.BOOLEAN_BINARY_OPERATORS = BOOLEAN_BINARY_OPERATORS;
  const NUMBER_BINARY_OPERATORS = ["-", "/", "%", "*", "**", "&", "|", ">>", ">>>", "<<", "^"];
  exports.NUMBER_BINARY_OPERATORS = NUMBER_BINARY_OPERATORS;
  const BINARY_OPERATORS = ["+", ...NUMBER_BINARY_OPERATORS, ...BOOLEAN_BINARY_OPERATORS];
  exports.BINARY_OPERATORS = BINARY_OPERATORS;
  const BOOLEAN_UNARY_OPERATORS = ["delete", "!"];
  exports.BOOLEAN_UNARY_OPERATORS = BOOLEAN_UNARY_OPERATORS;
  const NUMBER_UNARY_OPERATORS = ["+", "-", "~"];
  exports.NUMBER_UNARY_OPERATORS = NUMBER_UNARY_OPERATORS;
  const STRING_UNARY_OPERATORS = ["typeof"];
  exports.STRING_UNARY_OPERATORS = STRING_UNARY_OPERATORS;
  const UNARY_OPERATORS = ["void", "throw", ...BOOLEAN_UNARY_OPERATORS, ...NUMBER_UNARY_OPERATORS, ...STRING_UNARY_OPERATORS];
  exports.UNARY_OPERATORS = UNARY_OPERATORS;
  const INHERIT_KEYS = {
    optional: ["typeAnnotation", "typeParameters", "returnType"],
    force: ["start", "loc", "end"]
  };
  exports.INHERIT_KEYS = INHERIT_KEYS;
  const BLOCK_SCOPED_SYMBOL = Symbol.for("var used to be block scoped");
  exports.BLOCK_SCOPED_SYMBOL = BLOCK_SCOPED_SYMBOL;
  const NOT_LOCAL_BINDING = Symbol.for("should not be considered a local binding");
  exports.NOT_LOCAL_BINDING = NOT_LOCAL_BINDING;
});
unwrapExports(constants);
var constants_1 = constants.NOT_LOCAL_BINDING;
var constants_2 = constants.BLOCK_SCOPED_SYMBOL;
var constants_3 = constants.INHERIT_KEYS;
var constants_4 = constants.UNARY_OPERATORS;
var constants_5 = constants.STRING_UNARY_OPERATORS;
var constants_6 = constants.NUMBER_UNARY_OPERATORS;
var constants_7 = constants.BOOLEAN_UNARY_OPERATORS;
var constants_8 = constants.BINARY_OPERATORS;
var constants_9 = constants.NUMBER_BINARY_OPERATORS;
var constants_10 = constants.BOOLEAN_BINARY_OPERATORS;
var constants_11 = constants.COMPARISON_BINARY_OPERATORS;
var constants_12 = constants.EQUALITY_BINARY_OPERATORS;
var constants_13 = constants.BOOLEAN_NUMBER_BINARY_OPERATORS;
var constants_14 = constants.UPDATE_OPERATORS;
var constants_15 = constants.LOGICAL_OPERATORS;
var constants_16 = constants.COMMENT_KEYS;
var constants_17 = constants.FOR_INIT_KEYS;
var constants_18 = constants.FLATTENABLE_KEYS;
var constants_19 = constants.STATEMENT_OR_BLOCK_KEYS;
var isType_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isType;
  function isType(nodeType, targetType) {
    if (nodeType === targetType) return true;
    if (definitions.ALIAS_KEYS[targetType]) return false;
    const aliases = definitions.FLIPPED_ALIAS_KEYS[targetType];
    if (aliases) {
      if (aliases[0] === nodeType) return true;
      for (const alias of aliases) {
        if (nodeType === alias) return true;
      }
    }
    return false;
  }
});
unwrapExports(isType_1);
var is_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = is;
  var _shallowEqual = _interopRequireDefault(shallowEqual_1);
  var _isType = _interopRequireDefault(isType_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function is(type, node, opts) {
    if (!node) return false;
    const matches = (0, _isType.default)(node.type, type);
    if (!matches) return false;
    if (typeof opts === "undefined") {
      return true;
    } else {
      return (0, _shallowEqual.default)(node, opts);
    }
  }
});
unwrapExports(is_1);
var utils$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.validate = validate;
  exports.typeIs = typeIs;
  exports.validateType = validateType;
  exports.validateOptional = validateOptional;
  exports.validateOptionalType = validateOptionalType;
  exports.arrayOf = arrayOf;
  exports.arrayOfType = arrayOfType;
  exports.validateArrayOfType = validateArrayOfType;
  exports.assertEach = assertEach;
  exports.assertOneOf = assertOneOf;
  exports.assertNodeType = assertNodeType;
  exports.assertNodeOrValueType = assertNodeOrValueType;
  exports.assertValueType = assertValueType;
  exports.chain = chain;
  exports.default = defineType;
  exports.DEPRECATED_KEYS = exports.BUILDER_KEYS = exports.NODE_FIELDS = exports.FLIPPED_ALIAS_KEYS = exports.ALIAS_KEYS = exports.VISITOR_KEYS = void 0;
  var _is = _interopRequireDefault(is_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  const VISITOR_KEYS = {};
  exports.VISITOR_KEYS = VISITOR_KEYS;
  const ALIAS_KEYS = {};
  exports.ALIAS_KEYS = ALIAS_KEYS;
  const FLIPPED_ALIAS_KEYS = {};
  exports.FLIPPED_ALIAS_KEYS = FLIPPED_ALIAS_KEYS;
  const NODE_FIELDS = {};
  exports.NODE_FIELDS = NODE_FIELDS;
  const BUILDER_KEYS = {};
  exports.BUILDER_KEYS = BUILDER_KEYS;
  const DEPRECATED_KEYS = {};
  exports.DEPRECATED_KEYS = DEPRECATED_KEYS;
  function getType(val) {
    if (Array.isArray(val)) {
      return "array";
    } else if (val === null) {
      return "null";
    } else if (val === undefined) {
      return "undefined";
    } else {
      return typeof val;
    }
  }
  function validate(validate) {
    return {
      validate
    };
  }
  function typeIs(typeName) {
    return typeof typeName === "string" ? assertNodeType(typeName) : assertNodeType(...typeName);
  }
  function validateType(typeName) {
    return validate(typeIs(typeName));
  }
  function validateOptional(validate) {
    return {
      validate,
      optional: true
    };
  }
  function validateOptionalType(typeName) {
    return {
      validate: typeIs(typeName),
      optional: true
    };
  }
  function arrayOf(elementType) {
    return chain(assertValueType("array"), assertEach(elementType));
  }
  function arrayOfType(typeName) {
    return arrayOf(typeIs(typeName));
  }
  function validateArrayOfType(typeName) {
    return validate(arrayOfType(typeName));
  }
  function assertEach(callback) {
    function validator(node, key, val) {
      if (!Array.isArray(val)) return;
      for (let i = 0; i < val.length; i++) {
        callback(node, `${key}[${i}]`, val[i]);
      }
    }
    validator.each = callback;
    return validator;
  }
  function assertOneOf() {
    for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }
    function validate(node, key, val) {
      if (values.indexOf(val) < 0) {
        throw new TypeError(`Property ${key} expected value to be one of ${JSON.stringify(values)} but got ${JSON.stringify(val)}`);
      }
    }
    validate.oneOf = values;
    return validate;
  }
  function assertNodeType() {
    for (var _len3 = arguments.length, types = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      types[_key3] = arguments[_key3];
    }
    function validate(node, key, val) {
      let valid = false;
      for (const type of types) {
        if ((0, _is.default)(type, val)) {
          valid = true;
          break;
        }
      }
      if (!valid) {
        throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} ` + `but instead got ${JSON.stringify(val && val.type)}`);
      }
    }
    validate.oneOfNodeTypes = types;
    return validate;
  }
  function assertNodeOrValueType() {
    for (var _len4 = arguments.length, types = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      types[_key4] = arguments[_key4];
    }
    function validate(node, key, val) {
      let valid = false;
      for (const type of types) {
        if (getType(val) === type || (0, _is.default)(type, val)) {
          valid = true;
          break;
        }
      }
      if (!valid) {
        throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} ` + `but instead got ${JSON.stringify(val && val.type)}`);
      }
    }
    validate.oneOfNodeOrValueTypes = types;
    return validate;
  }
  function assertValueType(type) {
    function validate(node, key, val) {
      const valid = getType(val) === type;
      if (!valid) {
        throw new TypeError(`Property ${key} expected type of ${type} but got ${getType(val)}`);
      }
    }
    validate.type = type;
    return validate;
  }
  function chain() {
    for (var _len5 = arguments.length, fns = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      fns[_key5] = arguments[_key5];
    }
    function validate() {
      for (const fn of fns) {
        fn(...arguments);
      }
    }
    validate.chainOf = fns;
    return validate;
  }
  function defineType(type) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const inherits = opts.inherits && store[opts.inherits] || {};
    const fields = opts.fields || inherits.fields || {};
    const visitor = opts.visitor || inherits.visitor || [];
    const aliases = opts.aliases || inherits.aliases || [];
    const builder = opts.builder || inherits.builder || opts.visitor || [];
    if (opts.deprecatedAlias) {
      DEPRECATED_KEYS[opts.deprecatedAlias] = type;
    }
    for (const key of visitor.concat(builder)) {
      fields[key] = fields[key] || {};
    }
    for (const key in fields) {
      const field = fields[key];
      if (builder.indexOf(key) === -1) {
        field.optional = true;
      }
      if (field.default === undefined) {
        field.default = null;
      } else if (!field.validate) {
        field.validate = assertValueType(getType(field.default));
      }
    }
    VISITOR_KEYS[type] = opts.visitor = visitor;
    BUILDER_KEYS[type] = opts.builder = builder;
    NODE_FIELDS[type] = opts.fields = fields;
    ALIAS_KEYS[type] = opts.aliases = aliases;
    aliases.forEach(alias => {
      FLIPPED_ALIAS_KEYS[alias] = FLIPPED_ALIAS_KEYS[alias] || [];
      FLIPPED_ALIAS_KEYS[alias].push(type);
    });
    store[type] = opts;
  }
  const store = {};
});
unwrapExports(utils$1);
var utils_1$1 = utils$1.validate;
var utils_2$1 = utils$1.typeIs;
var utils_3$1 = utils$1.validateType;
var utils_4 = utils$1.validateOptional;
var utils_5 = utils$1.validateOptionalType;
var utils_6 = utils$1.arrayOf;
var utils_7 = utils$1.arrayOfType;
var utils_8 = utils$1.validateArrayOfType;
var utils_9 = utils$1.assertEach;
var utils_10 = utils$1.assertOneOf;
var utils_11 = utils$1.assertNodeType;
var utils_12 = utils$1.assertNodeOrValueType;
var utils_13 = utils$1.assertValueType;
var utils_14 = utils$1.chain;
var utils_15 = utils$1.DEPRECATED_KEYS;
var utils_16 = utils$1.BUILDER_KEYS;
var utils_17 = utils$1.NODE_FIELDS;
var utils_18 = utils$1.FLIPPED_ALIAS_KEYS;
var utils_19 = utils$1.ALIAS_KEYS;
var utils_20 = utils$1.VISITOR_KEYS;
var core = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.patternLikeCommon = exports.functionDeclarationCommon = exports.functionTypeAnnotationCommon = exports.functionCommon = void 0;
  var _isValidIdentifier = _interopRequireDefault(isValidIdentifier_1);
  var _utils = _interopRequireWildcard(utils$1);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  (0, _utils.default)("ArrayExpression", {
    fields: {
      elements: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeOrValueType)("null", "Expression", "SpreadElement"))),
        default: []
      }
    },
    visitor: ["elements"],
    aliases: ["Expression"]
  });
  (0, _utils.default)("AssignmentExpression", {
    fields: {
      operator: {
        validate: (0, _utils.assertValueType)("string")
      },
      left: {
        validate: (0, _utils.assertNodeType)("LVal")
      },
      right: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    },
    builder: ["operator", "left", "right"],
    visitor: ["left", "right"],
    aliases: ["Expression"]
  });
  (0, _utils.default)("BinaryExpression", {
    builder: ["operator", "left", "right"],
    fields: {
      operator: {
        validate: (0, _utils.assertOneOf)(...constants.BINARY_OPERATORS)
      },
      left: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      right: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    },
    visitor: ["left", "right"],
    aliases: ["Binary", "Expression"]
  });
  (0, _utils.default)("InterpreterDirective", {
    builder: ["value"],
    fields: {
      value: {
        validate: (0, _utils.assertValueType)("string")
      }
    }
  });
  (0, _utils.default)("Directive", {
    visitor: ["value"],
    fields: {
      value: {
        validate: (0, _utils.assertNodeType)("DirectiveLiteral")
      }
    }
  });
  (0, _utils.default)("DirectiveLiteral", {
    builder: ["value"],
    fields: {
      value: {
        validate: (0, _utils.assertValueType)("string")
      }
    }
  });
  (0, _utils.default)("BlockStatement", {
    builder: ["body", "directives"],
    visitor: ["directives", "body"],
    fields: {
      directives: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Directive"))),
        default: []
      },
      body: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
      }
    },
    aliases: ["Scopable", "BlockParent", "Block", "Statement"]
  });
  (0, _utils.default)("BreakStatement", {
    visitor: ["label"],
    fields: {
      label: {
        validate: (0, _utils.assertNodeType)("Identifier"),
        optional: true
      }
    },
    aliases: ["Statement", "Terminatorless", "CompletionStatement"]
  });
  (0, _utils.default)("CallExpression", {
    visitor: ["callee", "arguments", "typeParameters", "typeArguments"],
    builder: ["callee", "arguments"],
    aliases: ["Expression"],
    fields: {
      callee: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      arguments: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName")))
      },
      optional: {
        validate: (0, _utils.assertOneOf)(true, false),
        optional: true
      },
      typeArguments: {
        validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
        optional: true
      },
      typeParameters: {
        validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
        optional: true
      }
    }
  });
  (0, _utils.default)("CatchClause", {
    visitor: ["param", "body"],
    fields: {
      param: {
        validate: (0, _utils.assertNodeType)("Identifier"),
        optional: true
      },
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    },
    aliases: ["Scopable", "BlockParent"]
  });
  (0, _utils.default)("ConditionalExpression", {
    visitor: ["test", "consequent", "alternate"],
    fields: {
      test: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      consequent: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      alternate: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    },
    aliases: ["Expression", "Conditional"]
  });
  (0, _utils.default)("ContinueStatement", {
    visitor: ["label"],
    fields: {
      label: {
        validate: (0, _utils.assertNodeType)("Identifier"),
        optional: true
      }
    },
    aliases: ["Statement", "Terminatorless", "CompletionStatement"]
  });
  (0, _utils.default)("DebuggerStatement", {
    aliases: ["Statement"]
  });
  (0, _utils.default)("DoWhileStatement", {
    visitor: ["test", "body"],
    fields: {
      test: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      body: {
        validate: (0, _utils.assertNodeType)("Statement")
      }
    },
    aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"]
  });
  (0, _utils.default)("EmptyStatement", {
    aliases: ["Statement"]
  });
  (0, _utils.default)("ExpressionStatement", {
    visitor: ["expression"],
    fields: {
      expression: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    },
    aliases: ["Statement", "ExpressionWrapper"]
  });
  (0, _utils.default)("File", {
    builder: ["program", "comments", "tokens"],
    visitor: ["program"],
    fields: {
      program: {
        validate: (0, _utils.assertNodeType)("Program")
      }
    }
  });
  (0, _utils.default)("ForInStatement", {
    visitor: ["left", "right", "body"],
    aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
    fields: {
      left: {
        validate: (0, _utils.assertNodeType)("VariableDeclaration", "LVal")
      },
      right: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      body: {
        validate: (0, _utils.assertNodeType)("Statement")
      }
    }
  });
  (0, _utils.default)("ForStatement", {
    visitor: ["init", "test", "update", "body"],
    aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop"],
    fields: {
      init: {
        validate: (0, _utils.assertNodeType)("VariableDeclaration", "Expression"),
        optional: true
      },
      test: {
        validate: (0, _utils.assertNodeType)("Expression"),
        optional: true
      },
      update: {
        validate: (0, _utils.assertNodeType)("Expression"),
        optional: true
      },
      body: {
        validate: (0, _utils.assertNodeType)("Statement")
      }
    }
  });
  const functionCommon = {
    params: {
      validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("LVal")))
    },
    generator: {
      default: false,
      validate: (0, _utils.assertValueType)("boolean")
    },
    async: {
      validate: (0, _utils.assertValueType)("boolean"),
      default: false
    }
  };
  exports.functionCommon = functionCommon;
  const functionTypeAnnotationCommon = {
    returnType: {
      validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
      optional: true
    },
    typeParameters: {
      validate: (0, _utils.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
      optional: true
    }
  };
  exports.functionTypeAnnotationCommon = functionTypeAnnotationCommon;
  const functionDeclarationCommon = Object.assign({}, functionCommon, {
    declare: {
      validate: (0, _utils.assertValueType)("boolean"),
      optional: true
    },
    id: {
      validate: (0, _utils.assertNodeType)("Identifier"),
      optional: true
    }
  });
  exports.functionDeclarationCommon = functionDeclarationCommon;
  (0, _utils.default)("FunctionDeclaration", {
    builder: ["id", "params", "body", "generator", "async"],
    visitor: ["id", "params", "body", "returnType", "typeParameters"],
    fields: Object.assign({}, functionDeclarationCommon, functionTypeAnnotationCommon, {
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    }),
    aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Statement", "Pureish", "Declaration"]
  });
  (0, _utils.default)("FunctionExpression", {
    inherits: "FunctionDeclaration",
    aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
    fields: Object.assign({}, functionCommon, functionTypeAnnotationCommon, {
      id: {
        validate: (0, _utils.assertNodeType)("Identifier"),
        optional: true
      },
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    })
  });
  const patternLikeCommon = {
    typeAnnotation: {
      validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
      optional: true
    },
    decorators: {
      validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator")))
    }
  };
  exports.patternLikeCommon = patternLikeCommon;
  (0, _utils.default)("Identifier", {
    builder: ["name"],
    visitor: ["typeAnnotation", "decorators"],
    aliases: ["Expression", "PatternLike", "LVal", "TSEntityName"],
    fields: Object.assign({}, patternLikeCommon, {
      name: {
        validate: (0, _utils.chain)(function (node, key, val) {
          if (!(0, _isValidIdentifier.default)(val)) ;
        }, (0, _utils.assertValueType)("string"))
      },
      optional: {
        validate: (0, _utils.assertValueType)("boolean"),
        optional: true
      }
    })
  });
  (0, _utils.default)("IfStatement", {
    visitor: ["test", "consequent", "alternate"],
    aliases: ["Statement", "Conditional"],
    fields: {
      test: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      consequent: {
        validate: (0, _utils.assertNodeType)("Statement")
      },
      alternate: {
        optional: true,
        validate: (0, _utils.assertNodeType)("Statement")
      }
    }
  });
  (0, _utils.default)("LabeledStatement", {
    visitor: ["label", "body"],
    aliases: ["Statement"],
    fields: {
      label: {
        validate: (0, _utils.assertNodeType)("Identifier")
      },
      body: {
        validate: (0, _utils.assertNodeType)("Statement")
      }
    }
  });
  (0, _utils.default)("StringLiteral", {
    builder: ["value"],
    fields: {
      value: {
        validate: (0, _utils.assertValueType)("string")
      }
    },
    aliases: ["Expression", "Pureish", "Literal", "Immutable"]
  });
  (0, _utils.default)("NumericLiteral", {
    builder: ["value"],
    deprecatedAlias: "NumberLiteral",
    fields: {
      value: {
        validate: (0, _utils.assertValueType)("number")
      }
    },
    aliases: ["Expression", "Pureish", "Literal", "Immutable"]
  });
  (0, _utils.default)("NullLiteral", {
    aliases: ["Expression", "Pureish", "Literal", "Immutable"]
  });
  (0, _utils.default)("BooleanLiteral", {
    builder: ["value"],
    fields: {
      value: {
        validate: (0, _utils.assertValueType)("boolean")
      }
    },
    aliases: ["Expression", "Pureish", "Literal", "Immutable"]
  });
  (0, _utils.default)("RegExpLiteral", {
    builder: ["pattern", "flags"],
    deprecatedAlias: "RegexLiteral",
    aliases: ["Expression", "Literal"],
    fields: {
      pattern: {
        validate: (0, _utils.assertValueType)("string")
      },
      flags: {
        validate: (0, _utils.assertValueType)("string"),
        default: ""
      }
    }
  });
  (0, _utils.default)("LogicalExpression", {
    builder: ["operator", "left", "right"],
    visitor: ["left", "right"],
    aliases: ["Binary", "Expression"],
    fields: {
      operator: {
        validate: (0, _utils.assertOneOf)(...constants.LOGICAL_OPERATORS)
      },
      left: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      right: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("MemberExpression", {
    builder: ["object", "property", "computed", "optional"],
    visitor: ["object", "property"],
    aliases: ["Expression", "LVal"],
    fields: {
      object: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      property: {
        validate: function () {
          const normal = (0, _utils.assertNodeType)("Identifier", "PrivateName");
          const computed = (0, _utils.assertNodeType)("Expression");
          return function (node, key, val) {
            const validator = node.computed ? computed : normal;
            validator(node, key, val);
          };
        }()
      },
      computed: {
        default: false
      },
      optional: {
        validate: (0, _utils.assertOneOf)(true, false),
        optional: true
      }
    }
  });
  (0, _utils.default)("NewExpression", {
    inherits: "CallExpression"
  });
  (0, _utils.default)("Program", {
    visitor: ["directives", "body"],
    builder: ["body", "directives", "sourceType", "interpreter"],
    fields: {
      sourceFile: {
        validate: (0, _utils.assertValueType)("string")
      },
      sourceType: {
        validate: (0, _utils.assertOneOf)("script", "module"),
        default: "script"
      },
      interpreter: {
        validate: (0, _utils.assertNodeType)("InterpreterDirective"),
        default: null,
        optional: true
      },
      directives: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Directive"))),
        default: []
      },
      body: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
      }
    },
    aliases: ["Scopable", "BlockParent", "Block"]
  });
  (0, _utils.default)("ObjectExpression", {
    visitor: ["properties"],
    aliases: ["Expression"],
    fields: {
      properties: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ObjectMethod", "ObjectProperty", "SpreadElement")))
      }
    }
  });
  (0, _utils.default)("ObjectMethod", {
    builder: ["kind", "key", "params", "body", "computed"],
    fields: Object.assign({}, functionCommon, functionTypeAnnotationCommon, {
      kind: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("method", "get", "set")),
        default: "method"
      },
      computed: {
        validate: (0, _utils.assertValueType)("boolean"),
        default: false
      },
      key: {
        validate: function () {
          const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral");
          const computed = (0, _utils.assertNodeType)("Expression");
          return function (node, key, val) {
            const validator = node.computed ? computed : normal;
            validator(node, key, val);
          };
        }()
      },
      decorators: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator")))
      },
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    }),
    visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
    aliases: ["UserWhitespacable", "Function", "Scopable", "BlockParent", "FunctionParent", "Method", "ObjectMember"]
  });
  (0, _utils.default)("ObjectProperty", {
    builder: ["key", "value", "computed", "shorthand", "decorators"],
    fields: {
      computed: {
        validate: (0, _utils.assertValueType)("boolean"),
        default: false
      },
      key: {
        validate: function () {
          const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral");
          const computed = (0, _utils.assertNodeType)("Expression");
          return function (node, key, val) {
            const validator = node.computed ? computed : normal;
            validator(node, key, val);
          };
        }()
      },
      value: {
        validate: (0, _utils.assertNodeType)("Expression", "PatternLike")
      },
      shorthand: {
        validate: (0, _utils.assertValueType)("boolean"),
        default: false
      },
      decorators: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
        optional: true
      }
    },
    visitor: ["key", "value", "decorators"],
    aliases: ["UserWhitespacable", "Property", "ObjectMember"]
  });
  (0, _utils.default)("RestElement", {
    visitor: ["argument", "typeAnnotation"],
    builder: ["argument"],
    aliases: ["LVal", "PatternLike"],
    deprecatedAlias: "RestProperty",
    fields: Object.assign({}, patternLikeCommon, {
      argument: {
        validate: (0, _utils.assertNodeType)("LVal")
      }
    })
  });
  (0, _utils.default)("ReturnStatement", {
    visitor: ["argument"],
    aliases: ["Statement", "Terminatorless", "CompletionStatement"],
    fields: {
      argument: {
        validate: (0, _utils.assertNodeType)("Expression"),
        optional: true
      }
    }
  });
  (0, _utils.default)("SequenceExpression", {
    visitor: ["expressions"],
    fields: {
      expressions: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression")))
      }
    },
    aliases: ["Expression"]
  });
  (0, _utils.default)("SwitchCase", {
    visitor: ["test", "consequent"],
    fields: {
      test: {
        validate: (0, _utils.assertNodeType)("Expression"),
        optional: true
      },
      consequent: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
      }
    }
  });
  (0, _utils.default)("SwitchStatement", {
    visitor: ["discriminant", "cases"],
    aliases: ["Statement", "BlockParent", "Scopable"],
    fields: {
      discriminant: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      cases: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("SwitchCase")))
      }
    }
  });
  (0, _utils.default)("ThisExpression", {
    aliases: ["Expression"]
  });
  (0, _utils.default)("ThrowStatement", {
    visitor: ["argument"],
    aliases: ["Statement", "Terminatorless", "CompletionStatement"],
    fields: {
      argument: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("TryStatement", {
    visitor: ["block", "handler", "finalizer"],
    aliases: ["Statement"],
    fields: {
      block: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      },
      handler: {
        optional: true,
        validate: (0, _utils.assertNodeType)("CatchClause")
      },
      finalizer: {
        optional: true,
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    }
  });
  (0, _utils.default)("UnaryExpression", {
    builder: ["operator", "argument", "prefix"],
    fields: {
      prefix: {
        default: true
      },
      argument: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      operator: {
        validate: (0, _utils.assertOneOf)(...constants.UNARY_OPERATORS)
      }
    },
    visitor: ["argument"],
    aliases: ["UnaryLike", "Expression"]
  });
  (0, _utils.default)("UpdateExpression", {
    builder: ["operator", "argument", "prefix"],
    fields: {
      prefix: {
        default: false
      },
      argument: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      operator: {
        validate: (0, _utils.assertOneOf)(...constants.UPDATE_OPERATORS)
      }
    },
    visitor: ["argument"],
    aliases: ["Expression"]
  });
  (0, _utils.default)("VariableDeclaration", {
    builder: ["kind", "declarations"],
    visitor: ["declarations"],
    aliases: ["Statement", "Declaration"],
    fields: {
      declare: {
        validate: (0, _utils.assertValueType)("boolean"),
        optional: true
      },
      kind: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("var", "let", "const"))
      },
      declarations: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("VariableDeclarator")))
      }
    }
  });
  (0, _utils.default)("VariableDeclarator", {
    visitor: ["id", "init"],
    fields: {
      id: {
        validate: (0, _utils.assertNodeType)("LVal")
      },
      definite: {
        optional: true,
        validate: (0, _utils.assertValueType)("boolean")
      },
      init: {
        optional: true,
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("WhileStatement", {
    visitor: ["test", "body"],
    aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"],
    fields: {
      test: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement", "Statement")
      }
    }
  });
  (0, _utils.default)("WithStatement", {
    visitor: ["object", "body"],
    aliases: ["Statement"],
    fields: {
      object: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement", "Statement")
      }
    }
  });
});
unwrapExports(core);
var core_1 = core.patternLikeCommon;
var core_2 = core.functionDeclarationCommon;
var core_3 = core.functionTypeAnnotationCommon;
var core_4 = core.functionCommon;
var es2015 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.classMethodOrDeclareMethodCommon = exports.classMethodOrPropertyCommon = void 0;
  var _utils = _interopRequireWildcard(utils$1);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  (0, _utils.default)("AssignmentPattern", {
    visitor: ["left", "right", "decorators"],
    builder: ["left", "right"],
    aliases: ["Pattern", "PatternLike", "LVal"],
    fields: Object.assign({}, core.patternLikeCommon, {
      left: {
        validate: (0, _utils.assertNodeType)("Identifier", "ObjectPattern", "ArrayPattern")
      },
      right: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      decorators: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator")))
      }
    })
  });
  (0, _utils.default)("ArrayPattern", {
    visitor: ["elements", "typeAnnotation"],
    builder: ["elements"],
    aliases: ["Pattern", "PatternLike", "LVal"],
    fields: Object.assign({}, core.patternLikeCommon, {
      elements: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("PatternLike")))
      },
      decorators: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator")))
      }
    })
  });
  (0, _utils.default)("ArrowFunctionExpression", {
    builder: ["params", "body", "async"],
    visitor: ["params", "body", "returnType", "typeParameters"],
    aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
    fields: Object.assign({}, core.functionCommon, core.functionTypeAnnotationCommon, {
      expression: {
        validate: (0, _utils.assertValueType)("boolean")
      },
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement", "Expression")
      }
    })
  });
  (0, _utils.default)("ClassBody", {
    visitor: ["body"],
    fields: {
      body: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ClassMethod", "ClassPrivateMethod", "ClassProperty", "ClassPrivateProperty", "TSDeclareMethod", "TSIndexSignature")))
      }
    }
  });
  const classCommon = {
    typeParameters: {
      validate: (0, _utils.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
      optional: true
    },
    body: {
      validate: (0, _utils.assertNodeType)("ClassBody")
    },
    superClass: {
      optional: true,
      validate: (0, _utils.assertNodeType)("Expression")
    },
    superTypeParameters: {
      validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
      optional: true
    },
    implements: {
      validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSExpressionWithTypeArguments", "ClassImplements"))),
      optional: true
    }
  };
  (0, _utils.default)("ClassDeclaration", {
    builder: ["id", "superClass", "body", "decorators"],
    visitor: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators"],
    aliases: ["Scopable", "Class", "Statement", "Declaration", "Pureish"],
    fields: Object.assign({}, classCommon, {
      declare: {
        validate: (0, _utils.assertValueType)("boolean"),
        optional: true
      },
      abstract: {
        validate: (0, _utils.assertValueType)("boolean"),
        optional: true
      },
      id: {
        validate: (0, _utils.assertNodeType)("Identifier"),
        optional: true
      },
      decorators: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
        optional: true
      }
    })
  });
  (0, _utils.default)("ClassExpression", {
    inherits: "ClassDeclaration",
    aliases: ["Scopable", "Class", "Expression", "Pureish"],
    fields: Object.assign({}, classCommon, {
      id: {
        optional: true,
        validate: (0, _utils.assertNodeType)("Identifier")
      },
      body: {
        validate: (0, _utils.assertNodeType)("ClassBody")
      },
      superClass: {
        optional: true,
        validate: (0, _utils.assertNodeType)("Expression")
      },
      decorators: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
        optional: true
      }
    })
  });
  (0, _utils.default)("ExportAllDeclaration", {
    visitor: ["source"],
    aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
    fields: {
      source: {
        validate: (0, _utils.assertNodeType)("StringLiteral")
      }
    }
  });
  (0, _utils.default)("ExportDefaultDeclaration", {
    visitor: ["declaration"],
    aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
    fields: {
      declaration: {
        validate: (0, _utils.assertNodeType)("FunctionDeclaration", "TSDeclareFunction", "ClassDeclaration", "Expression")
      }
    }
  });
  (0, _utils.default)("ExportNamedDeclaration", {
    visitor: ["declaration", "specifiers", "source"],
    aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
    fields: {
      declaration: {
        validate: (0, _utils.assertNodeType)("Declaration"),
        optional: true
      },
      specifiers: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ExportSpecifier", "ExportDefaultSpecifier", "ExportNamespaceSpecifier")))
      },
      source: {
        validate: (0, _utils.assertNodeType)("StringLiteral"),
        optional: true
      }
    }
  });
  (0, _utils.default)("ExportSpecifier", {
    visitor: ["local", "exported"],
    aliases: ["ModuleSpecifier"],
    fields: {
      local: {
        validate: (0, _utils.assertNodeType)("Identifier")
      },
      exported: {
        validate: (0, _utils.assertNodeType)("Identifier")
      }
    }
  });
  (0, _utils.default)("ForOfStatement", {
    visitor: ["left", "right", "body"],
    aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
    fields: {
      left: {
        validate: (0, _utils.assertNodeType)("VariableDeclaration", "LVal")
      },
      right: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      body: {
        validate: (0, _utils.assertNodeType)("Statement")
      },
      await: {
        default: false,
        validate: (0, _utils.assertValueType)("boolean")
      }
    }
  });
  (0, _utils.default)("ImportDeclaration", {
    visitor: ["specifiers", "source"],
    aliases: ["Statement", "Declaration", "ModuleDeclaration"],
    fields: {
      specifiers: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier")))
      },
      source: {
        validate: (0, _utils.assertNodeType)("StringLiteral")
      }
    }
  });
  (0, _utils.default)("ImportDefaultSpecifier", {
    visitor: ["local"],
    aliases: ["ModuleSpecifier"],
    fields: {
      local: {
        validate: (0, _utils.assertNodeType)("Identifier")
      }
    }
  });
  (0, _utils.default)("ImportNamespaceSpecifier", {
    visitor: ["local"],
    aliases: ["ModuleSpecifier"],
    fields: {
      local: {
        validate: (0, _utils.assertNodeType)("Identifier")
      }
    }
  });
  (0, _utils.default)("ImportSpecifier", {
    visitor: ["local", "imported"],
    aliases: ["ModuleSpecifier"],
    fields: {
      local: {
        validate: (0, _utils.assertNodeType)("Identifier")
      },
      imported: {
        validate: (0, _utils.assertNodeType)("Identifier")
      },
      importKind: {
        validate: (0, _utils.assertOneOf)(null, "type", "typeof")
      }
    }
  });
  (0, _utils.default)("MetaProperty", {
    visitor: ["meta", "property"],
    aliases: ["Expression"],
    fields: {
      meta: {
        validate: (0, _utils.assertNodeType)("Identifier")
      },
      property: {
        validate: (0, _utils.assertNodeType)("Identifier")
      }
    }
  });
  const classMethodOrPropertyCommon = {
    abstract: {
      validate: (0, _utils.assertValueType)("boolean"),
      optional: true
    },
    accessibility: {
      validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("public", "private", "protected")),
      optional: true
    },
    static: {
      validate: (0, _utils.assertValueType)("boolean"),
      optional: true
    },
    computed: {
      default: false,
      validate: (0, _utils.assertValueType)("boolean")
    },
    optional: {
      validate: (0, _utils.assertValueType)("boolean"),
      optional: true
    },
    key: {
      validate: (0, _utils.chain)(function () {
        const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral");
        const computed = (0, _utils.assertNodeType)("Expression");
        return function (node, key, val) {
          const validator = node.computed ? computed : normal;
          validator(node, key, val);
        };
      }(), (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "Expression"))
    }
  };
  exports.classMethodOrPropertyCommon = classMethodOrPropertyCommon;
  const classMethodOrDeclareMethodCommon = Object.assign({}, core.functionCommon, classMethodOrPropertyCommon, {
    kind: {
      validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("get", "set", "method", "constructor")),
      default: "method"
    },
    access: {
      validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("public", "private", "protected")),
      optional: true
    },
    decorators: {
      validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
      optional: true
    }
  });
  exports.classMethodOrDeclareMethodCommon = classMethodOrDeclareMethodCommon;
  (0, _utils.default)("ClassMethod", {
    aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method"],
    builder: ["kind", "key", "params", "body", "computed", "static"],
    visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
    fields: Object.assign({}, classMethodOrDeclareMethodCommon, core.functionTypeAnnotationCommon, {
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    })
  });
  (0, _utils.default)("ObjectPattern", {
    visitor: ["properties", "typeAnnotation", "decorators"],
    builder: ["properties"],
    aliases: ["Pattern", "PatternLike", "LVal"],
    fields: Object.assign({}, core.patternLikeCommon, {
      properties: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("RestElement", "ObjectProperty")))
      }
    })
  });
  (0, _utils.default)("SpreadElement", {
    visitor: ["argument"],
    aliases: ["UnaryLike"],
    deprecatedAlias: "SpreadProperty",
    fields: {
      argument: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("Super", {
    aliases: ["Expression"]
  });
  (0, _utils.default)("TaggedTemplateExpression", {
    visitor: ["tag", "quasi"],
    aliases: ["Expression"],
    fields: {
      tag: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      quasi: {
        validate: (0, _utils.assertNodeType)("TemplateLiteral")
      },
      typeParameters: {
        validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
        optional: true
      }
    }
  });
  (0, _utils.default)("TemplateElement", {
    builder: ["value", "tail"],
    fields: {
      value: {},
      tail: {
        validate: (0, _utils.assertValueType)("boolean"),
        default: false
      }
    }
  });
  (0, _utils.default)("TemplateLiteral", {
    visitor: ["quasis", "expressions"],
    aliases: ["Expression", "Literal"],
    fields: {
      quasis: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TemplateElement")))
      },
      expressions: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression")))
      }
    }
  });
  (0, _utils.default)("YieldExpression", {
    builder: ["argument", "delegate"],
    visitor: ["argument"],
    aliases: ["Expression", "Terminatorless"],
    fields: {
      delegate: {
        validate: (0, _utils.assertValueType)("boolean"),
        default: false
      },
      argument: {
        optional: true,
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
});
unwrapExports(es2015);
var es2015_1 = es2015.classMethodOrDeclareMethodCommon;
var es2015_2 = es2015.classMethodOrPropertyCommon;
var flow = createCommonjsModule(function (module) {
  var _utils = _interopRequireWildcard(utils$1);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  const defineInterfaceishType = function (name) {
    let typeParameterType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "TypeParameterDeclaration";
    (0, _utils.default)(name, {
      builder: ["id", "typeParameters", "extends", "body"],
      visitor: ["id", "typeParameters", "extends", "mixins", "implements", "body"],
      aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
      fields: {
        id: (0, _utils.validateType)("Identifier"),
        typeParameters: (0, _utils.validateOptionalType)(typeParameterType),
        extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
        mixins: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
        implements: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ClassImplements")),
        body: (0, _utils.validateType)("ObjectTypeAnnotation")
      }
    });
  };
  (0, _utils.default)("AnyTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("ArrayTypeAnnotation", {
    visitor: ["elementType"],
    aliases: ["Flow", "FlowType"],
    fields: {
      elementType: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("BooleanTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("BooleanLiteralTypeAnnotation", {
    builder: ["value"],
    aliases: ["Flow", "FlowType"],
    fields: {
      value: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
    }
  });
  (0, _utils.default)("NullLiteralTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("ClassImplements", {
    visitor: ["id", "typeParameters"],
    aliases: ["Flow"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
    }
  });
  defineInterfaceishType("DeclareClass", "TypeParameterInstantiation");
  (0, _utils.default)("DeclareFunction", {
    visitor: ["id"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      predicate: (0, _utils.validateOptionalType)("DeclaredPredicate")
    }
  });
  defineInterfaceishType("DeclareInterface");
  (0, _utils.default)("DeclareModule", {
    builder: ["id", "body", "kind"],
    visitor: ["id", "body"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
      body: (0, _utils.validateType)("BlockStatement"),
      kind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("CommonJS", "ES"))
    }
  });
  (0, _utils.default)("DeclareModuleExports", {
    visitor: ["typeAnnotation"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
    }
  });
  (0, _utils.default)("DeclareTypeAlias", {
    visitor: ["id", "typeParameters", "right"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
      right: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("DeclareOpaqueType", {
    visitor: ["id", "typeParameters", "supertype"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
      supertype: (0, _utils.validateOptionalType)("FlowType")
    }
  });
  (0, _utils.default)("DeclareVariable", {
    visitor: ["id"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      id: (0, _utils.validateType)("Identifier")
    }
  });
  (0, _utils.default)("DeclareExportDeclaration", {
    visitor: ["declaration", "specifiers", "source"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      declaration: (0, _utils.validateOptionalType)("Flow"),
      specifiers: (0, _utils.validateOptional)((0, _utils.arrayOfType)(["ExportSpecifier", "ExportNamespaceSpecifier"])),
      source: (0, _utils.validateOptionalType)("StringLiteral"),
      default: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
    }
  });
  (0, _utils.default)("DeclareExportAllDeclaration", {
    visitor: ["source"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      source: (0, _utils.validateType)("StringLiteral"),
      exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)(["type", "value"]))
    }
  });
  (0, _utils.default)("DeclaredPredicate", {
    visitor: ["value"],
    aliases: ["Flow", "FlowPredicate"],
    fields: {
      value: (0, _utils.validateType)("Flow")
    }
  });
  (0, _utils.default)("ExistsTypeAnnotation", {
    aliases: ["Flow", "FlowType"]
  });
  (0, _utils.default)("FunctionTypeAnnotation", {
    visitor: ["typeParameters", "params", "rest", "returnType"],
    aliases: ["Flow", "FlowType"],
    fields: {
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
      params: (0, _utils.validate)((0, _utils.arrayOfType)("FunctionTypeParam")),
      rest: (0, _utils.validateOptionalType)("FunctionTypeParam"),
      returnType: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("FunctionTypeParam", {
    visitor: ["name", "typeAnnotation"],
    aliases: ["Flow"],
    fields: {
      name: (0, _utils.validateOptionalType)("Identifier"),
      typeAnnotation: (0, _utils.validateType)("FlowType"),
      optional: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
    }
  });
  (0, _utils.default)("GenericTypeAnnotation", {
    visitor: ["id", "typeParameters"],
    aliases: ["Flow", "FlowType"],
    fields: {
      id: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"]),
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
    }
  });
  (0, _utils.default)("InferredPredicate", {
    aliases: ["Flow", "FlowPredicate"]
  });
  (0, _utils.default)("InterfaceExtends", {
    visitor: ["id", "typeParameters"],
    aliases: ["Flow"],
    fields: {
      id: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"]),
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
    }
  });
  defineInterfaceishType("InterfaceDeclaration");
  (0, _utils.default)("InterfaceTypeAnnotation", {
    visitor: ["extends", "body"],
    aliases: ["Flow", "FlowType"],
    fields: {
      extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
      body: (0, _utils.validateType)("ObjectTypeAnnotation")
    }
  });
  (0, _utils.default)("IntersectionTypeAnnotation", {
    visitor: ["types"],
    aliases: ["Flow", "FlowType"],
    fields: {
      types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
    }
  });
  (0, _utils.default)("MixedTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("EmptyTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("NullableTypeAnnotation", {
    visitor: ["typeAnnotation"],
    aliases: ["Flow", "FlowType"],
    fields: {
      typeAnnotation: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("NumberLiteralTypeAnnotation", {
    builder: ["value"],
    aliases: ["Flow", "FlowType"],
    fields: {
      value: (0, _utils.validate)((0, _utils.assertValueType)("number"))
    }
  });
  (0, _utils.default)("NumberTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("ObjectTypeAnnotation", {
    visitor: ["properties", "indexers", "callProperties", "internalSlots"],
    aliases: ["Flow", "FlowType"],
    builder: ["properties", "indexers", "callProperties", "internalSlots", "exact"],
    fields: {
      properties: (0, _utils.validate)((0, _utils.arrayOfType)(["ObjectTypeProperty", "ObjectTypeSpreadProperty"])),
      indexers: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ObjectTypeIndexer")),
      callProperties: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ObjectTypeCallProperty")),
      internalSlots: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ObjectTypeInternalSlot")),
      exact: {
        validate: (0, _utils.assertValueType)("boolean"),
        default: false
      },
      inexact: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
    }
  });
  (0, _utils.default)("ObjectTypeInternalSlot", {
    visitor: ["id", "value", "optional", "static", "method"],
    aliases: ["Flow", "UserWhitespacable"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      value: (0, _utils.validateType)("FlowType"),
      optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
      static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
      method: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
    }
  });
  (0, _utils.default)("ObjectTypeCallProperty", {
    visitor: ["value"],
    aliases: ["Flow", "UserWhitespacable"],
    fields: {
      value: (0, _utils.validateType)("FlowType"),
      static: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
    }
  });
  (0, _utils.default)("ObjectTypeIndexer", {
    visitor: ["id", "key", "value", "variance"],
    aliases: ["Flow", "UserWhitespacable"],
    fields: {
      id: (0, _utils.validateOptionalType)("Identifier"),
      key: (0, _utils.validateType)("FlowType"),
      value: (0, _utils.validateType)("FlowType"),
      static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
      variance: (0, _utils.validateOptionalType)("Variance")
    }
  });
  (0, _utils.default)("ObjectTypeProperty", {
    visitor: ["key", "value", "variance"],
    aliases: ["Flow", "UserWhitespacable"],
    fields: {
      key: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
      value: (0, _utils.validateType)("FlowType"),
      kind: (0, _utils.validate)((0, _utils.assertOneOf)("init", "get", "set")),
      static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
      proto: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
      optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
      variance: (0, _utils.validateOptionalType)("Variance")
    }
  });
  (0, _utils.default)("ObjectTypeSpreadProperty", {
    visitor: ["argument"],
    aliases: ["Flow", "UserWhitespacable"],
    fields: {
      argument: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("OpaqueType", {
    visitor: ["id", "typeParameters", "supertype", "impltype"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
      supertype: (0, _utils.validateOptionalType)("FlowType"),
      impltype: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("QualifiedTypeIdentifier", {
    visitor: ["id", "qualification"],
    aliases: ["Flow"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      qualification: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"])
    }
  });
  (0, _utils.default)("StringLiteralTypeAnnotation", {
    builder: ["value"],
    aliases: ["Flow", "FlowType"],
    fields: {
      value: (0, _utils.validate)((0, _utils.assertValueType)("string"))
    }
  });
  (0, _utils.default)("StringTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("ThisTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
  (0, _utils.default)("TupleTypeAnnotation", {
    visitor: ["types"],
    aliases: ["Flow", "FlowType"],
    fields: {
      types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
    }
  });
  (0, _utils.default)("TypeofTypeAnnotation", {
    visitor: ["argument"],
    aliases: ["Flow", "FlowType"],
    fields: {
      argument: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("TypeAlias", {
    visitor: ["id", "typeParameters", "right"],
    aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
    fields: {
      id: (0, _utils.validateType)("Identifier"),
      typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
      right: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("TypeAnnotation", {
    aliases: ["Flow"],
    visitor: ["typeAnnotation"],
    fields: {
      typeAnnotation: (0, _utils.validateType)("FlowType")
    }
  });
  (0, _utils.default)("TypeCastExpression", {
    visitor: ["expression", "typeAnnotation"],
    aliases: ["Flow", "ExpressionWrapper", "Expression"],
    fields: {
      expression: (0, _utils.validateType)("Expression"),
      typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
    }
  });
  (0, _utils.default)("TypeParameter", {
    aliases: ["Flow"],
    visitor: ["bound", "default", "variance"],
    fields: {
      name: (0, _utils.validate)((0, _utils.assertValueType)("string")),
      bound: (0, _utils.validateOptionalType)("TypeAnnotation"),
      default: (0, _utils.validateOptionalType)("FlowType"),
      variance: (0, _utils.validateOptionalType)("Variance")
    }
  });
  (0, _utils.default)("TypeParameterDeclaration", {
    aliases: ["Flow"],
    visitor: ["params"],
    fields: {
      params: (0, _utils.validate)((0, _utils.arrayOfType)("TypeParameter"))
    }
  });
  (0, _utils.default)("TypeParameterInstantiation", {
    aliases: ["Flow"],
    visitor: ["params"],
    fields: {
      params: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
    }
  });
  (0, _utils.default)("UnionTypeAnnotation", {
    visitor: ["types"],
    aliases: ["Flow", "FlowType"],
    fields: {
      types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
    }
  });
  (0, _utils.default)("Variance", {
    aliases: ["Flow"],
    builder: ["kind"],
    fields: {
      kind: (0, _utils.validate)((0, _utils.assertOneOf)("minus", "plus"))
    }
  });
  (0, _utils.default)("VoidTypeAnnotation", {
    aliases: ["Flow", "FlowType", "FlowBaseAnnotation"]
  });
});
unwrapExports(flow);
var jsx = createCommonjsModule(function (module) {
  var _utils = _interopRequireWildcard(utils$1);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  (0, _utils.default)("JSXAttribute", {
    visitor: ["name", "value"],
    aliases: ["JSX", "Immutable"],
    fields: {
      name: {
        validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXNamespacedName")
      },
      value: {
        optional: true,
        validate: (0, _utils.assertNodeType)("JSXElement", "JSXFragment", "StringLiteral", "JSXExpressionContainer")
      }
    }
  });
  (0, _utils.default)("JSXClosingElement", {
    visitor: ["name"],
    aliases: ["JSX", "Immutable"],
    fields: {
      name: {
        validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression")
      }
    }
  });
  (0, _utils.default)("JSXElement", {
    builder: ["openingElement", "closingElement", "children", "selfClosing"],
    visitor: ["openingElement", "children", "closingElement"],
    aliases: ["JSX", "Immutable", "Expression"],
    fields: {
      openingElement: {
        validate: (0, _utils.assertNodeType)("JSXOpeningElement")
      },
      closingElement: {
        optional: true,
        validate: (0, _utils.assertNodeType)("JSXClosingElement")
      },
      children: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
      }
    }
  });
  (0, _utils.default)("JSXEmptyExpression", {
    aliases: ["JSX"]
  });
  (0, _utils.default)("JSXExpressionContainer", {
    visitor: ["expression"],
    aliases: ["JSX", "Immutable"],
    fields: {
      expression: {
        validate: (0, _utils.assertNodeType)("Expression", "JSXEmptyExpression")
      }
    }
  });
  (0, _utils.default)("JSXSpreadChild", {
    visitor: ["expression"],
    aliases: ["JSX", "Immutable"],
    fields: {
      expression: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("JSXIdentifier", {
    builder: ["name"],
    aliases: ["JSX"],
    fields: {
      name: {
        validate: (0, _utils.assertValueType)("string")
      }
    }
  });
  (0, _utils.default)("JSXMemberExpression", {
    visitor: ["object", "property"],
    aliases: ["JSX"],
    fields: {
      object: {
        validate: (0, _utils.assertNodeType)("JSXMemberExpression", "JSXIdentifier")
      },
      property: {
        validate: (0, _utils.assertNodeType)("JSXIdentifier")
      }
    }
  });
  (0, _utils.default)("JSXNamespacedName", {
    visitor: ["namespace", "name"],
    aliases: ["JSX"],
    fields: {
      namespace: {
        validate: (0, _utils.assertNodeType)("JSXIdentifier")
      },
      name: {
        validate: (0, _utils.assertNodeType)("JSXIdentifier")
      }
    }
  });
  (0, _utils.default)("JSXOpeningElement", {
    builder: ["name", "attributes", "selfClosing"],
    visitor: ["name", "attributes"],
    aliases: ["JSX", "Immutable"],
    fields: {
      name: {
        validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression")
      },
      selfClosing: {
        default: false,
        validate: (0, _utils.assertValueType)("boolean")
      },
      attributes: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXAttribute", "JSXSpreadAttribute")))
      },
      typeParameters: {
        validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
        optional: true
      }
    }
  });
  (0, _utils.default)("JSXSpreadAttribute", {
    visitor: ["argument"],
    aliases: ["JSX"],
    fields: {
      argument: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("JSXText", {
    aliases: ["JSX", "Immutable"],
    builder: ["value"],
    fields: {
      value: {
        validate: (0, _utils.assertValueType)("string")
      }
    }
  });
  (0, _utils.default)("JSXFragment", {
    builder: ["openingFragment", "closingFragment", "children"],
    visitor: ["openingFragment", "children", "closingFragment"],
    aliases: ["JSX", "Immutable", "Expression"],
    fields: {
      openingFragment: {
        validate: (0, _utils.assertNodeType)("JSXOpeningFragment")
      },
      closingFragment: {
        validate: (0, _utils.assertNodeType)("JSXClosingFragment")
      },
      children: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
      }
    }
  });
  (0, _utils.default)("JSXOpeningFragment", {
    aliases: ["JSX", "Immutable"]
  });
  (0, _utils.default)("JSXClosingFragment", {
    aliases: ["JSX", "Immutable"]
  });
});
unwrapExports(jsx);
var misc = createCommonjsModule(function (module) {
  var _utils = _interopRequireWildcard(utils$1);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  (0, _utils.default)("Noop", {
    visitor: []
  });
  (0, _utils.default)("ParenthesizedExpression", {
    visitor: ["expression"],
    aliases: ["Expression", "ExpressionWrapper"],
    fields: {
      expression: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
});
unwrapExports(misc);
var experimental = createCommonjsModule(function (module) {
  var _utils = _interopRequireWildcard(utils$1);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  (0, _utils.default)("AwaitExpression", {
    builder: ["argument"],
    visitor: ["argument"],
    aliases: ["Expression", "Terminatorless"],
    fields: {
      argument: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("BindExpression", {
    visitor: ["object", "callee"],
    aliases: ["Expression"],
    fields: {}
  });
  (0, _utils.default)("ClassProperty", {
    visitor: ["key", "value", "typeAnnotation", "decorators"],
    builder: ["key", "value", "typeAnnotation", "decorators", "computed"],
    aliases: ["Property"],
    fields: Object.assign({}, es2015.classMethodOrPropertyCommon, {
      value: {
        validate: (0, _utils.assertNodeType)("Expression"),
        optional: true
      },
      definite: {
        validate: (0, _utils.assertValueType)("boolean"),
        optional: true
      },
      typeAnnotation: {
        validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
        optional: true
      },
      decorators: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
        optional: true
      },
      readonly: {
        validate: (0, _utils.assertValueType)("boolean"),
        optional: true
      }
    })
  });
  (0, _utils.default)("OptionalMemberExpression", {
    builder: ["object", "property", "computed", "optional"],
    visitor: ["object", "property"],
    aliases: ["Expression"],
    fields: {
      object: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      property: {
        validate: function () {
          const normal = (0, _utils.assertNodeType)("Identifier");
          const computed = (0, _utils.assertNodeType)("Expression");
          return function (node, key, val) {
            const validator = node.computed ? computed : normal;
            validator(node, key, val);
          };
        }()
      },
      computed: {
        default: false
      },
      optional: {
        validate: (0, _utils.assertValueType)("boolean")
      }
    }
  });
  (0, _utils.default)("PipelineTopicExpression", {
    builder: ["expression"],
    visitor: ["expression"],
    fields: {
      expression: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("PipelineBareFunction", {
    builder: ["callee"],
    visitor: ["callee"],
    fields: {
      callee: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("PipelinePrimaryTopicReference", {
    aliases: ["Expression"]
  });
  (0, _utils.default)("OptionalCallExpression", {
    visitor: ["callee", "arguments", "typeParameters", "typeArguments"],
    builder: ["callee", "arguments", "optional"],
    aliases: ["Expression"],
    fields: {
      callee: {
        validate: (0, _utils.assertNodeType)("Expression")
      },
      arguments: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName")))
      },
      optional: {
        validate: (0, _utils.assertValueType)("boolean")
      },
      typeArguments: {
        validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
        optional: true
      },
      typeParameters: {
        validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
        optional: true
      }
    }
  });
  (0, _utils.default)("ClassPrivateProperty", {
    visitor: ["key", "value"],
    builder: ["key", "value"],
    aliases: ["Property", "Private"],
    fields: {
      key: {
        validate: (0, _utils.assertNodeType)("PrivateName")
      },
      value: {
        validate: (0, _utils.assertNodeType)("Expression"),
        optional: true
      }
    }
  });
  (0, _utils.default)("ClassPrivateMethod", {
    builder: ["kind", "key", "params", "body", "static"],
    visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
    aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method", "Private"],
    fields: Object.assign({}, es2015.classMethodOrDeclareMethodCommon, {
      key: {
        validate: (0, _utils.assertNodeType)("PrivateName")
      },
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    })
  });
  (0, _utils.default)("Import", {
    aliases: ["Expression"]
  });
  (0, _utils.default)("Decorator", {
    visitor: ["expression"],
    fields: {
      expression: {
        validate: (0, _utils.assertNodeType)("Expression")
      }
    }
  });
  (0, _utils.default)("DoExpression", {
    visitor: ["body"],
    aliases: ["Expression"],
    fields: {
      body: {
        validate: (0, _utils.assertNodeType)("BlockStatement")
      }
    }
  });
  (0, _utils.default)("ExportDefaultSpecifier", {
    visitor: ["exported"],
    aliases: ["ModuleSpecifier"],
    fields: {
      exported: {
        validate: (0, _utils.assertNodeType)("Identifier")
      }
    }
  });
  (0, _utils.default)("ExportNamespaceSpecifier", {
    visitor: ["exported"],
    aliases: ["ModuleSpecifier"],
    fields: {
      exported: {
        validate: (0, _utils.assertNodeType)("Identifier")
      }
    }
  });
  (0, _utils.default)("PrivateName", {
    visitor: ["id"],
    aliases: ["Private"],
    fields: {
      id: {
        validate: (0, _utils.assertNodeType)("Identifier")
      }
    }
  });
  (0, _utils.default)("BigIntLiteral", {
    builder: ["value"],
    fields: {
      value: {
        validate: (0, _utils.assertValueType)("string")
      }
    },
    aliases: ["Expression", "Pureish", "Literal", "Immutable"]
  });
});
unwrapExports(experimental);
var typescript = createCommonjsModule(function (module) {
  var _utils = _interopRequireWildcard(utils$1);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  const bool = (0, _utils.assertValueType)("boolean");
  const tSFunctionTypeAnnotationCommon = {
    returnType: {
      validate: (0, _utils.assertNodeType)("TSTypeAnnotation", "Noop"),
      optional: true
    },
    typeParameters: {
      validate: (0, _utils.assertNodeType)("TSTypeParameterDeclaration", "Noop"),
      optional: true
    }
  };
  (0, _utils.default)("TSParameterProperty", {
    aliases: ["LVal"],
    visitor: ["parameter"],
    fields: {
      accessibility: {
        validate: (0, _utils.assertOneOf)("public", "private", "protected"),
        optional: true
      },
      readonly: {
        validate: (0, _utils.assertValueType)("boolean"),
        optional: true
      },
      parameter: {
        validate: (0, _utils.assertNodeType)("Identifier", "AssignmentPattern")
      }
    }
  });
  (0, _utils.default)("TSDeclareFunction", {
    aliases: ["Statement", "Declaration"],
    visitor: ["id", "typeParameters", "params", "returnType"],
    fields: Object.assign({}, core.functionDeclarationCommon, tSFunctionTypeAnnotationCommon)
  });
  (0, _utils.default)("TSDeclareMethod", {
    visitor: ["decorators", "key", "typeParameters", "params", "returnType"],
    fields: Object.assign({}, es2015.classMethodOrDeclareMethodCommon, tSFunctionTypeAnnotationCommon)
  });
  (0, _utils.default)("TSQualifiedName", {
    aliases: ["TSEntityName"],
    visitor: ["left", "right"],
    fields: {
      left: (0, _utils.validateType)("TSEntityName"),
      right: (0, _utils.validateType)("Identifier")
    }
  });
  const signatureDeclarationCommon = {
    typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
    parameters: (0, _utils.validateArrayOfType)(["Identifier", "RestElement"]),
    typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation")
  };
  const callConstructSignatureDeclaration = {
    aliases: ["TSTypeElement"],
    visitor: ["typeParameters", "parameters", "typeAnnotation"],
    fields: signatureDeclarationCommon
  };
  (0, _utils.default)("TSCallSignatureDeclaration", callConstructSignatureDeclaration);
  (0, _utils.default)("TSConstructSignatureDeclaration", callConstructSignatureDeclaration);
  const namedTypeElementCommon = {
    key: (0, _utils.validateType)("Expression"),
    computed: (0, _utils.validate)(bool),
    optional: (0, _utils.validateOptional)(bool)
  };
  (0, _utils.default)("TSPropertySignature", {
    aliases: ["TSTypeElement"],
    visitor: ["key", "typeAnnotation", "initializer"],
    fields: Object.assign({}, namedTypeElementCommon, {
      readonly: (0, _utils.validateOptional)(bool),
      typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation"),
      initializer: (0, _utils.validateOptionalType)("Expression")
    })
  });
  (0, _utils.default)("TSMethodSignature", {
    aliases: ["TSTypeElement"],
    visitor: ["key", "typeParameters", "parameters", "typeAnnotation"],
    fields: Object.assign({}, signatureDeclarationCommon, namedTypeElementCommon)
  });
  (0, _utils.default)("TSIndexSignature", {
    aliases: ["TSTypeElement"],
    visitor: ["parameters", "typeAnnotation"],
    fields: {
      readonly: (0, _utils.validateOptional)(bool),
      parameters: (0, _utils.validateArrayOfType)("Identifier"),
      typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation")
    }
  });
  const tsKeywordTypes = ["TSAnyKeyword", "TSUnknownKeyword", "TSNumberKeyword", "TSObjectKeyword", "TSBooleanKeyword", "TSStringKeyword", "TSSymbolKeyword", "TSVoidKeyword", "TSUndefinedKeyword", "TSNullKeyword", "TSNeverKeyword"];
  for (const type of tsKeywordTypes) {
    (0, _utils.default)(type, {
      aliases: ["TSType"],
      visitor: [],
      fields: {}
    });
  }
  (0, _utils.default)("TSThisType", {
    aliases: ["TSType"],
    visitor: [],
    fields: {}
  });
  const fnOrCtr = {
    aliases: ["TSType"],
    visitor: ["typeParameters", "typeAnnotation"],
    fields: signatureDeclarationCommon
  };
  (0, _utils.default)("TSFunctionType", fnOrCtr);
  (0, _utils.default)("TSConstructorType", fnOrCtr);
  (0, _utils.default)("TSTypeReference", {
    aliases: ["TSType"],
    visitor: ["typeName", "typeParameters"],
    fields: {
      typeName: (0, _utils.validateType)("TSEntityName"),
      typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
    }
  });
  (0, _utils.default)("TSTypePredicate", {
    aliases: ["TSType"],
    visitor: ["parameterName", "typeAnnotation"],
    fields: {
      parameterName: (0, _utils.validateType)(["Identifier", "TSThisType"]),
      typeAnnotation: (0, _utils.validateType)("TSTypeAnnotation")
    }
  });
  (0, _utils.default)("TSTypeQuery", {
    aliases: ["TSType"],
    visitor: ["exprName"],
    fields: {
      exprName: (0, _utils.validateType)(["TSEntityName", "TSImportType"])
    }
  });
  (0, _utils.default)("TSTypeLiteral", {
    aliases: ["TSType"],
    visitor: ["members"],
    fields: {
      members: (0, _utils.validateArrayOfType)("TSTypeElement")
    }
  });
  (0, _utils.default)("TSArrayType", {
    aliases: ["TSType"],
    visitor: ["elementType"],
    fields: {
      elementType: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSTupleType", {
    aliases: ["TSType"],
    visitor: ["elementTypes"],
    fields: {
      elementTypes: (0, _utils.validateArrayOfType)("TSType")
    }
  });
  (0, _utils.default)("TSOptionalType", {
    aliases: ["TSType"],
    visitor: ["typeAnnotation"],
    fields: {
      typeAnnotation: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSRestType", {
    aliases: ["TSType"],
    visitor: ["typeAnnotation"],
    fields: {
      typeAnnotation: (0, _utils.validateType)("TSType")
    }
  });
  const unionOrIntersection = {
    aliases: ["TSType"],
    visitor: ["types"],
    fields: {
      types: (0, _utils.validateArrayOfType)("TSType")
    }
  };
  (0, _utils.default)("TSUnionType", unionOrIntersection);
  (0, _utils.default)("TSIntersectionType", unionOrIntersection);
  (0, _utils.default)("TSConditionalType", {
    aliases: ["TSType"],
    visitor: ["checkType", "extendsType", "trueType", "falseType"],
    fields: {
      checkType: (0, _utils.validateType)("TSType"),
      extendsType: (0, _utils.validateType)("TSType"),
      trueType: (0, _utils.validateType)("TSType"),
      falseType: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSInferType", {
    aliases: ["TSType"],
    visitor: ["typeParameter"],
    fields: {
      typeParameter: (0, _utils.validateType)("TSTypeParameter")
    }
  });
  (0, _utils.default)("TSParenthesizedType", {
    aliases: ["TSType"],
    visitor: ["typeAnnotation"],
    fields: {
      typeAnnotation: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSTypeOperator", {
    aliases: ["TSType"],
    visitor: ["typeAnnotation"],
    fields: {
      operator: (0, _utils.validate)((0, _utils.assertValueType)("string")),
      typeAnnotation: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSIndexedAccessType", {
    aliases: ["TSType"],
    visitor: ["objectType", "indexType"],
    fields: {
      objectType: (0, _utils.validateType)("TSType"),
      indexType: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSMappedType", {
    aliases: ["TSType"],
    visitor: ["typeParameter", "typeAnnotation"],
    fields: {
      readonly: (0, _utils.validateOptional)(bool),
      typeParameter: (0, _utils.validateType)("TSTypeParameter"),
      optional: (0, _utils.validateOptional)(bool),
      typeAnnotation: (0, _utils.validateOptionalType)("TSType")
    }
  });
  (0, _utils.default)("TSLiteralType", {
    aliases: ["TSType"],
    visitor: ["literal"],
    fields: {
      literal: (0, _utils.validateType)(["NumericLiteral", "StringLiteral", "BooleanLiteral"])
    }
  });
  (0, _utils.default)("TSExpressionWithTypeArguments", {
    aliases: ["TSType"],
    visitor: ["expression", "typeParameters"],
    fields: {
      expression: (0, _utils.validateType)("TSEntityName"),
      typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
    }
  });
  (0, _utils.default)("TSInterfaceDeclaration", {
    aliases: ["Statement", "Declaration"],
    visitor: ["id", "typeParameters", "extends", "body"],
    fields: {
      declare: (0, _utils.validateOptional)(bool),
      id: (0, _utils.validateType)("Identifier"),
      typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
      extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("TSExpressionWithTypeArguments")),
      body: (0, _utils.validateType)("TSInterfaceBody")
    }
  });
  (0, _utils.default)("TSInterfaceBody", {
    visitor: ["body"],
    fields: {
      body: (0, _utils.validateArrayOfType)("TSTypeElement")
    }
  });
  (0, _utils.default)("TSTypeAliasDeclaration", {
    aliases: ["Statement", "Declaration"],
    visitor: ["id", "typeParameters", "typeAnnotation"],
    fields: {
      declare: (0, _utils.validateOptional)(bool),
      id: (0, _utils.validateType)("Identifier"),
      typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
      typeAnnotation: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSAsExpression", {
    aliases: ["Expression"],
    visitor: ["expression", "typeAnnotation"],
    fields: {
      expression: (0, _utils.validateType)("Expression"),
      typeAnnotation: (0, _utils.validateType)("TSType")
    }
  });
  (0, _utils.default)("TSTypeAssertion", {
    aliases: ["Expression"],
    visitor: ["typeAnnotation", "expression"],
    fields: {
      typeAnnotation: (0, _utils.validateType)("TSType"),
      expression: (0, _utils.validateType)("Expression")
    }
  });
  (0, _utils.default)("TSEnumDeclaration", {
    aliases: ["Statement", "Declaration"],
    visitor: ["id", "members"],
    fields: {
      declare: (0, _utils.validateOptional)(bool),
      const: (0, _utils.validateOptional)(bool),
      id: (0, _utils.validateType)("Identifier"),
      members: (0, _utils.validateArrayOfType)("TSEnumMember"),
      initializer: (0, _utils.validateOptionalType)("Expression")
    }
  });
  (0, _utils.default)("TSEnumMember", {
    visitor: ["id", "initializer"],
    fields: {
      id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
      initializer: (0, _utils.validateOptionalType)("Expression")
    }
  });
  (0, _utils.default)("TSModuleDeclaration", {
    aliases: ["Statement", "Declaration"],
    visitor: ["id", "body"],
    fields: {
      declare: (0, _utils.validateOptional)(bool),
      global: (0, _utils.validateOptional)(bool),
      id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
      body: (0, _utils.validateType)(["TSModuleBlock", "TSModuleDeclaration"])
    }
  });
  (0, _utils.default)("TSModuleBlock", {
    visitor: ["body"],
    fields: {
      body: (0, _utils.validateArrayOfType)("Statement")
    }
  });
  (0, _utils.default)("TSImportType", {
    aliases: ["TSType"],
    visitor: ["argument", "qualifier", "typeParameters"],
    fields: {
      argument: (0, _utils.validateType)("StringLiteral"),
      qualifier: (0, _utils.validateOptionalType)("TSEntityName"),
      typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
    }
  });
  (0, _utils.default)("TSImportEqualsDeclaration", {
    aliases: ["Statement"],
    visitor: ["id", "moduleReference"],
    fields: {
      isExport: (0, _utils.validate)(bool),
      id: (0, _utils.validateType)("Identifier"),
      moduleReference: (0, _utils.validateType)(["TSEntityName", "TSExternalModuleReference"])
    }
  });
  (0, _utils.default)("TSExternalModuleReference", {
    visitor: ["expression"],
    fields: {
      expression: (0, _utils.validateType)("StringLiteral")
    }
  });
  (0, _utils.default)("TSNonNullExpression", {
    aliases: ["Expression"],
    visitor: ["expression"],
    fields: {
      expression: (0, _utils.validateType)("Expression")
    }
  });
  (0, _utils.default)("TSExportAssignment", {
    aliases: ["Statement"],
    visitor: ["expression"],
    fields: {
      expression: (0, _utils.validateType)("Expression")
    }
  });
  (0, _utils.default)("TSNamespaceExportDeclaration", {
    aliases: ["Statement"],
    visitor: ["id"],
    fields: {
      id: (0, _utils.validateType)("Identifier")
    }
  });
  (0, _utils.default)("TSTypeAnnotation", {
    visitor: ["typeAnnotation"],
    fields: {
      typeAnnotation: {
        validate: (0, _utils.assertNodeType)("TSType")
      }
    }
  });
  (0, _utils.default)("TSTypeParameterInstantiation", {
    visitor: ["params"],
    fields: {
      params: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSType")))
      }
    }
  });
  (0, _utils.default)("TSTypeParameterDeclaration", {
    visitor: ["params"],
    fields: {
      params: {
        validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSTypeParameter")))
      }
    }
  });
  (0, _utils.default)("TSTypeParameter", {
    visitor: ["constraint", "default"],
    fields: {
      name: {
        validate: (0, _utils.assertValueType)("string")
      },
      constraint: {
        validate: (0, _utils.assertNodeType)("TSType"),
        optional: true
      },
      default: {
        validate: (0, _utils.assertNodeType)("TSType"),
        optional: true
      }
    }
  });
});
unwrapExports(typescript);
var definitions = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "VISITOR_KEYS", {
    enumerable: true,
    get: function () {
      return utils$1.VISITOR_KEYS;
    }
  });
  Object.defineProperty(exports, "ALIAS_KEYS", {
    enumerable: true,
    get: function () {
      return utils$1.ALIAS_KEYS;
    }
  });
  Object.defineProperty(exports, "FLIPPED_ALIAS_KEYS", {
    enumerable: true,
    get: function () {
      return utils$1.FLIPPED_ALIAS_KEYS;
    }
  });
  Object.defineProperty(exports, "NODE_FIELDS", {
    enumerable: true,
    get: function () {
      return utils$1.NODE_FIELDS;
    }
  });
  Object.defineProperty(exports, "BUILDER_KEYS", {
    enumerable: true,
    get: function () {
      return utils$1.BUILDER_KEYS;
    }
  });
  Object.defineProperty(exports, "DEPRECATED_KEYS", {
    enumerable: true,
    get: function () {
      return utils$1.DEPRECATED_KEYS;
    }
  });
  exports.TYPES = void 0;
  function _toFastProperties() {
    const data = _interopRequireDefault(toFastProperties);
    _toFastProperties = function () {
      return data;
    };
    return data;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  (0, _toFastProperties().default)(utils$1.VISITOR_KEYS);
  (0, _toFastProperties().default)(utils$1.ALIAS_KEYS);
  (0, _toFastProperties().default)(utils$1.FLIPPED_ALIAS_KEYS);
  (0, _toFastProperties().default)(utils$1.NODE_FIELDS);
  (0, _toFastProperties().default)(utils$1.BUILDER_KEYS);
  (0, _toFastProperties().default)(utils$1.DEPRECATED_KEYS);
  const TYPES = Object.keys(utils$1.VISITOR_KEYS).concat(Object.keys(utils$1.FLIPPED_ALIAS_KEYS)).concat(Object.keys(utils$1.DEPRECATED_KEYS));
  exports.TYPES = TYPES;
});
unwrapExports(definitions);
var definitions_1 = definitions.TYPES;
var validate_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = validate;
  function validate(node, key, val) {
    if (!node) return;
    const fields = definitions.NODE_FIELDS[node.type];
    if (!fields) return;
    const field = fields[key];
    if (!field || !field.validate) return;
    if (field.optional && val == null) return;
    field.validate(node, key, val);
  }
});
unwrapExports(validate_1);
var builder_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = builder;
  function _clone() {
    const data = _interopRequireDefault(clone_1);
    _clone = function () {
      return data;
    };
    return data;
  }
  var _validate = _interopRequireDefault(validate_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function builder(type) {
    for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }
    const keys = definitions.BUILDER_KEYS[type];
    const countArgs = args.length;
    if (countArgs > keys.length) {
      throw new Error(`${type}: Too many arguments passed. Received ${countArgs} but can receive no more than ${keys.length}`);
    }
    const node = {
      type
    };
    let i = 0;
    keys.forEach(key => {
      const field = definitions.NODE_FIELDS[type][key];
      let arg;
      if (i < countArgs) arg = args[i];
      if (arg === undefined) arg = (0, _clone().default)(field.default);
      node[key] = arg;
      i++;
    });
    for (const key in node) {
      (0, _validate.default)(node, key, node[key]);
    }
    return node;
  }
});
unwrapExports(builder_1);
var generated$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.arrayExpression = exports.ArrayExpression = ArrayExpression;
  exports.assignmentExpression = exports.AssignmentExpression = AssignmentExpression;
  exports.binaryExpression = exports.BinaryExpression = BinaryExpression;
  exports.interpreterDirective = exports.InterpreterDirective = InterpreterDirective;
  exports.directive = exports.Directive = Directive;
  exports.directiveLiteral = exports.DirectiveLiteral = DirectiveLiteral;
  exports.blockStatement = exports.BlockStatement = BlockStatement;
  exports.breakStatement = exports.BreakStatement = BreakStatement;
  exports.callExpression = exports.CallExpression = CallExpression;
  exports.catchClause = exports.CatchClause = CatchClause;
  exports.conditionalExpression = exports.ConditionalExpression = ConditionalExpression;
  exports.continueStatement = exports.ContinueStatement = ContinueStatement;
  exports.debuggerStatement = exports.DebuggerStatement = DebuggerStatement;
  exports.doWhileStatement = exports.DoWhileStatement = DoWhileStatement;
  exports.emptyStatement = exports.EmptyStatement = EmptyStatement;
  exports.expressionStatement = exports.ExpressionStatement = ExpressionStatement;
  exports.file = exports.File = File;
  exports.forInStatement = exports.ForInStatement = ForInStatement;
  exports.forStatement = exports.ForStatement = ForStatement;
  exports.functionDeclaration = exports.FunctionDeclaration = FunctionDeclaration;
  exports.functionExpression = exports.FunctionExpression = FunctionExpression;
  exports.identifier = exports.Identifier = Identifier;
  exports.ifStatement = exports.IfStatement = IfStatement;
  exports.labeledStatement = exports.LabeledStatement = LabeledStatement;
  exports.stringLiteral = exports.StringLiteral = StringLiteral;
  exports.numericLiteral = exports.NumericLiteral = NumericLiteral;
  exports.nullLiteral = exports.NullLiteral = NullLiteral;
  exports.booleanLiteral = exports.BooleanLiteral = BooleanLiteral;
  exports.regExpLiteral = exports.RegExpLiteral = RegExpLiteral;
  exports.logicalExpression = exports.LogicalExpression = LogicalExpression;
  exports.memberExpression = exports.MemberExpression = MemberExpression;
  exports.newExpression = exports.NewExpression = NewExpression;
  exports.program = exports.Program = Program;
  exports.objectExpression = exports.ObjectExpression = ObjectExpression;
  exports.objectMethod = exports.ObjectMethod = ObjectMethod;
  exports.objectProperty = exports.ObjectProperty = ObjectProperty;
  exports.restElement = exports.RestElement = RestElement;
  exports.returnStatement = exports.ReturnStatement = ReturnStatement;
  exports.sequenceExpression = exports.SequenceExpression = SequenceExpression;
  exports.switchCase = exports.SwitchCase = SwitchCase;
  exports.switchStatement = exports.SwitchStatement = SwitchStatement;
  exports.thisExpression = exports.ThisExpression = ThisExpression;
  exports.throwStatement = exports.ThrowStatement = ThrowStatement;
  exports.tryStatement = exports.TryStatement = TryStatement;
  exports.unaryExpression = exports.UnaryExpression = UnaryExpression;
  exports.updateExpression = exports.UpdateExpression = UpdateExpression;
  exports.variableDeclaration = exports.VariableDeclaration = VariableDeclaration;
  exports.variableDeclarator = exports.VariableDeclarator = VariableDeclarator;
  exports.whileStatement = exports.WhileStatement = WhileStatement;
  exports.withStatement = exports.WithStatement = WithStatement;
  exports.assignmentPattern = exports.AssignmentPattern = AssignmentPattern;
  exports.arrayPattern = exports.ArrayPattern = ArrayPattern;
  exports.arrowFunctionExpression = exports.ArrowFunctionExpression = ArrowFunctionExpression;
  exports.classBody = exports.ClassBody = ClassBody;
  exports.classDeclaration = exports.ClassDeclaration = ClassDeclaration;
  exports.classExpression = exports.ClassExpression = ClassExpression;
  exports.exportAllDeclaration = exports.ExportAllDeclaration = ExportAllDeclaration;
  exports.exportDefaultDeclaration = exports.ExportDefaultDeclaration = ExportDefaultDeclaration;
  exports.exportNamedDeclaration = exports.ExportNamedDeclaration = ExportNamedDeclaration;
  exports.exportSpecifier = exports.ExportSpecifier = ExportSpecifier;
  exports.forOfStatement = exports.ForOfStatement = ForOfStatement;
  exports.importDeclaration = exports.ImportDeclaration = ImportDeclaration;
  exports.importDefaultSpecifier = exports.ImportDefaultSpecifier = ImportDefaultSpecifier;
  exports.importNamespaceSpecifier = exports.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
  exports.importSpecifier = exports.ImportSpecifier = ImportSpecifier;
  exports.metaProperty = exports.MetaProperty = MetaProperty;
  exports.classMethod = exports.ClassMethod = ClassMethod;
  exports.objectPattern = exports.ObjectPattern = ObjectPattern;
  exports.spreadElement = exports.SpreadElement = SpreadElement;
  exports.super = exports.Super = Super;
  exports.taggedTemplateExpression = exports.TaggedTemplateExpression = TaggedTemplateExpression;
  exports.templateElement = exports.TemplateElement = TemplateElement;
  exports.templateLiteral = exports.TemplateLiteral = TemplateLiteral;
  exports.yieldExpression = exports.YieldExpression = YieldExpression;
  exports.anyTypeAnnotation = exports.AnyTypeAnnotation = AnyTypeAnnotation;
  exports.arrayTypeAnnotation = exports.ArrayTypeAnnotation = ArrayTypeAnnotation;
  exports.booleanTypeAnnotation = exports.BooleanTypeAnnotation = BooleanTypeAnnotation;
  exports.booleanLiteralTypeAnnotation = exports.BooleanLiteralTypeAnnotation = BooleanLiteralTypeAnnotation;
  exports.nullLiteralTypeAnnotation = exports.NullLiteralTypeAnnotation = NullLiteralTypeAnnotation;
  exports.classImplements = exports.ClassImplements = ClassImplements;
  exports.declareClass = exports.DeclareClass = DeclareClass;
  exports.declareFunction = exports.DeclareFunction = DeclareFunction;
  exports.declareInterface = exports.DeclareInterface = DeclareInterface;
  exports.declareModule = exports.DeclareModule = DeclareModule;
  exports.declareModuleExports = exports.DeclareModuleExports = DeclareModuleExports;
  exports.declareTypeAlias = exports.DeclareTypeAlias = DeclareTypeAlias;
  exports.declareOpaqueType = exports.DeclareOpaqueType = DeclareOpaqueType;
  exports.declareVariable = exports.DeclareVariable = DeclareVariable;
  exports.declareExportDeclaration = exports.DeclareExportDeclaration = DeclareExportDeclaration;
  exports.declareExportAllDeclaration = exports.DeclareExportAllDeclaration = DeclareExportAllDeclaration;
  exports.declaredPredicate = exports.DeclaredPredicate = DeclaredPredicate;
  exports.existsTypeAnnotation = exports.ExistsTypeAnnotation = ExistsTypeAnnotation;
  exports.functionTypeAnnotation = exports.FunctionTypeAnnotation = FunctionTypeAnnotation;
  exports.functionTypeParam = exports.FunctionTypeParam = FunctionTypeParam;
  exports.genericTypeAnnotation = exports.GenericTypeAnnotation = GenericTypeAnnotation;
  exports.inferredPredicate = exports.InferredPredicate = InferredPredicate;
  exports.interfaceExtends = exports.InterfaceExtends = InterfaceExtends;
  exports.interfaceDeclaration = exports.InterfaceDeclaration = InterfaceDeclaration;
  exports.interfaceTypeAnnotation = exports.InterfaceTypeAnnotation = InterfaceTypeAnnotation;
  exports.intersectionTypeAnnotation = exports.IntersectionTypeAnnotation = IntersectionTypeAnnotation;
  exports.mixedTypeAnnotation = exports.MixedTypeAnnotation = MixedTypeAnnotation;
  exports.emptyTypeAnnotation = exports.EmptyTypeAnnotation = EmptyTypeAnnotation;
  exports.nullableTypeAnnotation = exports.NullableTypeAnnotation = NullableTypeAnnotation;
  exports.numberLiteralTypeAnnotation = exports.NumberLiteralTypeAnnotation = NumberLiteralTypeAnnotation;
  exports.numberTypeAnnotation = exports.NumberTypeAnnotation = NumberTypeAnnotation;
  exports.objectTypeAnnotation = exports.ObjectTypeAnnotation = ObjectTypeAnnotation;
  exports.objectTypeInternalSlot = exports.ObjectTypeInternalSlot = ObjectTypeInternalSlot;
  exports.objectTypeCallProperty = exports.ObjectTypeCallProperty = ObjectTypeCallProperty;
  exports.objectTypeIndexer = exports.ObjectTypeIndexer = ObjectTypeIndexer;
  exports.objectTypeProperty = exports.ObjectTypeProperty = ObjectTypeProperty;
  exports.objectTypeSpreadProperty = exports.ObjectTypeSpreadProperty = ObjectTypeSpreadProperty;
  exports.opaqueType = exports.OpaqueType = OpaqueType;
  exports.qualifiedTypeIdentifier = exports.QualifiedTypeIdentifier = QualifiedTypeIdentifier;
  exports.stringLiteralTypeAnnotation = exports.StringLiteralTypeAnnotation = StringLiteralTypeAnnotation;
  exports.stringTypeAnnotation = exports.StringTypeAnnotation = StringTypeAnnotation;
  exports.thisTypeAnnotation = exports.ThisTypeAnnotation = ThisTypeAnnotation;
  exports.tupleTypeAnnotation = exports.TupleTypeAnnotation = TupleTypeAnnotation;
  exports.typeofTypeAnnotation = exports.TypeofTypeAnnotation = TypeofTypeAnnotation;
  exports.typeAlias = exports.TypeAlias = TypeAlias;
  exports.typeAnnotation = exports.TypeAnnotation = TypeAnnotation;
  exports.typeCastExpression = exports.TypeCastExpression = TypeCastExpression;
  exports.typeParameter = exports.TypeParameter = TypeParameter;
  exports.typeParameterDeclaration = exports.TypeParameterDeclaration = TypeParameterDeclaration;
  exports.typeParameterInstantiation = exports.TypeParameterInstantiation = TypeParameterInstantiation;
  exports.unionTypeAnnotation = exports.UnionTypeAnnotation = UnionTypeAnnotation;
  exports.variance = exports.Variance = Variance;
  exports.voidTypeAnnotation = exports.VoidTypeAnnotation = VoidTypeAnnotation;
  exports.jSXAttribute = exports.jsxAttribute = exports.JSXAttribute = JSXAttribute;
  exports.jSXClosingElement = exports.jsxClosingElement = exports.JSXClosingElement = JSXClosingElement;
  exports.jSXElement = exports.jsxElement = exports.JSXElement = JSXElement;
  exports.jSXEmptyExpression = exports.jsxEmptyExpression = exports.JSXEmptyExpression = JSXEmptyExpression;
  exports.jSXExpressionContainer = exports.jsxExpressionContainer = exports.JSXExpressionContainer = JSXExpressionContainer;
  exports.jSXSpreadChild = exports.jsxSpreadChild = exports.JSXSpreadChild = JSXSpreadChild;
  exports.jSXIdentifier = exports.jsxIdentifier = exports.JSXIdentifier = JSXIdentifier;
  exports.jSXMemberExpression = exports.jsxMemberExpression = exports.JSXMemberExpression = JSXMemberExpression;
  exports.jSXNamespacedName = exports.jsxNamespacedName = exports.JSXNamespacedName = JSXNamespacedName;
  exports.jSXOpeningElement = exports.jsxOpeningElement = exports.JSXOpeningElement = JSXOpeningElement;
  exports.jSXSpreadAttribute = exports.jsxSpreadAttribute = exports.JSXSpreadAttribute = JSXSpreadAttribute;
  exports.jSXText = exports.jsxText = exports.JSXText = JSXText;
  exports.jSXFragment = exports.jsxFragment = exports.JSXFragment = JSXFragment;
  exports.jSXOpeningFragment = exports.jsxOpeningFragment = exports.JSXOpeningFragment = JSXOpeningFragment;
  exports.jSXClosingFragment = exports.jsxClosingFragment = exports.JSXClosingFragment = JSXClosingFragment;
  exports.noop = exports.Noop = Noop;
  exports.parenthesizedExpression = exports.ParenthesizedExpression = ParenthesizedExpression;
  exports.awaitExpression = exports.AwaitExpression = AwaitExpression;
  exports.bindExpression = exports.BindExpression = BindExpression;
  exports.classProperty = exports.ClassProperty = ClassProperty;
  exports.optionalMemberExpression = exports.OptionalMemberExpression = OptionalMemberExpression;
  exports.pipelineTopicExpression = exports.PipelineTopicExpression = PipelineTopicExpression;
  exports.pipelineBareFunction = exports.PipelineBareFunction = PipelineBareFunction;
  exports.pipelinePrimaryTopicReference = exports.PipelinePrimaryTopicReference = PipelinePrimaryTopicReference;
  exports.optionalCallExpression = exports.OptionalCallExpression = OptionalCallExpression;
  exports.classPrivateProperty = exports.ClassPrivateProperty = ClassPrivateProperty;
  exports.classPrivateMethod = exports.ClassPrivateMethod = ClassPrivateMethod;
  exports.import = exports.Import = Import;
  exports.decorator = exports.Decorator = Decorator;
  exports.doExpression = exports.DoExpression = DoExpression;
  exports.exportDefaultSpecifier = exports.ExportDefaultSpecifier = ExportDefaultSpecifier;
  exports.exportNamespaceSpecifier = exports.ExportNamespaceSpecifier = ExportNamespaceSpecifier;
  exports.privateName = exports.PrivateName = PrivateName;
  exports.bigIntLiteral = exports.BigIntLiteral = BigIntLiteral;
  exports.tSParameterProperty = exports.tsParameterProperty = exports.TSParameterProperty = TSParameterProperty;
  exports.tSDeclareFunction = exports.tsDeclareFunction = exports.TSDeclareFunction = TSDeclareFunction;
  exports.tSDeclareMethod = exports.tsDeclareMethod = exports.TSDeclareMethod = TSDeclareMethod;
  exports.tSQualifiedName = exports.tsQualifiedName = exports.TSQualifiedName = TSQualifiedName;
  exports.tSCallSignatureDeclaration = exports.tsCallSignatureDeclaration = exports.TSCallSignatureDeclaration = TSCallSignatureDeclaration;
  exports.tSConstructSignatureDeclaration = exports.tsConstructSignatureDeclaration = exports.TSConstructSignatureDeclaration = TSConstructSignatureDeclaration;
  exports.tSPropertySignature = exports.tsPropertySignature = exports.TSPropertySignature = TSPropertySignature;
  exports.tSMethodSignature = exports.tsMethodSignature = exports.TSMethodSignature = TSMethodSignature;
  exports.tSIndexSignature = exports.tsIndexSignature = exports.TSIndexSignature = TSIndexSignature;
  exports.tSAnyKeyword = exports.tsAnyKeyword = exports.TSAnyKeyword = TSAnyKeyword;
  exports.tSUnknownKeyword = exports.tsUnknownKeyword = exports.TSUnknownKeyword = TSUnknownKeyword;
  exports.tSNumberKeyword = exports.tsNumberKeyword = exports.TSNumberKeyword = TSNumberKeyword;
  exports.tSObjectKeyword = exports.tsObjectKeyword = exports.TSObjectKeyword = TSObjectKeyword;
  exports.tSBooleanKeyword = exports.tsBooleanKeyword = exports.TSBooleanKeyword = TSBooleanKeyword;
  exports.tSStringKeyword = exports.tsStringKeyword = exports.TSStringKeyword = TSStringKeyword;
  exports.tSSymbolKeyword = exports.tsSymbolKeyword = exports.TSSymbolKeyword = TSSymbolKeyword;
  exports.tSVoidKeyword = exports.tsVoidKeyword = exports.TSVoidKeyword = TSVoidKeyword;
  exports.tSUndefinedKeyword = exports.tsUndefinedKeyword = exports.TSUndefinedKeyword = TSUndefinedKeyword;
  exports.tSNullKeyword = exports.tsNullKeyword = exports.TSNullKeyword = TSNullKeyword;
  exports.tSNeverKeyword = exports.tsNeverKeyword = exports.TSNeverKeyword = TSNeverKeyword;
  exports.tSThisType = exports.tsThisType = exports.TSThisType = TSThisType;
  exports.tSFunctionType = exports.tsFunctionType = exports.TSFunctionType = TSFunctionType;
  exports.tSConstructorType = exports.tsConstructorType = exports.TSConstructorType = TSConstructorType;
  exports.tSTypeReference = exports.tsTypeReference = exports.TSTypeReference = TSTypeReference;
  exports.tSTypePredicate = exports.tsTypePredicate = exports.TSTypePredicate = TSTypePredicate;
  exports.tSTypeQuery = exports.tsTypeQuery = exports.TSTypeQuery = TSTypeQuery;
  exports.tSTypeLiteral = exports.tsTypeLiteral = exports.TSTypeLiteral = TSTypeLiteral;
  exports.tSArrayType = exports.tsArrayType = exports.TSArrayType = TSArrayType;
  exports.tSTupleType = exports.tsTupleType = exports.TSTupleType = TSTupleType;
  exports.tSOptionalType = exports.tsOptionalType = exports.TSOptionalType = TSOptionalType;
  exports.tSRestType = exports.tsRestType = exports.TSRestType = TSRestType;
  exports.tSUnionType = exports.tsUnionType = exports.TSUnionType = TSUnionType;
  exports.tSIntersectionType = exports.tsIntersectionType = exports.TSIntersectionType = TSIntersectionType;
  exports.tSConditionalType = exports.tsConditionalType = exports.TSConditionalType = TSConditionalType;
  exports.tSInferType = exports.tsInferType = exports.TSInferType = TSInferType;
  exports.tSParenthesizedType = exports.tsParenthesizedType = exports.TSParenthesizedType = TSParenthesizedType;
  exports.tSTypeOperator = exports.tsTypeOperator = exports.TSTypeOperator = TSTypeOperator;
  exports.tSIndexedAccessType = exports.tsIndexedAccessType = exports.TSIndexedAccessType = TSIndexedAccessType;
  exports.tSMappedType = exports.tsMappedType = exports.TSMappedType = TSMappedType;
  exports.tSLiteralType = exports.tsLiteralType = exports.TSLiteralType = TSLiteralType;
  exports.tSExpressionWithTypeArguments = exports.tsExpressionWithTypeArguments = exports.TSExpressionWithTypeArguments = TSExpressionWithTypeArguments;
  exports.tSInterfaceDeclaration = exports.tsInterfaceDeclaration = exports.TSInterfaceDeclaration = TSInterfaceDeclaration;
  exports.tSInterfaceBody = exports.tsInterfaceBody = exports.TSInterfaceBody = TSInterfaceBody;
  exports.tSTypeAliasDeclaration = exports.tsTypeAliasDeclaration = exports.TSTypeAliasDeclaration = TSTypeAliasDeclaration;
  exports.tSAsExpression = exports.tsAsExpression = exports.TSAsExpression = TSAsExpression;
  exports.tSTypeAssertion = exports.tsTypeAssertion = exports.TSTypeAssertion = TSTypeAssertion;
  exports.tSEnumDeclaration = exports.tsEnumDeclaration = exports.TSEnumDeclaration = TSEnumDeclaration;
  exports.tSEnumMember = exports.tsEnumMember = exports.TSEnumMember = TSEnumMember;
  exports.tSModuleDeclaration = exports.tsModuleDeclaration = exports.TSModuleDeclaration = TSModuleDeclaration;
  exports.tSModuleBlock = exports.tsModuleBlock = exports.TSModuleBlock = TSModuleBlock;
  exports.tSImportType = exports.tsImportType = exports.TSImportType = TSImportType;
  exports.tSImportEqualsDeclaration = exports.tsImportEqualsDeclaration = exports.TSImportEqualsDeclaration = TSImportEqualsDeclaration;
  exports.tSExternalModuleReference = exports.tsExternalModuleReference = exports.TSExternalModuleReference = TSExternalModuleReference;
  exports.tSNonNullExpression = exports.tsNonNullExpression = exports.TSNonNullExpression = TSNonNullExpression;
  exports.tSExportAssignment = exports.tsExportAssignment = exports.TSExportAssignment = TSExportAssignment;
  exports.tSNamespaceExportDeclaration = exports.tsNamespaceExportDeclaration = exports.TSNamespaceExportDeclaration = TSNamespaceExportDeclaration;
  exports.tSTypeAnnotation = exports.tsTypeAnnotation = exports.TSTypeAnnotation = TSTypeAnnotation;
  exports.tSTypeParameterInstantiation = exports.tsTypeParameterInstantiation = exports.TSTypeParameterInstantiation = TSTypeParameterInstantiation;
  exports.tSTypeParameterDeclaration = exports.tsTypeParameterDeclaration = exports.TSTypeParameterDeclaration = TSTypeParameterDeclaration;
  exports.tSTypeParameter = exports.tsTypeParameter = exports.TSTypeParameter = TSTypeParameter;
  exports.numberLiteral = exports.NumberLiteral = NumberLiteral;
  exports.regexLiteral = exports.RegexLiteral = RegexLiteral;
  exports.restProperty = exports.RestProperty = RestProperty;
  exports.spreadProperty = exports.SpreadProperty = SpreadProperty;
  var _builder = _interopRequireDefault(builder_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function ArrayExpression() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    return (0, _builder.default)("ArrayExpression", ...args);
  }
  function AssignmentExpression() {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }
    return (0, _builder.default)("AssignmentExpression", ...args);
  }
  function BinaryExpression() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    return (0, _builder.default)("BinaryExpression", ...args);
  }
  function InterpreterDirective() {
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }
    return (0, _builder.default)("InterpreterDirective", ...args);
  }
  function Directive() {
    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }
    return (0, _builder.default)("Directive", ...args);
  }
  function DirectiveLiteral() {
    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }
    return (0, _builder.default)("DirectiveLiteral", ...args);
  }
  function BlockStatement() {
    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }
    return (0, _builder.default)("BlockStatement", ...args);
  }
  function BreakStatement() {
    for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      args[_key14] = arguments[_key14];
    }
    return (0, _builder.default)("BreakStatement", ...args);
  }
  function CallExpression() {
    for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      args[_key15] = arguments[_key15];
    }
    return (0, _builder.default)("CallExpression", ...args);
  }
  function CatchClause() {
    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }
    return (0, _builder.default)("CatchClause", ...args);
  }
  function ConditionalExpression() {
    for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      args[_key17] = arguments[_key17];
    }
    return (0, _builder.default)("ConditionalExpression", ...args);
  }
  function ContinueStatement() {
    for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
      args[_key18] = arguments[_key18];
    }
    return (0, _builder.default)("ContinueStatement", ...args);
  }
  function DebuggerStatement() {
    for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
      args[_key19] = arguments[_key19];
    }
    return (0, _builder.default)("DebuggerStatement", ...args);
  }
  function DoWhileStatement() {
    for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      args[_key20] = arguments[_key20];
    }
    return (0, _builder.default)("DoWhileStatement", ...args);
  }
  function EmptyStatement() {
    for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      args[_key21] = arguments[_key21];
    }
    return (0, _builder.default)("EmptyStatement", ...args);
  }
  function ExpressionStatement() {
    for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      args[_key22] = arguments[_key22];
    }
    return (0, _builder.default)("ExpressionStatement", ...args);
  }
  function File() {
    for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      args[_key23] = arguments[_key23];
    }
    return (0, _builder.default)("File", ...args);
  }
  function ForInStatement() {
    for (var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      args[_key24] = arguments[_key24];
    }
    return (0, _builder.default)("ForInStatement", ...args);
  }
  function ForStatement() {
    for (var _len25 = arguments.length, args = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
      args[_key25] = arguments[_key25];
    }
    return (0, _builder.default)("ForStatement", ...args);
  }
  function FunctionDeclaration() {
    for (var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
      args[_key26] = arguments[_key26];
    }
    return (0, _builder.default)("FunctionDeclaration", ...args);
  }
  function FunctionExpression() {
    for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
      args[_key27] = arguments[_key27];
    }
    return (0, _builder.default)("FunctionExpression", ...args);
  }
  function Identifier() {
    for (var _len28 = arguments.length, args = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
      args[_key28] = arguments[_key28];
    }
    return (0, _builder.default)("Identifier", ...args);
  }
  function IfStatement() {
    for (var _len29 = arguments.length, args = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
      args[_key29] = arguments[_key29];
    }
    return (0, _builder.default)("IfStatement", ...args);
  }
  function LabeledStatement() {
    for (var _len30 = arguments.length, args = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
      args[_key30] = arguments[_key30];
    }
    return (0, _builder.default)("LabeledStatement", ...args);
  }
  function StringLiteral() {
    for (var _len31 = arguments.length, args = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
      args[_key31] = arguments[_key31];
    }
    return (0, _builder.default)("StringLiteral", ...args);
  }
  function NumericLiteral() {
    for (var _len32 = arguments.length, args = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
      args[_key32] = arguments[_key32];
    }
    return (0, _builder.default)("NumericLiteral", ...args);
  }
  function NullLiteral() {
    for (var _len33 = arguments.length, args = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
      args[_key33] = arguments[_key33];
    }
    return (0, _builder.default)("NullLiteral", ...args);
  }
  function BooleanLiteral() {
    for (var _len34 = arguments.length, args = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
      args[_key34] = arguments[_key34];
    }
    return (0, _builder.default)("BooleanLiteral", ...args);
  }
  function RegExpLiteral() {
    for (var _len35 = arguments.length, args = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
      args[_key35] = arguments[_key35];
    }
    return (0, _builder.default)("RegExpLiteral", ...args);
  }
  function LogicalExpression() {
    for (var _len36 = arguments.length, args = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
      args[_key36] = arguments[_key36];
    }
    return (0, _builder.default)("LogicalExpression", ...args);
  }
  function MemberExpression() {
    for (var _len37 = arguments.length, args = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
      args[_key37] = arguments[_key37];
    }
    return (0, _builder.default)("MemberExpression", ...args);
  }
  function NewExpression() {
    for (var _len38 = arguments.length, args = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
      args[_key38] = arguments[_key38];
    }
    return (0, _builder.default)("NewExpression", ...args);
  }
  function Program() {
    for (var _len39 = arguments.length, args = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
      args[_key39] = arguments[_key39];
    }
    return (0, _builder.default)("Program", ...args);
  }
  function ObjectExpression() {
    for (var _len40 = arguments.length, args = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
      args[_key40] = arguments[_key40];
    }
    return (0, _builder.default)("ObjectExpression", ...args);
  }
  function ObjectMethod() {
    for (var _len41 = arguments.length, args = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
      args[_key41] = arguments[_key41];
    }
    return (0, _builder.default)("ObjectMethod", ...args);
  }
  function ObjectProperty() {
    for (var _len42 = arguments.length, args = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
      args[_key42] = arguments[_key42];
    }
    return (0, _builder.default)("ObjectProperty", ...args);
  }
  function RestElement() {
    for (var _len43 = arguments.length, args = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
      args[_key43] = arguments[_key43];
    }
    return (0, _builder.default)("RestElement", ...args);
  }
  function ReturnStatement() {
    for (var _len44 = arguments.length, args = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
      args[_key44] = arguments[_key44];
    }
    return (0, _builder.default)("ReturnStatement", ...args);
  }
  function SequenceExpression() {
    for (var _len45 = arguments.length, args = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
      args[_key45] = arguments[_key45];
    }
    return (0, _builder.default)("SequenceExpression", ...args);
  }
  function SwitchCase() {
    for (var _len46 = arguments.length, args = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
      args[_key46] = arguments[_key46];
    }
    return (0, _builder.default)("SwitchCase", ...args);
  }
  function SwitchStatement() {
    for (var _len47 = arguments.length, args = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
      args[_key47] = arguments[_key47];
    }
    return (0, _builder.default)("SwitchStatement", ...args);
  }
  function ThisExpression() {
    for (var _len48 = arguments.length, args = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
      args[_key48] = arguments[_key48];
    }
    return (0, _builder.default)("ThisExpression", ...args);
  }
  function ThrowStatement() {
    for (var _len49 = arguments.length, args = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
      args[_key49] = arguments[_key49];
    }
    return (0, _builder.default)("ThrowStatement", ...args);
  }
  function TryStatement() {
    for (var _len50 = arguments.length, args = new Array(_len50), _key50 = 0; _key50 < _len50; _key50++) {
      args[_key50] = arguments[_key50];
    }
    return (0, _builder.default)("TryStatement", ...args);
  }
  function UnaryExpression() {
    for (var _len51 = arguments.length, args = new Array(_len51), _key51 = 0; _key51 < _len51; _key51++) {
      args[_key51] = arguments[_key51];
    }
    return (0, _builder.default)("UnaryExpression", ...args);
  }
  function UpdateExpression() {
    for (var _len52 = arguments.length, args = new Array(_len52), _key52 = 0; _key52 < _len52; _key52++) {
      args[_key52] = arguments[_key52];
    }
    return (0, _builder.default)("UpdateExpression", ...args);
  }
  function VariableDeclaration() {
    for (var _len53 = arguments.length, args = new Array(_len53), _key53 = 0; _key53 < _len53; _key53++) {
      args[_key53] = arguments[_key53];
    }
    return (0, _builder.default)("VariableDeclaration", ...args);
  }
  function VariableDeclarator() {
    for (var _len54 = arguments.length, args = new Array(_len54), _key54 = 0; _key54 < _len54; _key54++) {
      args[_key54] = arguments[_key54];
    }
    return (0, _builder.default)("VariableDeclarator", ...args);
  }
  function WhileStatement() {
    for (var _len55 = arguments.length, args = new Array(_len55), _key55 = 0; _key55 < _len55; _key55++) {
      args[_key55] = arguments[_key55];
    }
    return (0, _builder.default)("WhileStatement", ...args);
  }
  function WithStatement() {
    for (var _len56 = arguments.length, args = new Array(_len56), _key56 = 0; _key56 < _len56; _key56++) {
      args[_key56] = arguments[_key56];
    }
    return (0, _builder.default)("WithStatement", ...args);
  }
  function AssignmentPattern() {
    for (var _len57 = arguments.length, args = new Array(_len57), _key57 = 0; _key57 < _len57; _key57++) {
      args[_key57] = arguments[_key57];
    }
    return (0, _builder.default)("AssignmentPattern", ...args);
  }
  function ArrayPattern() {
    for (var _len58 = arguments.length, args = new Array(_len58), _key58 = 0; _key58 < _len58; _key58++) {
      args[_key58] = arguments[_key58];
    }
    return (0, _builder.default)("ArrayPattern", ...args);
  }
  function ArrowFunctionExpression() {
    for (var _len59 = arguments.length, args = new Array(_len59), _key59 = 0; _key59 < _len59; _key59++) {
      args[_key59] = arguments[_key59];
    }
    return (0, _builder.default)("ArrowFunctionExpression", ...args);
  }
  function ClassBody() {
    for (var _len60 = arguments.length, args = new Array(_len60), _key60 = 0; _key60 < _len60; _key60++) {
      args[_key60] = arguments[_key60];
    }
    return (0, _builder.default)("ClassBody", ...args);
  }
  function ClassDeclaration() {
    for (var _len61 = arguments.length, args = new Array(_len61), _key61 = 0; _key61 < _len61; _key61++) {
      args[_key61] = arguments[_key61];
    }
    return (0, _builder.default)("ClassDeclaration", ...args);
  }
  function ClassExpression() {
    for (var _len62 = arguments.length, args = new Array(_len62), _key62 = 0; _key62 < _len62; _key62++) {
      args[_key62] = arguments[_key62];
    }
    return (0, _builder.default)("ClassExpression", ...args);
  }
  function ExportAllDeclaration() {
    for (var _len63 = arguments.length, args = new Array(_len63), _key63 = 0; _key63 < _len63; _key63++) {
      args[_key63] = arguments[_key63];
    }
    return (0, _builder.default)("ExportAllDeclaration", ...args);
  }
  function ExportDefaultDeclaration() {
    for (var _len64 = arguments.length, args = new Array(_len64), _key64 = 0; _key64 < _len64; _key64++) {
      args[_key64] = arguments[_key64];
    }
    return (0, _builder.default)("ExportDefaultDeclaration", ...args);
  }
  function ExportNamedDeclaration() {
    for (var _len65 = arguments.length, args = new Array(_len65), _key65 = 0; _key65 < _len65; _key65++) {
      args[_key65] = arguments[_key65];
    }
    return (0, _builder.default)("ExportNamedDeclaration", ...args);
  }
  function ExportSpecifier() {
    for (var _len66 = arguments.length, args = new Array(_len66), _key66 = 0; _key66 < _len66; _key66++) {
      args[_key66] = arguments[_key66];
    }
    return (0, _builder.default)("ExportSpecifier", ...args);
  }
  function ForOfStatement() {
    for (var _len67 = arguments.length, args = new Array(_len67), _key67 = 0; _key67 < _len67; _key67++) {
      args[_key67] = arguments[_key67];
    }
    return (0, _builder.default)("ForOfStatement", ...args);
  }
  function ImportDeclaration() {
    for (var _len68 = arguments.length, args = new Array(_len68), _key68 = 0; _key68 < _len68; _key68++) {
      args[_key68] = arguments[_key68];
    }
    return (0, _builder.default)("ImportDeclaration", ...args);
  }
  function ImportDefaultSpecifier() {
    for (var _len69 = arguments.length, args = new Array(_len69), _key69 = 0; _key69 < _len69; _key69++) {
      args[_key69] = arguments[_key69];
    }
    return (0, _builder.default)("ImportDefaultSpecifier", ...args);
  }
  function ImportNamespaceSpecifier() {
    for (var _len70 = arguments.length, args = new Array(_len70), _key70 = 0; _key70 < _len70; _key70++) {
      args[_key70] = arguments[_key70];
    }
    return (0, _builder.default)("ImportNamespaceSpecifier", ...args);
  }
  function ImportSpecifier() {
    for (var _len71 = arguments.length, args = new Array(_len71), _key71 = 0; _key71 < _len71; _key71++) {
      args[_key71] = arguments[_key71];
    }
    return (0, _builder.default)("ImportSpecifier", ...args);
  }
  function MetaProperty() {
    for (var _len72 = arguments.length, args = new Array(_len72), _key72 = 0; _key72 < _len72; _key72++) {
      args[_key72] = arguments[_key72];
    }
    return (0, _builder.default)("MetaProperty", ...args);
  }
  function ClassMethod() {
    for (var _len73 = arguments.length, args = new Array(_len73), _key73 = 0; _key73 < _len73; _key73++) {
      args[_key73] = arguments[_key73];
    }
    return (0, _builder.default)("ClassMethod", ...args);
  }
  function ObjectPattern() {
    for (var _len74 = arguments.length, args = new Array(_len74), _key74 = 0; _key74 < _len74; _key74++) {
      args[_key74] = arguments[_key74];
    }
    return (0, _builder.default)("ObjectPattern", ...args);
  }
  function SpreadElement() {
    for (var _len75 = arguments.length, args = new Array(_len75), _key75 = 0; _key75 < _len75; _key75++) {
      args[_key75] = arguments[_key75];
    }
    return (0, _builder.default)("SpreadElement", ...args);
  }
  function Super() {
    for (var _len76 = arguments.length, args = new Array(_len76), _key76 = 0; _key76 < _len76; _key76++) {
      args[_key76] = arguments[_key76];
    }
    return (0, _builder.default)("Super", ...args);
  }
  function TaggedTemplateExpression() {
    for (var _len77 = arguments.length, args = new Array(_len77), _key77 = 0; _key77 < _len77; _key77++) {
      args[_key77] = arguments[_key77];
    }
    return (0, _builder.default)("TaggedTemplateExpression", ...args);
  }
  function TemplateElement() {
    for (var _len78 = arguments.length, args = new Array(_len78), _key78 = 0; _key78 < _len78; _key78++) {
      args[_key78] = arguments[_key78];
    }
    return (0, _builder.default)("TemplateElement", ...args);
  }
  function TemplateLiteral() {
    for (var _len79 = arguments.length, args = new Array(_len79), _key79 = 0; _key79 < _len79; _key79++) {
      args[_key79] = arguments[_key79];
    }
    return (0, _builder.default)("TemplateLiteral", ...args);
  }
  function YieldExpression() {
    for (var _len80 = arguments.length, args = new Array(_len80), _key80 = 0; _key80 < _len80; _key80++) {
      args[_key80] = arguments[_key80];
    }
    return (0, _builder.default)("YieldExpression", ...args);
  }
  function AnyTypeAnnotation() {
    for (var _len81 = arguments.length, args = new Array(_len81), _key81 = 0; _key81 < _len81; _key81++) {
      args[_key81] = arguments[_key81];
    }
    return (0, _builder.default)("AnyTypeAnnotation", ...args);
  }
  function ArrayTypeAnnotation() {
    for (var _len82 = arguments.length, args = new Array(_len82), _key82 = 0; _key82 < _len82; _key82++) {
      args[_key82] = arguments[_key82];
    }
    return (0, _builder.default)("ArrayTypeAnnotation", ...args);
  }
  function BooleanTypeAnnotation() {
    for (var _len83 = arguments.length, args = new Array(_len83), _key83 = 0; _key83 < _len83; _key83++) {
      args[_key83] = arguments[_key83];
    }
    return (0, _builder.default)("BooleanTypeAnnotation", ...args);
  }
  function BooleanLiteralTypeAnnotation() {
    for (var _len84 = arguments.length, args = new Array(_len84), _key84 = 0; _key84 < _len84; _key84++) {
      args[_key84] = arguments[_key84];
    }
    return (0, _builder.default)("BooleanLiteralTypeAnnotation", ...args);
  }
  function NullLiteralTypeAnnotation() {
    for (var _len85 = arguments.length, args = new Array(_len85), _key85 = 0; _key85 < _len85; _key85++) {
      args[_key85] = arguments[_key85];
    }
    return (0, _builder.default)("NullLiteralTypeAnnotation", ...args);
  }
  function ClassImplements() {
    for (var _len86 = arguments.length, args = new Array(_len86), _key86 = 0; _key86 < _len86; _key86++) {
      args[_key86] = arguments[_key86];
    }
    return (0, _builder.default)("ClassImplements", ...args);
  }
  function DeclareClass() {
    for (var _len87 = arguments.length, args = new Array(_len87), _key87 = 0; _key87 < _len87; _key87++) {
      args[_key87] = arguments[_key87];
    }
    return (0, _builder.default)("DeclareClass", ...args);
  }
  function DeclareFunction() {
    for (var _len88 = arguments.length, args = new Array(_len88), _key88 = 0; _key88 < _len88; _key88++) {
      args[_key88] = arguments[_key88];
    }
    return (0, _builder.default)("DeclareFunction", ...args);
  }
  function DeclareInterface() {
    for (var _len89 = arguments.length, args = new Array(_len89), _key89 = 0; _key89 < _len89; _key89++) {
      args[_key89] = arguments[_key89];
    }
    return (0, _builder.default)("DeclareInterface", ...args);
  }
  function DeclareModule() {
    for (var _len90 = arguments.length, args = new Array(_len90), _key90 = 0; _key90 < _len90; _key90++) {
      args[_key90] = arguments[_key90];
    }
    return (0, _builder.default)("DeclareModule", ...args);
  }
  function DeclareModuleExports() {
    for (var _len91 = arguments.length, args = new Array(_len91), _key91 = 0; _key91 < _len91; _key91++) {
      args[_key91] = arguments[_key91];
    }
    return (0, _builder.default)("DeclareModuleExports", ...args);
  }
  function DeclareTypeAlias() {
    for (var _len92 = arguments.length, args = new Array(_len92), _key92 = 0; _key92 < _len92; _key92++) {
      args[_key92] = arguments[_key92];
    }
    return (0, _builder.default)("DeclareTypeAlias", ...args);
  }
  function DeclareOpaqueType() {
    for (var _len93 = arguments.length, args = new Array(_len93), _key93 = 0; _key93 < _len93; _key93++) {
      args[_key93] = arguments[_key93];
    }
    return (0, _builder.default)("DeclareOpaqueType", ...args);
  }
  function DeclareVariable() {
    for (var _len94 = arguments.length, args = new Array(_len94), _key94 = 0; _key94 < _len94; _key94++) {
      args[_key94] = arguments[_key94];
    }
    return (0, _builder.default)("DeclareVariable", ...args);
  }
  function DeclareExportDeclaration() {
    for (var _len95 = arguments.length, args = new Array(_len95), _key95 = 0; _key95 < _len95; _key95++) {
      args[_key95] = arguments[_key95];
    }
    return (0, _builder.default)("DeclareExportDeclaration", ...args);
  }
  function DeclareExportAllDeclaration() {
    for (var _len96 = arguments.length, args = new Array(_len96), _key96 = 0; _key96 < _len96; _key96++) {
      args[_key96] = arguments[_key96];
    }
    return (0, _builder.default)("DeclareExportAllDeclaration", ...args);
  }
  function DeclaredPredicate() {
    for (var _len97 = arguments.length, args = new Array(_len97), _key97 = 0; _key97 < _len97; _key97++) {
      args[_key97] = arguments[_key97];
    }
    return (0, _builder.default)("DeclaredPredicate", ...args);
  }
  function ExistsTypeAnnotation() {
    for (var _len98 = arguments.length, args = new Array(_len98), _key98 = 0; _key98 < _len98; _key98++) {
      args[_key98] = arguments[_key98];
    }
    return (0, _builder.default)("ExistsTypeAnnotation", ...args);
  }
  function FunctionTypeAnnotation() {
    for (var _len99 = arguments.length, args = new Array(_len99), _key99 = 0; _key99 < _len99; _key99++) {
      args[_key99] = arguments[_key99];
    }
    return (0, _builder.default)("FunctionTypeAnnotation", ...args);
  }
  function FunctionTypeParam() {
    for (var _len100 = arguments.length, args = new Array(_len100), _key100 = 0; _key100 < _len100; _key100++) {
      args[_key100] = arguments[_key100];
    }
    return (0, _builder.default)("FunctionTypeParam", ...args);
  }
  function GenericTypeAnnotation() {
    for (var _len101 = arguments.length, args = new Array(_len101), _key101 = 0; _key101 < _len101; _key101++) {
      args[_key101] = arguments[_key101];
    }
    return (0, _builder.default)("GenericTypeAnnotation", ...args);
  }
  function InferredPredicate() {
    for (var _len102 = arguments.length, args = new Array(_len102), _key102 = 0; _key102 < _len102; _key102++) {
      args[_key102] = arguments[_key102];
    }
    return (0, _builder.default)("InferredPredicate", ...args);
  }
  function InterfaceExtends() {
    for (var _len103 = arguments.length, args = new Array(_len103), _key103 = 0; _key103 < _len103; _key103++) {
      args[_key103] = arguments[_key103];
    }
    return (0, _builder.default)("InterfaceExtends", ...args);
  }
  function InterfaceDeclaration() {
    for (var _len104 = arguments.length, args = new Array(_len104), _key104 = 0; _key104 < _len104; _key104++) {
      args[_key104] = arguments[_key104];
    }
    return (0, _builder.default)("InterfaceDeclaration", ...args);
  }
  function InterfaceTypeAnnotation() {
    for (var _len105 = arguments.length, args = new Array(_len105), _key105 = 0; _key105 < _len105; _key105++) {
      args[_key105] = arguments[_key105];
    }
    return (0, _builder.default)("InterfaceTypeAnnotation", ...args);
  }
  function IntersectionTypeAnnotation() {
    for (var _len106 = arguments.length, args = new Array(_len106), _key106 = 0; _key106 < _len106; _key106++) {
      args[_key106] = arguments[_key106];
    }
    return (0, _builder.default)("IntersectionTypeAnnotation", ...args);
  }
  function MixedTypeAnnotation() {
    for (var _len107 = arguments.length, args = new Array(_len107), _key107 = 0; _key107 < _len107; _key107++) {
      args[_key107] = arguments[_key107];
    }
    return (0, _builder.default)("MixedTypeAnnotation", ...args);
  }
  function EmptyTypeAnnotation() {
    for (var _len108 = arguments.length, args = new Array(_len108), _key108 = 0; _key108 < _len108; _key108++) {
      args[_key108] = arguments[_key108];
    }
    return (0, _builder.default)("EmptyTypeAnnotation", ...args);
  }
  function NullableTypeAnnotation() {
    for (var _len109 = arguments.length, args = new Array(_len109), _key109 = 0; _key109 < _len109; _key109++) {
      args[_key109] = arguments[_key109];
    }
    return (0, _builder.default)("NullableTypeAnnotation", ...args);
  }
  function NumberLiteralTypeAnnotation() {
    for (var _len110 = arguments.length, args = new Array(_len110), _key110 = 0; _key110 < _len110; _key110++) {
      args[_key110] = arguments[_key110];
    }
    return (0, _builder.default)("NumberLiteralTypeAnnotation", ...args);
  }
  function NumberTypeAnnotation() {
    for (var _len111 = arguments.length, args = new Array(_len111), _key111 = 0; _key111 < _len111; _key111++) {
      args[_key111] = arguments[_key111];
    }
    return (0, _builder.default)("NumberTypeAnnotation", ...args);
  }
  function ObjectTypeAnnotation() {
    for (var _len112 = arguments.length, args = new Array(_len112), _key112 = 0; _key112 < _len112; _key112++) {
      args[_key112] = arguments[_key112];
    }
    return (0, _builder.default)("ObjectTypeAnnotation", ...args);
  }
  function ObjectTypeInternalSlot() {
    for (var _len113 = arguments.length, args = new Array(_len113), _key113 = 0; _key113 < _len113; _key113++) {
      args[_key113] = arguments[_key113];
    }
    return (0, _builder.default)("ObjectTypeInternalSlot", ...args);
  }
  function ObjectTypeCallProperty() {
    for (var _len114 = arguments.length, args = new Array(_len114), _key114 = 0; _key114 < _len114; _key114++) {
      args[_key114] = arguments[_key114];
    }
    return (0, _builder.default)("ObjectTypeCallProperty", ...args);
  }
  function ObjectTypeIndexer() {
    for (var _len115 = arguments.length, args = new Array(_len115), _key115 = 0; _key115 < _len115; _key115++) {
      args[_key115] = arguments[_key115];
    }
    return (0, _builder.default)("ObjectTypeIndexer", ...args);
  }
  function ObjectTypeProperty() {
    for (var _len116 = arguments.length, args = new Array(_len116), _key116 = 0; _key116 < _len116; _key116++) {
      args[_key116] = arguments[_key116];
    }
    return (0, _builder.default)("ObjectTypeProperty", ...args);
  }
  function ObjectTypeSpreadProperty() {
    for (var _len117 = arguments.length, args = new Array(_len117), _key117 = 0; _key117 < _len117; _key117++) {
      args[_key117] = arguments[_key117];
    }
    return (0, _builder.default)("ObjectTypeSpreadProperty", ...args);
  }
  function OpaqueType() {
    for (var _len118 = arguments.length, args = new Array(_len118), _key118 = 0; _key118 < _len118; _key118++) {
      args[_key118] = arguments[_key118];
    }
    return (0, _builder.default)("OpaqueType", ...args);
  }
  function QualifiedTypeIdentifier() {
    for (var _len119 = arguments.length, args = new Array(_len119), _key119 = 0; _key119 < _len119; _key119++) {
      args[_key119] = arguments[_key119];
    }
    return (0, _builder.default)("QualifiedTypeIdentifier", ...args);
  }
  function StringLiteralTypeAnnotation() {
    for (var _len120 = arguments.length, args = new Array(_len120), _key120 = 0; _key120 < _len120; _key120++) {
      args[_key120] = arguments[_key120];
    }
    return (0, _builder.default)("StringLiteralTypeAnnotation", ...args);
  }
  function StringTypeAnnotation() {
    for (var _len121 = arguments.length, args = new Array(_len121), _key121 = 0; _key121 < _len121; _key121++) {
      args[_key121] = arguments[_key121];
    }
    return (0, _builder.default)("StringTypeAnnotation", ...args);
  }
  function ThisTypeAnnotation() {
    for (var _len122 = arguments.length, args = new Array(_len122), _key122 = 0; _key122 < _len122; _key122++) {
      args[_key122] = arguments[_key122];
    }
    return (0, _builder.default)("ThisTypeAnnotation", ...args);
  }
  function TupleTypeAnnotation() {
    for (var _len123 = arguments.length, args = new Array(_len123), _key123 = 0; _key123 < _len123; _key123++) {
      args[_key123] = arguments[_key123];
    }
    return (0, _builder.default)("TupleTypeAnnotation", ...args);
  }
  function TypeofTypeAnnotation() {
    for (var _len124 = arguments.length, args = new Array(_len124), _key124 = 0; _key124 < _len124; _key124++) {
      args[_key124] = arguments[_key124];
    }
    return (0, _builder.default)("TypeofTypeAnnotation", ...args);
  }
  function TypeAlias() {
    for (var _len125 = arguments.length, args = new Array(_len125), _key125 = 0; _key125 < _len125; _key125++) {
      args[_key125] = arguments[_key125];
    }
    return (0, _builder.default)("TypeAlias", ...args);
  }
  function TypeAnnotation() {
    for (var _len126 = arguments.length, args = new Array(_len126), _key126 = 0; _key126 < _len126; _key126++) {
      args[_key126] = arguments[_key126];
    }
    return (0, _builder.default)("TypeAnnotation", ...args);
  }
  function TypeCastExpression() {
    for (var _len127 = arguments.length, args = new Array(_len127), _key127 = 0; _key127 < _len127; _key127++) {
      args[_key127] = arguments[_key127];
    }
    return (0, _builder.default)("TypeCastExpression", ...args);
  }
  function TypeParameter() {
    for (var _len128 = arguments.length, args = new Array(_len128), _key128 = 0; _key128 < _len128; _key128++) {
      args[_key128] = arguments[_key128];
    }
    return (0, _builder.default)("TypeParameter", ...args);
  }
  function TypeParameterDeclaration() {
    for (var _len129 = arguments.length, args = new Array(_len129), _key129 = 0; _key129 < _len129; _key129++) {
      args[_key129] = arguments[_key129];
    }
    return (0, _builder.default)("TypeParameterDeclaration", ...args);
  }
  function TypeParameterInstantiation() {
    for (var _len130 = arguments.length, args = new Array(_len130), _key130 = 0; _key130 < _len130; _key130++) {
      args[_key130] = arguments[_key130];
    }
    return (0, _builder.default)("TypeParameterInstantiation", ...args);
  }
  function UnionTypeAnnotation() {
    for (var _len131 = arguments.length, args = new Array(_len131), _key131 = 0; _key131 < _len131; _key131++) {
      args[_key131] = arguments[_key131];
    }
    return (0, _builder.default)("UnionTypeAnnotation", ...args);
  }
  function Variance() {
    for (var _len132 = arguments.length, args = new Array(_len132), _key132 = 0; _key132 < _len132; _key132++) {
      args[_key132] = arguments[_key132];
    }
    return (0, _builder.default)("Variance", ...args);
  }
  function VoidTypeAnnotation() {
    for (var _len133 = arguments.length, args = new Array(_len133), _key133 = 0; _key133 < _len133; _key133++) {
      args[_key133] = arguments[_key133];
    }
    return (0, _builder.default)("VoidTypeAnnotation", ...args);
  }
  function JSXAttribute() {
    for (var _len134 = arguments.length, args = new Array(_len134), _key134 = 0; _key134 < _len134; _key134++) {
      args[_key134] = arguments[_key134];
    }
    return (0, _builder.default)("JSXAttribute", ...args);
  }
  function JSXClosingElement() {
    for (var _len135 = arguments.length, args = new Array(_len135), _key135 = 0; _key135 < _len135; _key135++) {
      args[_key135] = arguments[_key135];
    }
    return (0, _builder.default)("JSXClosingElement", ...args);
  }
  function JSXElement() {
    for (var _len136 = arguments.length, args = new Array(_len136), _key136 = 0; _key136 < _len136; _key136++) {
      args[_key136] = arguments[_key136];
    }
    return (0, _builder.default)("JSXElement", ...args);
  }
  function JSXEmptyExpression() {
    for (var _len137 = arguments.length, args = new Array(_len137), _key137 = 0; _key137 < _len137; _key137++) {
      args[_key137] = arguments[_key137];
    }
    return (0, _builder.default)("JSXEmptyExpression", ...args);
  }
  function JSXExpressionContainer() {
    for (var _len138 = arguments.length, args = new Array(_len138), _key138 = 0; _key138 < _len138; _key138++) {
      args[_key138] = arguments[_key138];
    }
    return (0, _builder.default)("JSXExpressionContainer", ...args);
  }
  function JSXSpreadChild() {
    for (var _len139 = arguments.length, args = new Array(_len139), _key139 = 0; _key139 < _len139; _key139++) {
      args[_key139] = arguments[_key139];
    }
    return (0, _builder.default)("JSXSpreadChild", ...args);
  }
  function JSXIdentifier() {
    for (var _len140 = arguments.length, args = new Array(_len140), _key140 = 0; _key140 < _len140; _key140++) {
      args[_key140] = arguments[_key140];
    }
    return (0, _builder.default)("JSXIdentifier", ...args);
  }
  function JSXMemberExpression() {
    for (var _len141 = arguments.length, args = new Array(_len141), _key141 = 0; _key141 < _len141; _key141++) {
      args[_key141] = arguments[_key141];
    }
    return (0, _builder.default)("JSXMemberExpression", ...args);
  }
  function JSXNamespacedName() {
    for (var _len142 = arguments.length, args = new Array(_len142), _key142 = 0; _key142 < _len142; _key142++) {
      args[_key142] = arguments[_key142];
    }
    return (0, _builder.default)("JSXNamespacedName", ...args);
  }
  function JSXOpeningElement() {
    for (var _len143 = arguments.length, args = new Array(_len143), _key143 = 0; _key143 < _len143; _key143++) {
      args[_key143] = arguments[_key143];
    }
    return (0, _builder.default)("JSXOpeningElement", ...args);
  }
  function JSXSpreadAttribute() {
    for (var _len144 = arguments.length, args = new Array(_len144), _key144 = 0; _key144 < _len144; _key144++) {
      args[_key144] = arguments[_key144];
    }
    return (0, _builder.default)("JSXSpreadAttribute", ...args);
  }
  function JSXText() {
    for (var _len145 = arguments.length, args = new Array(_len145), _key145 = 0; _key145 < _len145; _key145++) {
      args[_key145] = arguments[_key145];
    }
    return (0, _builder.default)("JSXText", ...args);
  }
  function JSXFragment() {
    for (var _len146 = arguments.length, args = new Array(_len146), _key146 = 0; _key146 < _len146; _key146++) {
      args[_key146] = arguments[_key146];
    }
    return (0, _builder.default)("JSXFragment", ...args);
  }
  function JSXOpeningFragment() {
    for (var _len147 = arguments.length, args = new Array(_len147), _key147 = 0; _key147 < _len147; _key147++) {
      args[_key147] = arguments[_key147];
    }
    return (0, _builder.default)("JSXOpeningFragment", ...args);
  }
  function JSXClosingFragment() {
    for (var _len148 = arguments.length, args = new Array(_len148), _key148 = 0; _key148 < _len148; _key148++) {
      args[_key148] = arguments[_key148];
    }
    return (0, _builder.default)("JSXClosingFragment", ...args);
  }
  function Noop() {
    for (var _len149 = arguments.length, args = new Array(_len149), _key149 = 0; _key149 < _len149; _key149++) {
      args[_key149] = arguments[_key149];
    }
    return (0, _builder.default)("Noop", ...args);
  }
  function ParenthesizedExpression() {
    for (var _len150 = arguments.length, args = new Array(_len150), _key150 = 0; _key150 < _len150; _key150++) {
      args[_key150] = arguments[_key150];
    }
    return (0, _builder.default)("ParenthesizedExpression", ...args);
  }
  function AwaitExpression() {
    for (var _len151 = arguments.length, args = new Array(_len151), _key151 = 0; _key151 < _len151; _key151++) {
      args[_key151] = arguments[_key151];
    }
    return (0, _builder.default)("AwaitExpression", ...args);
  }
  function BindExpression() {
    for (var _len152 = arguments.length, args = new Array(_len152), _key152 = 0; _key152 < _len152; _key152++) {
      args[_key152] = arguments[_key152];
    }
    return (0, _builder.default)("BindExpression", ...args);
  }
  function ClassProperty() {
    for (var _len153 = arguments.length, args = new Array(_len153), _key153 = 0; _key153 < _len153; _key153++) {
      args[_key153] = arguments[_key153];
    }
    return (0, _builder.default)("ClassProperty", ...args);
  }
  function OptionalMemberExpression() {
    for (var _len154 = arguments.length, args = new Array(_len154), _key154 = 0; _key154 < _len154; _key154++) {
      args[_key154] = arguments[_key154];
    }
    return (0, _builder.default)("OptionalMemberExpression", ...args);
  }
  function PipelineTopicExpression() {
    for (var _len155 = arguments.length, args = new Array(_len155), _key155 = 0; _key155 < _len155; _key155++) {
      args[_key155] = arguments[_key155];
    }
    return (0, _builder.default)("PipelineTopicExpression", ...args);
  }
  function PipelineBareFunction() {
    for (var _len156 = arguments.length, args = new Array(_len156), _key156 = 0; _key156 < _len156; _key156++) {
      args[_key156] = arguments[_key156];
    }
    return (0, _builder.default)("PipelineBareFunction", ...args);
  }
  function PipelinePrimaryTopicReference() {
    for (var _len157 = arguments.length, args = new Array(_len157), _key157 = 0; _key157 < _len157; _key157++) {
      args[_key157] = arguments[_key157];
    }
    return (0, _builder.default)("PipelinePrimaryTopicReference", ...args);
  }
  function OptionalCallExpression() {
    for (var _len158 = arguments.length, args = new Array(_len158), _key158 = 0; _key158 < _len158; _key158++) {
      args[_key158] = arguments[_key158];
    }
    return (0, _builder.default)("OptionalCallExpression", ...args);
  }
  function ClassPrivateProperty() {
    for (var _len159 = arguments.length, args = new Array(_len159), _key159 = 0; _key159 < _len159; _key159++) {
      args[_key159] = arguments[_key159];
    }
    return (0, _builder.default)("ClassPrivateProperty", ...args);
  }
  function ClassPrivateMethod() {
    for (var _len160 = arguments.length, args = new Array(_len160), _key160 = 0; _key160 < _len160; _key160++) {
      args[_key160] = arguments[_key160];
    }
    return (0, _builder.default)("ClassPrivateMethod", ...args);
  }
  function Import() {
    for (var _len161 = arguments.length, args = new Array(_len161), _key161 = 0; _key161 < _len161; _key161++) {
      args[_key161] = arguments[_key161];
    }
    return (0, _builder.default)("Import", ...args);
  }
  function Decorator() {
    for (var _len162 = arguments.length, args = new Array(_len162), _key162 = 0; _key162 < _len162; _key162++) {
      args[_key162] = arguments[_key162];
    }
    return (0, _builder.default)("Decorator", ...args);
  }
  function DoExpression() {
    for (var _len163 = arguments.length, args = new Array(_len163), _key163 = 0; _key163 < _len163; _key163++) {
      args[_key163] = arguments[_key163];
    }
    return (0, _builder.default)("DoExpression", ...args);
  }
  function ExportDefaultSpecifier() {
    for (var _len164 = arguments.length, args = new Array(_len164), _key164 = 0; _key164 < _len164; _key164++) {
      args[_key164] = arguments[_key164];
    }
    return (0, _builder.default)("ExportDefaultSpecifier", ...args);
  }
  function ExportNamespaceSpecifier() {
    for (var _len165 = arguments.length, args = new Array(_len165), _key165 = 0; _key165 < _len165; _key165++) {
      args[_key165] = arguments[_key165];
    }
    return (0, _builder.default)("ExportNamespaceSpecifier", ...args);
  }
  function PrivateName() {
    for (var _len166 = arguments.length, args = new Array(_len166), _key166 = 0; _key166 < _len166; _key166++) {
      args[_key166] = arguments[_key166];
    }
    return (0, _builder.default)("PrivateName", ...args);
  }
  function BigIntLiteral() {
    for (var _len167 = arguments.length, args = new Array(_len167), _key167 = 0; _key167 < _len167; _key167++) {
      args[_key167] = arguments[_key167];
    }
    return (0, _builder.default)("BigIntLiteral", ...args);
  }
  function TSParameterProperty() {
    for (var _len168 = arguments.length, args = new Array(_len168), _key168 = 0; _key168 < _len168; _key168++) {
      args[_key168] = arguments[_key168];
    }
    return (0, _builder.default)("TSParameterProperty", ...args);
  }
  function TSDeclareFunction() {
    for (var _len169 = arguments.length, args = new Array(_len169), _key169 = 0; _key169 < _len169; _key169++) {
      args[_key169] = arguments[_key169];
    }
    return (0, _builder.default)("TSDeclareFunction", ...args);
  }
  function TSDeclareMethod() {
    for (var _len170 = arguments.length, args = new Array(_len170), _key170 = 0; _key170 < _len170; _key170++) {
      args[_key170] = arguments[_key170];
    }
    return (0, _builder.default)("TSDeclareMethod", ...args);
  }
  function TSQualifiedName() {
    for (var _len171 = arguments.length, args = new Array(_len171), _key171 = 0; _key171 < _len171; _key171++) {
      args[_key171] = arguments[_key171];
    }
    return (0, _builder.default)("TSQualifiedName", ...args);
  }
  function TSCallSignatureDeclaration() {
    for (var _len172 = arguments.length, args = new Array(_len172), _key172 = 0; _key172 < _len172; _key172++) {
      args[_key172] = arguments[_key172];
    }
    return (0, _builder.default)("TSCallSignatureDeclaration", ...args);
  }
  function TSConstructSignatureDeclaration() {
    for (var _len173 = arguments.length, args = new Array(_len173), _key173 = 0; _key173 < _len173; _key173++) {
      args[_key173] = arguments[_key173];
    }
    return (0, _builder.default)("TSConstructSignatureDeclaration", ...args);
  }
  function TSPropertySignature() {
    for (var _len174 = arguments.length, args = new Array(_len174), _key174 = 0; _key174 < _len174; _key174++) {
      args[_key174] = arguments[_key174];
    }
    return (0, _builder.default)("TSPropertySignature", ...args);
  }
  function TSMethodSignature() {
    for (var _len175 = arguments.length, args = new Array(_len175), _key175 = 0; _key175 < _len175; _key175++) {
      args[_key175] = arguments[_key175];
    }
    return (0, _builder.default)("TSMethodSignature", ...args);
  }
  function TSIndexSignature() {
    for (var _len176 = arguments.length, args = new Array(_len176), _key176 = 0; _key176 < _len176; _key176++) {
      args[_key176] = arguments[_key176];
    }
    return (0, _builder.default)("TSIndexSignature", ...args);
  }
  function TSAnyKeyword() {
    for (var _len177 = arguments.length, args = new Array(_len177), _key177 = 0; _key177 < _len177; _key177++) {
      args[_key177] = arguments[_key177];
    }
    return (0, _builder.default)("TSAnyKeyword", ...args);
  }
  function TSUnknownKeyword() {
    for (var _len178 = arguments.length, args = new Array(_len178), _key178 = 0; _key178 < _len178; _key178++) {
      args[_key178] = arguments[_key178];
    }
    return (0, _builder.default)("TSUnknownKeyword", ...args);
  }
  function TSNumberKeyword() {
    for (var _len179 = arguments.length, args = new Array(_len179), _key179 = 0; _key179 < _len179; _key179++) {
      args[_key179] = arguments[_key179];
    }
    return (0, _builder.default)("TSNumberKeyword", ...args);
  }
  function TSObjectKeyword() {
    for (var _len180 = arguments.length, args = new Array(_len180), _key180 = 0; _key180 < _len180; _key180++) {
      args[_key180] = arguments[_key180];
    }
    return (0, _builder.default)("TSObjectKeyword", ...args);
  }
  function TSBooleanKeyword() {
    for (var _len181 = arguments.length, args = new Array(_len181), _key181 = 0; _key181 < _len181; _key181++) {
      args[_key181] = arguments[_key181];
    }
    return (0, _builder.default)("TSBooleanKeyword", ...args);
  }
  function TSStringKeyword() {
    for (var _len182 = arguments.length, args = new Array(_len182), _key182 = 0; _key182 < _len182; _key182++) {
      args[_key182] = arguments[_key182];
    }
    return (0, _builder.default)("TSStringKeyword", ...args);
  }
  function TSSymbolKeyword() {
    for (var _len183 = arguments.length, args = new Array(_len183), _key183 = 0; _key183 < _len183; _key183++) {
      args[_key183] = arguments[_key183];
    }
    return (0, _builder.default)("TSSymbolKeyword", ...args);
  }
  function TSVoidKeyword() {
    for (var _len184 = arguments.length, args = new Array(_len184), _key184 = 0; _key184 < _len184; _key184++) {
      args[_key184] = arguments[_key184];
    }
    return (0, _builder.default)("TSVoidKeyword", ...args);
  }
  function TSUndefinedKeyword() {
    for (var _len185 = arguments.length, args = new Array(_len185), _key185 = 0; _key185 < _len185; _key185++) {
      args[_key185] = arguments[_key185];
    }
    return (0, _builder.default)("TSUndefinedKeyword", ...args);
  }
  function TSNullKeyword() {
    for (var _len186 = arguments.length, args = new Array(_len186), _key186 = 0; _key186 < _len186; _key186++) {
      args[_key186] = arguments[_key186];
    }
    return (0, _builder.default)("TSNullKeyword", ...args);
  }
  function TSNeverKeyword() {
    for (var _len187 = arguments.length, args = new Array(_len187), _key187 = 0; _key187 < _len187; _key187++) {
      args[_key187] = arguments[_key187];
    }
    return (0, _builder.default)("TSNeverKeyword", ...args);
  }
  function TSThisType() {
    for (var _len188 = arguments.length, args = new Array(_len188), _key188 = 0; _key188 < _len188; _key188++) {
      args[_key188] = arguments[_key188];
    }
    return (0, _builder.default)("TSThisType", ...args);
  }
  function TSFunctionType() {
    for (var _len189 = arguments.length, args = new Array(_len189), _key189 = 0; _key189 < _len189; _key189++) {
      args[_key189] = arguments[_key189];
    }
    return (0, _builder.default)("TSFunctionType", ...args);
  }
  function TSConstructorType() {
    for (var _len190 = arguments.length, args = new Array(_len190), _key190 = 0; _key190 < _len190; _key190++) {
      args[_key190] = arguments[_key190];
    }
    return (0, _builder.default)("TSConstructorType", ...args);
  }
  function TSTypeReference() {
    for (var _len191 = arguments.length, args = new Array(_len191), _key191 = 0; _key191 < _len191; _key191++) {
      args[_key191] = arguments[_key191];
    }
    return (0, _builder.default)("TSTypeReference", ...args);
  }
  function TSTypePredicate() {
    for (var _len192 = arguments.length, args = new Array(_len192), _key192 = 0; _key192 < _len192; _key192++) {
      args[_key192] = arguments[_key192];
    }
    return (0, _builder.default)("TSTypePredicate", ...args);
  }
  function TSTypeQuery() {
    for (var _len193 = arguments.length, args = new Array(_len193), _key193 = 0; _key193 < _len193; _key193++) {
      args[_key193] = arguments[_key193];
    }
    return (0, _builder.default)("TSTypeQuery", ...args);
  }
  function TSTypeLiteral() {
    for (var _len194 = arguments.length, args = new Array(_len194), _key194 = 0; _key194 < _len194; _key194++) {
      args[_key194] = arguments[_key194];
    }
    return (0, _builder.default)("TSTypeLiteral", ...args);
  }
  function TSArrayType() {
    for (var _len195 = arguments.length, args = new Array(_len195), _key195 = 0; _key195 < _len195; _key195++) {
      args[_key195] = arguments[_key195];
    }
    return (0, _builder.default)("TSArrayType", ...args);
  }
  function TSTupleType() {
    for (var _len196 = arguments.length, args = new Array(_len196), _key196 = 0; _key196 < _len196; _key196++) {
      args[_key196] = arguments[_key196];
    }
    return (0, _builder.default)("TSTupleType", ...args);
  }
  function TSOptionalType() {
    for (var _len197 = arguments.length, args = new Array(_len197), _key197 = 0; _key197 < _len197; _key197++) {
      args[_key197] = arguments[_key197];
    }
    return (0, _builder.default)("TSOptionalType", ...args);
  }
  function TSRestType() {
    for (var _len198 = arguments.length, args = new Array(_len198), _key198 = 0; _key198 < _len198; _key198++) {
      args[_key198] = arguments[_key198];
    }
    return (0, _builder.default)("TSRestType", ...args);
  }
  function TSUnionType() {
    for (var _len199 = arguments.length, args = new Array(_len199), _key199 = 0; _key199 < _len199; _key199++) {
      args[_key199] = arguments[_key199];
    }
    return (0, _builder.default)("TSUnionType", ...args);
  }
  function TSIntersectionType() {
    for (var _len200 = arguments.length, args = new Array(_len200), _key200 = 0; _key200 < _len200; _key200++) {
      args[_key200] = arguments[_key200];
    }
    return (0, _builder.default)("TSIntersectionType", ...args);
  }
  function TSConditionalType() {
    for (var _len201 = arguments.length, args = new Array(_len201), _key201 = 0; _key201 < _len201; _key201++) {
      args[_key201] = arguments[_key201];
    }
    return (0, _builder.default)("TSConditionalType", ...args);
  }
  function TSInferType() {
    for (var _len202 = arguments.length, args = new Array(_len202), _key202 = 0; _key202 < _len202; _key202++) {
      args[_key202] = arguments[_key202];
    }
    return (0, _builder.default)("TSInferType", ...args);
  }
  function TSParenthesizedType() {
    for (var _len203 = arguments.length, args = new Array(_len203), _key203 = 0; _key203 < _len203; _key203++) {
      args[_key203] = arguments[_key203];
    }
    return (0, _builder.default)("TSParenthesizedType", ...args);
  }
  function TSTypeOperator() {
    for (var _len204 = arguments.length, args = new Array(_len204), _key204 = 0; _key204 < _len204; _key204++) {
      args[_key204] = arguments[_key204];
    }
    return (0, _builder.default)("TSTypeOperator", ...args);
  }
  function TSIndexedAccessType() {
    for (var _len205 = arguments.length, args = new Array(_len205), _key205 = 0; _key205 < _len205; _key205++) {
      args[_key205] = arguments[_key205];
    }
    return (0, _builder.default)("TSIndexedAccessType", ...args);
  }
  function TSMappedType() {
    for (var _len206 = arguments.length, args = new Array(_len206), _key206 = 0; _key206 < _len206; _key206++) {
      args[_key206] = arguments[_key206];
    }
    return (0, _builder.default)("TSMappedType", ...args);
  }
  function TSLiteralType() {
    for (var _len207 = arguments.length, args = new Array(_len207), _key207 = 0; _key207 < _len207; _key207++) {
      args[_key207] = arguments[_key207];
    }
    return (0, _builder.default)("TSLiteralType", ...args);
  }
  function TSExpressionWithTypeArguments() {
    for (var _len208 = arguments.length, args = new Array(_len208), _key208 = 0; _key208 < _len208; _key208++) {
      args[_key208] = arguments[_key208];
    }
    return (0, _builder.default)("TSExpressionWithTypeArguments", ...args);
  }
  function TSInterfaceDeclaration() {
    for (var _len209 = arguments.length, args = new Array(_len209), _key209 = 0; _key209 < _len209; _key209++) {
      args[_key209] = arguments[_key209];
    }
    return (0, _builder.default)("TSInterfaceDeclaration", ...args);
  }
  function TSInterfaceBody() {
    for (var _len210 = arguments.length, args = new Array(_len210), _key210 = 0; _key210 < _len210; _key210++) {
      args[_key210] = arguments[_key210];
    }
    return (0, _builder.default)("TSInterfaceBody", ...args);
  }
  function TSTypeAliasDeclaration() {
    for (var _len211 = arguments.length, args = new Array(_len211), _key211 = 0; _key211 < _len211; _key211++) {
      args[_key211] = arguments[_key211];
    }
    return (0, _builder.default)("TSTypeAliasDeclaration", ...args);
  }
  function TSAsExpression() {
    for (var _len212 = arguments.length, args = new Array(_len212), _key212 = 0; _key212 < _len212; _key212++) {
      args[_key212] = arguments[_key212];
    }
    return (0, _builder.default)("TSAsExpression", ...args);
  }
  function TSTypeAssertion() {
    for (var _len213 = arguments.length, args = new Array(_len213), _key213 = 0; _key213 < _len213; _key213++) {
      args[_key213] = arguments[_key213];
    }
    return (0, _builder.default)("TSTypeAssertion", ...args);
  }
  function TSEnumDeclaration() {
    for (var _len214 = arguments.length, args = new Array(_len214), _key214 = 0; _key214 < _len214; _key214++) {
      args[_key214] = arguments[_key214];
    }
    return (0, _builder.default)("TSEnumDeclaration", ...args);
  }
  function TSEnumMember() {
    for (var _len215 = arguments.length, args = new Array(_len215), _key215 = 0; _key215 < _len215; _key215++) {
      args[_key215] = arguments[_key215];
    }
    return (0, _builder.default)("TSEnumMember", ...args);
  }
  function TSModuleDeclaration() {
    for (var _len216 = arguments.length, args = new Array(_len216), _key216 = 0; _key216 < _len216; _key216++) {
      args[_key216] = arguments[_key216];
    }
    return (0, _builder.default)("TSModuleDeclaration", ...args);
  }
  function TSModuleBlock() {
    for (var _len217 = arguments.length, args = new Array(_len217), _key217 = 0; _key217 < _len217; _key217++) {
      args[_key217] = arguments[_key217];
    }
    return (0, _builder.default)("TSModuleBlock", ...args);
  }
  function TSImportType() {
    for (var _len218 = arguments.length, args = new Array(_len218), _key218 = 0; _key218 < _len218; _key218++) {
      args[_key218] = arguments[_key218];
    }
    return (0, _builder.default)("TSImportType", ...args);
  }
  function TSImportEqualsDeclaration() {
    for (var _len219 = arguments.length, args = new Array(_len219), _key219 = 0; _key219 < _len219; _key219++) {
      args[_key219] = arguments[_key219];
    }
    return (0, _builder.default)("TSImportEqualsDeclaration", ...args);
  }
  function TSExternalModuleReference() {
    for (var _len220 = arguments.length, args = new Array(_len220), _key220 = 0; _key220 < _len220; _key220++) {
      args[_key220] = arguments[_key220];
    }
    return (0, _builder.default)("TSExternalModuleReference", ...args);
  }
  function TSNonNullExpression() {
    for (var _len221 = arguments.length, args = new Array(_len221), _key221 = 0; _key221 < _len221; _key221++) {
      args[_key221] = arguments[_key221];
    }
    return (0, _builder.default)("TSNonNullExpression", ...args);
  }
  function TSExportAssignment() {
    for (var _len222 = arguments.length, args = new Array(_len222), _key222 = 0; _key222 < _len222; _key222++) {
      args[_key222] = arguments[_key222];
    }
    return (0, _builder.default)("TSExportAssignment", ...args);
  }
  function TSNamespaceExportDeclaration() {
    for (var _len223 = arguments.length, args = new Array(_len223), _key223 = 0; _key223 < _len223; _key223++) {
      args[_key223] = arguments[_key223];
    }
    return (0, _builder.default)("TSNamespaceExportDeclaration", ...args);
  }
  function TSTypeAnnotation() {
    for (var _len224 = arguments.length, args = new Array(_len224), _key224 = 0; _key224 < _len224; _key224++) {
      args[_key224] = arguments[_key224];
    }
    return (0, _builder.default)("TSTypeAnnotation", ...args);
  }
  function TSTypeParameterInstantiation() {
    for (var _len225 = arguments.length, args = new Array(_len225), _key225 = 0; _key225 < _len225; _key225++) {
      args[_key225] = arguments[_key225];
    }
    return (0, _builder.default)("TSTypeParameterInstantiation", ...args);
  }
  function TSTypeParameterDeclaration() {
    for (var _len226 = arguments.length, args = new Array(_len226), _key226 = 0; _key226 < _len226; _key226++) {
      args[_key226] = arguments[_key226];
    }
    return (0, _builder.default)("TSTypeParameterDeclaration", ...args);
  }
  function TSTypeParameter() {
    for (var _len227 = arguments.length, args = new Array(_len227), _key227 = 0; _key227 < _len227; _key227++) {
      args[_key227] = arguments[_key227];
    }
    return (0, _builder.default)("TSTypeParameter", ...args);
  }
  function NumberLiteral() {
    console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
    for (var _len228 = arguments.length, args = new Array(_len228), _key228 = 0; _key228 < _len228; _key228++) {
      args[_key228] = arguments[_key228];
    }
    return NumberLiteral("NumberLiteral", ...args);
  }
  function RegexLiteral() {
    console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
    for (var _len229 = arguments.length, args = new Array(_len229), _key229 = 0; _key229 < _len229; _key229++) {
      args[_key229] = arguments[_key229];
    }
    return RegexLiteral("RegexLiteral", ...args);
  }
  function RestProperty() {
    console.trace("The node type RestProperty has been renamed to RestElement");
    for (var _len230 = arguments.length, args = new Array(_len230), _key230 = 0; _key230 < _len230; _key230++) {
      args[_key230] = arguments[_key230];
    }
    return RestProperty("RestProperty", ...args);
  }
  function SpreadProperty() {
    console.trace("The node type SpreadProperty has been renamed to SpreadElement");
    for (var _len231 = arguments.length, args = new Array(_len231), _key231 = 0; _key231 < _len231; _key231++) {
      args[_key231] = arguments[_key231];
    }
    return SpreadProperty("SpreadProperty", ...args);
  }
});
unwrapExports(generated$1);
var generated_1$1 = generated$1.arrayExpression;
var generated_2$1 = generated$1.ArrayExpression;
var generated_3$1 = generated$1.assignmentExpression;
var generated_4$1 = generated$1.AssignmentExpression;
var generated_5$1 = generated$1.binaryExpression;
var generated_6$1 = generated$1.BinaryExpression;
var generated_7$1 = generated$1.interpreterDirective;
var generated_8$1 = generated$1.InterpreterDirective;
var generated_9$1 = generated$1.directive;
var generated_10$1 = generated$1.Directive;
var generated_11$1 = generated$1.directiveLiteral;
var generated_12$1 = generated$1.DirectiveLiteral;
var generated_13$1 = generated$1.blockStatement;
var generated_14$1 = generated$1.BlockStatement;
var generated_15$1 = generated$1.breakStatement;
var generated_16$1 = generated$1.BreakStatement;
var generated_17$1 = generated$1.callExpression;
var generated_18$1 = generated$1.CallExpression;
var generated_19$1 = generated$1.catchClause;
var generated_20$1 = generated$1.CatchClause;
var generated_21$1 = generated$1.conditionalExpression;
var generated_22$1 = generated$1.ConditionalExpression;
var generated_23$1 = generated$1.continueStatement;
var generated_24$1 = generated$1.ContinueStatement;
var generated_25$1 = generated$1.debuggerStatement;
var generated_26$1 = generated$1.DebuggerStatement;
var generated_27$1 = generated$1.doWhileStatement;
var generated_28$1 = generated$1.DoWhileStatement;
var generated_29$1 = generated$1.emptyStatement;
var generated_30$1 = generated$1.EmptyStatement;
var generated_31$1 = generated$1.expressionStatement;
var generated_32$1 = generated$1.ExpressionStatement;
var generated_33$1 = generated$1.file;
var generated_34$1 = generated$1.File;
var generated_35$1 = generated$1.forInStatement;
var generated_36$1 = generated$1.ForInStatement;
var generated_37$1 = generated$1.forStatement;
var generated_38$1 = generated$1.ForStatement;
var generated_39$1 = generated$1.functionDeclaration;
var generated_40$1 = generated$1.FunctionDeclaration;
var generated_41$1 = generated$1.functionExpression;
var generated_42$1 = generated$1.FunctionExpression;
var generated_43$1 = generated$1.identifier;
var generated_44$1 = generated$1.Identifier;
var generated_45$1 = generated$1.ifStatement;
var generated_46$1 = generated$1.IfStatement;
var generated_47$1 = generated$1.labeledStatement;
var generated_48$1 = generated$1.LabeledStatement;
var generated_49$1 = generated$1.stringLiteral;
var generated_50$1 = generated$1.StringLiteral;
var generated_51$1 = generated$1.numericLiteral;
var generated_52$1 = generated$1.NumericLiteral;
var generated_53$1 = generated$1.nullLiteral;
var generated_54$1 = generated$1.NullLiteral;
var generated_55$1 = generated$1.booleanLiteral;
var generated_56$1 = generated$1.BooleanLiteral;
var generated_57$1 = generated$1.regExpLiteral;
var generated_58$1 = generated$1.RegExpLiteral;
var generated_59$1 = generated$1.logicalExpression;
var generated_60$1 = generated$1.LogicalExpression;
var generated_61$1 = generated$1.memberExpression;
var generated_62$1 = generated$1.MemberExpression;
var generated_63$1 = generated$1.newExpression;
var generated_64$1 = generated$1.NewExpression;
var generated_65$1 = generated$1.program;
var generated_66$1 = generated$1.Program;
var generated_67$1 = generated$1.objectExpression;
var generated_68$1 = generated$1.ObjectExpression;
var generated_69$1 = generated$1.objectMethod;
var generated_70$1 = generated$1.ObjectMethod;
var generated_71$1 = generated$1.objectProperty;
var generated_72$1 = generated$1.ObjectProperty;
var generated_73$1 = generated$1.restElement;
var generated_74$1 = generated$1.RestElement;
var generated_75$1 = generated$1.returnStatement;
var generated_76$1 = generated$1.ReturnStatement;
var generated_77$1 = generated$1.sequenceExpression;
var generated_78$1 = generated$1.SequenceExpression;
var generated_79$1 = generated$1.switchCase;
var generated_80$1 = generated$1.SwitchCase;
var generated_81$1 = generated$1.switchStatement;
var generated_82$1 = generated$1.SwitchStatement;
var generated_83$1 = generated$1.thisExpression;
var generated_84$1 = generated$1.ThisExpression;
var generated_85$1 = generated$1.throwStatement;
var generated_86$1 = generated$1.ThrowStatement;
var generated_87$1 = generated$1.tryStatement;
var generated_88$1 = generated$1.TryStatement;
var generated_89$1 = generated$1.unaryExpression;
var generated_90$1 = generated$1.UnaryExpression;
var generated_91$1 = generated$1.updateExpression;
var generated_92$1 = generated$1.UpdateExpression;
var generated_93$1 = generated$1.variableDeclaration;
var generated_94$1 = generated$1.VariableDeclaration;
var generated_95$1 = generated$1.variableDeclarator;
var generated_96$1 = generated$1.VariableDeclarator;
var generated_97$1 = generated$1.whileStatement;
var generated_98$1 = generated$1.WhileStatement;
var generated_99$1 = generated$1.withStatement;
var generated_100$1 = generated$1.WithStatement;
var generated_101$1 = generated$1.assignmentPattern;
var generated_102$1 = generated$1.AssignmentPattern;
var generated_103$1 = generated$1.arrayPattern;
var generated_104$1 = generated$1.ArrayPattern;
var generated_105$1 = generated$1.arrowFunctionExpression;
var generated_106$1 = generated$1.ArrowFunctionExpression;
var generated_107$1 = generated$1.classBody;
var generated_108$1 = generated$1.ClassBody;
var generated_109$1 = generated$1.classDeclaration;
var generated_110$1 = generated$1.ClassDeclaration;
var generated_111$1 = generated$1.classExpression;
var generated_112$1 = generated$1.ClassExpression;
var generated_113$1 = generated$1.exportAllDeclaration;
var generated_114$1 = generated$1.ExportAllDeclaration;
var generated_115$1 = generated$1.exportDefaultDeclaration;
var generated_116$1 = generated$1.ExportDefaultDeclaration;
var generated_117$1 = generated$1.exportNamedDeclaration;
var generated_118$1 = generated$1.ExportNamedDeclaration;
var generated_119$1 = generated$1.exportSpecifier;
var generated_120$1 = generated$1.ExportSpecifier;
var generated_121$1 = generated$1.forOfStatement;
var generated_122$1 = generated$1.ForOfStatement;
var generated_123$1 = generated$1.importDeclaration;
var generated_124$1 = generated$1.ImportDeclaration;
var generated_125$1 = generated$1.importDefaultSpecifier;
var generated_126$1 = generated$1.ImportDefaultSpecifier;
var generated_127$1 = generated$1.importNamespaceSpecifier;
var generated_128$1 = generated$1.ImportNamespaceSpecifier;
var generated_129$1 = generated$1.importSpecifier;
var generated_130$1 = generated$1.ImportSpecifier;
var generated_131$1 = generated$1.metaProperty;
var generated_132$1 = generated$1.MetaProperty;
var generated_133$1 = generated$1.classMethod;
var generated_134$1 = generated$1.ClassMethod;
var generated_135$1 = generated$1.objectPattern;
var generated_136$1 = generated$1.ObjectPattern;
var generated_137$1 = generated$1.spreadElement;
var generated_138$1 = generated$1.SpreadElement;
var generated_139$1 = generated$1.Super;
var generated_140$1 = generated$1.taggedTemplateExpression;
var generated_141$1 = generated$1.TaggedTemplateExpression;
var generated_142$1 = generated$1.templateElement;
var generated_143$1 = generated$1.TemplateElement;
var generated_144$1 = generated$1.templateLiteral;
var generated_145$1 = generated$1.TemplateLiteral;
var generated_146$1 = generated$1.yieldExpression;
var generated_147$1 = generated$1.YieldExpression;
var generated_148$1 = generated$1.anyTypeAnnotation;
var generated_149$1 = generated$1.AnyTypeAnnotation;
var generated_150$1 = generated$1.arrayTypeAnnotation;
var generated_151$1 = generated$1.ArrayTypeAnnotation;
var generated_152$1 = generated$1.booleanTypeAnnotation;
var generated_153$1 = generated$1.BooleanTypeAnnotation;
var generated_154$1 = generated$1.booleanLiteralTypeAnnotation;
var generated_155$1 = generated$1.BooleanLiteralTypeAnnotation;
var generated_156$1 = generated$1.nullLiteralTypeAnnotation;
var generated_157$1 = generated$1.NullLiteralTypeAnnotation;
var generated_158$1 = generated$1.classImplements;
var generated_159$1 = generated$1.ClassImplements;
var generated_160$1 = generated$1.declareClass;
var generated_161$1 = generated$1.DeclareClass;
var generated_162$1 = generated$1.declareFunction;
var generated_163$1 = generated$1.DeclareFunction;
var generated_164$1 = generated$1.declareInterface;
var generated_165$1 = generated$1.DeclareInterface;
var generated_166$1 = generated$1.declareModule;
var generated_167$1 = generated$1.DeclareModule;
var generated_168$1 = generated$1.declareModuleExports;
var generated_169$1 = generated$1.DeclareModuleExports;
var generated_170$1 = generated$1.declareTypeAlias;
var generated_171$1 = generated$1.DeclareTypeAlias;
var generated_172$1 = generated$1.declareOpaqueType;
var generated_173$1 = generated$1.DeclareOpaqueType;
var generated_174$1 = generated$1.declareVariable;
var generated_175$1 = generated$1.DeclareVariable;
var generated_176$1 = generated$1.declareExportDeclaration;
var generated_177$1 = generated$1.DeclareExportDeclaration;
var generated_178$1 = generated$1.declareExportAllDeclaration;
var generated_179$1 = generated$1.DeclareExportAllDeclaration;
var generated_180$1 = generated$1.declaredPredicate;
var generated_181$1 = generated$1.DeclaredPredicate;
var generated_182$1 = generated$1.existsTypeAnnotation;
var generated_183$1 = generated$1.ExistsTypeAnnotation;
var generated_184$1 = generated$1.functionTypeAnnotation;
var generated_185$1 = generated$1.FunctionTypeAnnotation;
var generated_186$1 = generated$1.functionTypeParam;
var generated_187$1 = generated$1.FunctionTypeParam;
var generated_188$1 = generated$1.genericTypeAnnotation;
var generated_189$1 = generated$1.GenericTypeAnnotation;
var generated_190$1 = generated$1.inferredPredicate;
var generated_191$1 = generated$1.InferredPredicate;
var generated_192$1 = generated$1.interfaceExtends;
var generated_193$1 = generated$1.InterfaceExtends;
var generated_194$1 = generated$1.interfaceDeclaration;
var generated_195$1 = generated$1.InterfaceDeclaration;
var generated_196$1 = generated$1.interfaceTypeAnnotation;
var generated_197$1 = generated$1.InterfaceTypeAnnotation;
var generated_198$1 = generated$1.intersectionTypeAnnotation;
var generated_199$1 = generated$1.IntersectionTypeAnnotation;
var generated_200$1 = generated$1.mixedTypeAnnotation;
var generated_201$1 = generated$1.MixedTypeAnnotation;
var generated_202$1 = generated$1.emptyTypeAnnotation;
var generated_203$1 = generated$1.EmptyTypeAnnotation;
var generated_204$1 = generated$1.nullableTypeAnnotation;
var generated_205$1 = generated$1.NullableTypeAnnotation;
var generated_206$1 = generated$1.numberLiteralTypeAnnotation;
var generated_207$1 = generated$1.NumberLiteralTypeAnnotation;
var generated_208$1 = generated$1.numberTypeAnnotation;
var generated_209$1 = generated$1.NumberTypeAnnotation;
var generated_210$1 = generated$1.objectTypeAnnotation;
var generated_211$1 = generated$1.ObjectTypeAnnotation;
var generated_212$1 = generated$1.objectTypeInternalSlot;
var generated_213$1 = generated$1.ObjectTypeInternalSlot;
var generated_214$1 = generated$1.objectTypeCallProperty;
var generated_215$1 = generated$1.ObjectTypeCallProperty;
var generated_216$1 = generated$1.objectTypeIndexer;
var generated_217$1 = generated$1.ObjectTypeIndexer;
var generated_218$1 = generated$1.objectTypeProperty;
var generated_219$1 = generated$1.ObjectTypeProperty;
var generated_220$1 = generated$1.objectTypeSpreadProperty;
var generated_221$1 = generated$1.ObjectTypeSpreadProperty;
var generated_222$1 = generated$1.opaqueType;
var generated_223$1 = generated$1.OpaqueType;
var generated_224$1 = generated$1.qualifiedTypeIdentifier;
var generated_225$1 = generated$1.QualifiedTypeIdentifier;
var generated_226$1 = generated$1.stringLiteralTypeAnnotation;
var generated_227$1 = generated$1.StringLiteralTypeAnnotation;
var generated_228$1 = generated$1.stringTypeAnnotation;
var generated_229$1 = generated$1.StringTypeAnnotation;
var generated_230$1 = generated$1.thisTypeAnnotation;
var generated_231$1 = generated$1.ThisTypeAnnotation;
var generated_232$1 = generated$1.tupleTypeAnnotation;
var generated_233$1 = generated$1.TupleTypeAnnotation;
var generated_234$1 = generated$1.typeofTypeAnnotation;
var generated_235$1 = generated$1.TypeofTypeAnnotation;
var generated_236$1 = generated$1.typeAlias;
var generated_237$1 = generated$1.TypeAlias;
var generated_238$1 = generated$1.typeAnnotation;
var generated_239$1 = generated$1.TypeAnnotation;
var generated_240$1 = generated$1.typeCastExpression;
var generated_241$1 = generated$1.TypeCastExpression;
var generated_242$1 = generated$1.typeParameter;
var generated_243$1 = generated$1.TypeParameter;
var generated_244$1 = generated$1.typeParameterDeclaration;
var generated_245$1 = generated$1.TypeParameterDeclaration;
var generated_246$1 = generated$1.typeParameterInstantiation;
var generated_247$1 = generated$1.TypeParameterInstantiation;
var generated_248$1 = generated$1.unionTypeAnnotation;
var generated_249$1 = generated$1.UnionTypeAnnotation;
var generated_250$1 = generated$1.variance;
var generated_251$1 = generated$1.Variance;
var generated_252$1 = generated$1.voidTypeAnnotation;
var generated_253$1 = generated$1.VoidTypeAnnotation;
var generated_254$1 = generated$1.jSXAttribute;
var generated_255$1 = generated$1.jsxAttribute;
var generated_256$1 = generated$1.JSXAttribute;
var generated_257$1 = generated$1.jSXClosingElement;
var generated_258$1 = generated$1.jsxClosingElement;
var generated_259$1 = generated$1.JSXClosingElement;
var generated_260$1 = generated$1.jSXElement;
var generated_261$1 = generated$1.jsxElement;
var generated_262$1 = generated$1.JSXElement;
var generated_263$1 = generated$1.jSXEmptyExpression;
var generated_264$1 = generated$1.jsxEmptyExpression;
var generated_265$1 = generated$1.JSXEmptyExpression;
var generated_266$1 = generated$1.jSXExpressionContainer;
var generated_267$1 = generated$1.jsxExpressionContainer;
var generated_268 = generated$1.JSXExpressionContainer;
var generated_269 = generated$1.jSXSpreadChild;
var generated_270 = generated$1.jsxSpreadChild;
var generated_271 = generated$1.JSXSpreadChild;
var generated_272 = generated$1.jSXIdentifier;
var generated_273 = generated$1.jsxIdentifier;
var generated_274 = generated$1.JSXIdentifier;
var generated_275 = generated$1.jSXMemberExpression;
var generated_276 = generated$1.jsxMemberExpression;
var generated_277 = generated$1.JSXMemberExpression;
var generated_278 = generated$1.jSXNamespacedName;
var generated_279 = generated$1.jsxNamespacedName;
var generated_280 = generated$1.JSXNamespacedName;
var generated_281 = generated$1.jSXOpeningElement;
var generated_282 = generated$1.jsxOpeningElement;
var generated_283 = generated$1.JSXOpeningElement;
var generated_284 = generated$1.jSXSpreadAttribute;
var generated_285 = generated$1.jsxSpreadAttribute;
var generated_286 = generated$1.JSXSpreadAttribute;
var generated_287 = generated$1.jSXText;
var generated_288 = generated$1.jsxText;
var generated_289 = generated$1.JSXText;
var generated_290 = generated$1.jSXFragment;
var generated_291 = generated$1.jsxFragment;
var generated_292 = generated$1.JSXFragment;
var generated_293 = generated$1.jSXOpeningFragment;
var generated_294 = generated$1.jsxOpeningFragment;
var generated_295 = generated$1.JSXOpeningFragment;
var generated_296 = generated$1.jSXClosingFragment;
var generated_297 = generated$1.jsxClosingFragment;
var generated_298 = generated$1.JSXClosingFragment;
var generated_299 = generated$1.noop;
var generated_300 = generated$1.Noop;
var generated_301 = generated$1.parenthesizedExpression;
var generated_302 = generated$1.ParenthesizedExpression;
var generated_303 = generated$1.awaitExpression;
var generated_304 = generated$1.AwaitExpression;
var generated_305 = generated$1.bindExpression;
var generated_306 = generated$1.BindExpression;
var generated_307 = generated$1.classProperty;
var generated_308 = generated$1.ClassProperty;
var generated_309 = generated$1.optionalMemberExpression;
var generated_310 = generated$1.OptionalMemberExpression;
var generated_311 = generated$1.pipelineTopicExpression;
var generated_312 = generated$1.PipelineTopicExpression;
var generated_313 = generated$1.pipelineBareFunction;
var generated_314 = generated$1.PipelineBareFunction;
var generated_315 = generated$1.pipelinePrimaryTopicReference;
var generated_316 = generated$1.PipelinePrimaryTopicReference;
var generated_317 = generated$1.optionalCallExpression;
var generated_318 = generated$1.OptionalCallExpression;
var generated_319 = generated$1.classPrivateProperty;
var generated_320 = generated$1.ClassPrivateProperty;
var generated_321 = generated$1.classPrivateMethod;
var generated_322 = generated$1.ClassPrivateMethod;
var generated_323 = generated$1.Import;
var generated_324 = generated$1.decorator;
var generated_325 = generated$1.Decorator;
var generated_326 = generated$1.doExpression;
var generated_327 = generated$1.DoExpression;
var generated_328 = generated$1.exportDefaultSpecifier;
var generated_329 = generated$1.ExportDefaultSpecifier;
var generated_330 = generated$1.exportNamespaceSpecifier;
var generated_331 = generated$1.ExportNamespaceSpecifier;
var generated_332 = generated$1.privateName;
var generated_333 = generated$1.PrivateName;
var generated_334 = generated$1.bigIntLiteral;
var generated_335 = generated$1.BigIntLiteral;
var generated_336 = generated$1.tSParameterProperty;
var generated_337 = generated$1.tsParameterProperty;
var generated_338 = generated$1.TSParameterProperty;
var generated_339 = generated$1.tSDeclareFunction;
var generated_340 = generated$1.tsDeclareFunction;
var generated_341 = generated$1.TSDeclareFunction;
var generated_342 = generated$1.tSDeclareMethod;
var generated_343 = generated$1.tsDeclareMethod;
var generated_344 = generated$1.TSDeclareMethod;
var generated_345 = generated$1.tSQualifiedName;
var generated_346 = generated$1.tsQualifiedName;
var generated_347 = generated$1.TSQualifiedName;
var generated_348 = generated$1.tSCallSignatureDeclaration;
var generated_349 = generated$1.tsCallSignatureDeclaration;
var generated_350 = generated$1.TSCallSignatureDeclaration;
var generated_351 = generated$1.tSConstructSignatureDeclaration;
var generated_352 = generated$1.tsConstructSignatureDeclaration;
var generated_353 = generated$1.TSConstructSignatureDeclaration;
var generated_354 = generated$1.tSPropertySignature;
var generated_355 = generated$1.tsPropertySignature;
var generated_356 = generated$1.TSPropertySignature;
var generated_357 = generated$1.tSMethodSignature;
var generated_358 = generated$1.tsMethodSignature;
var generated_359 = generated$1.TSMethodSignature;
var generated_360 = generated$1.tSIndexSignature;
var generated_361 = generated$1.tsIndexSignature;
var generated_362 = generated$1.TSIndexSignature;
var generated_363 = generated$1.tSAnyKeyword;
var generated_364 = generated$1.tsAnyKeyword;
var generated_365 = generated$1.TSAnyKeyword;
var generated_366 = generated$1.tSUnknownKeyword;
var generated_367 = generated$1.tsUnknownKeyword;
var generated_368 = generated$1.TSUnknownKeyword;
var generated_369 = generated$1.tSNumberKeyword;
var generated_370 = generated$1.tsNumberKeyword;
var generated_371 = generated$1.TSNumberKeyword;
var generated_372 = generated$1.tSObjectKeyword;
var generated_373 = generated$1.tsObjectKeyword;
var generated_374 = generated$1.TSObjectKeyword;
var generated_375 = generated$1.tSBooleanKeyword;
var generated_376 = generated$1.tsBooleanKeyword;
var generated_377 = generated$1.TSBooleanKeyword;
var generated_378 = generated$1.tSStringKeyword;
var generated_379 = generated$1.tsStringKeyword;
var generated_380 = generated$1.TSStringKeyword;
var generated_381 = generated$1.tSSymbolKeyword;
var generated_382 = generated$1.tsSymbolKeyword;
var generated_383 = generated$1.TSSymbolKeyword;
var generated_384 = generated$1.tSVoidKeyword;
var generated_385 = generated$1.tsVoidKeyword;
var generated_386 = generated$1.TSVoidKeyword;
var generated_387 = generated$1.tSUndefinedKeyword;
var generated_388 = generated$1.tsUndefinedKeyword;
var generated_389 = generated$1.TSUndefinedKeyword;
var generated_390 = generated$1.tSNullKeyword;
var generated_391 = generated$1.tsNullKeyword;
var generated_392 = generated$1.TSNullKeyword;
var generated_393 = generated$1.tSNeverKeyword;
var generated_394 = generated$1.tsNeverKeyword;
var generated_395 = generated$1.TSNeverKeyword;
var generated_396 = generated$1.tSThisType;
var generated_397 = generated$1.tsThisType;
var generated_398 = generated$1.TSThisType;
var generated_399 = generated$1.tSFunctionType;
var generated_400 = generated$1.tsFunctionType;
var generated_401 = generated$1.TSFunctionType;
var generated_402 = generated$1.tSConstructorType;
var generated_403 = generated$1.tsConstructorType;
var generated_404 = generated$1.TSConstructorType;
var generated_405 = generated$1.tSTypeReference;
var generated_406 = generated$1.tsTypeReference;
var generated_407 = generated$1.TSTypeReference;
var generated_408 = generated$1.tSTypePredicate;
var generated_409 = generated$1.tsTypePredicate;
var generated_410 = generated$1.TSTypePredicate;
var generated_411 = generated$1.tSTypeQuery;
var generated_412 = generated$1.tsTypeQuery;
var generated_413 = generated$1.TSTypeQuery;
var generated_414 = generated$1.tSTypeLiteral;
var generated_415 = generated$1.tsTypeLiteral;
var generated_416 = generated$1.TSTypeLiteral;
var generated_417 = generated$1.tSArrayType;
var generated_418 = generated$1.tsArrayType;
var generated_419 = generated$1.TSArrayType;
var generated_420 = generated$1.tSTupleType;
var generated_421 = generated$1.tsTupleType;
var generated_422 = generated$1.TSTupleType;
var generated_423 = generated$1.tSOptionalType;
var generated_424 = generated$1.tsOptionalType;
var generated_425 = generated$1.TSOptionalType;
var generated_426 = generated$1.tSRestType;
var generated_427 = generated$1.tsRestType;
var generated_428 = generated$1.TSRestType;
var generated_429 = generated$1.tSUnionType;
var generated_430 = generated$1.tsUnionType;
var generated_431 = generated$1.TSUnionType;
var generated_432 = generated$1.tSIntersectionType;
var generated_433 = generated$1.tsIntersectionType;
var generated_434 = generated$1.TSIntersectionType;
var generated_435 = generated$1.tSConditionalType;
var generated_436 = generated$1.tsConditionalType;
var generated_437 = generated$1.TSConditionalType;
var generated_438 = generated$1.tSInferType;
var generated_439 = generated$1.tsInferType;
var generated_440 = generated$1.TSInferType;
var generated_441 = generated$1.tSParenthesizedType;
var generated_442 = generated$1.tsParenthesizedType;
var generated_443 = generated$1.TSParenthesizedType;
var generated_444 = generated$1.tSTypeOperator;
var generated_445 = generated$1.tsTypeOperator;
var generated_446 = generated$1.TSTypeOperator;
var generated_447 = generated$1.tSIndexedAccessType;
var generated_448 = generated$1.tsIndexedAccessType;
var generated_449 = generated$1.TSIndexedAccessType;
var generated_450 = generated$1.tSMappedType;
var generated_451 = generated$1.tsMappedType;
var generated_452 = generated$1.TSMappedType;
var generated_453 = generated$1.tSLiteralType;
var generated_454 = generated$1.tsLiteralType;
var generated_455 = generated$1.TSLiteralType;
var generated_456 = generated$1.tSExpressionWithTypeArguments;
var generated_457 = generated$1.tsExpressionWithTypeArguments;
var generated_458 = generated$1.TSExpressionWithTypeArguments;
var generated_459 = generated$1.tSInterfaceDeclaration;
var generated_460 = generated$1.tsInterfaceDeclaration;
var generated_461 = generated$1.TSInterfaceDeclaration;
var generated_462 = generated$1.tSInterfaceBody;
var generated_463 = generated$1.tsInterfaceBody;
var generated_464 = generated$1.TSInterfaceBody;
var generated_465 = generated$1.tSTypeAliasDeclaration;
var generated_466 = generated$1.tsTypeAliasDeclaration;
var generated_467 = generated$1.TSTypeAliasDeclaration;
var generated_468 = generated$1.tSAsExpression;
var generated_469 = generated$1.tsAsExpression;
var generated_470 = generated$1.TSAsExpression;
var generated_471 = generated$1.tSTypeAssertion;
var generated_472 = generated$1.tsTypeAssertion;
var generated_473 = generated$1.TSTypeAssertion;
var generated_474 = generated$1.tSEnumDeclaration;
var generated_475 = generated$1.tsEnumDeclaration;
var generated_476 = generated$1.TSEnumDeclaration;
var generated_477 = generated$1.tSEnumMember;
var generated_478 = generated$1.tsEnumMember;
var generated_479 = generated$1.TSEnumMember;
var generated_480 = generated$1.tSModuleDeclaration;
var generated_481 = generated$1.tsModuleDeclaration;
var generated_482 = generated$1.TSModuleDeclaration;
var generated_483 = generated$1.tSModuleBlock;
var generated_484 = generated$1.tsModuleBlock;
var generated_485 = generated$1.TSModuleBlock;
var generated_486 = generated$1.tSImportType;
var generated_487 = generated$1.tsImportType;
var generated_488 = generated$1.TSImportType;
var generated_489 = generated$1.tSImportEqualsDeclaration;
var generated_490 = generated$1.tsImportEqualsDeclaration;
var generated_491 = generated$1.TSImportEqualsDeclaration;
var generated_492 = generated$1.tSExternalModuleReference;
var generated_493 = generated$1.tsExternalModuleReference;
var generated_494 = generated$1.TSExternalModuleReference;
var generated_495 = generated$1.tSNonNullExpression;
var generated_496 = generated$1.tsNonNullExpression;
var generated_497 = generated$1.TSNonNullExpression;
var generated_498 = generated$1.tSExportAssignment;
var generated_499 = generated$1.tsExportAssignment;
var generated_500 = generated$1.TSExportAssignment;
var generated_501 = generated$1.tSNamespaceExportDeclaration;
var generated_502 = generated$1.tsNamespaceExportDeclaration;
var generated_503 = generated$1.TSNamespaceExportDeclaration;
var generated_504 = generated$1.tSTypeAnnotation;
var generated_505 = generated$1.tsTypeAnnotation;
var generated_506 = generated$1.TSTypeAnnotation;
var generated_507 = generated$1.tSTypeParameterInstantiation;
var generated_508 = generated$1.tsTypeParameterInstantiation;
var generated_509 = generated$1.TSTypeParameterInstantiation;
var generated_510 = generated$1.tSTypeParameterDeclaration;
var generated_511 = generated$1.tsTypeParameterDeclaration;
var generated_512 = generated$1.TSTypeParameterDeclaration;
var generated_513 = generated$1.tSTypeParameter;
var generated_514 = generated$1.tsTypeParameter;
var generated_515 = generated$1.TSTypeParameter;
var generated_516 = generated$1.numberLiteral;
var generated_517 = generated$1.NumberLiteral;
var generated_518 = generated$1.regexLiteral;
var generated_519 = generated$1.RegexLiteral;
var generated_520 = generated$1.restProperty;
var generated_521 = generated$1.RestProperty;
var generated_522 = generated$1.spreadProperty;
var generated_523 = generated$1.SpreadProperty;
var cleanJSXElementLiteralChild_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = cleanJSXElementLiteralChild;
  function cleanJSXElementLiteralChild(child, args) {
    const lines = child.value.split(/\r\n|\n|\r/);
    let lastNonEmptyLine = 0;
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].match(/[^ \t]/)) {
        lastNonEmptyLine = i;
      }
    }
    let str = "";
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const isFirstLine = i === 0;
      const isLastLine = i === lines.length - 1;
      const isLastNonEmptyLine = i === lastNonEmptyLine;
      let trimmedLine = line.replace(/\t/g, " ");
      if (!isFirstLine) {
        trimmedLine = trimmedLine.replace(/^[ ]+/, "");
      }
      if (!isLastLine) {
        trimmedLine = trimmedLine.replace(/[ ]+$/, "");
      }
      if (trimmedLine) {
        if (!isLastNonEmptyLine) {
          trimmedLine += " ";
        }
        str += trimmedLine;
      }
    }
    if (str) args.push((0, generated$1.stringLiteral)(str));
  }
});
unwrapExports(cleanJSXElementLiteralChild_1);
var buildChildren_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = buildChildren;
  var _cleanJSXElementLiteralChild = _interopRequireDefault(cleanJSXElementLiteralChild_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function buildChildren(node) {
    const elements = [];
    for (let i = 0; i < node.children.length; i++) {
      let child = node.children[i];
      if ((0, generated.isJSXText)(child)) {
        (0, _cleanJSXElementLiteralChild.default)(child, elements);
        continue;
      }
      if ((0, generated.isJSXExpressionContainer)(child)) child = child.expression;
      if ((0, generated.isJSXEmptyExpression)(child)) continue;
      elements.push(child);
    }
    return elements;
  }
});
unwrapExports(buildChildren_1);
var isNode_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isNode;
  function isNode(node) {
    return !!(node && definitions.VISITOR_KEYS[node.type]);
  }
});
unwrapExports(isNode_1);
var assertNode_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = assertNode;
  var _isNode = _interopRequireDefault(isNode_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function assertNode(node) {
    if (!(0, _isNode.default)(node)) {
      const type = node && node.type || JSON.stringify(node);
      throw new TypeError(`Not a valid node of type "${type}"`);
    }
  }
});
unwrapExports(assertNode_1);
var generated$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.assertArrayExpression = assertArrayExpression;
  exports.assertAssignmentExpression = assertAssignmentExpression;
  exports.assertBinaryExpression = assertBinaryExpression;
  exports.assertInterpreterDirective = assertInterpreterDirective;
  exports.assertDirective = assertDirective;
  exports.assertDirectiveLiteral = assertDirectiveLiteral;
  exports.assertBlockStatement = assertBlockStatement;
  exports.assertBreakStatement = assertBreakStatement;
  exports.assertCallExpression = assertCallExpression;
  exports.assertCatchClause = assertCatchClause;
  exports.assertConditionalExpression = assertConditionalExpression;
  exports.assertContinueStatement = assertContinueStatement;
  exports.assertDebuggerStatement = assertDebuggerStatement;
  exports.assertDoWhileStatement = assertDoWhileStatement;
  exports.assertEmptyStatement = assertEmptyStatement;
  exports.assertExpressionStatement = assertExpressionStatement;
  exports.assertFile = assertFile;
  exports.assertForInStatement = assertForInStatement;
  exports.assertForStatement = assertForStatement;
  exports.assertFunctionDeclaration = assertFunctionDeclaration;
  exports.assertFunctionExpression = assertFunctionExpression;
  exports.assertIdentifier = assertIdentifier;
  exports.assertIfStatement = assertIfStatement;
  exports.assertLabeledStatement = assertLabeledStatement;
  exports.assertStringLiteral = assertStringLiteral;
  exports.assertNumericLiteral = assertNumericLiteral;
  exports.assertNullLiteral = assertNullLiteral;
  exports.assertBooleanLiteral = assertBooleanLiteral;
  exports.assertRegExpLiteral = assertRegExpLiteral;
  exports.assertLogicalExpression = assertLogicalExpression;
  exports.assertMemberExpression = assertMemberExpression;
  exports.assertNewExpression = assertNewExpression;
  exports.assertProgram = assertProgram;
  exports.assertObjectExpression = assertObjectExpression;
  exports.assertObjectMethod = assertObjectMethod;
  exports.assertObjectProperty = assertObjectProperty;
  exports.assertRestElement = assertRestElement;
  exports.assertReturnStatement = assertReturnStatement;
  exports.assertSequenceExpression = assertSequenceExpression;
  exports.assertSwitchCase = assertSwitchCase;
  exports.assertSwitchStatement = assertSwitchStatement;
  exports.assertThisExpression = assertThisExpression;
  exports.assertThrowStatement = assertThrowStatement;
  exports.assertTryStatement = assertTryStatement;
  exports.assertUnaryExpression = assertUnaryExpression;
  exports.assertUpdateExpression = assertUpdateExpression;
  exports.assertVariableDeclaration = assertVariableDeclaration;
  exports.assertVariableDeclarator = assertVariableDeclarator;
  exports.assertWhileStatement = assertWhileStatement;
  exports.assertWithStatement = assertWithStatement;
  exports.assertAssignmentPattern = assertAssignmentPattern;
  exports.assertArrayPattern = assertArrayPattern;
  exports.assertArrowFunctionExpression = assertArrowFunctionExpression;
  exports.assertClassBody = assertClassBody;
  exports.assertClassDeclaration = assertClassDeclaration;
  exports.assertClassExpression = assertClassExpression;
  exports.assertExportAllDeclaration = assertExportAllDeclaration;
  exports.assertExportDefaultDeclaration = assertExportDefaultDeclaration;
  exports.assertExportNamedDeclaration = assertExportNamedDeclaration;
  exports.assertExportSpecifier = assertExportSpecifier;
  exports.assertForOfStatement = assertForOfStatement;
  exports.assertImportDeclaration = assertImportDeclaration;
  exports.assertImportDefaultSpecifier = assertImportDefaultSpecifier;
  exports.assertImportNamespaceSpecifier = assertImportNamespaceSpecifier;
  exports.assertImportSpecifier = assertImportSpecifier;
  exports.assertMetaProperty = assertMetaProperty;
  exports.assertClassMethod = assertClassMethod;
  exports.assertObjectPattern = assertObjectPattern;
  exports.assertSpreadElement = assertSpreadElement;
  exports.assertSuper = assertSuper;
  exports.assertTaggedTemplateExpression = assertTaggedTemplateExpression;
  exports.assertTemplateElement = assertTemplateElement;
  exports.assertTemplateLiteral = assertTemplateLiteral;
  exports.assertYieldExpression = assertYieldExpression;
  exports.assertAnyTypeAnnotation = assertAnyTypeAnnotation;
  exports.assertArrayTypeAnnotation = assertArrayTypeAnnotation;
  exports.assertBooleanTypeAnnotation = assertBooleanTypeAnnotation;
  exports.assertBooleanLiteralTypeAnnotation = assertBooleanLiteralTypeAnnotation;
  exports.assertNullLiteralTypeAnnotation = assertNullLiteralTypeAnnotation;
  exports.assertClassImplements = assertClassImplements;
  exports.assertDeclareClass = assertDeclareClass;
  exports.assertDeclareFunction = assertDeclareFunction;
  exports.assertDeclareInterface = assertDeclareInterface;
  exports.assertDeclareModule = assertDeclareModule;
  exports.assertDeclareModuleExports = assertDeclareModuleExports;
  exports.assertDeclareTypeAlias = assertDeclareTypeAlias;
  exports.assertDeclareOpaqueType = assertDeclareOpaqueType;
  exports.assertDeclareVariable = assertDeclareVariable;
  exports.assertDeclareExportDeclaration = assertDeclareExportDeclaration;
  exports.assertDeclareExportAllDeclaration = assertDeclareExportAllDeclaration;
  exports.assertDeclaredPredicate = assertDeclaredPredicate;
  exports.assertExistsTypeAnnotation = assertExistsTypeAnnotation;
  exports.assertFunctionTypeAnnotation = assertFunctionTypeAnnotation;
  exports.assertFunctionTypeParam = assertFunctionTypeParam;
  exports.assertGenericTypeAnnotation = assertGenericTypeAnnotation;
  exports.assertInferredPredicate = assertInferredPredicate;
  exports.assertInterfaceExtends = assertInterfaceExtends;
  exports.assertInterfaceDeclaration = assertInterfaceDeclaration;
  exports.assertInterfaceTypeAnnotation = assertInterfaceTypeAnnotation;
  exports.assertIntersectionTypeAnnotation = assertIntersectionTypeAnnotation;
  exports.assertMixedTypeAnnotation = assertMixedTypeAnnotation;
  exports.assertEmptyTypeAnnotation = assertEmptyTypeAnnotation;
  exports.assertNullableTypeAnnotation = assertNullableTypeAnnotation;
  exports.assertNumberLiteralTypeAnnotation = assertNumberLiteralTypeAnnotation;
  exports.assertNumberTypeAnnotation = assertNumberTypeAnnotation;
  exports.assertObjectTypeAnnotation = assertObjectTypeAnnotation;
  exports.assertObjectTypeInternalSlot = assertObjectTypeInternalSlot;
  exports.assertObjectTypeCallProperty = assertObjectTypeCallProperty;
  exports.assertObjectTypeIndexer = assertObjectTypeIndexer;
  exports.assertObjectTypeProperty = assertObjectTypeProperty;
  exports.assertObjectTypeSpreadProperty = assertObjectTypeSpreadProperty;
  exports.assertOpaqueType = assertOpaqueType;
  exports.assertQualifiedTypeIdentifier = assertQualifiedTypeIdentifier;
  exports.assertStringLiteralTypeAnnotation = assertStringLiteralTypeAnnotation;
  exports.assertStringTypeAnnotation = assertStringTypeAnnotation;
  exports.assertThisTypeAnnotation = assertThisTypeAnnotation;
  exports.assertTupleTypeAnnotation = assertTupleTypeAnnotation;
  exports.assertTypeofTypeAnnotation = assertTypeofTypeAnnotation;
  exports.assertTypeAlias = assertTypeAlias;
  exports.assertTypeAnnotation = assertTypeAnnotation;
  exports.assertTypeCastExpression = assertTypeCastExpression;
  exports.assertTypeParameter = assertTypeParameter;
  exports.assertTypeParameterDeclaration = assertTypeParameterDeclaration;
  exports.assertTypeParameterInstantiation = assertTypeParameterInstantiation;
  exports.assertUnionTypeAnnotation = assertUnionTypeAnnotation;
  exports.assertVariance = assertVariance;
  exports.assertVoidTypeAnnotation = assertVoidTypeAnnotation;
  exports.assertJSXAttribute = assertJSXAttribute;
  exports.assertJSXClosingElement = assertJSXClosingElement;
  exports.assertJSXElement = assertJSXElement;
  exports.assertJSXEmptyExpression = assertJSXEmptyExpression;
  exports.assertJSXExpressionContainer = assertJSXExpressionContainer;
  exports.assertJSXSpreadChild = assertJSXSpreadChild;
  exports.assertJSXIdentifier = assertJSXIdentifier;
  exports.assertJSXMemberExpression = assertJSXMemberExpression;
  exports.assertJSXNamespacedName = assertJSXNamespacedName;
  exports.assertJSXOpeningElement = assertJSXOpeningElement;
  exports.assertJSXSpreadAttribute = assertJSXSpreadAttribute;
  exports.assertJSXText = assertJSXText;
  exports.assertJSXFragment = assertJSXFragment;
  exports.assertJSXOpeningFragment = assertJSXOpeningFragment;
  exports.assertJSXClosingFragment = assertJSXClosingFragment;
  exports.assertNoop = assertNoop;
  exports.assertParenthesizedExpression = assertParenthesizedExpression;
  exports.assertAwaitExpression = assertAwaitExpression;
  exports.assertBindExpression = assertBindExpression;
  exports.assertClassProperty = assertClassProperty;
  exports.assertOptionalMemberExpression = assertOptionalMemberExpression;
  exports.assertPipelineTopicExpression = assertPipelineTopicExpression;
  exports.assertPipelineBareFunction = assertPipelineBareFunction;
  exports.assertPipelinePrimaryTopicReference = assertPipelinePrimaryTopicReference;
  exports.assertOptionalCallExpression = assertOptionalCallExpression;
  exports.assertClassPrivateProperty = assertClassPrivateProperty;
  exports.assertClassPrivateMethod = assertClassPrivateMethod;
  exports.assertImport = assertImport;
  exports.assertDecorator = assertDecorator;
  exports.assertDoExpression = assertDoExpression;
  exports.assertExportDefaultSpecifier = assertExportDefaultSpecifier;
  exports.assertExportNamespaceSpecifier = assertExportNamespaceSpecifier;
  exports.assertPrivateName = assertPrivateName;
  exports.assertBigIntLiteral = assertBigIntLiteral;
  exports.assertTSParameterProperty = assertTSParameterProperty;
  exports.assertTSDeclareFunction = assertTSDeclareFunction;
  exports.assertTSDeclareMethod = assertTSDeclareMethod;
  exports.assertTSQualifiedName = assertTSQualifiedName;
  exports.assertTSCallSignatureDeclaration = assertTSCallSignatureDeclaration;
  exports.assertTSConstructSignatureDeclaration = assertTSConstructSignatureDeclaration;
  exports.assertTSPropertySignature = assertTSPropertySignature;
  exports.assertTSMethodSignature = assertTSMethodSignature;
  exports.assertTSIndexSignature = assertTSIndexSignature;
  exports.assertTSAnyKeyword = assertTSAnyKeyword;
  exports.assertTSUnknownKeyword = assertTSUnknownKeyword;
  exports.assertTSNumberKeyword = assertTSNumberKeyword;
  exports.assertTSObjectKeyword = assertTSObjectKeyword;
  exports.assertTSBooleanKeyword = assertTSBooleanKeyword;
  exports.assertTSStringKeyword = assertTSStringKeyword;
  exports.assertTSSymbolKeyword = assertTSSymbolKeyword;
  exports.assertTSVoidKeyword = assertTSVoidKeyword;
  exports.assertTSUndefinedKeyword = assertTSUndefinedKeyword;
  exports.assertTSNullKeyword = assertTSNullKeyword;
  exports.assertTSNeverKeyword = assertTSNeverKeyword;
  exports.assertTSThisType = assertTSThisType;
  exports.assertTSFunctionType = assertTSFunctionType;
  exports.assertTSConstructorType = assertTSConstructorType;
  exports.assertTSTypeReference = assertTSTypeReference;
  exports.assertTSTypePredicate = assertTSTypePredicate;
  exports.assertTSTypeQuery = assertTSTypeQuery;
  exports.assertTSTypeLiteral = assertTSTypeLiteral;
  exports.assertTSArrayType = assertTSArrayType;
  exports.assertTSTupleType = assertTSTupleType;
  exports.assertTSOptionalType = assertTSOptionalType;
  exports.assertTSRestType = assertTSRestType;
  exports.assertTSUnionType = assertTSUnionType;
  exports.assertTSIntersectionType = assertTSIntersectionType;
  exports.assertTSConditionalType = assertTSConditionalType;
  exports.assertTSInferType = assertTSInferType;
  exports.assertTSParenthesizedType = assertTSParenthesizedType;
  exports.assertTSTypeOperator = assertTSTypeOperator;
  exports.assertTSIndexedAccessType = assertTSIndexedAccessType;
  exports.assertTSMappedType = assertTSMappedType;
  exports.assertTSLiteralType = assertTSLiteralType;
  exports.assertTSExpressionWithTypeArguments = assertTSExpressionWithTypeArguments;
  exports.assertTSInterfaceDeclaration = assertTSInterfaceDeclaration;
  exports.assertTSInterfaceBody = assertTSInterfaceBody;
  exports.assertTSTypeAliasDeclaration = assertTSTypeAliasDeclaration;
  exports.assertTSAsExpression = assertTSAsExpression;
  exports.assertTSTypeAssertion = assertTSTypeAssertion;
  exports.assertTSEnumDeclaration = assertTSEnumDeclaration;
  exports.assertTSEnumMember = assertTSEnumMember;
  exports.assertTSModuleDeclaration = assertTSModuleDeclaration;
  exports.assertTSModuleBlock = assertTSModuleBlock;
  exports.assertTSImportType = assertTSImportType;
  exports.assertTSImportEqualsDeclaration = assertTSImportEqualsDeclaration;
  exports.assertTSExternalModuleReference = assertTSExternalModuleReference;
  exports.assertTSNonNullExpression = assertTSNonNullExpression;
  exports.assertTSExportAssignment = assertTSExportAssignment;
  exports.assertTSNamespaceExportDeclaration = assertTSNamespaceExportDeclaration;
  exports.assertTSTypeAnnotation = assertTSTypeAnnotation;
  exports.assertTSTypeParameterInstantiation = assertTSTypeParameterInstantiation;
  exports.assertTSTypeParameterDeclaration = assertTSTypeParameterDeclaration;
  exports.assertTSTypeParameter = assertTSTypeParameter;
  exports.assertExpression = assertExpression;
  exports.assertBinary = assertBinary;
  exports.assertScopable = assertScopable;
  exports.assertBlockParent = assertBlockParent;
  exports.assertBlock = assertBlock;
  exports.assertStatement = assertStatement;
  exports.assertTerminatorless = assertTerminatorless;
  exports.assertCompletionStatement = assertCompletionStatement;
  exports.assertConditional = assertConditional;
  exports.assertLoop = assertLoop;
  exports.assertWhile = assertWhile;
  exports.assertExpressionWrapper = assertExpressionWrapper;
  exports.assertFor = assertFor;
  exports.assertForXStatement = assertForXStatement;
  exports.assertFunction = assertFunction;
  exports.assertFunctionParent = assertFunctionParent;
  exports.assertPureish = assertPureish;
  exports.assertDeclaration = assertDeclaration;
  exports.assertPatternLike = assertPatternLike;
  exports.assertLVal = assertLVal;
  exports.assertTSEntityName = assertTSEntityName;
  exports.assertLiteral = assertLiteral;
  exports.assertImmutable = assertImmutable;
  exports.assertUserWhitespacable = assertUserWhitespacable;
  exports.assertMethod = assertMethod;
  exports.assertObjectMember = assertObjectMember;
  exports.assertProperty = assertProperty;
  exports.assertUnaryLike = assertUnaryLike;
  exports.assertPattern = assertPattern;
  exports.assertClass = assertClass;
  exports.assertModuleDeclaration = assertModuleDeclaration;
  exports.assertExportDeclaration = assertExportDeclaration;
  exports.assertModuleSpecifier = assertModuleSpecifier;
  exports.assertFlow = assertFlow;
  exports.assertFlowType = assertFlowType;
  exports.assertFlowBaseAnnotation = assertFlowBaseAnnotation;
  exports.assertFlowDeclaration = assertFlowDeclaration;
  exports.assertFlowPredicate = assertFlowPredicate;
  exports.assertJSX = assertJSX;
  exports.assertPrivate = assertPrivate;
  exports.assertTSTypeElement = assertTSTypeElement;
  exports.assertTSType = assertTSType;
  exports.assertNumberLiteral = assertNumberLiteral;
  exports.assertRegexLiteral = assertRegexLiteral;
  exports.assertRestProperty = assertRestProperty;
  exports.assertSpreadProperty = assertSpreadProperty;
  var _is = _interopRequireDefault(is_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function assert(type, node, opts) {
    if (!(0, _is.default)(type, node, opts)) {
      throw new Error(`Expected type "${type}" with option ${JSON.stringify(opts)}, but instead got "${node.type}".`);
    }
  }
  function assertArrayExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ArrayExpression", node, opts);
  }
  function assertAssignmentExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("AssignmentExpression", node, opts);
  }
  function assertBinaryExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BinaryExpression", node, opts);
  }
  function assertInterpreterDirective(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("InterpreterDirective", node, opts);
  }
  function assertDirective(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Directive", node, opts);
  }
  function assertDirectiveLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DirectiveLiteral", node, opts);
  }
  function assertBlockStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BlockStatement", node, opts);
  }
  function assertBreakStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BreakStatement", node, opts);
  }
  function assertCallExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("CallExpression", node, opts);
  }
  function assertCatchClause(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("CatchClause", node, opts);
  }
  function assertConditionalExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ConditionalExpression", node, opts);
  }
  function assertContinueStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ContinueStatement", node, opts);
  }
  function assertDebuggerStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DebuggerStatement", node, opts);
  }
  function assertDoWhileStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DoWhileStatement", node, opts);
  }
  function assertEmptyStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("EmptyStatement", node, opts);
  }
  function assertExpressionStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExpressionStatement", node, opts);
  }
  function assertFile(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("File", node, opts);
  }
  function assertForInStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ForInStatement", node, opts);
  }
  function assertForStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ForStatement", node, opts);
  }
  function assertFunctionDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FunctionDeclaration", node, opts);
  }
  function assertFunctionExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FunctionExpression", node, opts);
  }
  function assertIdentifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Identifier", node, opts);
  }
  function assertIfStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("IfStatement", node, opts);
  }
  function assertLabeledStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("LabeledStatement", node, opts);
  }
  function assertStringLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("StringLiteral", node, opts);
  }
  function assertNumericLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("NumericLiteral", node, opts);
  }
  function assertNullLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("NullLiteral", node, opts);
  }
  function assertBooleanLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BooleanLiteral", node, opts);
  }
  function assertRegExpLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("RegExpLiteral", node, opts);
  }
  function assertLogicalExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("LogicalExpression", node, opts);
  }
  function assertMemberExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("MemberExpression", node, opts);
  }
  function assertNewExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("NewExpression", node, opts);
  }
  function assertProgram(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Program", node, opts);
  }
  function assertObjectExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectExpression", node, opts);
  }
  function assertObjectMethod(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectMethod", node, opts);
  }
  function assertObjectProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectProperty", node, opts);
  }
  function assertRestElement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("RestElement", node, opts);
  }
  function assertReturnStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ReturnStatement", node, opts);
  }
  function assertSequenceExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("SequenceExpression", node, opts);
  }
  function assertSwitchCase(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("SwitchCase", node, opts);
  }
  function assertSwitchStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("SwitchStatement", node, opts);
  }
  function assertThisExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ThisExpression", node, opts);
  }
  function assertThrowStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ThrowStatement", node, opts);
  }
  function assertTryStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TryStatement", node, opts);
  }
  function assertUnaryExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("UnaryExpression", node, opts);
  }
  function assertUpdateExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("UpdateExpression", node, opts);
  }
  function assertVariableDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("VariableDeclaration", node, opts);
  }
  function assertVariableDeclarator(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("VariableDeclarator", node, opts);
  }
  function assertWhileStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("WhileStatement", node, opts);
  }
  function assertWithStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("WithStatement", node, opts);
  }
  function assertAssignmentPattern(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("AssignmentPattern", node, opts);
  }
  function assertArrayPattern(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ArrayPattern", node, opts);
  }
  function assertArrowFunctionExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ArrowFunctionExpression", node, opts);
  }
  function assertClassBody(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassBody", node, opts);
  }
  function assertClassDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassDeclaration", node, opts);
  }
  function assertClassExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassExpression", node, opts);
  }
  function assertExportAllDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExportAllDeclaration", node, opts);
  }
  function assertExportDefaultDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExportDefaultDeclaration", node, opts);
  }
  function assertExportNamedDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExportNamedDeclaration", node, opts);
  }
  function assertExportSpecifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExportSpecifier", node, opts);
  }
  function assertForOfStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ForOfStatement", node, opts);
  }
  function assertImportDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ImportDeclaration", node, opts);
  }
  function assertImportDefaultSpecifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ImportDefaultSpecifier", node, opts);
  }
  function assertImportNamespaceSpecifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ImportNamespaceSpecifier", node, opts);
  }
  function assertImportSpecifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ImportSpecifier", node, opts);
  }
  function assertMetaProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("MetaProperty", node, opts);
  }
  function assertClassMethod(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassMethod", node, opts);
  }
  function assertObjectPattern(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectPattern", node, opts);
  }
  function assertSpreadElement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("SpreadElement", node, opts);
  }
  function assertSuper(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Super", node, opts);
  }
  function assertTaggedTemplateExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TaggedTemplateExpression", node, opts);
  }
  function assertTemplateElement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TemplateElement", node, opts);
  }
  function assertTemplateLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TemplateLiteral", node, opts);
  }
  function assertYieldExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("YieldExpression", node, opts);
  }
  function assertAnyTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("AnyTypeAnnotation", node, opts);
  }
  function assertArrayTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ArrayTypeAnnotation", node, opts);
  }
  function assertBooleanTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BooleanTypeAnnotation", node, opts);
  }
  function assertBooleanLiteralTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BooleanLiteralTypeAnnotation", node, opts);
  }
  function assertNullLiteralTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("NullLiteralTypeAnnotation", node, opts);
  }
  function assertClassImplements(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassImplements", node, opts);
  }
  function assertDeclareClass(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareClass", node, opts);
  }
  function assertDeclareFunction(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareFunction", node, opts);
  }
  function assertDeclareInterface(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareInterface", node, opts);
  }
  function assertDeclareModule(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareModule", node, opts);
  }
  function assertDeclareModuleExports(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareModuleExports", node, opts);
  }
  function assertDeclareTypeAlias(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareTypeAlias", node, opts);
  }
  function assertDeclareOpaqueType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareOpaqueType", node, opts);
  }
  function assertDeclareVariable(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareVariable", node, opts);
  }
  function assertDeclareExportDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareExportDeclaration", node, opts);
  }
  function assertDeclareExportAllDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclareExportAllDeclaration", node, opts);
  }
  function assertDeclaredPredicate(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DeclaredPredicate", node, opts);
  }
  function assertExistsTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExistsTypeAnnotation", node, opts);
  }
  function assertFunctionTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FunctionTypeAnnotation", node, opts);
  }
  function assertFunctionTypeParam(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FunctionTypeParam", node, opts);
  }
  function assertGenericTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("GenericTypeAnnotation", node, opts);
  }
  function assertInferredPredicate(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("InferredPredicate", node, opts);
  }
  function assertInterfaceExtends(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("InterfaceExtends", node, opts);
  }
  function assertInterfaceDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("InterfaceDeclaration", node, opts);
  }
  function assertInterfaceTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("InterfaceTypeAnnotation", node, opts);
  }
  function assertIntersectionTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("IntersectionTypeAnnotation", node, opts);
  }
  function assertMixedTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("MixedTypeAnnotation", node, opts);
  }
  function assertEmptyTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("EmptyTypeAnnotation", node, opts);
  }
  function assertNullableTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("NullableTypeAnnotation", node, opts);
  }
  function assertNumberLiteralTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("NumberLiteralTypeAnnotation", node, opts);
  }
  function assertNumberTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("NumberTypeAnnotation", node, opts);
  }
  function assertObjectTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectTypeAnnotation", node, opts);
  }
  function assertObjectTypeInternalSlot(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectTypeInternalSlot", node, opts);
  }
  function assertObjectTypeCallProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectTypeCallProperty", node, opts);
  }
  function assertObjectTypeIndexer(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectTypeIndexer", node, opts);
  }
  function assertObjectTypeProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectTypeProperty", node, opts);
  }
  function assertObjectTypeSpreadProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectTypeSpreadProperty", node, opts);
  }
  function assertOpaqueType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("OpaqueType", node, opts);
  }
  function assertQualifiedTypeIdentifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("QualifiedTypeIdentifier", node, opts);
  }
  function assertStringLiteralTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("StringLiteralTypeAnnotation", node, opts);
  }
  function assertStringTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("StringTypeAnnotation", node, opts);
  }
  function assertThisTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ThisTypeAnnotation", node, opts);
  }
  function assertTupleTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TupleTypeAnnotation", node, opts);
  }
  function assertTypeofTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TypeofTypeAnnotation", node, opts);
  }
  function assertTypeAlias(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TypeAlias", node, opts);
  }
  function assertTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TypeAnnotation", node, opts);
  }
  function assertTypeCastExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TypeCastExpression", node, opts);
  }
  function assertTypeParameter(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TypeParameter", node, opts);
  }
  function assertTypeParameterDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TypeParameterDeclaration", node, opts);
  }
  function assertTypeParameterInstantiation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TypeParameterInstantiation", node, opts);
  }
  function assertUnionTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("UnionTypeAnnotation", node, opts);
  }
  function assertVariance(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Variance", node, opts);
  }
  function assertVoidTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("VoidTypeAnnotation", node, opts);
  }
  function assertJSXAttribute(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXAttribute", node, opts);
  }
  function assertJSXClosingElement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXClosingElement", node, opts);
  }
  function assertJSXElement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXElement", node, opts);
  }
  function assertJSXEmptyExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXEmptyExpression", node, opts);
  }
  function assertJSXExpressionContainer(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXExpressionContainer", node, opts);
  }
  function assertJSXSpreadChild(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXSpreadChild", node, opts);
  }
  function assertJSXIdentifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXIdentifier", node, opts);
  }
  function assertJSXMemberExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXMemberExpression", node, opts);
  }
  function assertJSXNamespacedName(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXNamespacedName", node, opts);
  }
  function assertJSXOpeningElement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXOpeningElement", node, opts);
  }
  function assertJSXSpreadAttribute(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXSpreadAttribute", node, opts);
  }
  function assertJSXText(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXText", node, opts);
  }
  function assertJSXFragment(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXFragment", node, opts);
  }
  function assertJSXOpeningFragment(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXOpeningFragment", node, opts);
  }
  function assertJSXClosingFragment(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSXClosingFragment", node, opts);
  }
  function assertNoop(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Noop", node, opts);
  }
  function assertParenthesizedExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ParenthesizedExpression", node, opts);
  }
  function assertAwaitExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("AwaitExpression", node, opts);
  }
  function assertBindExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BindExpression", node, opts);
  }
  function assertClassProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassProperty", node, opts);
  }
  function assertOptionalMemberExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("OptionalMemberExpression", node, opts);
  }
  function assertPipelineTopicExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("PipelineTopicExpression", node, opts);
  }
  function assertPipelineBareFunction(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("PipelineBareFunction", node, opts);
  }
  function assertPipelinePrimaryTopicReference(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("PipelinePrimaryTopicReference", node, opts);
  }
  function assertOptionalCallExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("OptionalCallExpression", node, opts);
  }
  function assertClassPrivateProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassPrivateProperty", node, opts);
  }
  function assertClassPrivateMethod(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ClassPrivateMethod", node, opts);
  }
  function assertImport(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Import", node, opts);
  }
  function assertDecorator(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Decorator", node, opts);
  }
  function assertDoExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("DoExpression", node, opts);
  }
  function assertExportDefaultSpecifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExportDefaultSpecifier", node, opts);
  }
  function assertExportNamespaceSpecifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExportNamespaceSpecifier", node, opts);
  }
  function assertPrivateName(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("PrivateName", node, opts);
  }
  function assertBigIntLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BigIntLiteral", node, opts);
  }
  function assertTSParameterProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSParameterProperty", node, opts);
  }
  function assertTSDeclareFunction(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSDeclareFunction", node, opts);
  }
  function assertTSDeclareMethod(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSDeclareMethod", node, opts);
  }
  function assertTSQualifiedName(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSQualifiedName", node, opts);
  }
  function assertTSCallSignatureDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSCallSignatureDeclaration", node, opts);
  }
  function assertTSConstructSignatureDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSConstructSignatureDeclaration", node, opts);
  }
  function assertTSPropertySignature(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSPropertySignature", node, opts);
  }
  function assertTSMethodSignature(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSMethodSignature", node, opts);
  }
  function assertTSIndexSignature(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSIndexSignature", node, opts);
  }
  function assertTSAnyKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSAnyKeyword", node, opts);
  }
  function assertTSUnknownKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSUnknownKeyword", node, opts);
  }
  function assertTSNumberKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSNumberKeyword", node, opts);
  }
  function assertTSObjectKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSObjectKeyword", node, opts);
  }
  function assertTSBooleanKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSBooleanKeyword", node, opts);
  }
  function assertTSStringKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSStringKeyword", node, opts);
  }
  function assertTSSymbolKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSSymbolKeyword", node, opts);
  }
  function assertTSVoidKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSVoidKeyword", node, opts);
  }
  function assertTSUndefinedKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSUndefinedKeyword", node, opts);
  }
  function assertTSNullKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSNullKeyword", node, opts);
  }
  function assertTSNeverKeyword(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSNeverKeyword", node, opts);
  }
  function assertTSThisType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSThisType", node, opts);
  }
  function assertTSFunctionType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSFunctionType", node, opts);
  }
  function assertTSConstructorType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSConstructorType", node, opts);
  }
  function assertTSTypeReference(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeReference", node, opts);
  }
  function assertTSTypePredicate(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypePredicate", node, opts);
  }
  function assertTSTypeQuery(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeQuery", node, opts);
  }
  function assertTSTypeLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeLiteral", node, opts);
  }
  function assertTSArrayType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSArrayType", node, opts);
  }
  function assertTSTupleType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTupleType", node, opts);
  }
  function assertTSOptionalType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSOptionalType", node, opts);
  }
  function assertTSRestType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSRestType", node, opts);
  }
  function assertTSUnionType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSUnionType", node, opts);
  }
  function assertTSIntersectionType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSIntersectionType", node, opts);
  }
  function assertTSConditionalType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSConditionalType", node, opts);
  }
  function assertTSInferType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSInferType", node, opts);
  }
  function assertTSParenthesizedType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSParenthesizedType", node, opts);
  }
  function assertTSTypeOperator(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeOperator", node, opts);
  }
  function assertTSIndexedAccessType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSIndexedAccessType", node, opts);
  }
  function assertTSMappedType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSMappedType", node, opts);
  }
  function assertTSLiteralType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSLiteralType", node, opts);
  }
  function assertTSExpressionWithTypeArguments(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSExpressionWithTypeArguments", node, opts);
  }
  function assertTSInterfaceDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSInterfaceDeclaration", node, opts);
  }
  function assertTSInterfaceBody(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSInterfaceBody", node, opts);
  }
  function assertTSTypeAliasDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeAliasDeclaration", node, opts);
  }
  function assertTSAsExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSAsExpression", node, opts);
  }
  function assertTSTypeAssertion(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeAssertion", node, opts);
  }
  function assertTSEnumDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSEnumDeclaration", node, opts);
  }
  function assertTSEnumMember(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSEnumMember", node, opts);
  }
  function assertTSModuleDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSModuleDeclaration", node, opts);
  }
  function assertTSModuleBlock(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSModuleBlock", node, opts);
  }
  function assertTSImportType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSImportType", node, opts);
  }
  function assertTSImportEqualsDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSImportEqualsDeclaration", node, opts);
  }
  function assertTSExternalModuleReference(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSExternalModuleReference", node, opts);
  }
  function assertTSNonNullExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSNonNullExpression", node, opts);
  }
  function assertTSExportAssignment(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSExportAssignment", node, opts);
  }
  function assertTSNamespaceExportDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSNamespaceExportDeclaration", node, opts);
  }
  function assertTSTypeAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeAnnotation", node, opts);
  }
  function assertTSTypeParameterInstantiation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeParameterInstantiation", node, opts);
  }
  function assertTSTypeParameterDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeParameterDeclaration", node, opts);
  }
  function assertTSTypeParameter(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeParameter", node, opts);
  }
  function assertExpression(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Expression", node, opts);
  }
  function assertBinary(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Binary", node, opts);
  }
  function assertScopable(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Scopable", node, opts);
  }
  function assertBlockParent(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("BlockParent", node, opts);
  }
  function assertBlock(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Block", node, opts);
  }
  function assertStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Statement", node, opts);
  }
  function assertTerminatorless(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Terminatorless", node, opts);
  }
  function assertCompletionStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("CompletionStatement", node, opts);
  }
  function assertConditional(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Conditional", node, opts);
  }
  function assertLoop(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Loop", node, opts);
  }
  function assertWhile(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("While", node, opts);
  }
  function assertExpressionWrapper(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExpressionWrapper", node, opts);
  }
  function assertFor(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("For", node, opts);
  }
  function assertForXStatement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ForXStatement", node, opts);
  }
  function assertFunction(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Function", node, opts);
  }
  function assertFunctionParent(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FunctionParent", node, opts);
  }
  function assertPureish(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Pureish", node, opts);
  }
  function assertDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Declaration", node, opts);
  }
  function assertPatternLike(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("PatternLike", node, opts);
  }
  function assertLVal(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("LVal", node, opts);
  }
  function assertTSEntityName(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSEntityName", node, opts);
  }
  function assertLiteral(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Literal", node, opts);
  }
  function assertImmutable(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Immutable", node, opts);
  }
  function assertUserWhitespacable(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("UserWhitespacable", node, opts);
  }
  function assertMethod(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Method", node, opts);
  }
  function assertObjectMember(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ObjectMember", node, opts);
  }
  function assertProperty(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Property", node, opts);
  }
  function assertUnaryLike(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("UnaryLike", node, opts);
  }
  function assertPattern(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Pattern", node, opts);
  }
  function assertClass(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Class", node, opts);
  }
  function assertModuleDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ModuleDeclaration", node, opts);
  }
  function assertExportDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ExportDeclaration", node, opts);
  }
  function assertModuleSpecifier(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("ModuleSpecifier", node, opts);
  }
  function assertFlow(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Flow", node, opts);
  }
  function assertFlowType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FlowType", node, opts);
  }
  function assertFlowBaseAnnotation(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FlowBaseAnnotation", node, opts);
  }
  function assertFlowDeclaration(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FlowDeclaration", node, opts);
  }
  function assertFlowPredicate(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("FlowPredicate", node, opts);
  }
  function assertJSX(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("JSX", node, opts);
  }
  function assertPrivate(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("Private", node, opts);
  }
  function assertTSTypeElement(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSTypeElement", node, opts);
  }
  function assertTSType(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    assert("TSType", node, opts);
  }
  function assertNumberLiteral(node, opts) {
    console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
    assert("NumberLiteral", node, opts);
  }
  function assertRegexLiteral(node, opts) {
    console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
    assert("RegexLiteral", node, opts);
  }
  function assertRestProperty(node, opts) {
    console.trace("The node type RestProperty has been renamed to RestElement");
    assert("RestProperty", node, opts);
  }
  function assertSpreadProperty(node, opts) {
    console.trace("The node type SpreadProperty has been renamed to SpreadElement");
    assert("SpreadProperty", node, opts);
  }
});
unwrapExports(generated$2);
var generated_1$2 = generated$2.assertArrayExpression;
var generated_2$2 = generated$2.assertAssignmentExpression;
var generated_3$2 = generated$2.assertBinaryExpression;
var generated_4$2 = generated$2.assertInterpreterDirective;
var generated_5$2 = generated$2.assertDirective;
var generated_6$2 = generated$2.assertDirectiveLiteral;
var generated_7$2 = generated$2.assertBlockStatement;
var generated_8$2 = generated$2.assertBreakStatement;
var generated_9$2 = generated$2.assertCallExpression;
var generated_10$2 = generated$2.assertCatchClause;
var generated_11$2 = generated$2.assertConditionalExpression;
var generated_12$2 = generated$2.assertContinueStatement;
var generated_13$2 = generated$2.assertDebuggerStatement;
var generated_14$2 = generated$2.assertDoWhileStatement;
var generated_15$2 = generated$2.assertEmptyStatement;
var generated_16$2 = generated$2.assertExpressionStatement;
var generated_17$2 = generated$2.assertFile;
var generated_18$2 = generated$2.assertForInStatement;
var generated_19$2 = generated$2.assertForStatement;
var generated_20$2 = generated$2.assertFunctionDeclaration;
var generated_21$2 = generated$2.assertFunctionExpression;
var generated_22$2 = generated$2.assertIdentifier;
var generated_23$2 = generated$2.assertIfStatement;
var generated_24$2 = generated$2.assertLabeledStatement;
var generated_25$2 = generated$2.assertStringLiteral;
var generated_26$2 = generated$2.assertNumericLiteral;
var generated_27$2 = generated$2.assertNullLiteral;
var generated_28$2 = generated$2.assertBooleanLiteral;
var generated_29$2 = generated$2.assertRegExpLiteral;
var generated_30$2 = generated$2.assertLogicalExpression;
var generated_31$2 = generated$2.assertMemberExpression;
var generated_32$2 = generated$2.assertNewExpression;
var generated_33$2 = generated$2.assertProgram;
var generated_34$2 = generated$2.assertObjectExpression;
var generated_35$2 = generated$2.assertObjectMethod;
var generated_36$2 = generated$2.assertObjectProperty;
var generated_37$2 = generated$2.assertRestElement;
var generated_38$2 = generated$2.assertReturnStatement;
var generated_39$2 = generated$2.assertSequenceExpression;
var generated_40$2 = generated$2.assertSwitchCase;
var generated_41$2 = generated$2.assertSwitchStatement;
var generated_42$2 = generated$2.assertThisExpression;
var generated_43$2 = generated$2.assertThrowStatement;
var generated_44$2 = generated$2.assertTryStatement;
var generated_45$2 = generated$2.assertUnaryExpression;
var generated_46$2 = generated$2.assertUpdateExpression;
var generated_47$2 = generated$2.assertVariableDeclaration;
var generated_48$2 = generated$2.assertVariableDeclarator;
var generated_49$2 = generated$2.assertWhileStatement;
var generated_50$2 = generated$2.assertWithStatement;
var generated_51$2 = generated$2.assertAssignmentPattern;
var generated_52$2 = generated$2.assertArrayPattern;
var generated_53$2 = generated$2.assertArrowFunctionExpression;
var generated_54$2 = generated$2.assertClassBody;
var generated_55$2 = generated$2.assertClassDeclaration;
var generated_56$2 = generated$2.assertClassExpression;
var generated_57$2 = generated$2.assertExportAllDeclaration;
var generated_58$2 = generated$2.assertExportDefaultDeclaration;
var generated_59$2 = generated$2.assertExportNamedDeclaration;
var generated_60$2 = generated$2.assertExportSpecifier;
var generated_61$2 = generated$2.assertForOfStatement;
var generated_62$2 = generated$2.assertImportDeclaration;
var generated_63$2 = generated$2.assertImportDefaultSpecifier;
var generated_64$2 = generated$2.assertImportNamespaceSpecifier;
var generated_65$2 = generated$2.assertImportSpecifier;
var generated_66$2 = generated$2.assertMetaProperty;
var generated_67$2 = generated$2.assertClassMethod;
var generated_68$2 = generated$2.assertObjectPattern;
var generated_69$2 = generated$2.assertSpreadElement;
var generated_70$2 = generated$2.assertSuper;
var generated_71$2 = generated$2.assertTaggedTemplateExpression;
var generated_72$2 = generated$2.assertTemplateElement;
var generated_73$2 = generated$2.assertTemplateLiteral;
var generated_74$2 = generated$2.assertYieldExpression;
var generated_75$2 = generated$2.assertAnyTypeAnnotation;
var generated_76$2 = generated$2.assertArrayTypeAnnotation;
var generated_77$2 = generated$2.assertBooleanTypeAnnotation;
var generated_78$2 = generated$2.assertBooleanLiteralTypeAnnotation;
var generated_79$2 = generated$2.assertNullLiteralTypeAnnotation;
var generated_80$2 = generated$2.assertClassImplements;
var generated_81$2 = generated$2.assertDeclareClass;
var generated_82$2 = generated$2.assertDeclareFunction;
var generated_83$2 = generated$2.assertDeclareInterface;
var generated_84$2 = generated$2.assertDeclareModule;
var generated_85$2 = generated$2.assertDeclareModuleExports;
var generated_86$2 = generated$2.assertDeclareTypeAlias;
var generated_87$2 = generated$2.assertDeclareOpaqueType;
var generated_88$2 = generated$2.assertDeclareVariable;
var generated_89$2 = generated$2.assertDeclareExportDeclaration;
var generated_90$2 = generated$2.assertDeclareExportAllDeclaration;
var generated_91$2 = generated$2.assertDeclaredPredicate;
var generated_92$2 = generated$2.assertExistsTypeAnnotation;
var generated_93$2 = generated$2.assertFunctionTypeAnnotation;
var generated_94$2 = generated$2.assertFunctionTypeParam;
var generated_95$2 = generated$2.assertGenericTypeAnnotation;
var generated_96$2 = generated$2.assertInferredPredicate;
var generated_97$2 = generated$2.assertInterfaceExtends;
var generated_98$2 = generated$2.assertInterfaceDeclaration;
var generated_99$2 = generated$2.assertInterfaceTypeAnnotation;
var generated_100$2 = generated$2.assertIntersectionTypeAnnotation;
var generated_101$2 = generated$2.assertMixedTypeAnnotation;
var generated_102$2 = generated$2.assertEmptyTypeAnnotation;
var generated_103$2 = generated$2.assertNullableTypeAnnotation;
var generated_104$2 = generated$2.assertNumberLiteralTypeAnnotation;
var generated_105$2 = generated$2.assertNumberTypeAnnotation;
var generated_106$2 = generated$2.assertObjectTypeAnnotation;
var generated_107$2 = generated$2.assertObjectTypeInternalSlot;
var generated_108$2 = generated$2.assertObjectTypeCallProperty;
var generated_109$2 = generated$2.assertObjectTypeIndexer;
var generated_110$2 = generated$2.assertObjectTypeProperty;
var generated_111$2 = generated$2.assertObjectTypeSpreadProperty;
var generated_112$2 = generated$2.assertOpaqueType;
var generated_113$2 = generated$2.assertQualifiedTypeIdentifier;
var generated_114$2 = generated$2.assertStringLiteralTypeAnnotation;
var generated_115$2 = generated$2.assertStringTypeAnnotation;
var generated_116$2 = generated$2.assertThisTypeAnnotation;
var generated_117$2 = generated$2.assertTupleTypeAnnotation;
var generated_118$2 = generated$2.assertTypeofTypeAnnotation;
var generated_119$2 = generated$2.assertTypeAlias;
var generated_120$2 = generated$2.assertTypeAnnotation;
var generated_121$2 = generated$2.assertTypeCastExpression;
var generated_122$2 = generated$2.assertTypeParameter;
var generated_123$2 = generated$2.assertTypeParameterDeclaration;
var generated_124$2 = generated$2.assertTypeParameterInstantiation;
var generated_125$2 = generated$2.assertUnionTypeAnnotation;
var generated_126$2 = generated$2.assertVariance;
var generated_127$2 = generated$2.assertVoidTypeAnnotation;
var generated_128$2 = generated$2.assertJSXAttribute;
var generated_129$2 = generated$2.assertJSXClosingElement;
var generated_130$2 = generated$2.assertJSXElement;
var generated_131$2 = generated$2.assertJSXEmptyExpression;
var generated_132$2 = generated$2.assertJSXExpressionContainer;
var generated_133$2 = generated$2.assertJSXSpreadChild;
var generated_134$2 = generated$2.assertJSXIdentifier;
var generated_135$2 = generated$2.assertJSXMemberExpression;
var generated_136$2 = generated$2.assertJSXNamespacedName;
var generated_137$2 = generated$2.assertJSXOpeningElement;
var generated_138$2 = generated$2.assertJSXSpreadAttribute;
var generated_139$2 = generated$2.assertJSXText;
var generated_140$2 = generated$2.assertJSXFragment;
var generated_141$2 = generated$2.assertJSXOpeningFragment;
var generated_142$2 = generated$2.assertJSXClosingFragment;
var generated_143$2 = generated$2.assertNoop;
var generated_144$2 = generated$2.assertParenthesizedExpression;
var generated_145$2 = generated$2.assertAwaitExpression;
var generated_146$2 = generated$2.assertBindExpression;
var generated_147$2 = generated$2.assertClassProperty;
var generated_148$2 = generated$2.assertOptionalMemberExpression;
var generated_149$2 = generated$2.assertPipelineTopicExpression;
var generated_150$2 = generated$2.assertPipelineBareFunction;
var generated_151$2 = generated$2.assertPipelinePrimaryTopicReference;
var generated_152$2 = generated$2.assertOptionalCallExpression;
var generated_153$2 = generated$2.assertClassPrivateProperty;
var generated_154$2 = generated$2.assertClassPrivateMethod;
var generated_155$2 = generated$2.assertImport;
var generated_156$2 = generated$2.assertDecorator;
var generated_157$2 = generated$2.assertDoExpression;
var generated_158$2 = generated$2.assertExportDefaultSpecifier;
var generated_159$2 = generated$2.assertExportNamespaceSpecifier;
var generated_160$2 = generated$2.assertPrivateName;
var generated_161$2 = generated$2.assertBigIntLiteral;
var generated_162$2 = generated$2.assertTSParameterProperty;
var generated_163$2 = generated$2.assertTSDeclareFunction;
var generated_164$2 = generated$2.assertTSDeclareMethod;
var generated_165$2 = generated$2.assertTSQualifiedName;
var generated_166$2 = generated$2.assertTSCallSignatureDeclaration;
var generated_167$2 = generated$2.assertTSConstructSignatureDeclaration;
var generated_168$2 = generated$2.assertTSPropertySignature;
var generated_169$2 = generated$2.assertTSMethodSignature;
var generated_170$2 = generated$2.assertTSIndexSignature;
var generated_171$2 = generated$2.assertTSAnyKeyword;
var generated_172$2 = generated$2.assertTSUnknownKeyword;
var generated_173$2 = generated$2.assertTSNumberKeyword;
var generated_174$2 = generated$2.assertTSObjectKeyword;
var generated_175$2 = generated$2.assertTSBooleanKeyword;
var generated_176$2 = generated$2.assertTSStringKeyword;
var generated_177$2 = generated$2.assertTSSymbolKeyword;
var generated_178$2 = generated$2.assertTSVoidKeyword;
var generated_179$2 = generated$2.assertTSUndefinedKeyword;
var generated_180$2 = generated$2.assertTSNullKeyword;
var generated_181$2 = generated$2.assertTSNeverKeyword;
var generated_182$2 = generated$2.assertTSThisType;
var generated_183$2 = generated$2.assertTSFunctionType;
var generated_184$2 = generated$2.assertTSConstructorType;
var generated_185$2 = generated$2.assertTSTypeReference;
var generated_186$2 = generated$2.assertTSTypePredicate;
var generated_187$2 = generated$2.assertTSTypeQuery;
var generated_188$2 = generated$2.assertTSTypeLiteral;
var generated_189$2 = generated$2.assertTSArrayType;
var generated_190$2 = generated$2.assertTSTupleType;
var generated_191$2 = generated$2.assertTSOptionalType;
var generated_192$2 = generated$2.assertTSRestType;
var generated_193$2 = generated$2.assertTSUnionType;
var generated_194$2 = generated$2.assertTSIntersectionType;
var generated_195$2 = generated$2.assertTSConditionalType;
var generated_196$2 = generated$2.assertTSInferType;
var generated_197$2 = generated$2.assertTSParenthesizedType;
var generated_198$2 = generated$2.assertTSTypeOperator;
var generated_199$2 = generated$2.assertTSIndexedAccessType;
var generated_200$2 = generated$2.assertTSMappedType;
var generated_201$2 = generated$2.assertTSLiteralType;
var generated_202$2 = generated$2.assertTSExpressionWithTypeArguments;
var generated_203$2 = generated$2.assertTSInterfaceDeclaration;
var generated_204$2 = generated$2.assertTSInterfaceBody;
var generated_205$2 = generated$2.assertTSTypeAliasDeclaration;
var generated_206$2 = generated$2.assertTSAsExpression;
var generated_207$2 = generated$2.assertTSTypeAssertion;
var generated_208$2 = generated$2.assertTSEnumDeclaration;
var generated_209$2 = generated$2.assertTSEnumMember;
var generated_210$2 = generated$2.assertTSModuleDeclaration;
var generated_211$2 = generated$2.assertTSModuleBlock;
var generated_212$2 = generated$2.assertTSImportType;
var generated_213$2 = generated$2.assertTSImportEqualsDeclaration;
var generated_214$2 = generated$2.assertTSExternalModuleReference;
var generated_215$2 = generated$2.assertTSNonNullExpression;
var generated_216$2 = generated$2.assertTSExportAssignment;
var generated_217$2 = generated$2.assertTSNamespaceExportDeclaration;
var generated_218$2 = generated$2.assertTSTypeAnnotation;
var generated_219$2 = generated$2.assertTSTypeParameterInstantiation;
var generated_220$2 = generated$2.assertTSTypeParameterDeclaration;
var generated_221$2 = generated$2.assertTSTypeParameter;
var generated_222$2 = generated$2.assertExpression;
var generated_223$2 = generated$2.assertBinary;
var generated_224$2 = generated$2.assertScopable;
var generated_225$2 = generated$2.assertBlockParent;
var generated_226$2 = generated$2.assertBlock;
var generated_227$2 = generated$2.assertStatement;
var generated_228$2 = generated$2.assertTerminatorless;
var generated_229$2 = generated$2.assertCompletionStatement;
var generated_230$2 = generated$2.assertConditional;
var generated_231$2 = generated$2.assertLoop;
var generated_232$2 = generated$2.assertWhile;
var generated_233$2 = generated$2.assertExpressionWrapper;
var generated_234$2 = generated$2.assertFor;
var generated_235$2 = generated$2.assertForXStatement;
var generated_236$2 = generated$2.assertFunction;
var generated_237$2 = generated$2.assertFunctionParent;
var generated_238$2 = generated$2.assertPureish;
var generated_239$2 = generated$2.assertDeclaration;
var generated_240$2 = generated$2.assertPatternLike;
var generated_241$2 = generated$2.assertLVal;
var generated_242$2 = generated$2.assertTSEntityName;
var generated_243$2 = generated$2.assertLiteral;
var generated_244$2 = generated$2.assertImmutable;
var generated_245$2 = generated$2.assertUserWhitespacable;
var generated_246$2 = generated$2.assertMethod;
var generated_247$2 = generated$2.assertObjectMember;
var generated_248$2 = generated$2.assertProperty;
var generated_249$2 = generated$2.assertUnaryLike;
var generated_250$2 = generated$2.assertPattern;
var generated_251$2 = generated$2.assertClass;
var generated_252$2 = generated$2.assertModuleDeclaration;
var generated_253$2 = generated$2.assertExportDeclaration;
var generated_254$2 = generated$2.assertModuleSpecifier;
var generated_255$2 = generated$2.assertFlow;
var generated_256$2 = generated$2.assertFlowType;
var generated_257$2 = generated$2.assertFlowBaseAnnotation;
var generated_258$2 = generated$2.assertFlowDeclaration;
var generated_259$2 = generated$2.assertFlowPredicate;
var generated_260$2 = generated$2.assertJSX;
var generated_261$2 = generated$2.assertPrivate;
var generated_262$2 = generated$2.assertTSTypeElement;
var generated_263$2 = generated$2.assertTSType;
var generated_264$2 = generated$2.assertNumberLiteral;
var generated_265$2 = generated$2.assertRegexLiteral;
var generated_266$2 = generated$2.assertRestProperty;
var generated_267$2 = generated$2.assertSpreadProperty;
var createTypeAnnotationBasedOnTypeof_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = createTypeAnnotationBasedOnTypeof;
  function createTypeAnnotationBasedOnTypeof(type) {
    if (type === "string") {
      return (0, generated$1.stringTypeAnnotation)();
    } else if (type === "number") {
      return (0, generated$1.numberTypeAnnotation)();
    } else if (type === "undefined") {
      return (0, generated$1.voidTypeAnnotation)();
    } else if (type === "boolean") {
      return (0, generated$1.booleanTypeAnnotation)();
    } else if (type === "function") {
      return (0, generated$1.genericTypeAnnotation)((0, generated$1.identifier)("Function"));
    } else if (type === "object") {
      return (0, generated$1.genericTypeAnnotation)((0, generated$1.identifier)("Object"));
    } else if (type === "symbol") {
      return (0, generated$1.genericTypeAnnotation)((0, generated$1.identifier)("Symbol"));
    } else {
      throw new Error("Invalid typeof value");
    }
  }
});
unwrapExports(createTypeAnnotationBasedOnTypeof_1);
var removeTypeDuplicates_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = removeTypeDuplicates;
  function removeTypeDuplicates(nodes) {
    const generics = {};
    const bases = {};
    const typeGroups = [];
    const types = [];
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (!node) continue;
      if (types.indexOf(node) >= 0) {
        continue;
      }
      if ((0, generated.isAnyTypeAnnotation)(node)) {
        return [node];
      }
      if ((0, generated.isFlowBaseAnnotation)(node)) {
        bases[node.type] = node;
        continue;
      }
      if ((0, generated.isUnionTypeAnnotation)(node)) {
        if (typeGroups.indexOf(node.types) < 0) {
          nodes = nodes.concat(node.types);
          typeGroups.push(node.types);
        }
        continue;
      }
      if ((0, generated.isGenericTypeAnnotation)(node)) {
        const name = node.id.name;
        if (generics[name]) {
          let existing = generics[name];
          if (existing.typeParameters) {
            if (node.typeParameters) {
              existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
            }
          } else {
            existing = node.typeParameters;
          }
        } else {
          generics[name] = node;
        }
        continue;
      }
      types.push(node);
    }
    for (const type in bases) {
      types.push(bases[type]);
    }
    for (const name in generics) {
      types.push(generics[name]);
    }
    return types;
  }
});
unwrapExports(removeTypeDuplicates_1);
var createUnionTypeAnnotation_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = createUnionTypeAnnotation;
  var _removeTypeDuplicates = _interopRequireDefault(removeTypeDuplicates_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function createUnionTypeAnnotation(types) {
    const flattened = (0, _removeTypeDuplicates.default)(types);
    if (flattened.length === 1) {
      return flattened[0];
    } else {
      return (0, generated$1.unionTypeAnnotation)(flattened);
    }
  }
});
unwrapExports(createUnionTypeAnnotation_1);
var cloneNode_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = cloneNode;
  const has = Function.call.bind(Object.prototype.hasOwnProperty);
  function cloneIfNode(obj, deep) {
    if (obj && typeof obj.type === "string" && obj.type !== "CommentLine" && obj.type !== "CommentBlock") {
      return cloneNode(obj, deep);
    }
    return obj;
  }
  function cloneIfNodeOrArray(obj, deep) {
    if (Array.isArray(obj)) {
      return obj.map(node => cloneIfNode(node, deep));
    }
    return cloneIfNode(obj, deep);
  }
  function cloneNode(node) {
    let deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!node) return node;
    const {
      type
    } = node;
    const newNode = {
      type
    };
    if (type === "Identifier") {
      newNode.name = node.name;
      if (has(node, "optional") && typeof node.optional === "boolean") {
        newNode.optional = node.optional;
      }
      if (has(node, "typeAnnotation")) {
        newNode.typeAnnotation = deep ? cloneIfNodeOrArray(node.typeAnnotation, true) : node.typeAnnotation;
      }
    } else if (!has(definitions.NODE_FIELDS, type)) {
      throw new Error(`Unknown node type: "${type}"`);
    } else {
      for (const field of Object.keys(definitions.NODE_FIELDS[type])) {
        if (has(node, field)) {
          newNode[field] = deep ? cloneIfNodeOrArray(node[field], true) : node[field];
        }
      }
    }
    if (has(node, "loc")) {
      newNode.loc = node.loc;
    }
    if (has(node, "leadingComments")) {
      newNode.leadingComments = node.leadingComments;
    }
    if (has(node, "innerComments")) {
      newNode.innerComments = node.innerCmments;
    }
    if (has(node, "trailingComments")) {
      newNode.trailingComments = node.trailingComments;
    }
    if (has(node, "extra")) {
      newNode.extra = Object.assign({}, node.extra);
    }
    return newNode;
  }
});
unwrapExports(cloneNode_1);
var clone_1$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = clone;
  var _cloneNode = _interopRequireDefault(cloneNode_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function clone(node) {
    return (0, _cloneNode.default)(node, false);
  }
});
unwrapExports(clone_1$1);
var cloneDeep_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = cloneDeep;
  var _cloneNode = _interopRequireDefault(cloneNode_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function cloneDeep(node) {
    return (0, _cloneNode.default)(node);
  }
});
unwrapExports(cloneDeep_1);
var cloneWithoutLoc_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = cloneWithoutLoc;
  var _clone = _interopRequireDefault(clone_1$1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function cloneWithoutLoc(node) {
    const newNode = (0, _clone.default)(node);
    newNode.loc = null;
    return newNode;
  }
});
unwrapExports(cloneWithoutLoc_1);
var addComments_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addComments;
  function addComments(node, type, comments) {
    if (!comments || !node) return node;
    const key = `${type}Comments`;
    if (node[key]) {
      if (type === "leading") {
        node[key] = comments.concat(node[key]);
      } else {
        node[key] = node[key].concat(comments);
      }
    } else {
      node[key] = comments;
    }
    return node;
  }
});
unwrapExports(addComments_1);
var addComment_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addComment;
  var _addComments = _interopRequireDefault(addComments_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function addComment(node, type, content, line) {
    return (0, _addComments.default)(node, type, [{
      type: line ? "CommentLine" : "CommentBlock",
      value: content
    }]);
  }
});
unwrapExports(addComment_1);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}
var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new _MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;
var _SetCache = SetCache;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
    index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
    length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value ? _strictIndexOf(array, value, fromIndex) : _baseFindIndex(array, _baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && _baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}
var noop_1 = noop;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(_Set && 1 / _setToArray(new _Set([, -0]))[1] == INFINITY) ? noop_1 : function (values) {
  return new _Set(values);
};
var _createSet = createSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
    includes = _arrayIncludes,
    length = array.length,
    isCommon = true,
    result = [],
    seen = result;
  if (comparator) {
    isCommon = false;
    includes = _arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE$1) {
    var set = iteratee ? null : _createSet(array);
    if (set) {
      return _setToArray(set);
    }
    isCommon = false;
    includes = _cacheHas;
    seen = new _SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
      computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}
var _baseUniq = baseUniq;

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return array && array.length ? _baseUniq(array) : [];
}
var uniq_1 = uniq;
var inherit_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = inherit;
  function _uniq() {
    const data = _interopRequireDefault(uniq_1);
    _uniq = function () {
      return data;
    };
    return data;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function inherit(key, child, parent) {
    if (child && parent) {
      child[key] = (0, _uniq().default)([].concat(child[key], parent[key]).filter(Boolean));
    }
  }
});
unwrapExports(inherit_1);
var inheritInnerComments_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = inheritInnerComments;
  var _inherit = _interopRequireDefault(inherit_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function inheritInnerComments(child, parent) {
    (0, _inherit.default)("innerComments", child, parent);
  }
});
unwrapExports(inheritInnerComments_1);
var inheritLeadingComments_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = inheritLeadingComments;
  var _inherit = _interopRequireDefault(inherit_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function inheritLeadingComments(child, parent) {
    (0, _inherit.default)("leadingComments", child, parent);
  }
});
unwrapExports(inheritLeadingComments_1);
var inheritTrailingComments_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = inheritTrailingComments;
  var _inherit = _interopRequireDefault(inherit_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function inheritTrailingComments(child, parent) {
    (0, _inherit.default)("trailingComments", child, parent);
  }
});
unwrapExports(inheritTrailingComments_1);
var inheritsComments_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = inheritsComments;
  var _inheritTrailingComments = _interopRequireDefault(inheritTrailingComments_1);
  var _inheritLeadingComments = _interopRequireDefault(inheritLeadingComments_1);
  var _inheritInnerComments = _interopRequireDefault(inheritInnerComments_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function inheritsComments(child, parent) {
    (0, _inheritTrailingComments.default)(child, parent);
    (0, _inheritLeadingComments.default)(child, parent);
    (0, _inheritInnerComments.default)(child, parent);
    return child;
  }
});
unwrapExports(inheritsComments_1);
var removeComments_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = removeComments;
  function removeComments(node) {
    constants.COMMENT_KEYS.forEach(key => {
      node[key] = null;
    });
    return node;
  }
});
unwrapExports(removeComments_1);
var generated$3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TSTYPE_TYPES = exports.TSTYPEELEMENT_TYPES = exports.PRIVATE_TYPES = exports.JSX_TYPES = exports.FLOWPREDICATE_TYPES = exports.FLOWDECLARATION_TYPES = exports.FLOWBASEANNOTATION_TYPES = exports.FLOWTYPE_TYPES = exports.FLOW_TYPES = exports.MODULESPECIFIER_TYPES = exports.EXPORTDECLARATION_TYPES = exports.MODULEDECLARATION_TYPES = exports.CLASS_TYPES = exports.PATTERN_TYPES = exports.UNARYLIKE_TYPES = exports.PROPERTY_TYPES = exports.OBJECTMEMBER_TYPES = exports.METHOD_TYPES = exports.USERWHITESPACABLE_TYPES = exports.IMMUTABLE_TYPES = exports.LITERAL_TYPES = exports.TSENTITYNAME_TYPES = exports.LVAL_TYPES = exports.PATTERNLIKE_TYPES = exports.DECLARATION_TYPES = exports.PUREISH_TYPES = exports.FUNCTIONPARENT_TYPES = exports.FUNCTION_TYPES = exports.FORXSTATEMENT_TYPES = exports.FOR_TYPES = exports.EXPRESSIONWRAPPER_TYPES = exports.WHILE_TYPES = exports.LOOP_TYPES = exports.CONDITIONAL_TYPES = exports.COMPLETIONSTATEMENT_TYPES = exports.TERMINATORLESS_TYPES = exports.STATEMENT_TYPES = exports.BLOCK_TYPES = exports.BLOCKPARENT_TYPES = exports.SCOPABLE_TYPES = exports.BINARY_TYPES = exports.EXPRESSION_TYPES = void 0;
  const EXPRESSION_TYPES = definitions.FLIPPED_ALIAS_KEYS["Expression"];
  exports.EXPRESSION_TYPES = EXPRESSION_TYPES;
  const BINARY_TYPES = definitions.FLIPPED_ALIAS_KEYS["Binary"];
  exports.BINARY_TYPES = BINARY_TYPES;
  const SCOPABLE_TYPES = definitions.FLIPPED_ALIAS_KEYS["Scopable"];
  exports.SCOPABLE_TYPES = SCOPABLE_TYPES;
  const BLOCKPARENT_TYPES = definitions.FLIPPED_ALIAS_KEYS["BlockParent"];
  exports.BLOCKPARENT_TYPES = BLOCKPARENT_TYPES;
  const BLOCK_TYPES = definitions.FLIPPED_ALIAS_KEYS["Block"];
  exports.BLOCK_TYPES = BLOCK_TYPES;
  const STATEMENT_TYPES = definitions.FLIPPED_ALIAS_KEYS["Statement"];
  exports.STATEMENT_TYPES = STATEMENT_TYPES;
  const TERMINATORLESS_TYPES = definitions.FLIPPED_ALIAS_KEYS["Terminatorless"];
  exports.TERMINATORLESS_TYPES = TERMINATORLESS_TYPES;
  const COMPLETIONSTATEMENT_TYPES = definitions.FLIPPED_ALIAS_KEYS["CompletionStatement"];
  exports.COMPLETIONSTATEMENT_TYPES = COMPLETIONSTATEMENT_TYPES;
  const CONDITIONAL_TYPES = definitions.FLIPPED_ALIAS_KEYS["Conditional"];
  exports.CONDITIONAL_TYPES = CONDITIONAL_TYPES;
  const LOOP_TYPES = definitions.FLIPPED_ALIAS_KEYS["Loop"];
  exports.LOOP_TYPES = LOOP_TYPES;
  const WHILE_TYPES = definitions.FLIPPED_ALIAS_KEYS["While"];
  exports.WHILE_TYPES = WHILE_TYPES;
  const EXPRESSIONWRAPPER_TYPES = definitions.FLIPPED_ALIAS_KEYS["ExpressionWrapper"];
  exports.EXPRESSIONWRAPPER_TYPES = EXPRESSIONWRAPPER_TYPES;
  const FOR_TYPES = definitions.FLIPPED_ALIAS_KEYS["For"];
  exports.FOR_TYPES = FOR_TYPES;
  const FORXSTATEMENT_TYPES = definitions.FLIPPED_ALIAS_KEYS["ForXStatement"];
  exports.FORXSTATEMENT_TYPES = FORXSTATEMENT_TYPES;
  const FUNCTION_TYPES = definitions.FLIPPED_ALIAS_KEYS["Function"];
  exports.FUNCTION_TYPES = FUNCTION_TYPES;
  const FUNCTIONPARENT_TYPES = definitions.FLIPPED_ALIAS_KEYS["FunctionParent"];
  exports.FUNCTIONPARENT_TYPES = FUNCTIONPARENT_TYPES;
  const PUREISH_TYPES = definitions.FLIPPED_ALIAS_KEYS["Pureish"];
  exports.PUREISH_TYPES = PUREISH_TYPES;
  const DECLARATION_TYPES = definitions.FLIPPED_ALIAS_KEYS["Declaration"];
  exports.DECLARATION_TYPES = DECLARATION_TYPES;
  const PATTERNLIKE_TYPES = definitions.FLIPPED_ALIAS_KEYS["PatternLike"];
  exports.PATTERNLIKE_TYPES = PATTERNLIKE_TYPES;
  const LVAL_TYPES = definitions.FLIPPED_ALIAS_KEYS["LVal"];
  exports.LVAL_TYPES = LVAL_TYPES;
  const TSENTITYNAME_TYPES = definitions.FLIPPED_ALIAS_KEYS["TSEntityName"];
  exports.TSENTITYNAME_TYPES = TSENTITYNAME_TYPES;
  const LITERAL_TYPES = definitions.FLIPPED_ALIAS_KEYS["Literal"];
  exports.LITERAL_TYPES = LITERAL_TYPES;
  const IMMUTABLE_TYPES = definitions.FLIPPED_ALIAS_KEYS["Immutable"];
  exports.IMMUTABLE_TYPES = IMMUTABLE_TYPES;
  const USERWHITESPACABLE_TYPES = definitions.FLIPPED_ALIAS_KEYS["UserWhitespacable"];
  exports.USERWHITESPACABLE_TYPES = USERWHITESPACABLE_TYPES;
  const METHOD_TYPES = definitions.FLIPPED_ALIAS_KEYS["Method"];
  exports.METHOD_TYPES = METHOD_TYPES;
  const OBJECTMEMBER_TYPES = definitions.FLIPPED_ALIAS_KEYS["ObjectMember"];
  exports.OBJECTMEMBER_TYPES = OBJECTMEMBER_TYPES;
  const PROPERTY_TYPES = definitions.FLIPPED_ALIAS_KEYS["Property"];
  exports.PROPERTY_TYPES = PROPERTY_TYPES;
  const UNARYLIKE_TYPES = definitions.FLIPPED_ALIAS_KEYS["UnaryLike"];
  exports.UNARYLIKE_TYPES = UNARYLIKE_TYPES;
  const PATTERN_TYPES = definitions.FLIPPED_ALIAS_KEYS["Pattern"];
  exports.PATTERN_TYPES = PATTERN_TYPES;
  const CLASS_TYPES = definitions.FLIPPED_ALIAS_KEYS["Class"];
  exports.CLASS_TYPES = CLASS_TYPES;
  const MODULEDECLARATION_TYPES = definitions.FLIPPED_ALIAS_KEYS["ModuleDeclaration"];
  exports.MODULEDECLARATION_TYPES = MODULEDECLARATION_TYPES;
  const EXPORTDECLARATION_TYPES = definitions.FLIPPED_ALIAS_KEYS["ExportDeclaration"];
  exports.EXPORTDECLARATION_TYPES = EXPORTDECLARATION_TYPES;
  const MODULESPECIFIER_TYPES = definitions.FLIPPED_ALIAS_KEYS["ModuleSpecifier"];
  exports.MODULESPECIFIER_TYPES = MODULESPECIFIER_TYPES;
  const FLOW_TYPES = definitions.FLIPPED_ALIAS_KEYS["Flow"];
  exports.FLOW_TYPES = FLOW_TYPES;
  const FLOWTYPE_TYPES = definitions.FLIPPED_ALIAS_KEYS["FlowType"];
  exports.FLOWTYPE_TYPES = FLOWTYPE_TYPES;
  const FLOWBASEANNOTATION_TYPES = definitions.FLIPPED_ALIAS_KEYS["FlowBaseAnnotation"];
  exports.FLOWBASEANNOTATION_TYPES = FLOWBASEANNOTATION_TYPES;
  const FLOWDECLARATION_TYPES = definitions.FLIPPED_ALIAS_KEYS["FlowDeclaration"];
  exports.FLOWDECLARATION_TYPES = FLOWDECLARATION_TYPES;
  const FLOWPREDICATE_TYPES = definitions.FLIPPED_ALIAS_KEYS["FlowPredicate"];
  exports.FLOWPREDICATE_TYPES = FLOWPREDICATE_TYPES;
  const JSX_TYPES = definitions.FLIPPED_ALIAS_KEYS["JSX"];
  exports.JSX_TYPES = JSX_TYPES;
  const PRIVATE_TYPES = definitions.FLIPPED_ALIAS_KEYS["Private"];
  exports.PRIVATE_TYPES = PRIVATE_TYPES;
  const TSTYPEELEMENT_TYPES = definitions.FLIPPED_ALIAS_KEYS["TSTypeElement"];
  exports.TSTYPEELEMENT_TYPES = TSTYPEELEMENT_TYPES;
  const TSTYPE_TYPES = definitions.FLIPPED_ALIAS_KEYS["TSType"];
  exports.TSTYPE_TYPES = TSTYPE_TYPES;
});
unwrapExports(generated$3);
var generated_1$3 = generated$3.TSTYPE_TYPES;
var generated_2$3 = generated$3.TSTYPEELEMENT_TYPES;
var generated_3$3 = generated$3.PRIVATE_TYPES;
var generated_4$3 = generated$3.JSX_TYPES;
var generated_5$3 = generated$3.FLOWPREDICATE_TYPES;
var generated_6$3 = generated$3.FLOWDECLARATION_TYPES;
var generated_7$3 = generated$3.FLOWBASEANNOTATION_TYPES;
var generated_8$3 = generated$3.FLOWTYPE_TYPES;
var generated_9$3 = generated$3.FLOW_TYPES;
var generated_10$3 = generated$3.MODULESPECIFIER_TYPES;
var generated_11$3 = generated$3.EXPORTDECLARATION_TYPES;
var generated_12$3 = generated$3.MODULEDECLARATION_TYPES;
var generated_13$3 = generated$3.CLASS_TYPES;
var generated_14$3 = generated$3.PATTERN_TYPES;
var generated_15$3 = generated$3.UNARYLIKE_TYPES;
var generated_16$3 = generated$3.PROPERTY_TYPES;
var generated_17$3 = generated$3.OBJECTMEMBER_TYPES;
var generated_18$3 = generated$3.METHOD_TYPES;
var generated_19$3 = generated$3.USERWHITESPACABLE_TYPES;
var generated_20$3 = generated$3.IMMUTABLE_TYPES;
var generated_21$3 = generated$3.LITERAL_TYPES;
var generated_22$3 = generated$3.TSENTITYNAME_TYPES;
var generated_23$3 = generated$3.LVAL_TYPES;
var generated_24$3 = generated$3.PATTERNLIKE_TYPES;
var generated_25$3 = generated$3.DECLARATION_TYPES;
var generated_26$3 = generated$3.PUREISH_TYPES;
var generated_27$3 = generated$3.FUNCTIONPARENT_TYPES;
var generated_28$3 = generated$3.FUNCTION_TYPES;
var generated_29$3 = generated$3.FORXSTATEMENT_TYPES;
var generated_30$3 = generated$3.FOR_TYPES;
var generated_31$3 = generated$3.EXPRESSIONWRAPPER_TYPES;
var generated_32$3 = generated$3.WHILE_TYPES;
var generated_33$3 = generated$3.LOOP_TYPES;
var generated_34$3 = generated$3.CONDITIONAL_TYPES;
var generated_35$3 = generated$3.COMPLETIONSTATEMENT_TYPES;
var generated_36$3 = generated$3.TERMINATORLESS_TYPES;
var generated_37$3 = generated$3.STATEMENT_TYPES;
var generated_38$3 = generated$3.BLOCK_TYPES;
var generated_39$3 = generated$3.BLOCKPARENT_TYPES;
var generated_40$3 = generated$3.SCOPABLE_TYPES;
var generated_41$3 = generated$3.BINARY_TYPES;
var generated_42$3 = generated$3.EXPRESSION_TYPES;
var toBlock_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toBlock;
  function toBlock(node, parent) {
    if ((0, generated.isBlockStatement)(node)) {
      return node;
    }
    let blockNodes = [];
    if ((0, generated.isEmptyStatement)(node)) {
      blockNodes = [];
    } else {
      if (!(0, generated.isStatement)(node)) {
        if ((0, generated.isFunction)(parent)) {
          node = (0, generated$1.returnStatement)(node);
        } else {
          node = (0, generated$1.expressionStatement)(node);
        }
      }
      blockNodes = [node];
    }
    return (0, generated$1.blockStatement)(blockNodes);
  }
});
unwrapExports(toBlock_1);
var ensureBlock_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ensureBlock;
  var _toBlock = _interopRequireDefault(toBlock_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function ensureBlock(node) {
    let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "body";
    return node[key] = (0, _toBlock.default)(node[key], node);
  }
});
unwrapExports(ensureBlock_1);
var toIdentifier_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toIdentifier;
  var _isValidIdentifier = _interopRequireDefault(isValidIdentifier_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function toIdentifier(name) {
    name = name + "";
    name = name.replace(/[^a-zA-Z0-9$_]/g, "-");
    name = name.replace(/^[-0-9]+/, "");
    name = name.replace(/[-\s]+(.)?/g, function (match, c) {
      return c ? c.toUpperCase() : "";
    });
    if (!(0, _isValidIdentifier.default)(name)) {
      name = `_${name}`;
    }
    return name || "_";
  }
});
unwrapExports(toIdentifier_1);
var toBindingIdentifierName_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toBindingIdentifierName;
  var _toIdentifier = _interopRequireDefault(toIdentifier_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function toBindingIdentifierName(name) {
    name = (0, _toIdentifier.default)(name);
    if (name === "eval" || name === "arguments") name = "_" + name;
    return name;
  }
});
unwrapExports(toBindingIdentifierName_1);
var toComputedKey_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toComputedKey;
  function toComputedKey(node) {
    let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : node.key || node.property;
    if (!node.computed && (0, generated.isIdentifier)(key)) key = (0, generated$1.stringLiteral)(key.name);
    return key;
  }
});
unwrapExports(toComputedKey_1);
var toExpression_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toExpression;
  function toExpression(node) {
    if ((0, generated.isExpressionStatement)(node)) {
      node = node.expression;
    }
    if ((0, generated.isExpression)(node)) {
      return node;
    }
    if ((0, generated.isClass)(node)) {
      node.type = "ClassExpression";
    } else if ((0, generated.isFunction)(node)) {
      node.type = "FunctionExpression";
    }
    if (!(0, generated.isExpression)(node)) {
      throw new Error(`cannot turn ${node.type} to an expression`);
    }
    return node;
  }
});
unwrapExports(toExpression_1);
var traverseFast_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = traverseFast;
  function traverseFast(node, enter, opts) {
    if (!node) return;
    const keys = definitions.VISITOR_KEYS[node.type];
    if (!keys) return;
    opts = opts || {};
    enter(node, opts);
    for (const key of keys) {
      const subNode = node[key];
      if (Array.isArray(subNode)) {
        for (const node of subNode) {
          traverseFast(node, enter, opts);
        }
      } else {
        traverseFast(subNode, enter, opts);
      }
    }
  }
});
unwrapExports(traverseFast_1);
var removeProperties_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = removeProperties;
  const CLEAR_KEYS = ["tokens", "start", "end", "loc", "raw", "rawValue"];
  const CLEAR_KEYS_PLUS_COMMENTS = constants.COMMENT_KEYS.concat(["comments"]).concat(CLEAR_KEYS);
  function removeProperties(node) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const map = opts.preserveComments ? CLEAR_KEYS : CLEAR_KEYS_PLUS_COMMENTS;
    for (const key of map) {
      if (node[key] != null) node[key] = undefined;
    }
    for (const key in node) {
      if (key[0] === "_" && node[key] != null) node[key] = undefined;
    }
    const symbols = Object.getOwnPropertySymbols(node);
    for (const sym of symbols) {
      node[sym] = null;
    }
  }
});
unwrapExports(removeProperties_1);
var removePropertiesDeep_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = removePropertiesDeep;
  var _traverseFast = _interopRequireDefault(traverseFast_1);
  var _removeProperties = _interopRequireDefault(removeProperties_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function removePropertiesDeep(tree, opts) {
    (0, _traverseFast.default)(tree, _removeProperties.default, opts);
    return tree;
  }
});
unwrapExports(removePropertiesDeep_1);
var toKeyAlias_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toKeyAlias;
  var _cloneNode = _interopRequireDefault(cloneNode_1);
  var _removePropertiesDeep = _interopRequireDefault(removePropertiesDeep_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function toKeyAlias(node) {
    let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : node.key;
    let alias;
    if (node.kind === "method") {
      return toKeyAlias.increment() + "";
    } else if ((0, generated.isIdentifier)(key)) {
      alias = key.name;
    } else if ((0, generated.isStringLiteral)(key)) {
      alias = JSON.stringify(key.value);
    } else {
      alias = JSON.stringify((0, _removePropertiesDeep.default)((0, _cloneNode.default)(key)));
    }
    if (node.computed) {
      alias = `[${alias}]`;
    }
    if (node.static) {
      alias = `static:${alias}`;
    }
    return alias;
  }
  toKeyAlias.uid = 0;
  toKeyAlias.increment = function () {
    if (toKeyAlias.uid >= Number.MAX_SAFE_INTEGER) {
      return toKeyAlias.uid = 0;
    } else {
      return toKeyAlias.uid++;
    }
  };
});
unwrapExports(toKeyAlias_1);
var getBindingIdentifiers_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getBindingIdentifiers;
  function getBindingIdentifiers(node, duplicates, outerOnly) {
    let search = [].concat(node);
    const ids = Object.create(null);
    while (search.length) {
      const id = search.shift();
      if (!id) continue;
      const keys = getBindingIdentifiers.keys[id.type];
      if ((0, generated.isIdentifier)(id)) {
        if (duplicates) {
          const _ids = ids[id.name] = ids[id.name] || [];
          _ids.push(id);
        } else {
          ids[id.name] = id;
        }
        continue;
      }
      if ((0, generated.isExportDeclaration)(id)) {
        if ((0, generated.isDeclaration)(id.declaration)) {
          search.push(id.declaration);
        }
        continue;
      }
      if (outerOnly) {
        if ((0, generated.isFunctionDeclaration)(id)) {
          search.push(id.id);
          continue;
        }
        if ((0, generated.isFunctionExpression)(id)) {
          continue;
        }
      }
      if (keys) {
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          if (id[key]) {
            search = search.concat(id[key]);
          }
        }
      }
    }
    return ids;
  }
  getBindingIdentifiers.keys = {
    DeclareClass: ["id"],
    DeclareFunction: ["id"],
    DeclareModule: ["id"],
    DeclareVariable: ["id"],
    DeclareInterface: ["id"],
    DeclareTypeAlias: ["id"],
    DeclareOpaqueType: ["id"],
    InterfaceDeclaration: ["id"],
    TypeAlias: ["id"],
    OpaqueType: ["id"],
    CatchClause: ["param"],
    LabeledStatement: ["label"],
    UnaryExpression: ["argument"],
    AssignmentExpression: ["left"],
    ImportSpecifier: ["local"],
    ImportNamespaceSpecifier: ["local"],
    ImportDefaultSpecifier: ["local"],
    ImportDeclaration: ["specifiers"],
    ExportSpecifier: ["exported"],
    ExportNamespaceSpecifier: ["exported"],
    ExportDefaultSpecifier: ["exported"],
    FunctionDeclaration: ["id", "params"],
    FunctionExpression: ["id", "params"],
    ArrowFunctionExpression: ["params"],
    ObjectMethod: ["params"],
    ClassMethod: ["params"],
    ForInStatement: ["left"],
    ForOfStatement: ["left"],
    ClassDeclaration: ["id"],
    ClassExpression: ["id"],
    RestElement: ["argument"],
    UpdateExpression: ["argument"],
    ObjectProperty: ["value"],
    AssignmentPattern: ["left"],
    ArrayPattern: ["elements"],
    ObjectPattern: ["properties"],
    VariableDeclaration: ["declarations"],
    VariableDeclarator: ["id"]
  };
});
unwrapExports(getBindingIdentifiers_1);
var gatherSequenceExpressions_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = gatherSequenceExpressions;
  var _getBindingIdentifiers = _interopRequireDefault(getBindingIdentifiers_1);
  var _cloneNode = _interopRequireDefault(cloneNode_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function gatherSequenceExpressions(nodes, scope, declars) {
    const exprs = [];
    let ensureLastUndefined = true;
    for (const node of nodes) {
      ensureLastUndefined = false;
      if ((0, generated.isExpression)(node)) {
        exprs.push(node);
      } else if ((0, generated.isExpressionStatement)(node)) {
        exprs.push(node.expression);
      } else if ((0, generated.isVariableDeclaration)(node)) {
        if (node.kind !== "var") return;
        for (const declar of node.declarations) {
          const bindings = (0, _getBindingIdentifiers.default)(declar);
          for (const key in bindings) {
            declars.push({
              kind: node.kind,
              id: (0, _cloneNode.default)(bindings[key])
            });
          }
          if (declar.init) {
            exprs.push((0, generated$1.assignmentExpression)("=", declar.id, declar.init));
          }
        }
        ensureLastUndefined = true;
      } else if ((0, generated.isIfStatement)(node)) {
        const consequent = node.consequent ? gatherSequenceExpressions([node.consequent], scope, declars) : scope.buildUndefinedNode();
        const alternate = node.alternate ? gatherSequenceExpressions([node.alternate], scope, declars) : scope.buildUndefinedNode();
        if (!consequent || !alternate) return;
        exprs.push((0, generated$1.conditionalExpression)(node.test, consequent, alternate));
      } else if ((0, generated.isBlockStatement)(node)) {
        const body = gatherSequenceExpressions(node.body, scope, declars);
        if (!body) return;
        exprs.push(body);
      } else if ((0, generated.isEmptyStatement)(node)) {
        ensureLastUndefined = true;
      } else {
        return;
      }
    }
    if (ensureLastUndefined) {
      exprs.push(scope.buildUndefinedNode());
    }
    if (exprs.length === 1) {
      return exprs[0];
    } else {
      return (0, generated$1.sequenceExpression)(exprs);
    }
  }
});
unwrapExports(gatherSequenceExpressions_1);
var toSequenceExpression_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toSequenceExpression;
  var _gatherSequenceExpressions = _interopRequireDefault(gatherSequenceExpressions_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function toSequenceExpression(nodes, scope) {
    if (!nodes || !nodes.length) return;
    const declars = [];
    const result = (0, _gatherSequenceExpressions.default)(nodes, scope, declars);
    if (!result) return;
    for (const declar of declars) {
      scope.push(declar);
    }
    return result;
  }
});
unwrapExports(toSequenceExpression_1);
var toStatement_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toStatement;
  function toStatement(node, ignore) {
    if ((0, generated.isStatement)(node)) {
      return node;
    }
    let mustHaveId = false;
    let newType;
    if ((0, generated.isClass)(node)) {
      mustHaveId = true;
      newType = "ClassDeclaration";
    } else if ((0, generated.isFunction)(node)) {
      mustHaveId = true;
      newType = "FunctionDeclaration";
    } else if ((0, generated.isAssignmentExpression)(node)) {
      return (0, generated$1.expressionStatement)(node);
    }
    if (mustHaveId && !node.id) {
      newType = false;
    }
    if (!newType) {
      if (ignore) {
        return false;
      } else {
        throw new Error(`cannot turn ${node.type} to a statement`);
      }
    }
    node.type = newType;
    return node;
  }
});
unwrapExports(toStatement_1);

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
  objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject;

/** `Object#toString` result references. */
var regexpTag$3 = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == regexpTag$3;
}
var _baseIsRegExp = baseIsRegExp;

/* Node.js helper references. */
var nodeIsRegExp = _nodeUtil && _nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? _baseUnary(nodeIsRegExp) : _baseIsRegExp;
var isRegExp_1 = isRegExp;
var valueToNode_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = valueToNode;
  function _isPlainObject() {
    const data = _interopRequireDefault(isPlainObject_1);
    _isPlainObject = function () {
      return data;
    };
    return data;
  }
  function _isRegExp() {
    const data = _interopRequireDefault(isRegExp_1);
    _isRegExp = function () {
      return data;
    };
    return data;
  }
  var _isValidIdentifier = _interopRequireDefault(isValidIdentifier_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function valueToNode(value) {
    if (value === undefined) {
      return (0, generated$1.identifier)("undefined");
    }
    if (value === true || value === false) {
      return (0, generated$1.booleanLiteral)(value);
    }
    if (value === null) {
      return (0, generated$1.nullLiteral)();
    }
    if (typeof value === "string") {
      return (0, generated$1.stringLiteral)(value);
    }
    if (typeof value === "number") {
      let result;
      if (Number.isFinite(value)) {
        result = (0, generated$1.numericLiteral)(Math.abs(value));
      } else {
        let numerator;
        if (Number.isNaN(value)) {
          numerator = (0, generated$1.numericLiteral)(0);
        } else {
          numerator = (0, generated$1.numericLiteral)(1);
        }
        result = (0, generated$1.binaryExpression)("/", numerator, (0, generated$1.numericLiteral)(0));
      }
      if (value < 0 || Object.is(value, -0)) {
        result = (0, generated$1.unaryExpression)("-", result);
      }
      return result;
    }
    if ((0, _isRegExp().default)(value)) {
      const pattern = value.source;
      const flags = value.toString().match(/\/([a-z]+|)$/)[1];
      return (0, generated$1.regExpLiteral)(pattern, flags);
    }
    if (Array.isArray(value)) {
      return (0, generated$1.arrayExpression)(value.map(valueToNode));
    }
    if ((0, _isPlainObject().default)(value)) {
      const props = [];
      for (const key in value) {
        let nodeKey;
        if ((0, _isValidIdentifier.default)(key)) {
          nodeKey = (0, generated$1.identifier)(key);
        } else {
          nodeKey = (0, generated$1.stringLiteral)(key);
        }
        props.push((0, generated$1.objectProperty)(nodeKey, valueToNode(value[key])));
      }
      return (0, generated$1.objectExpression)(props);
    }
    throw new Error("don't know how to turn this value into a node");
  }
});
unwrapExports(valueToNode_1);
var appendToMemberExpression_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = appendToMemberExpression;
  function appendToMemberExpression(member, append) {
    let computed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    member.object = (0, generated$1.memberExpression)(member.object, member.property, member.computed);
    member.property = append;
    member.computed = !!computed;
    return member;
  }
});
unwrapExports(appendToMemberExpression_1);
var inherits_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = inherits;
  var _inheritsComments = _interopRequireDefault(inheritsComments_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function inherits(child, parent) {
    if (!child || !parent) return child;
    for (const key of constants.INHERIT_KEYS.optional) {
      if (child[key] == null) {
        child[key] = parent[key];
      }
    }
    for (const key in parent) {
      if (key[0] === "_" && key !== "__clone") child[key] = parent[key];
    }
    for (const key of constants.INHERIT_KEYS.force) {
      child[key] = parent[key];
    }
    (0, _inheritsComments.default)(child, parent);
    return child;
  }
});
unwrapExports(inherits_1);
var prependToMemberExpression_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = prependToMemberExpression;
  function prependToMemberExpression(member, prepend) {
    member.object = (0, generated$1.memberExpression)(prepend, member.object);
    return member;
  }
});
unwrapExports(prependToMemberExpression_1);
var getOuterBindingIdentifiers_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getOuterBindingIdentifiers;
  var _getBindingIdentifiers = _interopRequireDefault(getBindingIdentifiers_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function getOuterBindingIdentifiers(node, duplicates) {
    return (0, _getBindingIdentifiers.default)(node, duplicates, true);
  }
});
unwrapExports(getOuterBindingIdentifiers_1);
var traverse_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = traverse;
  function traverse(node, handlers, state) {
    if (typeof handlers === "function") {
      handlers = {
        enter: handlers
      };
    }
    const {
      enter,
      exit
    } = handlers;
    traverseSimpleImpl(node, enter, exit, state, []);
  }
  function traverseSimpleImpl(node, enter, exit, state, ancestors) {
    const keys = definitions.VISITOR_KEYS[node.type];
    if (!keys) return;
    if (enter) enter(node, ancestors, state);
    for (const key of keys) {
      const subNode = node[key];
      if (Array.isArray(subNode)) {
        for (let i = 0; i < subNode.length; i++) {
          const child = subNode[i];
          if (!child) continue;
          ancestors.push({
            node,
            key,
            index: i
          });
          traverseSimpleImpl(child, enter, exit, state, ancestors);
          ancestors.pop();
        }
      } else if (subNode) {
        ancestors.push({
          node,
          key
        });
        traverseSimpleImpl(subNode, enter, exit, state, ancestors);
        ancestors.pop();
      }
    }
    if (exit) exit(node, ancestors, state);
  }
});
unwrapExports(traverse_1);
var isBinding_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isBinding;
  var _getBindingIdentifiers = _interopRequireDefault(getBindingIdentifiers_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function isBinding(node, parent) {
    const keys = _getBindingIdentifiers.default.keys[parent.type];
    if (keys) {
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const val = parent[key];
        if (Array.isArray(val)) {
          if (val.indexOf(node) >= 0) return true;
        } else {
          if (val === node) return true;
        }
      }
    }
    return false;
  }
});
unwrapExports(isBinding_1);
var isLet_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isLet;
  function isLet(node) {
    return (0, generated.isVariableDeclaration)(node) && (node.kind !== "var" || node[constants.BLOCK_SCOPED_SYMBOL]);
  }
});
unwrapExports(isLet_1);
var isBlockScoped_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isBlockScoped;
  var _isLet = _interopRequireDefault(isLet_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function isBlockScoped(node) {
    return (0, generated.isFunctionDeclaration)(node) || (0, generated.isClassDeclaration)(node) || (0, _isLet.default)(node);
  }
});
unwrapExports(isBlockScoped_1);
var isImmutable_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isImmutable;
  var _isType = _interopRequireDefault(isType_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function isImmutable(node) {
    if ((0, _isType.default)(node.type, "Immutable")) return true;
    if ((0, generated.isIdentifier)(node)) {
      if (node.name === "undefined") {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
});
unwrapExports(isImmutable_1);
var isNodesEquivalent_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isNodesEquivalent;
  function isNodesEquivalent(a, b) {
    if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
      return a === b;
    }
    if (a.type !== b.type) {
      return false;
    }
    const fields = Object.keys(definitions.NODE_FIELDS[a.type] || a.type);
    const visitorKeys = definitions.VISITOR_KEYS[a.type];
    for (const field of fields) {
      if (typeof a[field] !== typeof b[field]) {
        return false;
      }
      if (Array.isArray(a[field])) {
        if (!Array.isArray(b[field])) {
          return false;
        }
        if (a[field].length !== b[field].length) {
          return false;
        }
        for (let i = 0; i < a[field].length; i++) {
          if (!isNodesEquivalent(a[field][i], b[field][i])) {
            return false;
          }
        }
        continue;
      }
      if (typeof a[field] === "object" && (!visitorKeys || !visitorKeys.includes(field))) {
        for (const key in a[field]) {
          if (a[field][key] !== b[field][key]) {
            return false;
          }
        }
        continue;
      }
      if (!isNodesEquivalent(a[field], b[field])) {
        return false;
      }
    }
    return true;
  }
});
unwrapExports(isNodesEquivalent_1);
var isReferenced_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isReferenced;
  function isReferenced(node, parent) {
    switch (parent.type) {
      case "MemberExpression":
      case "JSXMemberExpression":
      case "OptionalMemberExpression":
        if (parent.property === node) {
          return !!parent.computed;
        }
        return parent.object === node;
      case "VariableDeclarator":
        return parent.init === node;
      case "ArrowFunctionExpression":
        return parent.body === node;
      case "ExportSpecifier":
        if (parent.source) {
          return false;
        }
        return parent.local === node;
      case "ObjectProperty":
      case "ClassProperty":
      case "ClassPrivateProperty":
      case "ClassMethod":
      case "ClassPrivateMethod":
      case "ObjectMethod":
        if (parent.key === node) {
          return !!parent.computed;
        }
        return parent.value === node;
      case "ClassDeclaration":
      case "ClassExpression":
        return parent.superClass === node;
      case "AssignmentExpression":
        return parent.right === node;
      case "AssignmentPattern":
        return parent.right === node;
      case "LabeledStatement":
        return false;
      case "CatchClause":
        return false;
      case "RestElement":
        return false;
      case "BreakStatement":
      case "ContinueStatement":
        return false;
      case "FunctionDeclaration":
      case "FunctionExpression":
        return false;
      case "ExportNamespaceSpecifier":
      case "ExportDefaultSpecifier":
        return false;
      case "ImportDefaultSpecifier":
      case "ImportNamespaceSpecifier":
      case "ImportSpecifier":
        return false;
      case "JSXAttribute":
        return false;
      case "ObjectPattern":
      case "ArrayPattern":
        return false;
      case "MetaProperty":
        return false;
      case "ObjectTypeProperty":
        return parent.key !== node;
    }
    return true;
  }
});
unwrapExports(isReferenced_1);
var isScope_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isScope;
  function isScope(node, parent) {
    if ((0, generated.isBlockStatement)(node) && (0, generated.isFunction)(parent, {
      body: node
    })) {
      return false;
    }
    if ((0, generated.isBlockStatement)(node) && (0, generated.isCatchClause)(parent, {
      body: node
    })) {
      return false;
    }
    return (0, generated.isScopable)(node);
  }
});
unwrapExports(isScope_1);
var isSpecifierDefault_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isSpecifierDefault;
  function isSpecifierDefault(specifier) {
    return (0, generated.isImportDefaultSpecifier)(specifier) || (0, generated.isIdentifier)(specifier.imported || specifier.exported, {
      name: "default"
    });
  }
});
unwrapExports(isSpecifierDefault_1);
var isValidES3Identifier_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isValidES3Identifier;
  var _isValidIdentifier = _interopRequireDefault(isValidIdentifier_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  const RESERVED_WORDS_ES3_ONLY = new Set(["abstract", "boolean", "byte", "char", "double", "enum", "final", "float", "goto", "implements", "int", "interface", "long", "native", "package", "private", "protected", "public", "short", "static", "synchronized", "throws", "transient", "volatile"]);
  function isValidES3Identifier(name) {
    return (0, _isValidIdentifier.default)(name) && !RESERVED_WORDS_ES3_ONLY.has(name);
  }
});
unwrapExports(isValidES3Identifier_1);
var isVar_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isVar;
  function isVar(node) {
    return (0, generated.isVariableDeclaration)(node, {
      kind: "var"
    }) && !node[constants.BLOCK_SCOPED_SYMBOL];
  }
});
unwrapExports(isVar_1);
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    react: true,
    assertNode: true,
    createTypeAnnotationBasedOnTypeof: true,
    createUnionTypeAnnotation: true,
    cloneNode: true,
    clone: true,
    cloneDeep: true,
    cloneWithoutLoc: true,
    addComment: true,
    addComments: true,
    inheritInnerComments: true,
    inheritLeadingComments: true,
    inheritsComments: true,
    inheritTrailingComments: true,
    removeComments: true,
    ensureBlock: true,
    toBindingIdentifierName: true,
    toBlock: true,
    toComputedKey: true,
    toExpression: true,
    toIdentifier: true,
    toKeyAlias: true,
    toSequenceExpression: true,
    toStatement: true,
    valueToNode: true,
    appendToMemberExpression: true,
    inherits: true,
    prependToMemberExpression: true,
    removeProperties: true,
    removePropertiesDeep: true,
    removeTypeDuplicates: true,
    getBindingIdentifiers: true,
    getOuterBindingIdentifiers: true,
    traverse: true,
    traverseFast: true,
    shallowEqual: true,
    is: true,
    isBinding: true,
    isBlockScoped: true,
    isImmutable: true,
    isLet: true,
    isNode: true,
    isNodesEquivalent: true,
    isReferenced: true,
    isScope: true,
    isSpecifierDefault: true,
    isType: true,
    isValidES3Identifier: true,
    isValidIdentifier: true,
    isVar: true,
    matchesPattern: true,
    validate: true,
    buildMatchMemberExpression: true
  };
  Object.defineProperty(exports, "assertNode", {
    enumerable: true,
    get: function () {
      return _assertNode.default;
    }
  });
  Object.defineProperty(exports, "createTypeAnnotationBasedOnTypeof", {
    enumerable: true,
    get: function () {
      return _createTypeAnnotationBasedOnTypeof.default;
    }
  });
  Object.defineProperty(exports, "createUnionTypeAnnotation", {
    enumerable: true,
    get: function () {
      return _createUnionTypeAnnotation.default;
    }
  });
  Object.defineProperty(exports, "cloneNode", {
    enumerable: true,
    get: function () {
      return _cloneNode.default;
    }
  });
  Object.defineProperty(exports, "clone", {
    enumerable: true,
    get: function () {
      return _clone.default;
    }
  });
  Object.defineProperty(exports, "cloneDeep", {
    enumerable: true,
    get: function () {
      return _cloneDeep.default;
    }
  });
  Object.defineProperty(exports, "cloneWithoutLoc", {
    enumerable: true,
    get: function () {
      return _cloneWithoutLoc.default;
    }
  });
  Object.defineProperty(exports, "addComment", {
    enumerable: true,
    get: function () {
      return _addComment.default;
    }
  });
  Object.defineProperty(exports, "addComments", {
    enumerable: true,
    get: function () {
      return _addComments.default;
    }
  });
  Object.defineProperty(exports, "inheritInnerComments", {
    enumerable: true,
    get: function () {
      return _inheritInnerComments.default;
    }
  });
  Object.defineProperty(exports, "inheritLeadingComments", {
    enumerable: true,
    get: function () {
      return _inheritLeadingComments.default;
    }
  });
  Object.defineProperty(exports, "inheritsComments", {
    enumerable: true,
    get: function () {
      return _inheritsComments.default;
    }
  });
  Object.defineProperty(exports, "inheritTrailingComments", {
    enumerable: true,
    get: function () {
      return _inheritTrailingComments.default;
    }
  });
  Object.defineProperty(exports, "removeComments", {
    enumerable: true,
    get: function () {
      return _removeComments.default;
    }
  });
  Object.defineProperty(exports, "ensureBlock", {
    enumerable: true,
    get: function () {
      return _ensureBlock.default;
    }
  });
  Object.defineProperty(exports, "toBindingIdentifierName", {
    enumerable: true,
    get: function () {
      return _toBindingIdentifierName.default;
    }
  });
  Object.defineProperty(exports, "toBlock", {
    enumerable: true,
    get: function () {
      return _toBlock.default;
    }
  });
  Object.defineProperty(exports, "toComputedKey", {
    enumerable: true,
    get: function () {
      return _toComputedKey.default;
    }
  });
  Object.defineProperty(exports, "toExpression", {
    enumerable: true,
    get: function () {
      return _toExpression.default;
    }
  });
  Object.defineProperty(exports, "toIdentifier", {
    enumerable: true,
    get: function () {
      return _toIdentifier.default;
    }
  });
  Object.defineProperty(exports, "toKeyAlias", {
    enumerable: true,
    get: function () {
      return _toKeyAlias.default;
    }
  });
  Object.defineProperty(exports, "toSequenceExpression", {
    enumerable: true,
    get: function () {
      return _toSequenceExpression.default;
    }
  });
  Object.defineProperty(exports, "toStatement", {
    enumerable: true,
    get: function () {
      return _toStatement.default;
    }
  });
  Object.defineProperty(exports, "valueToNode", {
    enumerable: true,
    get: function () {
      return _valueToNode.default;
    }
  });
  Object.defineProperty(exports, "appendToMemberExpression", {
    enumerable: true,
    get: function () {
      return _appendToMemberExpression.default;
    }
  });
  Object.defineProperty(exports, "inherits", {
    enumerable: true,
    get: function () {
      return _inherits.default;
    }
  });
  Object.defineProperty(exports, "prependToMemberExpression", {
    enumerable: true,
    get: function () {
      return _prependToMemberExpression.default;
    }
  });
  Object.defineProperty(exports, "removeProperties", {
    enumerable: true,
    get: function () {
      return _removeProperties.default;
    }
  });
  Object.defineProperty(exports, "removePropertiesDeep", {
    enumerable: true,
    get: function () {
      return _removePropertiesDeep.default;
    }
  });
  Object.defineProperty(exports, "removeTypeDuplicates", {
    enumerable: true,
    get: function () {
      return _removeTypeDuplicates.default;
    }
  });
  Object.defineProperty(exports, "getBindingIdentifiers", {
    enumerable: true,
    get: function () {
      return _getBindingIdentifiers.default;
    }
  });
  Object.defineProperty(exports, "getOuterBindingIdentifiers", {
    enumerable: true,
    get: function () {
      return _getOuterBindingIdentifiers.default;
    }
  });
  Object.defineProperty(exports, "traverse", {
    enumerable: true,
    get: function () {
      return _traverse.default;
    }
  });
  Object.defineProperty(exports, "traverseFast", {
    enumerable: true,
    get: function () {
      return _traverseFast.default;
    }
  });
  Object.defineProperty(exports, "shallowEqual", {
    enumerable: true,
    get: function () {
      return _shallowEqual.default;
    }
  });
  Object.defineProperty(exports, "is", {
    enumerable: true,
    get: function () {
      return _is.default;
    }
  });
  Object.defineProperty(exports, "isBinding", {
    enumerable: true,
    get: function () {
      return _isBinding.default;
    }
  });
  Object.defineProperty(exports, "isBlockScoped", {
    enumerable: true,
    get: function () {
      return _isBlockScoped.default;
    }
  });
  Object.defineProperty(exports, "isImmutable", {
    enumerable: true,
    get: function () {
      return _isImmutable.default;
    }
  });
  Object.defineProperty(exports, "isLet", {
    enumerable: true,
    get: function () {
      return _isLet.default;
    }
  });
  Object.defineProperty(exports, "isNode", {
    enumerable: true,
    get: function () {
      return _isNode.default;
    }
  });
  Object.defineProperty(exports, "isNodesEquivalent", {
    enumerable: true,
    get: function () {
      return _isNodesEquivalent.default;
    }
  });
  Object.defineProperty(exports, "isReferenced", {
    enumerable: true,
    get: function () {
      return _isReferenced.default;
    }
  });
  Object.defineProperty(exports, "isScope", {
    enumerable: true,
    get: function () {
      return _isScope.default;
    }
  });
  Object.defineProperty(exports, "isSpecifierDefault", {
    enumerable: true,
    get: function () {
      return _isSpecifierDefault.default;
    }
  });
  Object.defineProperty(exports, "isType", {
    enumerable: true,
    get: function () {
      return _isType.default;
    }
  });
  Object.defineProperty(exports, "isValidES3Identifier", {
    enumerable: true,
    get: function () {
      return _isValidES3Identifier.default;
    }
  });
  Object.defineProperty(exports, "isValidIdentifier", {
    enumerable: true,
    get: function () {
      return _isValidIdentifier.default;
    }
  });
  Object.defineProperty(exports, "isVar", {
    enumerable: true,
    get: function () {
      return _isVar.default;
    }
  });
  Object.defineProperty(exports, "matchesPattern", {
    enumerable: true,
    get: function () {
      return _matchesPattern.default;
    }
  });
  Object.defineProperty(exports, "validate", {
    enumerable: true,
    get: function () {
      return _validate.default;
    }
  });
  Object.defineProperty(exports, "buildMatchMemberExpression", {
    enumerable: true,
    get: function () {
      return _buildMatchMemberExpression.default;
    }
  });
  exports.react = void 0;
  var _isReactComponent = _interopRequireDefault(isReactComponent_1);
  var _isCompatTag = _interopRequireDefault(isCompatTag_1);
  var _buildChildren = _interopRequireDefault(buildChildren_1);
  var _assertNode = _interopRequireDefault(assertNode_1);
  Object.keys(generated$2).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return generated$2[key];
      }
    });
  });
  var _createTypeAnnotationBasedOnTypeof = _interopRequireDefault(createTypeAnnotationBasedOnTypeof_1);
  var _createUnionTypeAnnotation = _interopRequireDefault(createUnionTypeAnnotation_1);
  Object.keys(generated$1).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return generated$1[key];
      }
    });
  });
  var _cloneNode = _interopRequireDefault(cloneNode_1);
  var _clone = _interopRequireDefault(clone_1$1);
  var _cloneDeep = _interopRequireDefault(cloneDeep_1);
  var _cloneWithoutLoc = _interopRequireDefault(cloneWithoutLoc_1);
  var _addComment = _interopRequireDefault(addComment_1);
  var _addComments = _interopRequireDefault(addComments_1);
  var _inheritInnerComments = _interopRequireDefault(inheritInnerComments_1);
  var _inheritLeadingComments = _interopRequireDefault(inheritLeadingComments_1);
  var _inheritsComments = _interopRequireDefault(inheritsComments_1);
  var _inheritTrailingComments = _interopRequireDefault(inheritTrailingComments_1);
  var _removeComments = _interopRequireDefault(removeComments_1);
  Object.keys(generated$3).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return generated$3[key];
      }
    });
  });
  Object.keys(constants).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return constants[key];
      }
    });
  });
  var _ensureBlock = _interopRequireDefault(ensureBlock_1);
  var _toBindingIdentifierName = _interopRequireDefault(toBindingIdentifierName_1);
  var _toBlock = _interopRequireDefault(toBlock_1);
  var _toComputedKey = _interopRequireDefault(toComputedKey_1);
  var _toExpression = _interopRequireDefault(toExpression_1);
  var _toIdentifier = _interopRequireDefault(toIdentifier_1);
  var _toKeyAlias = _interopRequireDefault(toKeyAlias_1);
  var _toSequenceExpression = _interopRequireDefault(toSequenceExpression_1);
  var _toStatement = _interopRequireDefault(toStatement_1);
  var _valueToNode = _interopRequireDefault(valueToNode_1);
  Object.keys(definitions).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return definitions[key];
      }
    });
  });
  var _appendToMemberExpression = _interopRequireDefault(appendToMemberExpression_1);
  var _inherits = _interopRequireDefault(inherits_1);
  var _prependToMemberExpression = _interopRequireDefault(prependToMemberExpression_1);
  var _removeProperties = _interopRequireDefault(removeProperties_1);
  var _removePropertiesDeep = _interopRequireDefault(removePropertiesDeep_1);
  var _removeTypeDuplicates = _interopRequireDefault(removeTypeDuplicates_1);
  var _getBindingIdentifiers = _interopRequireDefault(getBindingIdentifiers_1);
  var _getOuterBindingIdentifiers = _interopRequireDefault(getOuterBindingIdentifiers_1);
  var _traverse = _interopRequireDefault(traverse_1);
  var _traverseFast = _interopRequireDefault(traverseFast_1);
  var _shallowEqual = _interopRequireDefault(shallowEqual_1);
  var _is = _interopRequireDefault(is_1);
  var _isBinding = _interopRequireDefault(isBinding_1);
  var _isBlockScoped = _interopRequireDefault(isBlockScoped_1);
  var _isImmutable = _interopRequireDefault(isImmutable_1);
  var _isLet = _interopRequireDefault(isLet_1);
  var _isNode = _interopRequireDefault(isNode_1);
  var _isNodesEquivalent = _interopRequireDefault(isNodesEquivalent_1);
  var _isReferenced = _interopRequireDefault(isReferenced_1);
  var _isScope = _interopRequireDefault(isScope_1);
  var _isSpecifierDefault = _interopRequireDefault(isSpecifierDefault_1);
  var _isType = _interopRequireDefault(isType_1);
  var _isValidES3Identifier = _interopRequireDefault(isValidES3Identifier_1);
  var _isValidIdentifier = _interopRequireDefault(isValidIdentifier_1);
  var _isVar = _interopRequireDefault(isVar_1);
  var _matchesPattern = _interopRequireDefault(matchesPattern_1);
  var _validate = _interopRequireDefault(validate_1);
  var _buildMatchMemberExpression = _interopRequireDefault(buildMatchMemberExpression_1);
  Object.keys(generated).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return generated[key];
      }
    });
  });
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  const react = {
    isReactComponent: _isReactComponent.default,
    isCompatTag: _isCompatTag.default,
    buildChildren: _buildChildren.default
  };
  exports.react = react;
});
unwrapExports(lib);
var lib_1 = lib.react;
var LightBox = /*#__PURE__*/
function (_React$Component) {
  _inherits(LightBox, _React$Component);
  function LightBox(props) {
    var _this;
    _classCallCheck(this, LightBox);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LightBox).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "setScreenSize", function () {
      _this.setState({
        screenSize: {
          x: window.innerWidth,
          y: window.innerHeight
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      return {
        activeKey: null,
        changeSlide: false,
        dragImg: false,
        dragImgPos: {},
        dragPercent: 0,
        galleryImagesData: [],
        imgSrc: null,
        imgSrcData: null,
        resize: false,
        resizePos: {
          x: 0,
          y: 0
        },
        scale: 0,
        scaleWheel: false,
        screenSize: {
          x: window.innerWidth,
          y: window.innerHeight
        },
        showLeft: false,
        showRight: false,
        sliderOpened: false,
        zoomedScale: 0
      };
    });
    _defineProperty(_assertThisInitialized(_this), "updateGalleryData", function () {
      var gallery = [];
      if (_this.slideRefs) _this.slideRefs.map(function (el) {
        return gallery.push(_this.setData(el));
      });
      _this.setState({
        galleryImagesData: gallery
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setScale", function (e) {
      var screenSize = _this.state.screenSize;
      var _e$size = e.size,
        height = _e$size.height,
        width = _e$size.width;
      var margin = _this.props.marginSpace;
      var scale = 1;
      if (screenSize.x > screenSize.y) {
        if (e.realH > height) {
          if (height === width && screenSize.y > screenSize.x) {
            scale = (screenSize.x - margin) / width;
          } else if (height === width && screenSize.y < screenSize.x) {
            scale = (screenSize.y - margin) / height;
          } else if (height > width) {
            scale = (screenSize.y - margin) / height;
            if (scale * width > screenSize.x) {
              scale = (screenSize.x - margin) / width;
            }
          } else if (height < width) {
            scale = (screenSize.x - margin) / width;
            if (scale * height > screenSize.y) {
              scale = (screenSize.y - margin) / height;
            }
          }
        }
        return scale * (height / e.realH);
      } else {
        return scale;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setData", function (img) {
      var screenSize = _this.state.screenSize;
      var data = {
        activeKey: _this.slideRefs.indexOf(img),
        imgSrc: img,
        imgSrcData: {
          realW: img.naturalWidth,
          realH: img.naturalHeight,
          size: img.getBoundingClientRect()
        },
        scale: screenSize.x > screenSize.y ? img.getBoundingClientRect().width / img.naturalWidth : img.getBoundingClientRect().width / screenSize.x
      };
      data.zoomedScale = _this.setScale(data.imgSrcData);
      return data;
    });
    _defineProperty(_assertThisInitialized(_this), "zoom", function (e) {
      var imgSrc = _this.state.imgSrc;
      var transition = _this.props.transition;
      var img = e.target;
      if (!imgSrc) {
        _this.updateGalleryData();
        var dataOfImage = _this.setData(img);
        var _dataOfImage$imgSrcDa = dataOfImage.imgSrcData.size,
          left = _dataOfImage$imgSrcDa.left,
          top = _dataOfImage$imgSrcDa.top;
        _this.setState(dataOfImage, function () {
          img.style.cssText = "\n          top: 0;\n          left: 0;\n          transform:  translate(".concat(left, "px, ").concat(top, "px) translate3d(0,0,0) scale(").concat(dataOfImage.scale, ") ;\n          position: fixed;\n        ");
          setTimeout(function () {
            document.body.classList.add('overflow-hidden');
            img.style.cssText = "\n            transition: ".concat(transition, "ms; \n            transform: \n              translate(-50%,-50%) \n              translate3d(0,0,0)\n              scale(").concat(_this.setScale(dataOfImage.imgSrcData), ") \n          ");
            img.classList.add('zoom');
            _this.overlay.current.classList.add('active');
            setTimeout(function () {
              img.style.transition = "0ms";
              _this.setState({
                sliderOpened: true
              }, function () {
                _this.setState({
                  showRight: _this.checkSiblings('next'),
                  showLeft: _this.checkSiblings('prev')
                });
              });
            }, _this.props.transition);
          }, 5);
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeZoom", function () {
      var _this$state = _this.state,
        imgSrc = _this$state.imgSrc,
        galleryImagesData = _this$state.galleryImagesData,
        activeKey = _this$state.activeKey;
      _this.setState({
        sliderOpened: false
      });
      var PREV_IMG = _this.slideRefs[activeKey - 1] || _this.slideRefs[_this.slideRefs.length - 1];
      var NEXT_IMG = _this.slideRefs[activeKey + 1] || _this.slideRefs[0];
      PREV_IMG.style.cssText = '';
      NEXT_IMG.style.cssText = '';
      document.body.classList.remove('overflow-hidden');
      imgSrc.classList.remove('zoom');
      imgSrc.style.cssText = "\n        transition: ".concat(_this.props.transition, "ms;\n        z-index: 9999;\n        top: 0;\n        left: 0;\n        transform: translate(").concat(galleryImagesData[activeKey].imgSrcData.size.left, "px, ").concat(galleryImagesData[activeKey].imgSrcData.size.top, "px) translate3d(0,0,0) scale(").concat(galleryImagesData[activeKey].scale, ");\n        position: fixed;\n      ");
      _this.overlay.current.classList.remove('active');
      setTimeout(function () {
        imgSrc.style.cssText = '';
        _this.setState(_this.reset());
      }, _this.props.transition);
    });
    _defineProperty(_assertThisInitialized(_this), "scrollZoom", function (e) {
      if (_this.slideRefs[_this.state.activeKey] === _this.state.imgSrc && _this.state.sliderOpened) {
        var SCALE_RATIO = _this.props.scale || 0.1;
        var SCALE_UP = 1 + SCALE_RATIO;
        var SCALE_DOWN = 1 - SCALE_RATIO;
        var WHEEL_UP = e.deltaY < 0;
        var WHEEL_DOWN = e.deltaY > 0;
        var IMG_DATA = _this.state.zoomedScale;
        var target;
        e.target.tagName === 'BUTTON' ? target = _this.slideRefs[_this.state.activeKey] : target = e.target;
        var scaleTransform = target.style.transform.split(' ');
        var scaleValue = Number(scaleTransform.filter(function (el) {
          return !el.search('scale');
        })[0].replace('scale(', '').replace(')', ''));
        var trans3d = _this.slideRefs[_this.state.activeKey].style.transform.split(') ').filter(function (el) {
          return !el.search('translate3d');
        }).map(function (el) {
          return el.replace('translate3d(', '');
        }).map(function (el) {
          return el.replace(',', '');
        })[0].split(' ').map(function (el) {
          return Number(el.replace('px', '').replace(',', ''));
        });
        target.style.transition = "".concat(0, "ms");
        if (WHEEL_UP || e.button === 0 && !e.target.classList.contains('lb-zoom-out') && e.target.tagName === 'BUTTON') {
          if (scaleValue * SCALE_UP < IMG_DATA * 4) {
            scaleValue *= SCALE_UP;
          }
          _this.setState({
            resize: true
          });
        }
        if (WHEEL_DOWN || e.button === 0 && e.target.classList.contains('lb-zoom-out')) {
          if (scaleValue * SCALE_DOWN >= IMG_DATA) {
            scaleValue *= SCALE_DOWN;
            trans3d[0] *= SCALE_DOWN / 1.15;
            trans3d[1] *= SCALE_DOWN / 1.15;
          } else {
            scaleValue = IMG_DATA;
            _this.setState({
              resize: false
            });
            trans3d[0] = 0;
            trans3d[1] = 0;
            _this.setState({
              resizePos: {
                x: 0,
                y: 0
              }
            });
          }
        }
        target.style.transform = "\n        translate(-50%, -50%) \n        translate3d(".concat(trans3d[0], "px,").concat(trans3d[1], "px, 0px)\n        scale(").concat(scaleValue, ") \n      ");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleFullscreen", function (e) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
        e.target.classList.remove('fullscreen');
      } else {
        document.documentElement.requestFullscreen();
        e.target.classList.add('fullscreen');
      }
    });
    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (direction) {
      var _this$state2 = _this.state,
        activeKey = _this$state2.activeKey,
        changeSlide = _this$state2.changeSlide,
        imgSrc = _this$state2.imgSrc,
        galleryImagesData = _this$state2.galleryImagesData;
      var transition = _this.props.transition;
      var _assertThisInitialize = _assertThisInitialized(_this),
        slideRefs = _assertThisInitialize.slideRefs;
      var CURRENT_IMG = imgSrc;
      var PREV_IMG = slideRefs[activeKey - 1] || slideRefs[slideRefs.length - 1];
      var NEXT_IMG = slideRefs[activeKey + 1] || slideRefs[0];
      var actual_key;
      var trans3d_Unset = function trans3d_Unset(index) {
        return "\n      translate(-50%, -50%) \n      translate3d(0px, 0px, 0px) \n      scale(".concat(galleryImagesData[index].zoomedScale, ")\n    ");
      };
      var change = function change() {
        setTimeout(function () {
          PREV_IMG.style.transition = CURRENT_IMG.style.transition = NEXT_IMG.style.transition = "".concat(0, "ms");
          var CURRENT = _this.state.imgSrc;
          var dataOfImage = _this.setData(CURRENT);
          _this.setState(dataOfImage, function () {
            CURRENT.classList.add('zoom');
            CURRENT.style.cssText = "\n            transform: \n              translate(-50%,-50%)\n              translate3d(0,0,0)\n              scale(".concat(_this.setScale(dataOfImage.imgSrcData), ")\n          ");
            _this.setState({
              changeSlide: false,
              showRight: _this.checkSiblings('next'),
              showLeft: _this.checkSiblings('prev')
            });
          });
        }, transition);
      };
      PREV_IMG.style.transition = CURRENT_IMG.style.transition = NEXT_IMG.style.transition = "".concat(transition, "ms");
      CURRENT_IMG.style.transform = trans3d_Unset(activeKey);
      PREV_IMG.style.transform = trans3d_Unset(_this.slideRefs.indexOf(PREV_IMG));
      NEXT_IMG.style.transform = trans3d_Unset(_this.slideRefs.indexOf(NEXT_IMG));
      if (!changeSlide) {
        _this.setState({
          changeSlide: true
        });
        if (direction === 'prev') {
          actual_key = _this.slideRefs.indexOf(PREV_IMG);
          CURRENT_IMG.classList.add('next-img');
          PREV_IMG.classList.remove('prev-img');
          _this.setState({
            imgSrc: PREV_IMG
          });
          change();
        } else if (direction === 'next') {
          actual_key = _this.slideRefs.indexOf(NEXT_IMG);
          CURRENT_IMG.classList.add('prev-img');
          NEXT_IMG.classList.remove('next-img');
          _this.setState({
            imgSrc: NEXT_IMG
          });
          change();
        } else {
          _this.setState({
            dragImg: false,
            changeSlide: false
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "dragStart", function (e) {
      if (!_this.state.dragImg && _this.state.imgSrc && !_this.state.changeSlide && _this.state.sliderOpened && _this.state.dragPercent === 0) {
        var dragImgPos = {
          x: e.clientX || e.touches[0].clientX,
          y: e.clientY || e.touches[0].clientY
        };
        _this.setState({
          dragImg: true,
          dragImgPos: dragImgPos
        });
      } else {
        _this.setState({
          changeSlide: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "dragMoveSlide", function (e) {
      var _this$state3 = _this.state,
        activeKey = _this$state3.activeKey,
        galleryImagesData = _this$state3.galleryImagesData,
        resize = _this$state3.resize;
      var _assertThisInitialize2 = _assertThisInitialized(_this),
        slideRefs = _assertThisInitialize2.slideRefs;
      if (_this.state.dragImg && !resize) {
        var CURRENT_IMG = e.target;
        var PREV_IMG = slideRefs[activeKey - 1] || slideRefs[slideRefs.length - 1];
        var NEXT_IMG = slideRefs[activeKey + 1] || slideRefs[0];
        var dragPos = {
          x: e.clientX || e.touches[0].clientX,
          y: e.clientY || e.touches[0].clientY
        };
        var diffX = dragPos.x - _this.state.dragImgPos.x;
        var diffY = dragPos.y - _this.state.dragImgPos.y;
        if (Math.abs(diffX) > Math.abs(diffY)) {
          _this.setState({
            dragPercent: diffX / window.innerWidth * 100
          });
          var styleSlide = function styleSlide(index) {
            return "transform: \n          translate(-50%,-50%)\n          translate3d(".concat(diffX, "px, 0, 0)  \n          scale(").concat(galleryImagesData[index].zoomedScale, ")\n        ");
          };
          CURRENT_IMG.style.cssText = styleSlide(activeKey);
          PREV_IMG.style.cssText = styleSlide(_this.slideRefs.indexOf(PREV_IMG));
          NEXT_IMG.style.cssText = styleSlide(_this.slideRefs.indexOf(NEXT_IMG));
        }
      } else if (_this.state.dragImg && resize) {
        var _CURRENT_IMG = e.target;
        var _dragPos = {
          x: e.clientX || e.touches[0].clientX,
          y: e.clientY || e.touches[0].clientY
        };
        var CRR = galleryImagesData[activeKey];
        var scaleValue = Number(_CURRENT_IMG.style.transform.split(' ').filter(function (el) {
          return !el.search('scale');
        })[0].replace('scale(', '').replace(')', ''));
        var _diffX = _dragPos.x - _this.state.dragImgPos.x + _this.state.resizePos.x;
        var _diffY = _dragPos.y - _this.state.dragImgPos.y + _this.state.resizePos.y;
        var scaleX = CRR.imgSrcData.realW * scaleValue / 3;
        var scaleY = CRR.imgSrcData.realH * scaleValue / 3;
        if (_diffX > scaleX) _diffX = scaleX;else if (_diffX < -scaleX) _diffX = -scaleX;
        if (_diffY > scaleY) _diffY = scaleY;else if (_diffY < -scaleY) _diffY = -scaleY;
        _CURRENT_IMG.style.cssText = "transform: \n        translate(-50%,-50%)\n        translate3d(".concat(_diffX, "px, ").concat(_diffY, "px, 0)\n        scale(").concat(scaleValue, ")\n      ");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "dragStop", function () {
      if (_this.state.dragImg) {
        var _this$state4 = _this.state,
          activeKey = _this$state4.activeKey,
          dragPercent = _this$state4.dragPercent;
        var dragPercentScale = 20;
        if (!_this.state.resize) {
          if (dragPercent > dragPercentScale) {
            _this.checkSiblings('prev') ? _this.changeSlide('prev') : _this.changeSlide(null);
          } else if (dragPercent < -dragPercentScale) {
            _this.checkSiblings('next') ? _this.changeSlide('next') : _this.changeSlide(null);
          } else {
            _this.changeSlide(null);
          }
        } else {
          var trans3d = _this.slideRefs[activeKey].style.transform.split(') ').filter(function (el) {
            return !el.search('translate3d');
          }).map(function (el) {
            return el.replace('translate3d(', '');
          }).map(function (el) {
            return el.replace(',', '');
          })[0].split(' ').map(function (el) {
            return Number(el.replace('px', '').replace(',', ''));
          });
          _this.setState({
            resizePos: {
              x: trans3d[0],
              y: trans3d[1]
            }
          });
        }
        _this.setState({
          dragImg: false,
          dragPercent: 0
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "checkSiblings", function (direction) {
      return _this.slideRefs.filter(function (target) {
        return target.classList.contains("".concat(direction, "-img"));
      }).length > 0;
    });
    _this.state = _this.reset();
    _this.overlay = React.createRef();
    _this.slideRefs = [];
    return _this;
  }
  _createClass(LightBox, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        images = _this$props.images,
        itemClassName = _this$props.itemClassName,
        descriptionClassName = _this$props.descriptionClassName,
        noMargins = _this$props.noMargins,
        lg = _this$props.lg,
        md = _this$props.md,
        sm = _this$props.sm,
        size = _this$props.size,
        xl = _this$props.xl,
        xs = _this$props.xs,
        transition = _this$props.transition;
      var _this$state5 = this.state,
        activeKey = _this$state5.activeKey,
        galleryImagesData = _this$state5.galleryImagesData,
        imgSrc = _this$state5.imgSrc,
        sliderOpened = _this$state5.sliderOpened;
      var lightBoxClasses = classNames('mdb-lightbox d-flex flex-wrap', !noMargins && 'no-margin', className);
      var descriptionClasses = classNames('text-uppercase font-weight-bold mt-4', descriptionClassName);
      var pswp__button = function pswp__button(button) {
        return classNames("pswp__button d-block z-depth-0 pswp__button--".concat(button));
      };
      var galleryClassNames = function galleryClassNames(id) {
        var sliders1 = _this2.slideRefs.length > 1;
        var sliders2 = _this2.slideRefs.length > 2;
        return classNames("figure-img img-fluid z-depth-1 m-0", sliders1 && sliderOpened && id === activeKey + 1 && 'zoom next-img', sliders1 && sliderOpened && id === activeKey - 1 && 'zoom prev-img', sliders1 && sliders2 && sliderOpened && id === 0 && activeKey + 1 > _this2.slideRefs.length - 1 && 'zoom next-img', sliders1 && sliders2 && sliderOpened && id === _this2.slideRefs.length - 1 && activeKey === 0 && 'zoom prev-img', sliders1 && sliders2 && sliderOpened && id === 1 && activeKey === 0 && 'zoom next-img');
      };
      var galleryStyles = function galleryStyles(id) {
        if (_this2.slideRefs[id]) {
          var next = id === activeKey + 1;
          var prev = id === activeKey - 1;
          var second = id === 0 && activeKey + 1 > _this2.slideRefs.length - 1;
          var last = id === _this2.slideRefs.length - 1 && activeKey === 0;
          var first = id === 1 && activeKey === 0;
          var style = {
            transform: _this2.slideRefs.length > 1 && sliderOpened && (next || prev || second || last || first) && "translate(-50%, -50%) translate3d(0,0,0) scale(".concat(_this2.setScale({
              realW: _this2.slideRefs[id].naturalWidth,
              realH: _this2.slideRefs[id].naturalHeight,
              size: _this2.slideRefs[id].getBoundingClientRect()
            }), ")")
          };
          return style;
        }
      };
      var items = images.map(function (image, id) {
        return React.createElement(Col, {
          tag: "figure",
          lg: image.lg || lg,
          md: image.md || md,
          sm: image.sm || sm,
          xl: image.xl || xl,
          xs: image.xs || xs,
          size: size || image.size,
          className: image.className || itemClassName,
          key: id
        }, React.createElement("img", {
          src: image.src,
          className: galleryClassNames(id),
          alt: image.alt || "image ".concat(id + 1),
          ref: function ref(img) {
            return _this2.slideRefs[id] = img;
          },
          style: galleryStyles(id),
          draggable: !imgSrc,
          onClick: _this2.zoom,
          onDragStart: function onDragStart(e) {
            return e.preventDefault();
          },
          onMouseDown: _this2.dragStart,
          onTouchStart: _this2.dragStart,
          onMouseMove: _this2.dragMoveSlide,
          onTouchMove: _this2.dragMoveSlide,
          onMouseLeave: _this2.dragStop,
          onMouseUp: _this2.dragStop,
          onTouchEnd: _this2.dragStop,
          onWheel: _this2.scrollZoom
        }), _this2.slideRefs[id] === imgSrc && React.createElement("div", {
          className: "block",
          style: {
            height: "".concat(galleryImagesData[activeKey].imgSrcData.size.height, "px"),
            width: "".concat(galleryImagesData[activeKey].imgSrcData.size.width, "px")
          }
        }), image.description && React.createElement("p", {
          className: descriptionClasses
        }, image.description));
      });
      return React.createElement(Container, {
        "data-test": "light-box",
        className: "mdb-lightbox"
      }, imgSrc && React.createElement("div", {
        className: "ui-controls"
      }, React.createElement("p", {
        className: "float-left text-white-50 mt-3 ml-3"
      }, activeKey + 1, "/", images.length), React.createElement(ButtonGroup, {
        style: {
          transition: "".concat(transition / 2, "ms"),
          right: '0'
        }
      }, React.createElement(Button, {
        className: pswp__button('zoom'),
        color: "transparent",
        onClick: this.scrollZoom
      }), React.createElement(Button, {
        className: pswp__button('zoom lb-zoom-out'),
        color: "transparent",
        onClick: this.scrollZoom
      }), React.createElement(Button, {
        className: pswp__button('fs'),
        color: "transparent",
        onClick: this.toggleFullscreen
      }), React.createElement(Button, {
        className: pswp__button('close'),
        color: "transparent",
        onClick: this.closeZoom
      })), React.createElement("div", {
        className: "d-flex justify-content-between w-100 arrow-container",
        style: {
          transition: "".concat(transition, "ms")
        }
      }, this.state.showLeft && React.createElement("div", {
        className: pswp__button('arrow--left prev'),
        onClick: function onClick() {
          return _this2.changeSlide('prev');
        }
      }), this.state.showRight && React.createElement("div", {
        className: pswp__button('arrow--right next'),
        onClick: function onClick() {
          return _this2.changeSlide('next');
        }
      }))), React.createElement("div", {
        className: "overlay",
        ref: this.overlay,
        style: {
          transition: "".concat(transition, "ms")
        },
        onClick: this.closeZoom
      }), React.createElement("div", {
        className: lightBoxClasses
      }, items));
    }
  }]);
  return LightBox;
}(React.Component);
LightBox.propTypes = {
  images: propTypes.array,
  itemClassName: propTypes.string,
  noMargins: propTypes.bool,
  marginSpace: propTypes.number,
  lg: propTypes.string,
  md: propTypes.string,
  sm: propTypes.string,
  size: propTypes.string,
  xl: propTypes.string,
  xs: propTypes.string,
  transition: propTypes.number
};
LightBox.defaultProps = {
  images: [],
  noMargins: false,
  marginSpace: 150,
  transition: 400
};
var css$d = "\n/*\n * Container style\n */\n .ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  -ms-overflow-style: none;\n  touch-action: auto;\n  -ms-touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x {\n  background-color: #999;\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y {\n  background-color: #999;\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n.scrollbar-container {\n  position: relative;\n  height: 100%;\n}\n";
styleInject(css$d);
var handlerNameByEvent = {
  'ps-scroll-y': 'onScrollY',
  'ps-scroll-x': 'onScrollX',
  'ps-scroll-up': 'onScrollUp',
  'ps-scroll-down': 'onScrollDown',
  'ps-scroll-left': 'onScrollLeft',
  'ps-scroll-right': 'onScrollRight',
  'ps-y-reach-start': 'onYReachStart',
  'ps-y-reach-end': 'onYReachEnd',
  'ps-x-reach-start': 'onXReachStart',
  'ps-x-reach-end': 'onXReachEnd'
};
Object.freeze(handlerNameByEvent);
var ScrollBar = /*#__PURE__*/
function (_Component) {
  _inherits(ScrollBar, _Component);
  function ScrollBar(props) {
    var _this;
    _classCallCheck(this, ScrollBar);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollBar).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this._container = ref;
      _this.props.containerRef(ref);
    });
    _this._handlerByEvent = new Map();
    return _this;
  }
  _createClass(ScrollBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this._ps = new PerfectScrollbar(this._container, this.props.option); // hook up events

      Object.keys(handlerNameByEvent).forEach(function (key) {
        var callback = _this2.props[handlerNameByEvent[key]];
        if (callback) {
          var handler = function handler() {
            return callback(_this2._container);
          };
          _this2._handlerByEvent.set(key, handler);
          _this2._container.addEventListener(key, handler, false);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._ps.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      // unhook up evens
      Object.keys(this._handlerByEvent).forEach(function (value, key) {
        _this3._container.removeEventListener(key, value, false);
      });
      this._handlerByEvent.clear();
      this._ps.destroy();
      this._ps = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;
      return React.createElement("div", {
        className: "scrollbar-container ".concat(className),
        ref: this.handleRef
      }, children);
    }
  }]);
  return ScrollBar;
}(Component);
ScrollBar.defaultProps = {
  className: '',
  option: undefined,
  containerRef: function containerRef() {},
  onScrollY: undefined,
  onScrollX: undefined,
  onScrollUp: undefined,
  onScrollDown: undefined,
  onScrollLeft: undefined,
  onScrollRight: undefined,
  onYReachStart: undefined,
  onYReachEnd: undefined,
  onXReachStart: undefined,
  onXReachEnd: undefined
};
ScrollBar.propTypes = {
  children: propTypes.node.isRequired,
  className: propTypes.string,
  option: propTypes.object,
  containerRef: propTypes.func,
  onScrollY: propTypes.func,
  onScrollX: propTypes.func,
  onScrollUp: propTypes.func,
  onScrollDown: propTypes.func,
  onScrollLeft: propTypes.func,
  onScrollRight: propTypes.func,
  onYReachStart: propTypes.func,
  onYReachEnd: propTypes.func,
  onXReachStart: propTypes.func,
  onXReachEnd: propTypes.func
};
var ScrollBox = function ScrollBox(props) {
  var className = props.className,
    children = props.children,
    attributes = _objectWithoutProperties(props, ["className", "children"]);
  var classes = classNames("scroll-box", className);
  return React.createElement("div", _extends({}, attributes, {
    className: classes
  }), children);
};
ScrollBox.propTypes = {
  className: propTypes.string,
  children: propTypes.node
};
var ScrollSpyList = function ScrollSpyList(props) {
  var className = props.className,
    children = props.children,
    color = props.color,
    attributes = _objectWithoutProperties(props, ["className", "children", "color"]);
  var classes = classNames("nav md-tabs horizontal-spy", color ? color : false, className);
  return React.createElement("ul", _extends({}, attributes, {
    role: "navigation",
    className: classes
  }), children);
};
ScrollSpyList.propTypes = {
  className: propTypes.string,
  children: propTypes.node,
  color: propTypes.string
};
var ScrollSpyListItem = function ScrollSpyListItem(props) {
  var className = props.className,
    children = props.children,
    active = props.active,
    attributes = _objectWithoutProperties(props, ["className", "children", "active"]);
  var classes = classNames("nav-link ", active ? "active" : false, className);
  return React.createElement("li", {
    className: "nav-item"
  }, React.createElement("a", _extends({}, attributes, {
    className: classes,
    role: "tab"
  }), children));
};
ScrollSpyListItem.propTypes = {
  className: propTypes.string,
  children: propTypes.node,
  active: propTypes.bool
};
var ScrollSpyText = function ScrollSpyText(props) {
  var className = props.className,
    children = props.children,
    scrollSpyRef = props.scrollSpyRef,
    attributes = _objectWithoutProperties(props, ["className", "children", "scrollSpyRef"]);
  var classes = classNames("scrollspy-example z-depth-1", className);
  return React.createElement("div", _extends({}, attributes, {
    ref: props.scrollSpyRef,
    className: classes
  }), children);
};
ScrollSpyText.propTypes = {
  className: propTypes.string,
  children: propTypes.node,
  scrollSpyRef: propTypes.oneOfType([propTypes.func, propTypes.object])
};
var css$e = ".popover-enter {\n  opacity: 0.01;\n  transform: scale(0.9) translateY(50%);\n}\n\n.popover-enter-active {\n  opacity: 1;\n  transform: scale(1);\n  transition: scale 300ms ease-out, opacity 300ms ease;\n}\n\n.popover-enter-done {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.popover-exit {\n  opacity: 1;\n  transform: scale(0.8);\n  transition: all 300ms ease-out;\n}\n\n.popover-exit-active {\n  opacity: 0;\n  transform: scale(0.8);\n  transition: all 300ms ease-out;\n}\n\n/* slide from side */\n\n.side-slide-enter, .side-slide-appear {\n  opacity: 0.2;\n  transform: translateX(-100%);\n}\n\n.side-slide-enter-active, .side-slide-appear-active {\n  opacity: 1;\n  transform: translateX(0%);\n  transition: transform 300ms ease-out, opacity 300ms ease;\n}\n\n.side-slide-enter-done {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.side-slide-exit {\n  opacity: 1;\n  transform: translateX(0%);\n  transition: all 300ms ease-out;\n}\n\n.side-slide-exit-active {\n  opacity: 0.2;\n  transform: translateX(-100%);\n  transition: all 300ms ease-out;\n}\n\n.right-side-slide-enter, .right-side-slide-appear {\n  opacity: 0.2;\n  transform: translateX(100%);\n}\n\n.right-side-slide-enter-active, .right-side-slide-appear-active {\n  opacity: 1;\n  transform: translateX(0%) !important;\n  transition: transform 300ms ease-out, opacity 300ms ease;\n}\n\n.right-side-slide-enter-done {\n  opacity: 1;\n  transform: translateX(0%) !important;\n}\n\n.right-side-slide-exit {\n  opacity: 1;\n  transform: translateX(0%);\n  transition: all 300ms ease-out;\n}\n\n.right-side-slide-exit-active {\n  opacity: 0.2;\n  transform: translateX(100%);\n  transition: all 300ms ease-out;\n}\n\n.side-nav[data-animate=\"false\"]{\n  transform: translateX(0%);\n}\n\n\n.side-nav.wide {\n    transition-property: all;\n    transition-duration: 300ms;\n    transition-timing-function: ease-out;\n}\n\n\n.side-nav.wide.slim {\n    width: 3.75rem;\n    transition-property: all;\n    transition-duration: 300ms;\n    transition-timing-function: ease-out;\n    right: 3.75rem;\n}\n\n.right-aligned.side-nav.wide.slim {\n    right: 0;\n}\n\n\n";
styleInject(css$e);
var defaultValue = {
  slim: false
};
var SideNavContext = React.createContext(defaultValue);
var SideNav = /*#__PURE__*/
function (_React$Component) {
  _inherits(SideNav, _React$Component);
  function SideNav(props) {
    var _this;
    _classCallCheck(this, SideNav);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideNav).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "startTouch", function (e) {
      _this.initialX = e.touches[0].clientX;
      _this.initialY = e.touches[0].clientY;
    });
    _defineProperty(_assertThisInitialized(_this), "moveTouch", function (e) {
      if (_this.initialX === null) {
        return;
      }
      if (_this.initialY === null) {
        return;
      }
      var currentX = e.touches[0].clientX;
      var currentY = e.touches[0].clientY;
      var diffX = _this.initialX - currentX;
      var diffY = _this.initialY - currentY;
      if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) {
          !_this.props.right && _this.handleOverlayClick();
        } else {
          _this.props.right && _this.handleOverlayClick();
        }
      }
      _this.initialX = null;
      _this.initialY = null;
      e.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "updatePredicate", function () {
      if (!_this.props.hidden && _this.props.responsive) {
        _this.setState({
          isOpen: window.innerWidth > _this.props.breakWidth
        });
        if (window.innerWidth > _this.props.breakWidth) {
          _this.setState({
            isOpen: true,
            isFixed: _this.state.initiallyFixed
          });
        } else {
          _this.setState({
            isOpen: false,
            isFixed: false
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleSlim", function (e) {
      return function () {
        _this.setState({
          slim: !_this.state.slim
        });
        var sidenav = ReactDOM.findDOMNode(_this.sideNavRef.current);
        sidenav.classList.toggle("slim");
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handleOverlayClick", function () {
      if (_this.state.isFixed) return;
      _this.setState({
        isOpen: false
      });
      if (_this.props.onOverlayClick) {
        _this.props.onOverlayClick();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      if (!_this.props.disabled) {
        // Waves - Get Cursor Position
        var cursorPos = {
          top: e.clientY,
          left: e.clientX,
          time: Date.now()
        };
        _this.setState({
          cursorPos: cursorPos
        }); // do the passed in callback:

        if (_this.props.onClick) {
          _this.props.onClick(e);
        }
      }
      e.stopPropagation();
    });
    function isOpen() {
      if (props.fixed) {
        if (window.innerWidth <= props.breakWidth) {
          return props.responsive ? false : true;
        }
        return true;
      } else {
        if (props.triggerOpening) {
          if (window.innerWidth > props.breakWidth) {
            return true;
          }
          return false;
        }
        return false;
      }
    }
    _this.sideNavRef = React.createRef();
    _this.initialX = null;
    _this.initialY = null;
    _this.state = {
      initiallyFixed: props.fixed,
      isFixed: !isOpen() ? false : props.fixed,
      isOpen: isOpen(),
      cursorPos: {},
      slim: _this.props.slim,
      slimInitial: _this.props.slim
    };
    return _this;
  }
  _createClass(SideNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.triggerOpening && !this.props.responsive) {
        throw new Error('Received "triggerOpening" prop for a  non-responsive Sidebar. If you want to contidionally render Sidenav, set the responsive prop to true');
      }
      this.sideNavRef.current.addEventListener("touchstart", this.startTouch);
      this.sideNavRef.current.addEventListener("touchmove", this.moveTouch);
      window.addEventListener("resize", this.updatePredicate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.triggerOpening !== this.props.triggerOpening) {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updatePredicate);
      this.sideNavRef.current.removeEventListener("touchstart", this.startTouch);
      this.sideNavRef.current.removeEventListener("touchmove", this.moveTouch);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        bg = _this$props.bg,
        breakWidth = _this$props.breakWidth,
        children = _this$props.children,
        className = _this$props.className,
        hidden = _this$props.hidden,
        href = _this$props.href,
        logo = _this$props.logo,
        mask = _this$props.mask,
        onOverlayClick = _this$props.onOverlayClick,
        right = _this$props.right,
        triggerOpening = _this$props.triggerOpening,
        showOverlay = _this$props.showOverlay,
        fixed = _this$props.fixed,
        responsive = _this$props.responsive,
        slim = _this$props.slim,
        Tag = _this$props.tag,
        attributes = _objectWithoutProperties(_this$props, ["bg", "breakWidth", "children", "className", "hidden", "href", "logo", "mask", "onOverlayClick", "right", "triggerOpening", "showOverlay", "fixed", "responsive", "slim", "tag"]);
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        isFixed = _this$state.isFixed;
      var classes = classNames("side-nav", "wide", right && "right-aligned", this.state.slimInitial && "slim", className);
      var overlay = React.createElement("div", {
        id: "sidenav-overlay",
        onClick: this.handleOverlayClick
      });
      var sidenav = React.createElement(Tag, _extends({}, attributes, {
        ref: this.sideNavRef,
        className: classes,
        "data-animate": isFixed ? false : undefined,
        style: bg ? {
          backgroundImage: "url(".concat(bg)
        } : undefined
      }), React.createElement(ScrollBar, {
        option: {
          suppressScrollX: true
        }
      }, React.createElement("ul", {
        className: "list-unstyled"
      }, logo && React.createElement("li", null, React.createElement("div", {
        className: "logo-wrapper"
      }, React.createElement("a", {
        href: href,
        className: "Ripple-parent",
        onClick: this.handleClick
      }, React.createElement("img", {
        src: logo,
        alt: "",
        className: "img-fluid flex-center d-block"
      }), React.createElement(Waves, {
        cursorPos: this.state.cursorPos
      })))), children)), mask && React.createElement("div", {
        className: "sidenav-bg ".concat(mask)
      }));
      return React.createElement(SideNavContext.Provider, {
        value: {
          slimInitial: this.state.slimInitial,
          slim: this.state.slim,
          toggleSlim: this.toggleSlim,
          right: this.props.right
        }
      }, isFixed ? sidenav : React.createElement(CSSTransition, {
        appear: !this.state.isFixed,
        timeout: {
          enter: 300,
          exit: 300
        },
        classNames: right ? "right-side-slide" : "side-slide",
        "in": isOpen
      }, sidenav), isFixed ? false : showOverlay && isOpen && overlay);
    }
  }]);
  return SideNav;
}(React.Component);
SideNav.propTypes = {
  bg: propTypes.string,
  breakWidth: propTypes.number,
  children: propTypes.node,
  className: propTypes.string,
  hidden: propTypes.bool,
  href: propTypes.string,
  logo: propTypes.string,
  mask: propTypes.string,
  onOverlayClick: propTypes.func,
  right: propTypes.bool,
  triggerOpening: propTypes.bool,
  tag: propTypes.string,
  fixed: propTypes.bool,
  showOverlay: propTypes.bool,
  responsive: propTypes.bool,
  slim: propTypes.bool
};
SideNav.defaultProps = {
  bg: "",
  breakWidth: 1400,
  className: "",
  hidden: false,
  href: "#",
  logo: "",
  mask: "",
  onOverlayClick: function onOverlayClick() {},
  right: false,
  triggerOpening: false,
  tag: "div",
  fixed: false,
  responsive: true,
  showOverlay: true,
  slim: false
};
var SideNavCat = /*#__PURE__*/
function (_React$Component) {
  _inherits(SideNavCat, _React$Component);
  function SideNavCat(props) {
    var _this;
    _classCallCheck(this, SideNavCat);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideNavCat).call(this, props));
    _this.state = {
      cursorPos: {},
      isOpenID: ""
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SideNavCat, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isOpen !== this.props.isOpen) {
        this.setState({
          isOpenID: this.props.isOpen ? this.props.id : ""
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e, id) {
      if (!this.props.disabled) {
        // Waves - Get Cursor Position
        var cursorPos = {
          top: e.clientY,
          left: e.clientX,
          time: Date.now()
        };
        this.setState({
          cursorPos: cursorPos
        }); // do the passed in callback:

        if (this.props.onClick) {
          this.props.onClick(id);
        }
        e.stopPropagation();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        Tag = _this$props.tag,
        children = _this$props.children,
        className = _this$props.className,
        name = _this$props.name,
        icon = _this$props.icon,
        iconBrand = _this$props.iconBrand,
        iconLight = _this$props.iconLight,
        iconRegular = _this$props.iconRegular,
        iconSize = _this$props.iconSize,
        onClick = _this$props.onClick,
        disabled = _this$props.disabled,
        isOpen = _this$props.isOpen,
        isOpenID = _this$props.isOpenID,
        id = _this$props.id,
        attributes = _objectWithoutProperties(_this$props, ["tag", "children", "className", "name", "icon", "iconBrand", "iconLight", "iconRegular", "iconSize", "onClick", "disabled", "isOpen", "isOpenID", "id"]);
      var classes = classNames("collapsible-header", "Ripple-parent", "arrow-r", isOpen && "active", disabled && "disabled", className);
      return React.createElement(SideNavContext.Consumer, null, function (_ref) {
        var slim = _ref.slim;
        var iconClass = ['mr-2'];
        slim && iconClass.push('v-slim-icon');
        return React.createElement(Tag, null, React.createElement("a", _extends({
          className: classes,
          onClick: function onClick(e) {
            return _this2.handleClick(e, id);
          }
        }, attributes), icon && React.createElement(Fa, {
          icon: icon,
          brand: iconBrand,
          light: iconLight,
          regular: iconRegular,
          size: iconSize,
          className: iconClass.join(" ")
        }), name, React.createElement(Fa, {
          icon: "angle-down",
          className: "rotate-icon"
        }), React.createElement(Waves, {
          cursorPos: _this2.state.cursorPos
        })), React.createElement(Collapse, {
          id: id,
          isOpen: _this2.state.isOpenID
        }, React.createElement("div", {
          className: "collapsible-body",
          style: {
            display: "block"
          }
        }, React.createElement("ul", null, children))));
      });
    }
  }]);
  return SideNavCat;
}(React.Component);
_defineProperty(SideNavCat, "displayName", "SideNavCat");
SideNavCat.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  disabled: propTypes.bool,
  icon: propTypes.string,
  iconBrand: propTypes.bool,
  iconLight: propTypes.bool,
  iconRegular: propTypes.bool,
  iconSize: propTypes.string,
  id: propTypes.string,
  isOpen: propTypes.bool,
  isOpenID: propTypes.string,
  name: propTypes.string,
  onClick: propTypes.func,
  tag: propTypes.string
};
SideNavCat.defaultProps = {
  className: "",
  disabled: false,
  icon: "",
  iconBrand: false,
  iconLight: false,
  iconRegular: false,
  iconSize: "",
  id: "",
  isOpen: false,
  isOpenID: "",
  name: "",
  onClick: function onClick() {},
  tag: "li"
};
var SideNavItem = function SideNavItem(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    if (!props.disabled) {
      // Waves - Get Cursor Position
      var _cursorPos = {
        top: e.clientY,
        left: e.clientX,
        time: Date.now()
      };
      setCursorPos(_cursorPos); // do the passed in callback:

      if (props.onClick) {
        props.onClick(e);
      }
      e.stopPropagation();
    }
  };
  var Tag = props.tag,
    children = props.children,
    href = props.href,
    className = props.className,
    innerRef = props.innerRef,
    attributes = _objectWithoutProperties(props, ["tag", "children", "href", "className", "innerRef"]);
  var classes = classNames("Ripple-parent", className);
  return React.createElement(Tag, _extends({
    className: classes,
    ref: innerRef,
    onClick: handleClick
  }, attributes), React.createElement("a", {
    className: classes,
    href: href
  }, children, React.createElement(Waves, {
    cursorPos: cursorPos
  })));
};
SideNavItem.propTypes = {
  children: propTypes.node,
  href: propTypes.string,
  tag: propTypes.string,
  innerRef: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string
};
SideNavItem.defaultProps = {
  tag: "li"
};
var SideNavLink = /*#__PURE__*/
function (_React$Component) {
  _inherits(SideNavLink, _React$Component);
  function SideNavLink(props) {
    var _this;
    _classCallCheck(this, SideNavLink);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideNavLink).call(this, props));
    _this.state = {
      cursorPos: {}
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SideNavLink, [{
    key: "handleClick",
    value: function handleClick(e) {
      if (!this.props.disabled) {
        // Waves - Get Cursor Position
        var cursorPos = {
          top: e.clientY,
          left: e.clientX,
          time: Date.now()
        };
        this.setState({
          cursorPos: cursorPos
        }); // do the passed in callback:

        if (this.props.onClick) {
          this.props.onClick(e);
        }
        e.stopPropagation();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        Tag = _this$props.tag,
        children = _this$props.children,
        to = _this$props.to,
        className = _this$props.className,
        innerRef = _this$props.innerRef,
        topLevel = _this$props.topLevel,
        shortcut = _this$props.shortcut,
        attributes = _objectWithoutProperties(_this$props, ["tag", "children", "to", "className", "innerRef", "topLevel", "shortcut"]);
      var classes = classNames('Ripple-parent', topLevel && 'collapsible-header', className);
      var sideNavLink = React.createElement(SideNavContext.Consumer, null, function (_ref) {
        var slim = _ref.slim;
        var shortcut;
        function calculateShortcut() {
          if (typeof children === 'string') {
            var wordsArray = children.toString().split(' ');
            if (wordsArray.length === 1) {
              return wordsArray[0].substr(0, 2).toUpperCase();
            }
            if (wordsArray.length >= 2) {
              var firstLetter = wordsArray[0].substr(0, 1);
              var secondLetter = wordsArray[1].substr(0, 1);
              return firstLetter.concat(secondLetter).toUpperCase();
            }
          }
          return children;
        }
        if (slim) {
          shortcut = _this2.props.shortcut || calculateShortcut();
        }
        return React.createElement(NavLink$1, _extends({
          className: classes,
          ref: innerRef,
          onClick: _this2.handleClick,
          to: to
        }, attributes), slim ? React.createElement(React.Fragment, null, React.createElement("span", {
          className: "sv-slim"
        }, shortcut), React.createElement("span", {
          className: "sv-normal"
        }, children)) : React.createElement("span", {
          className: "sv-normal"
        }, children), React.createElement(Waves, {
          cursorPos: _this2.state.cursorPos
        }));
      });
      return topLevel ? React.createElement("li", null, " ", sideNavLink) : sideNavLink;
    }
  }]);
  return SideNavLink;
}(React.Component);
SideNavLink.propTypes = {
  children: propTypes.node,
  href: propTypes.string,
  tag: propTypes.string,
  innerRef: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string,
  topLevel: propTypes.bool,
  shortcut: propTypes.string
};
SideNavLink.defaultProps = {
  to: '#',
  topLevel: false
};
var SideNavNav = /*#__PURE__*/
function (_React$Component) {
  _inherits(SideNavNav, _React$Component);
  function SideNavNav(props) {
    var _this;
    _classCallCheck(this, SideNavNav);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideNavNav).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "onClick", function (number) {
      return function () {
        var state = "";
        if (_this.state.accordion !== number) {
          state = number;
        } else {
          state = null;
        }
        _this.setState({
          accordion: state
        });
      };
    });
    _this.state = {
      accordion: null
    };
    return _this;
  }
  _createClass(SideNavNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        Tag = _this$props.tag,
        children = _this$props.children,
        className = _this$props.className,
        attributes = _objectWithoutProperties(_this$props, ["tag", "children", "className"]);
      var accordion = this.state.accordion;
      var classes = classNames("collapsible", "collapsible-accordion", className);
      var modified = React.Children.map(this.props.children, function (child, i) {
        if (child.type.displayName === "SideNavCat") {
          return React.cloneElement(child, {
            onClick: _this2.onClick(i),
            isOpen: accordion === i
          });
        } else {
          return child;
        }
      });
      return React.createElement(SideNavContext.Consumer, null, function (_ref) {
        var slim = _ref.slim,
          slimInitial = _ref.slimInitial,
          toggleSlim = _ref.toggleSlim,
          right = _ref.right;
        var iconClass = ['mr-2', "sv-slim-icon", "fas", "icon-rotate"];
        right & slim && iconClass.push('fa-angle-double-left');
        right & !slim && iconClass.push('fa-angle-double-right');
        !right & !slim && iconClass.push('fa-angle-double-left');
        !right & slim && iconClass.push('fa-angle-double-right');
        return React.createElement(React.Fragment, null, React.createElement("li", null, React.createElement(Tag, _extends({}, attributes, {
          className: classes
        }), modified, slimInitial && React.createElement("li", {
          onClick: toggleSlim()
        }, React.createElement("a", {
          href: "#!",
          className: "waves-effect"
        }, React.createElement("i", {
          className: iconClass.join(" ")
        }), "Minimize menu")))));
      });
    }
  }]);
  return SideNavNav;
}(React.Component);
SideNavNav.propTypes = {
  children: propTypes.node,
  tag: propTypes.string,
  className: propTypes.string
};
SideNavNav.defaultProps = {
  tag: "ul"
};
var SimpleChart = function SimpleChart(props) {
  var polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians)
    };
  };
  var describeArc = function describeArc(x, y, radius, startAngle, endAngle) {
    if (!x || !y) console.error('x or y missing to describeArc');
    var start = polarToCartesian(x, y, radius, endAngle),
      end = polarToCartesian(x, y, radius, startAngle),
      arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
    return ["M", start.x, start.y, "A", radius, radius, 0, arcSweep, 0, end.x, end.y].join(" ");
  };
  var percent = Math.min(props.percent || 0, 100),
    radius = props.width / 2 - props.strokeWidth / 2 - props.padding,
    center = radius + props.strokeWidth / 2 + props.padding,
    startAngle = 0,
    endAngle = 3.6 * percent,
    label = "".concat(percent, "%"),
    labelLeftOffset = label.length === 3 || label.length === 4 ? -0.95 : -0.6,
    arc = describeArc(center, center, radius, startAngle, endAngle - .001);
  return React.createElement("svg", {
    className: "react-chart ".concat(props.type),
    width: props.width,
    style: _objectSpread({
      overflow: 'visible',
      border: props.border
    }, props.style),
    height: props.height
  }, React.createElement("circle", {
    cx: center,
    cy: center,
    r: radius,
    fill: props.fillColor,
    stroke: props.railColor,
    strokeWidth: props.strokeWidth
  }), React.createElement("path", {
    fill: props.fillColor,
    stroke: props.strokeColor,
    strokeWidth: props.strokeWidth,
    d: arc
  }), React.createElement("text", {
    x: center,
    y: center,
    dx: "".concat(labelLeftOffset, "em"),
    dy: ".35em",
    fill: props.labelColor,
    fontWeight: props.labelFontWeight,
    fontSize: props.labelFontSize
  }, label));
};
SimpleChart.defaultProps = {
  width: 150,
  height: 150,
  border: 'none',
  strokeWidth: 10,
  style: {},
  labelColor: '#408AE5',
  labelFontSize: '1.2em',
  labelFontWeight: 'bold',
  strokeColor: '#408AE5',
  railColor: '#f5f5f5',
  fillColor: 'none',
  percent: 70,
  padding: 0
};
SimpleChart.propTypes = {
  width: propTypes.number,
  height: propTypes.number,
  strokeWidth: propTypes.number,
  strokeColor: propTypes.string,
  labelFontWeight: propTypes.string,
  labelFontSize: propTypes.string,
  fillColor: propTypes.string,
  startAngle: propTypes.number,
  endAngle: propTypes.number,
  radius: propTypes.number,
  style: propTypes.object
};
var SmoothScroll = function SmoothScroll(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPos = _useState2[0],
    setCursorPos = _useState2[1];
  var handleClick = function handleClick(e) {
    if (!props.disabled) {
      e.stopPropagation(); // Waves - Get Cursor Position

      var _cursorPos = {
        top: e.clientY,
        left: e.clientX,
        time: Date.now()
      };
      setCursorPos(_cursorPos);
    }
  };
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    active = props.active,
    to = props.to,
    spy = props.spy,
    smooth = props.smooth,
    offset = props.offset,
    duration = props.duration,
    block = props.block,
    color = props.color,
    outline = props.outline,
    size = props.size,
    rounded = props.rounded,
    gradient = props.gradient,
    floating = props.floating,
    flat = props.flat,
    social = props.social,
    btn = props.btn,
    fixed = props.fixed,
    bottom = props.bottom,
    right = props.right,
    top = props.top,
    left = props.left,
    attributes = _objectWithoutProperties(props, ["children", "className", "disabled", "active", "to", "spy", "smooth", "offset", "duration", "block", "color", "outline", "size", "rounded", "gradient", "floating", "flat", "social", "btn", "fixed", "bottom", "right", "top", "left"]);
  var classes = classNames("nav-link", disabled ? "disabled" : "Ripple-parent", active && "active", (btn || floating) && "btn", floating && "btn-floating", flat ? "btn-flat" : gradient ? "".concat(gradient, "-gradient") : "btn".concat(outline ? "-outline" : "", "-").concat(color), size ? "btn-".concat(size) : false, rounded ? "btn-rounded" : false, block ? "btn-block" : false, social ? "btn-" + social : false, "Ripple-parent", className);
  var fixedStyles = {
    position: "fixed",
    top: top ? "".concat(top, "px") : null,
    bottom: bottom ? "".concat(bottom, "px") : !top ? "45px" : null,
    left: left ? "".concat(left, "px") : null,
    right: right ? "".concat(right, "px") : !left ? "24px" : null
  };
  return React.createElement(Link, _extends({
    className: classes,
    onMouseUp: handleClick,
    onTouchStart: handleClick,
    to: to,
    spy: spy,
    smooth: smooth,
    offset: offset,
    duration: duration,
    style: fixed ? fixedStyles : null
  }, attributes), children, props.disabled ? false : React.createElement(Waves, {
    cursorPos: cursorPos
  }));
};
SmoothScroll.propTypes = {
  to: propTypes.string.isRequired,
  children: propTypes.node,
  className: propTypes.string,
  disabled: propTypes.bool,
  active: propTypes.bool,
  spy: propTypes.bool,
  smooth: propTypes.bool,
  offset: propTypes.number,
  duration: propTypes.number,
  block: propTypes.bool,
  color: propTypes.string,
  outline: propTypes.bool,
  size: propTypes.string,
  rounded: propTypes.bool,
  gradient: propTypes.string,
  floating: propTypes.bool,
  flat: propTypes.bool,
  social: propTypes.string,
  fixed: propTypes.bool,
  top: propTypes.string,
  bottom: propTypes.string,
  right: propTypes.string,
  left: propTypes.string
};
SmoothScroll.defaultProps = {
  active: false,
  className: "",
  disabled: false,
  spy: true,
  smooth: true,
  offset: -70,
  duration: 500
};
var Spinner = function Spinner(props) {
  var theChosenColorSpinner = function theChosenColorSpinner(spinnerClasses) {
    if (props.multicolor) {
      var theSpinnerItself = React.createElement("div", null, React.createElement("div", {
        className: "spinner-layer spinner-blue"
      }, React.createElement("div", {
        className: "circle-clipper left"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "gap-patch"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "circle-clipper right"
      }, React.createElement("div", {
        className: "circle"
      }))), React.createElement("div", {
        className: "spinner-layer spinner-red"
      }, React.createElement("div", {
        className: "circle-clipper left"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "gap-patch"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "circle-clipper right"
      }, React.createElement("div", {
        className: "circle"
      }))), React.createElement("div", {
        className: "spinner-layer spinner-yellow"
      }, React.createElement("div", {
        className: "circle-clipper left"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "gap-patch"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "circle-clipper right"
      }, React.createElement("div", {
        className: "circle"
      }))), React.createElement("div", {
        className: "spinner-layer spinner-green"
      }, React.createElement("div", {
        className: "circle-clipper left"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "gap-patch"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "circle-clipper right"
      }, React.createElement("div", {
        className: "circle"
      }))));
      return theSpinnerItself;
    } else {
      var _theSpinnerItself = React.createElement("div", {
        className: spinnerClasses
      }, React.createElement("div", {
        className: "circle-clipper left"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "gap-patch"
      }, React.createElement("div", {
        className: "circle"
      })), React.createElement("div", {
        className: "circle-clipper right"
      }, React.createElement("div", {
        className: "circle"
      })));
      return _theSpinnerItself;
    }
  };
  var className = props.className,
    big = props.big,
    small = props.small,
    red = props.red,
    green = props.green,
    yellow = props.yellow;
  var wrapperClasses = classNames("preloader-wrapper", "active", big ? "big" : false, small ? "small" : false, className);
  var spinnerClasses = classNames("spinner-layer", red ? "spinner-red-only" : false, green ? "spinner-green-only" : false, yellow ? "spinner-yellow-only" : "spinner-blue-only", className);
  if (props.crazy) {
    return React.createElement("div", {
      className: wrapperClasses
    }, React.createElement("div", {
      className: wrapperClasses
    }, React.createElement("div", {
      className: wrapperClasses
    }, React.createElement("div", {
      className: wrapperClasses
    }, theChosenColorSpinner(spinnerClasses)))));
  } else {
    return React.createElement("div", {
      className: wrapperClasses
    }, theChosenColorSpinner(spinnerClasses));
  }
};
Spinner.propTypes = {
  className: propTypes.string,
  big: propTypes.bool,
  small: propTypes.bool,
  crazy: propTypes.bool,
  red: propTypes.bool,
  green: propTypes.bool,
  yellow: propTypes.bool,
  multicolor: propTypes.bool
};
Spinner.defaultProps = {
  tag: "div"
};
var Step = function Step(props) {
  var Tag = props.tag,
    form = props.form,
    icon = props.icon,
    stepName = props.stepName,
    vertical = props.vertical;
  var iconClass = classNames("fa fa-" + icon, "Ripple-parent");
  var stepClass = classNames(form ? "steps-step" : icon && vertical ? "steps-step-3" : icon && !vertical ? "steps-step-2" : null, props.className);
  var step;
  if (form) {
    step = React.createElement(Tag, {
      className: stepClass
    }, props.children);
  } else if (icon && !vertical) {
    step = React.createElement(Tag, {
      className: stepClass,
      onClick: props.onClick
    }, React.createElement(Popper, {
      placement: "top"
    }, React.createElement(Button, {
      className: "btn-circle-2 btn-blue-grey"
    }, React.createElement("i", {
      className: iconClass
    })), React.createElement("div", null, stepName)));
  } else if (icon && vertical) {
    step = React.createElement(Tag, {
      className: stepClass,
      onClick: props.onClick
    }, React.createElement(Popper, {
      placement: "top"
    }, React.createElement(Button, {
      className: "btn-circle-3 btn-blue-grey"
    }, React.createElement("i", {
      className: iconClass
    })), React.createElement("div", null, stepName)));
  } else {
    step = React.createElement("li", {
      className: stepClass
    }, props.children);
  }
  return step;
};
Step.defaultProps = {
  tag: "div",
  form: false,
  vertical: false
};
var css$f = "/* Stepper Form */\n\n/* Stepper v.2 (Form) */\n.steps-form {\n  display: table;\n  width: 100%;\n  position: relative; }\n.steps-form .steps-row {\n  display: table-row; }\n.steps-form .steps-row:before {\n  top: 14px;\n  bottom: 0;\n  position: absolute;\n  content: \" \";\n  width: 100%;\n  height: 1px;\n  background-color: #ccc; }\n.steps-form .steps-row .steps-step {\n  display: table-cell;\n  text-align: center;\n  position: relative; }\n.steps-form .steps-row .steps-step p {\n  margin-top: 0.5rem; }\n.steps-form .steps-row .steps-step button[disabled] {\n  opacity: 1 !important;\n  filter: alpha(opacity=100) !important; }\n.steps-form .steps-row .steps-step .btn-circle {\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  padding: 6px 0;\n  font-size: 12px;\n  line-height: 1.428571429;\n  border-radius: 15px;\n  margin-top: 0; }\n\n/* Stepper v.3 (Icons) */\n.steps-form-2 {\n  display: table;\n  width: 100%;\n  position: relative; }\n.steps-form-2 .steps-row-2 {\n  display: table-row; }\n.steps-form-2 .steps-row-2:before {\n  top: 14px;\n  bottom: 0;\n  position: absolute;\n  content: \" \";\n  width: 99%;\n  height: 2px;\n  background-color: #7283a7; }\n.steps-form-2 .steps-row-2 .steps-step-2 {\n  display: table-cell;\n  text-align: center;\n  position: relative; }\n.steps-form-2 .steps-row-2 .steps-step-2 p {\n  margin-top: 0.5rem; }\n.steps-form-2 .steps-row-2 .steps-step-2 button[disabled] {\n  opacity: 1 !important;\n  filter: alpha(opacity=100) !important; }\n.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 {\n  width: 70px;\n  height: 70px;\n  border: 2px solid #59698D;\n  background-color: white !important;\n  color: #59698D !important;\n  border-radius: 50%;\n  padding: 22px 18px 15px 18px;\n  margin-top: -22px; }\n.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2:hover {\n  border: 2px solid #4285F4;\n  color: #4285F4 !important;\n  background-color: white !important; }\n.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 .fa {\n  font-size: 1.7rem; }\n .steps-row-2:first-child .btn {\n  margin-left: 0\n}\n.steps-row-2:last-child .btn {\n  margin-right: 0\n}\n\n\n/* Stepper v.4 (Icon-vertical) */\n\n.steps-form-3 {\n  width: 2px;\nheight: 470px;\n  position: relative; }\n.steps-form-3 .steps-row-3 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column; }\n.steps-form-3 .steps-row-3:before {\n  top: 14px;\n  bottom: 0;\n  position: absolute;\n  content: \"\";\n  width: 2px;\n  height: 100%;\n  background-color: #7283a7; }\n.steps-form-3 .steps-row-3 .steps-step-3 {\n  height: 150px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n  position: relative; }\n.steps-form-3 .steps-row-3 .steps-step-3.no-height {\n  height: 50px; }\n.steps-form-3 .steps-row-3 .steps-step-3 p {\nmargin-top: 0.5rem; }\n.steps-form-3 .steps-row-3 .steps-step-3 button[disabled] {\n  opacity: 1 !important;\n  filter: alpha(opacity=100) !important; }\n.steps-form-3 .steps-row-3 .steps-step-3 .btn-circle-3 {\n  width: 60px;\n  height: 60px;\n  border: 2px solid #59698D;\n  background-color: white !important;\n  color: #59698D !important;\n  border-radius: 50%;\n  padding: 18px 18px 15px 15px;\n  margin-top: -22px; }\n.steps-form-3 .steps-row-3 .steps-step-3 .btn-circle-3:hover {\n  border: 2px solid #4285F4;\n  color: #4285F4 !important;\n  background-color: white !important; }\n.steps-form-3 .steps-row-3 .steps-step-3 .btn-circle-3 .fa {\n  font-size: 1.7rem; }\n";
styleInject(css$f);
var Stepper = function Stepper(props) {
  var vertical = props.vertical,
    form = props.form,
    icon = props.icon;
  var stepperClass = classNames(form ? "steps-form" : icon && vertical ? "steps-form-3" : icon && !vertical ? "steps-form-2" : "stepper", vertical && !icon ? "stepper-vertical" : form || icon ? null : "stepper-horizontal", props.className);
  var wrapperFix = classNames(form ? "steps-row" : icon && vertical ? "steps-row-3 d-flex justify-content-between" : icon && !vertical ? "steps-row-2 d-flex justify-content-between" : null); // wrapper shim in case props.form

  var stepper;
  if (form || icon) {
    stepper = React.createElement("div", {
      className: stepperClass
    }, React.createElement("div", {
      className: wrapperFix
    }, props.children));
  } else {
    stepper = React.createElement("ul", {
      className: stepperClass
    }, props.children);
  }
  return stepper;
};
Stepper.propTypes = {
  vertical: propTypes.bool,
  form: propTypes.bool,
  icon: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string
};
Stepper.defaultProps = {
  form: false
};
var Sticky = /*#__PURE__*/
function (_Component) {
  _inherits(Sticky, _Component);
  function Sticky() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Sticky);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Sticky)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isSticky: false,
      wasSticky: false,
      style: {}
    });
    _defineProperty(_assertThisInitialized(_this), "handleContainerEvent", function (_ref) {
      var distanceFromTop = _ref.distanceFromTop,
        distanceFromBottom = _ref.distanceFromBottom,
        eventSource = _ref.eventSource;
      var parent = _this.context.getParent();
      var preventingStickyStateChanges = false;
      if (_this.props.relative) {
        preventingStickyStateChanges = eventSource !== parent;
        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
      }
      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
      var contentClientRect = _this.content.getBoundingClientRect();
      var calculatedHeight = contentClientRect.height;
      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;
      var wasSticky = !!_this.state.isSticky;
      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;
      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;
      var style = !isSticky ? {} : {
        position: "fixed",
        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
        left: placeholderClientRect.left,
        width: placeholderClientRect.width
      };
      if (!_this.props.disableHardwareAcceleration) {
        style.transform = "translateZ(0)";
      }
      _this.setState({
        isSticky: isSticky,
        wasSticky: wasSticky,
        distanceFromTop: distanceFromTop,
        distanceFromBottom: distanceFromBottom,
        calculatedHeight: calculatedHeight,
        style: style
      });
    });
    return _this;
  }
  _createClass(Sticky, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");
      this.context.subscribe(this.handleContainerEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.unsubscribe(this.handleContainerEvent);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : "".concat(this.state.isSticky ? this.state.calculatedHeight : 0, "px");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var element = React.cloneElement(this.props.children({
        isSticky: this.state.isSticky,
        wasSticky: this.state.wasSticky,
        distanceFromTop: this.state.distanceFromTop,
        distanceFromBottom: this.state.distanceFromBottom,
        calculatedHeight: this.state.calculatedHeight,
        style: this.state.style
      }), {
        ref: function ref(content) {
          _this2.content = ReactDOM.findDOMNode(content);
        }
      });
      return React.createElement("div", null, React.createElement("div", {
        ref: function ref(placeholder) {
          return _this2.placeholder = placeholder;
        }
      }), element);
    }
  }]);
  return Sticky;
}(Component);
_defineProperty(Sticky, "propTypes", {
  topOffset: propTypes.number,
  bottomOffset: propTypes.number,
  relative: propTypes.bool,
  children: propTypes.func.isRequired
});
_defineProperty(Sticky, "defaultProps", {
  relative: false,
  topOffset: 0,
  bottomOffset: 0,
  disableCompensation: false,
  disableHardwareAcceleration: false
});
_defineProperty(Sticky, "contextTypes", {
  subscribe: propTypes.func,
  unsubscribe: propTypes.func,
  getParent: propTypes.func
});
var Container$1 = /*#__PURE__*/
function (_PureComponent) {
  _inherits(Container, _PureComponent);
  function Container() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Container);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Container)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "events", ["resize", "scroll", "touchstart", "touchmove", "touchend", "pageshow", "load"]);
    _defineProperty(_assertThisInitialized(_this), "subscribers", []);
    _defineProperty(_assertThisInitialized(_this), "subscribe", function (handler) {
      _this.subscribers = _this.subscribers.concat(handler);
    });
    _defineProperty(_assertThisInitialized(_this), "unsubscribe", function (handler) {
      _this.subscribers = _this.subscribers.filter(function (current) {
        return current !== handler;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "notifySubscribers", function (evt) {
      if (!_this.framePending) {
        var currentTarget = evt.currentTarget;
        raf(function () {
          _this.framePending = false;
          var _this$node$getBoundin = _this.node.getBoundingClientRect(),
            top = _this$node$getBoundin.top,
            bottom = _this$node$getBoundin.bottom;
          _this.subscribers.forEach(function (handler) {
            return handler({
              distanceFromTop: top,
              distanceFromBottom: bottom,
              eventSource: currentTarget === window ? document.body : _this.node
            });
          });
        });
        _this.framePending = true;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getParent", function () {
      return _this.node;
    });
    return _this;
  }
  _createClass(Container, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
        getParent: this.getParent
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.events.forEach(function (event) {
        return window.addEventListener(event, _this2.notifySubscribers);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      this.events.forEach(function (event) {
        return window.removeEventListener(event, _this3.notifySubscribers);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return React.createElement("div", _extends({}, this.props, {
        ref: function ref(node) {
          return _this4.node = node;
        },
        onScroll: this.notifySubscribers,
        onTouchStart: this.notifySubscribers,
        onTouchMove: this.notifySubscribers,
        onTouchEnd: this.notifySubscribers
      }));
    }
  }]);
  return Container;
}(PureComponent);
_defineProperty(Container$1, "childContextTypes", {
  subscribe: propTypes.func,
  unsubscribe: propTypes.func,
  getParent: propTypes.func
});
var MDBStreak = function MDBStreak(_ref) {
  var children = _ref.children,
    by = _ref.by,
    byClass = _ref.byClass,
    wrapperClass = _ref.wrapperClass,
    size = _ref.size,
    quoteClass = _ref.quoteClass,
    photo = _ref.photo,
    overlayClass = _ref.overlayClass;
  var byClasses = classNames("text-center", "font-italic", "mb-0", byClass);
  var wrapperClasses = classNames("streak", photo && "streak-photo", size && "streak-".concat(size), wrapperClass);
  var quoteClasses = classNames("h2-responsive", quoteClass);
  var overlayClasses = classNames("flex-center", overlayClass);
  return React.createElement("div", {
    className: wrapperClasses,
    style: {
      backgroundImage: "url(\"".concat(photo, "\")"),
      backgroundAttachment: "fixed"
    }
  }, React.createElement("div", {
    className: overlayClasses
  }, React.createElement("ul", {
    className: "mb-0 list-unstyled"
  }, React.createElement("li", null, React.createElement("h2", {
    className: quoteClasses
  }, React.createElement(Fa, {
    icon: "quote-left"
  }), " ", children, " ", React.createElement(Fa, {
    icon: "quote-right"
  }))), React.createElement("li", {
    className: "mb-0"
  }, React.createElement("h5", {
    className: byClasses
  }, "~ ", by)))));
};
MDBStreak.propTypes = {
  size: propTypes.oneOf(['lg', 'md']),
  by: propTypes.string,
  wrapperClass: propTypes.string,
  byClass: propTypes.string,
  quoteClass: propTypes.string,
  photo: propTypes.string,
  overlayClass: propTypes.string
};
MDBStreak.defaultProps = {
  wrapperClass: "grey lighten-3"
};
var css$g = ".react-bootstrap-table {\n  padding-top: 65px;\n}\n\n.react-bootstrap-table .caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid\\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n\n.react-bootstrap-table .dropup .caret {\n  content: \"\";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid\\9;\n}\n\n.react-bootstrap-table-pagination .pagination {\n  float: right;\n}\n\n.react-bootstrap-table-pagination .pagination .page-item.active .page-link {\n  background-color: #09c;\n}\n\n.react-bootstrap-table-pagination .select-wrapper {\n  display: inline-block;\n  width: 100px;\n  margin: 0 15px;\n}\n\n.react-bootstrap-table-pagination .dropdown-item {\n  padding: 0;\n}\n\n.react-bootstrap-table-pagination-total {\n  display: block;\n}\n\n.react-bootstrap-table .md-form {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  width: 200px;\n}\n\n.react-bootstrap-table-pagination > * {\n  position: inherit;\n}\n\n.react-bs-table-sizePerPage-dropdown {\n  position: absolute;\n  top: 0;\n  left: 0;\n}";
styleInject(css$g);
var TableEditable = /*#__PURE__*/
function (_React$Component) {
  _inherits(TableEditable, _React$Component);
  function TableEditable() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TableEditable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TableEditable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      data: []
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.data && _this.setState(_objectSpread({}, _this.state, {
        data: _this.props.data
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "addRow", function () {
      var newData = _toConsumableArray(_this.state.data);
      var newRow = [];
      _this.props.columns.forEach(function () {
        newRow.push("");
      });
      newData.push(newRow);
      _this.setState(_objectSpread({}, _this.state.data, {
        data: newData
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "removeRow", function (index) {
      var newData = _toConsumableArray(_this.state.data);
      newData = [].concat(_toConsumableArray(newData.slice(0, index)), _toConsumableArray(newData.slice(index + 1)));
      _this.setState(_objectSpread({}, _this.state, {
        data: newData
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "decreaseIndex", function (index) {
      if (index === 0) return;
      var newData = _this.changeArrayOrder(index, index - 1);
      _this.setState(_objectSpread({}, _this.state, {
        data: newData
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "increaseIndex", function (index) {
      if (index === _this.state.data.length - 1) return;
      var newData = _this.changeArrayOrder(index, index + 1);
      _this.setState(_objectSpread({}, _this.state, {
        data: newData
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "changeArrayOrder", function (oldIndex, newIndex) {
      var array = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _toConsumableArray(_this.state.data);
      var newArray = array;
      var oldIndexValue = _toConsumableArray(newArray[oldIndex]);
      var newIndexValue = _toConsumableArray(newArray[newIndex]);
      newArray.splice(oldIndex, 1, newIndexValue);
      newArray.splice(newIndex, 1, oldIndexValue);
      return newArray;
    });
    _defineProperty(_assertThisInitialized(_this), "onBlurHandler", function (trIndex, tdIndex, e) {
      var value = e.target.innerText;
      var newData = _toConsumableArray(_this.state.data);
      newData = newData.map(function (item, index) {
        if (index !== trIndex) {
          return item;
        }
        return item.map(function (tdItem, index) {
          if (index !== tdIndex) {
            return tdItem;
          }
          return tdItem = value;
        });
      });
      _this.setState(_objectSpread({}, _this.state, {
        data: newData
      }));
    });
    return _this;
  }
  _createClass(TableEditable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.data !== this.props.data && this.props.data !== this.state.data) {
        this.setState({
          data: this.props.data
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        small = _this$props.small,
        bordered = _this$props.bordered,
        striped = _this$props.striped,
        hover = _this$props.hover,
        data = _this$props.data,
        columns = _this$props.columns,
        responsive = _this$props.responsive,
        responsiveSm = _this$props.responsiveSm,
        responsiveMd = _this$props.responsiveMd,
        responsiveLg = _this$props.responsiveLg,
        responsiveXl = _this$props.responsiveXl,
        attributes = _objectWithoutProperties(_this$props, ["className", "small", "bordered", "striped", "hover", "data", "columns", "responsive", "responsiveSm", "responsiveMd", "responsiveLg", "responsiveXl"]);
      var classes = classNames("table", small && "table-sm", bordered && "table-bordered", striped && "table-striped", hover && "table-hover", className);
      var wrapperClasses = classNames("table-editable text-center", responsive && "table-responsive", responsiveSm && "table-responsive-sm", responsiveMd && "table-responsive-md", responsiveLg && "table-responsive-lg", responsiveXl && "table-responsive-xl");
      return React.createElement("div", {
        className: wrapperClasses
      }, React.createElement("span", {
        onClick: this.addRow,
        className: "table-add float-right mb-3 mr-2"
      }, React.createElement("a", {
        href: "#!",
        className: "text-success"
      }, React.createElement(Fa, {
        icon: "plus",
        size: "2x"
      }))), React.createElement("table", _extends({}, attributes, {
        className: classes
      }), React.createElement("thead", null, React.createElement("tr", null, this.props.columns && this.props.columns.map(function (th, i) {
        return React.createElement("th", {
          key: i
        }, th);
      }), React.createElement("th", null, "Sort "), React.createElement("th", null, "Delete "))), React.createElement("tbody", null, this.state.data.map(function (tr, trIndex) {
        return React.createElement("tr", {
          key: trIndex
        }, tr.map(function (td, tdIndex) {
          return React.createElement("td", {
            key: tdIndex,
            contentEditable: true,
            suppressContentEditableWarning: "true",
            onBlur: function onBlur(e) {
              return _this2.onBlurHandler(trIndex, tdIndex, e);
            }
          }, td);
        }), React.createElement("td", null, React.createElement("span", {
          onClick: function onClick() {
            return _this2.decreaseIndex(trIndex);
          },
          className: "table-up"
        }, React.createElement("a", {
          href: "#!",
          className: "indigo-text"
        }, React.createElement(Fa, {
          icon: "long-arrow-alt-up"
        }))), React.createElement("span", {
          onClick: function onClick() {
            return _this2.increaseIndex(trIndex);
          },
          className: "table-down"
        }, React.createElement("a", {
          href: "#!",
          className: "indigo-text"
        }, React.createElement(Fa, {
          icon: "long-arrow-alt-down"
        })))), React.createElement("td", null, React.createElement("span", {
          onClick: function onClick() {
            return _this2.removeRow(trIndex);
          },
          className: "table-remove"
        }, React.createElement("button", {
          type: "button",
          className: "btn btn-danger btn-rounded btn-sm my-0"
        }, "Remove"))));
      }))));
    }
  }]);
  return TableEditable;
}(React.Component);
TableEditable.propTypes = {
  className: propTypes.string,
  small: propTypes.bool,
  bordered: propTypes.bool,
  striped: propTypes.bool,
  hover: propTypes.bool,
  data: propTypes.array,
  columns: propTypes.array,
  children: propTypes.node,
  responsive: propTypes.bool,
  responsiveSm: propTypes.bool,
  responsiveMd: propTypes.bool,
  responsiveLg: propTypes.bool,
  responsiveXl: propTypes.bool
};
var Testimonial = function Testimonial(props) {
  var className = props.className,
    Tag = props.tag,
    attributes = _objectWithoutProperties(props, ["className", "tag"]);
  var classes = classNames("testimonial", className);
  return React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};
Testimonial.propTypes = {
  tag: propTypes.oneOfType([propTypes.func, propTypes.string]),
  className: propTypes.string
};
Testimonial.defaultProps = {
  tag: "div"
};
var css$h = "@media (max-width: 1025px) {\n  .stepper.timeline li {\n    -webkit-box-align: end;\n    -webkit-align-items: flex-end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n  }\n}\n\n.stepper.timeline li a {\n  padding: 0px 24px;\n  left: 50%;\n}\n@media (max-width: 450px) {\n  .stepper.timeline li a {\n    left: 6%;\n  }\n}\n@media (min-width: 451px) and (max-width: 1025px) {\n  .stepper.timeline li a {\n    left: 6%;\n  }\n}\n.stepper.timeline li a .circle {\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  font-size: 1.4em;\n  text-align: center;\n  position: absolute;\n  top: 16px;\n  margin-left: -50px;\n  background-color: #fff;\n  z-index: 2;\n}\n\n.stepper.timeline li .step-content {\n  width: 45%;\n  float: left;\n  border-radius: 2px;\n  position: relative;\n  background-color: #fff;\n}\n.stepper.timeline li .step-content:before {\n  position: absolute;\n  top: 26px;\n  right: -15px;\n  display: inline-block;\n  border-top: 15px solid transparent;\n  border-left: 15px solid #e0e0e0;\n  border-right: 0 solid #e0e0e0;\n  border-bottom: 15px solid transparent;\n  content: \" \";\n}\n.stepper.timeline li .step-content:after {\n  position: absolute;\n  top: 27px;\n  right: -14px;\n  display: inline-block;\n  border-top: 14px solid transparent;\n  border-left: 14px solid #fff;\n  border-right: 0 solid #fff;\n  border-bottom: 14px solid transparent;\n  content: \" \";\n}\n@media (max-width: 450px) {\n  .stepper.timeline li .step-content {\n    width: 80%;\n    left: 3rem;\n    margin-right: 3rem;\n    margin-bottom: 2rem;\n    float: right;\n  }\n  .stepper.timeline li .step-content:before {\n    border-left-width: 0;\n    border-right-width: 15px;\n    left: -15px;\n    right: auto;\n  }\n  .stepper.timeline li .step-content:after {\n    border-left-width: 0;\n    border-right-width: 14px;\n    left: -14px;\n    right: auto;\n  }\n}\n@media (min-width: 451px) and (max-width: 1025px) {\n  .stepper.timeline li .step-content {\n    width: 85%;\n    left: 3rem;\n    margin-right: 3rem;\n    margin-bottom: 2rem;\n    float: right;\n  }\n  .stepper.timeline li .step-content:before {\n    border-left-width: 0;\n    border-right-width: 15px;\n    left: -15px;\n    right: auto;\n  }\n  .stepper.timeline li .step-content:after {\n    border-left-width: 0;\n    border-right-width: 14px;\n    left: -14px;\n    right: auto;\n  }\n}\n\n.stepper.timeline li.timeline-inverted {\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n.stepper.timeline li.timeline-inverted .step-content {\n  float: right;\n}\n.stepper.timeline li.timeline-inverted .step-content:before {\n  border-left-width: 0;\n  border-right-width: 15px;\n  left: -15px;\n  right: auto;\n}\n.stepper.timeline li.timeline-inverted .step-content:after {\n  border-left-width: 0;\n  border-right-width: 14px;\n  left: -14px;\n  right: auto;\n}\n\n.stepper.timeline.stepper-vertical li:not(:last-child):after {\n  content: \" \";\n  position: absolute;\n  width: 3px;\n  background-color: #e0e0e0;\n  left: 50%;\n  top: 57px;\n  margin-left: -1.5px;\n}\n@media (max-width: 450px) {\n  .stepper.timeline.stepper-vertical li:not(:last-child):after {\n    left: 6%;\n  }\n}\n@media (min-width: 451px) and (max-width: 1025px) {\n  .stepper.timeline.stepper-vertical li:not(:last-child):after {\n    left: 6%;\n  }\n}\n";
styleInject(css$h);
var Timeline = function Timeline(props) {
  var children = props.children;
  return React.createElement("ul", {
    className: "stepper stepper-vertical timeline pl-0"
  }, children);
};
var TimelineStep = function TimelineStep(props) {
  var href = props.href,
    color = props.color,
    icon = props.icon,
    iconBrand = props.iconBrand,
    iconClass = props.iconClass,
    iconLight = props.iconLight,
    iconRegular = props.iconRegular,
    iconSize = props.iconSize,
    className = props.className,
    children = props.children,
    inverted = props.inverted,
    colorful = props.colorful,
    hoverable = props.hoverable,
    label = props.label;
  var circleClasses = classNames("circle", "z-depth-1-half", color ? color : "primary-color", className);
  var stepContentClasses = classNames("step-content", "z-depth-1", "ml-xl-0", colorful ? "p-0 mt-2" : "p-4", hoverable && "hoverable");
  var liClasses = classNames(inverted && "timeline-inverted");
  return React.createElement("li", {
    className: liClasses
  }, React.createElement("a", {
    href: href
  }, React.createElement("span", {
    className: circleClasses
  }, icon && React.createElement(Fa, {
    icon: icon,
    size: iconSize,
    brand: iconBrand,
    light: iconLight,
    regular: iconRegular,
    className: iconClass
  }), label)), React.createElement("div", {
    className: stepContentClasses
  }, children));
};
TimelineStep.propTypes = {
  href: propTypes.string,
  color: propTypes.string,
  size: propTypes.string,
  icon: propTypes.string,
  iconBrand: propTypes.bool,
  iconClass: propTypes.string,
  iconLight: propTypes.bool,
  iconRegular: propTypes.bool,
  iconSize: propTypes.string,
  className: propTypes.string
};
TimelineStep.defaultProps = {
  href: "#"
};
var css$i = ".time-picker-clock {\n  border-radius: 100%;\n  position: relative;\n  /* transition: 0.3s cubic-bezier(.25,.8,.50,1); */\n  user-select: none;\n  background: #f0f0f0;\n  animation: show-up-clock 0.2s linear;\n}\n@keyframes show-up-clock {\n  0% {\n    opacity: 0;\n    transform: scale(0.7);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.time-picker-clock__container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n.time-picker-clock__hand {\n  height: calc(50% - 28px);\n  width: 2px;\n  bottom: 50%;\n  left: calc(50% - 1px);\n  transform-origin: center bottom;\n  position: absolute;\n  will-change: transform;\n  z-index: 1;\n  background-color: rgba(0, 150, 136, 0.25);\n}\n\n.time-picker-clock__hand.between .time-picker-clock__hand--ring {\n  background-color: rgba(0, 150, 136, 0.25);\n  border-color: inherit;\n  border-radius: 100%;\n  width: 2.5rem;\n  height: 2.5rem;\n  content: \"\";\n  position: absolute;\n  top: -3%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.time-picker-clock__hand.between .time-picker-clock__hand--ring:before {\n  background-color: rgba(0, 77, 64, 0.75);\n  border-color: inherit;\n  border-radius: 100%;\n  width: 10px;\n  height: 10px;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.time-picker-clock__hand:after {\n  content: \"\";\n  position: absolute;\n  height: 6px;\n  width: 6px;\n  top: 100%;\n  left: 50%;\n  border-radius: 50%;\n  background-color: rgba(0, 77, 64, 0.75);\n  opacity: 0.75;\n  transform: translate(-50%, -50%);\n}\n.time-picker-clock > span {\n  align-items: center;\n  border-radius: 100%;\n  cursor: default;\n  display: flex;\n  font-size: 1rem;\n  line-height: 1.2;\n  justify-content: center;\n  left: calc(50% - 40px / 2);\n  height: 40px;\n  position: absolute;\n  text-align: center;\n  top: calc(50% - 40px / 2);\n  width: 40px;\n  user-select: none;\n}\n.time-picker-clock > span:hover,\n.time-picker-clock > span.active:hover {\n  cursor: pointer;\n}\n.time-picker-clock > span:active:hover,\n.time-picker-clock > span.active:active:hover {\n  cursor: move;\n}\n.time-picker-clock:active:hover {\n  cursor: move;\n}\n.time-picker-clock > span > span {\n  z-index: 1;\n}\n\n.time-picker-clock > span:before,\n.time-picker-clock > span:after {\n  content: \"\";\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 14px;\n  width: 14px;\n  transform: translate(-50%, -50%);\n}\n.time-picker-clock > span > span:after,\n.time-picker-clock > span > span:before {\n  height: 40px;\n  width: 40px;\n}\n.time-picker-clock > span.active {\n  color: #fff;\n  cursor: default;\n  z-index: 2;\n  background: blue;\n}\n.time-picker-clock > span > span.disabled {\n  pointer-events: none;\n}\n\n.picker__footer .clockpicker-button {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n";
styleInject(css$i);
var propTypes$2 = {
  color: propTypes.string.isRequired,
  hours: propTypes.string.isRequired,
  minutes: propTypes.string.isRequired,
  dayTime: propTypes.string.isRequired,
  unitsMode: propTypes.string.isRequired,
  handleModeChange: propTypes.func.isRequired,
  hoursFormat: propTypes.number.isRequired
};
var TimePickerDisplay = function TimePickerDisplay(_ref) {
  var color = _ref.color,
    hours = _ref.hours,
    minutes = _ref.minutes,
    dayTime = _ref.dayTime,
    unitsMode = _ref.unitsMode,
    handleModeChange = _ref.handleModeChange,
    hoursFormat = _ref.hoursFormat;
  var displayClasses = classNames('picker__date-display', "btn-".concat(color));
  var hourClasses = classNames('clockpicker-span-hours', unitsMode === 'h' && 'text-primary');
  var minuteClasses = classNames('clockpicker-span-minutes', unitsMode === 'm' && 'text-primary');
  return React.createElement("div", {
    className: displayClasses
  }, React.createElement("div", {
    className: "clockpicker-display"
  }, React.createElement("div", {
    className: "clockpicker-display-column"
  }, React.createElement("span", {
    className: hourClasses,
    onClick: function onClick() {
      return handleModeChange('h');
    }
  }, hours !== '' ? hours : "--"), ":", React.createElement("span", {
    className: minuteClasses,
    onClick: function onClick() {
      return handleModeChange('m');
    }
  }, minutes !== '' ? minutes : "--")), hoursFormat === 12 && React.createElement("div", {
    className: "clockpicker-display-column clockpicker-display-am-pm"
  }, React.createElement("div", {
    className: "clockpicker-span-am-pm"
  }, dayTime.toUpperCase()))));
};
TimePickerDisplay.propTypes = propTypes$2;
var propTypes$3 = {
  angle: propTypes.number.isRequired,
  color: propTypes.string.isRequired,
  scale: propTypes.number.isRequired
};
var TimpiePickerClockHand = function TimpiePickerClockHand(_ref) {
  var angle = _ref.angle,
    between = _ref.between,
    color = _ref.color,
    scale = _ref.scale;
  var classes = classNames('time-picker-clock__hand', color, between && 'between');
  return React.createElement("div", {
    className: classes,
    style: {
      transform: "rotate(".concat(angle, "deg)"),
      height: "calc((50% - 28px) * ".concat(scale, ")")
    }
  }, React.createElement("div", {
    className: "time-picker-clock__hand--ring"
  }));
};
TimpiePickerClockHand.propTypes = propTypes$3;
var propTypes$4 = {
  className: propTypes.string.isRequired,
  handleChange: propTypes.func.isRequired,
  max: propTypes.number.isRequired,
  min: propTypes.number.isRequired,
  rotate: propTypes.number.isRequired,
  step: propTypes.number.isRequired,
  startFromInner: propTypes.bool.isRequired,
  allowedValues: propTypes.arrayOf(propTypes.number),
  autoSwitch: propTypes.bool,
  color: propTypes.string,
  "double": propTypes.bool,
  handleModeChange: propTypes.func,
  size: propTypes.number,
  value: propTypes.number
};
var defaultProps = {
  allowedValues: [],
  autoSwitch: false,
  color: 'priamry',
  "double": false,
  handleModeChange: function handleModeChange() {},
  size: 270,
  value: 0
};
var TimePickerClock = /*#__PURE__*/
function (_Component) {
  _inherits(TimePickerClock, _Component);
  function TimePickerClock(props) {
    var _this;
    _classCallCheck(this, TimePickerClock);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePickerClock).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "buildComponentState", function () {
      var _this$props = _this.props,
        size = _this$props.size,
        max = _this$props.max,
        min = _this$props.min,
        _double = _this$props["double"],
        rotate = _this$props.rotate,
        value = _this$props.value;
      var clockRadius = size / 2;
      var digitsAmount = max - min + 1;
      var digitsInRound = _double ? digitsAmount / 2 : digitsAmount;
      var degreesPerUnit = 360 / digitsInRound;
      var outerRadius = clockRadius - 4;
      var innerRadius = clockRadius - Math.max(clockRadius * 0.2, 40); // cant be lower than 40

      var degrees = degreesPerUnit * Math.PI / 180;
      var handAngle = rotate + degreesPerUnit * (value - min);
      _this.setState({
        clockRadius: clockRadius,
        degrees: degrees,
        degreesPerUnit: degreesPerUnit,
        digitsInRound: digitsInRound,
        handAngle: handAngle,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        value: value
      }, function () {
        return _this.setState({
          handScale: _this.getScale(value)
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getScale", function (value) {
      if (_this.props.startFromInner && _this.props["double"]) {
        return value - _this.props.min >= _this.state.digitsInRound ? _this.state.outerRadius / _this.state.clockRadius : _this.state.innerRadius / _this.state.clockRadius;
      }
      return value - _this.props.min >= _this.state.digitsInRound ? _this.state.innerRadius / _this.state.clockRadius : _this.state.outerRadius / _this.state.clockRadius;
    });
    _defineProperty(_assertThisInitialized(_this), "getAngle", function (center, p1) {
      var value = 2 * Math.atan2(p1.y - center.y - _this.euclidean(center, p1), p1.x - center.x);
      return Math.abs(value * 180 / Math.PI);
    });
    _defineProperty(_assertThisInitialized(_this), "getCoords", function (e) {
      var _this$clockRef$curren = _this.clockRef.current.getBoundingClientRect(),
        width = _this$clockRef$curren.width,
        top = _this$clockRef$curren.top,
        left = _this$clockRef$curren.left;
      var _ref = 'touches' in e ? e.touches[0] : e,
        clientX = _ref.clientX,
        clientY = _ref.clientY;
      var center = {
        x: width / 2,
        y: -width / 2
      };
      var coords = {
        x: clientX - left,
        y: top - clientY
      };
      return {
        center: center,
        coords: coords
      };
    });
    _defineProperty(_assertThisInitialized(_this), "setPosition", function (value) {
      var radius = (_this.state.clockRadius - 24) * _this.getScale(value);
      var rotateRadians = _this.props.rotate * Math.PI / 180;
      return {
        x: Math.round(Math.sin((value - _this.props.min) * _this.state.degrees + rotateRadians) * radius),
        y: Math.round(-Math.cos((value - _this.props.min) * _this.state.degrees + rotateRadians) * radius)
      };
    });
    _defineProperty(_assertThisInitialized(_this), "isValueAllowed", function (value) {
      return _this.props.allowedValues.length ? _this.props.allowedValues.find(function (item) {
        return item === value;
      }) : value >= _this.props.min && value <= _this.props.max;
    });
    _defineProperty(_assertThisInitialized(_this), "isOnInner", function (center, coords) {
      var centerDistance = _this.euclidean(center, coords);
      var betweenRadiusDistance = (_this.state.outerRadius + _this.state.innerRadius) / 2 - 16;
      if (_this.props["double"]) {
        return _this.props.startFromInner ? centerDistance > betweenRadiusDistance : centerDistance < betweenRadiusDistance;
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "computeTimeNumber", function (number) {
      return number < 10 ? "0".concat(number.toString()) : "".concat(number.toString());
    });
    _defineProperty(_assertThisInitialized(_this), "computeHandAngle", function (exactAngle) {
      if (360 % _this.props.max !== 0) {
        return exactAngle >= 360 - _this.state.degreesPerUnit / 2 ? 0 : exactAngle;
      }
      return exactAngle <= _this.state.degreesPerUnit / 2 ? 360 : exactAngle;
    });
    _defineProperty(_assertThisInitialized(_this), "euclidean", function (p0, p1) {
      var dx = p1.x - p0.x;
      var dy = p1.y - p0.y;
      return Math.sqrt(dx * dx + dy * dy);
    });
    _defineProperty(_assertThisInitialized(_this), "transformPosition", function (value) {
      var _this$setPosition = _this.setPosition(value),
        x = _this$setPosition.x,
        y = _this$setPosition.y;
      return {
        transform: "translate(".concat(x, "px, ").concat(y, "px)")
      };
    });
    _defineProperty(_assertThisInitialized(_this), "genClockDigits", function () {
      var children = [];
      var _loop = function _loop(value) {
        var classes = classNames('clockpicker-tick', value === _this.state.value && 'active', !_this.isValueAllowed(value) && 'disabled');
        children.push(React.createElement("span", {
          className: classes,
          style: Object.assign(_this.transformPosition(value), {
            fontSize: !_this.props["double"] ? '140%' : _this.props.startFromInner ? value <= 12 ? '120%' : '100%' : value > 12 ? '120%' : '100%'
          }),
          key: value,
          onMouseDown: function onMouseDown(e) {
            return _this.onMouseDown(e, value);
          },
          onTouchStart: function onTouchStart(e) {
            return _this.onMouseDown(e, value);
          }
        }, _this.props.max > 24 ? _this.computeTimeNumber(value) : value === 24 ? '00' : value));
      };
      for (var value = _this.props.min; value <= _this.props.max; value += _this.props.step) {
        _loop(value);
      }
      return children;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e, value) {
      e.preventDefault();
      _this.setState({
        isDragging: true
      });
      var handAngle = _this.props.rotate + _this.state.degreesPerUnit * (value - _this.props.min);
      var handScale = _this.getScale(value);
      if (_this.state.value !== value && _this.isValueAllowed(value)) {
        _this.updateValue(value, handAngle, handScale);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      e.preventDefault();
      if (_this.state.isDragging) {
        _this.setState({
          isDragging: false
        });
        if (_this.props.autoSwitch) _this.props.handleModeChange('m');
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      e.preventDefault();
      if (_this.state.isDragging) _this.setState({
        isDragging: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onDragMove", function (e) {
      e.preventDefault();
      if (!_this.state.isDragging && e.type !== 'click') return;
      var _this$getCoords = _this.getCoords(e),
        center = _this$getCoords.center,
        coords = _this$getCoords.coords;
      var isOnInner = _this.isOnInner(center, coords);
      var exactHandAngle = _this.getAngle(center, coords);
      var computedHandAngle = _this.computeHandAngle(exactHandAngle);
      var value = Math.round((computedHandAngle - _this.props.rotate) / _this.state.degreesPerUnit) + _this.props.min + (isOnInner ? _this.state.digitsInRound : 0);
      var handAngle = _this.props.rotate + _this.state.degreesPerUnit * (value - _this.props.min);
      var handScale = _this.getScale(value);
      if (_this.state.value !== value && _this.isValueAllowed(value)) {
        _this.updateValue(value, handAngle, handScale);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateValue", function (value, handAngle, handScale) {
      _this.props.handleChange(value);
      _this.setState({
        value: value,
        handAngle: handAngle,
        handScale: handScale
      });
    });
    _this.state = {
      clockRadius: 135,
      degrees: 30,
      digitsInRound: 12,
      degreesPerUnit: 30,
      handAngle: 0,
      handScale: 1,
      isDragging: false,
      innerRadius: 120,
      outerRadius: 266,
      value: 0
    };
    _this.clockRef = React.createRef();
    return _this;
  }
  _createClass(TimePickerClock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.buildComponentState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.max !== this.props.max || prevProps.min !== this.props.min || this.state.value !== this.props.value) {
        this.buildComponentState();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classes = classNames('time-picker-clock', 'clockpicker-dial', this.props.className, this.state.value === null && 'time-picker-clock--indeterminate');
      return React.createElement("div", {
        className: classes,
        style: {
          height: "".concat(this.props.size, "px"),
          width: "".concat(this.props.size, "px"),
          visibility: 'visible'
        },
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        onMouseLeave: this.onMouseLeave,
        onTouchStart: this.onMouseDown,
        onTouchEnd: this.onMouseUp,
        onMouseMove: this.onDragMove,
        onTouchMove: this.onDragMove,
        ref: this.clockRef
      }, React.createElement(TimpiePickerClockHand, {
        between: this.state.value % this.props.step !== 0,
        color: this.props.color,
        angle: this.state.handAngle,
        scale: this.state.handScale
      }), this.genClockDigits());
    }
  }]);
  return TimePickerClock;
}(Component);
TimePickerClock.propTypes = propTypes$4;
TimePickerClock.defaultProps = defaultProps;
var propTypes$5 = {
  color: propTypes.string.isRequired,
  dayTime: propTypes.string.isRequired,
  handleDayTimeChange: propTypes.func.isRequired
};
var TimePickerAmPmBlock = function TimePickerAmPmBlock(_ref) {
  var color = _ref.color,
    dayTime = _ref.dayTime,
    handleDayTimeChange = _ref.handleDayTimeChange;
  var classesAM = classNames('btn-floating', 'btn-flat', 'clockpicker-button', 'am-button', dayTime === 'am' && 'active', "btn-".concat(color));
  var classesPM = classNames('btn-floating', 'btn-flat', 'clockpicker-button', 'pm-button', dayTime === 'pm' && 'active', "btn-".concat(color));
  return React.createElement("div", {
    className: "clockpicker-am-pm-block d-flex justify-content-between"
  }, React.createElement("button", {
    type: "button",
    className: classesAM,
    onClick: function onClick() {
      return handleDayTimeChange('am');
    }
  }, "AM"), React.createElement("button", {
    type: "button",
    className: classesPM,
    onClick: function onClick() {
      return handleDayTimeChange('pm');
    }
  }, "PM"));
};
TimePickerAmPmBlock.propTypes = propTypes$5;
var propTypes$6 = {
  cancelable: propTypes.bool.isRequired,
  cancelText: propTypes.string.isRequired,
  clearable: propTypes.bool.isRequired,
  clearText: propTypes.string.isRequired,
  doneText: propTypes.string.isRequired,
  handleCancelClick: propTypes.func.isRequired,
  handleClearClick: propTypes.func.isRequired,
  handleDoneClick: propTypes.func.isRequired
};
var TimePickerFooter = function TimePickerFooter(_ref) {
  var cancelable = _ref.cancelable,
    cancelText = _ref.cancelText,
    clearable = _ref.clearable,
    clearText = _ref.clearText,
    doneText = _ref.doneText,
    handleCancelClick = _ref.handleCancelClick,
    handleClearClick = _ref.handleClearClick,
    handleDoneClick = _ref.handleDoneClick;
  return React.createElement("div", {
    className: "picker__footer"
  }, clearable && React.createElement(Button, {
    flat: true,
    className: "clockpicker-button",
    tabIndex: "0",
    onClick: handleClearClick
  }, clearText), cancelable && React.createElement(Button, {
    flat: true,
    className: "clockpicker-button",
    tabIndex: "0",
    onClick: handleCancelClick
  }, cancelText), React.createElement(Button, {
    flat: true,
    className: "clockpicker-button",
    tabIndex: "0",
    onClick: handleDoneClick
  }, doneText));
};
TimePickerFooter.propTypes = propTypes$6;
var propTypes$7 = {
  id: propTypes.string.isRequired,
  allowedValues: propTypes.arrayOf(propTypes.number),
  autoSwitch: propTypes.bool,
  cancelable: propTypes.bool,
  cancelText: propTypes.string,
  clearable: propTypes.bool,
  clearText: propTypes.string,
  closeOnCancel: propTypes.bool,
  color: propTypes.string,
  doneText: propTypes.string,
  getValue: propTypes.func,
  hours: propTypes.number,
  hoursFormat: propTypes.number,
  label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.object]),
  minutes: propTypes.number,
  placeholder: propTypes.string,
  startFromInner: propTypes.bool
};
var defaultProps$1 = {
  allowedValues: [],
  autoSwitch: true,
  cancelable: false,
  cancelText: 'Cancel',
  clearable: false,
  clearText: 'Clear',
  closeOnCancel: false,
  color: 'primary',
  doneText: 'Done',
  getValue: function getValue() {},
  hours: 12,
  hoursFormat: 12,
  label: '',
  minutes: 0,
  placeholder: '',
  startFromInner: true
};
var TimePicker = /*#__PURE__*/
function (_Component) {
  _inherits(TimePicker, _Component);
  function TimePicker(props) {
    var _this;
    _classCallCheck(this, TimePicker);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "setInputText", function () {
      var value = '';
      if (_this.state.hours !== null && _this.state.minutes !== null) {
        value = _this.props.hoursFormat === 12 ? "".concat(_this.state.computedHours, ":").concat(_this.state.computedMinutes).concat(_this.state.dayTime.toUpperCase()) : "".concat(_this.state.computedHours, ":").concat(_this.state.computedMinutes);
      }
      _this.setState({
        value: value,
        unitsMode: 'h'
      });
    });
    _defineProperty(_assertThisInitialized(_this), "computeTimeNumber", function (number) {
      if (number !== null) {
        number = _this.state.unitsMode === 'h' && number === 24 ? 0 : number;
        return number < 10 ? "0".concat(number.toString()) : "".concat(number.toString());
      }
      return '';
    });
    _defineProperty(_assertThisInitialized(_this), "handlePickerDialogOpen", function () {
      return _this.setState({
        pickerDialogOpen: !_this.state.pickerDialogOpen
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleModeChange", function (unitsMode) {
      return _this.setState({
        unitsMode: unitsMode
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDayTimeChange", function (dayTime) {
      return _this.setState({
        dayTime: dayTime
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMinutesChange", function (minutes) {
      return _this.setState({
        minutes: minutes
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleHoursChange", function (hours) {
      _this.setState({
        hours: hours
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleBackdropClick", function (e) {
      if (e.target.classList.value === 'picker__holder') {
        _this.handlePickerDialogOpen();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleDoneClick", function () {
      _this.setInputText();
      _this.handlePickerDialogOpen();
    });
    _defineProperty(_assertThisInitialized(_this), "handleClearClick", function () {
      _this.handleHoursChange(null);
      _this.handleMinutesChange(null);
      _this.handleModeChange('h');
      _this.handleDayTimeChange('am');
    });
    _defineProperty(_assertThisInitialized(_this), "handleCancelClick", function () {
      _this.handleHoursChange(_this.props.hours);
      _this.handleMinutesChange(_this.props.minutes);
      _this.handleModeChange('h');
      _this.handleDayTimeChange('am');
      if (_this.props.closeOnCancel) {
        _this.handlePickerDialogOpen();
      }
    });
    _this.state = {
      allowedValues: [],
      computedHours: '',
      computedMinutes: '',
      dayTime: 'am',
      hours: _this.props.hours,
      minutes: _this.props.minutes,
      pickerDialogOpen: false,
      unitsMode: 'h',
      value: ''
    };
    return _this;
  }
  _createClass(TimePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.setState({
        computedHours: this.computeTimeNumber(this.state.hours),
        computedMinutes: this.computeTimeNumber(this.state.minutes)
      }, function () {
        return _this2.setInputText();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.minutes !== this.state.minutes) {
        this.setState({
          computedMinutes: this.computeTimeNumber(this.state.minutes)
        });
      }
      if (prevState.hours !== this.state.hours) {
        this.setState({
          computedHours: this.computeTimeNumber(this.state.hours)
        });
      }
      if (prevState.value !== this.state.value) {
        this.props.getValue(this.state.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        computedHours = _this$state.computedHours,
        computedMinutes = _this$state.computedMinutes,
        dayTime = _this$state.dayTime,
        hours = _this$state.hours,
        minutes = _this$state.minutes,
        pickerDialogOpen = _this$state.pickerDialogOpen,
        unitsMode = _this$state.unitsMode,
        value = _this$state.value;
      var _this$props = this.props,
        allowedValues = _this$props.allowedValues,
        autoSwitch = _this$props.autoSwitch,
        cancelable = _this$props.cancelable,
        cancelText = _this$props.cancelText,
        clearable = _this$props.clearable,
        clearText = _this$props.clearText,
        color = _this$props.color,
        doneText = _this$props.doneText,
        hoursFormat = _this$props.hoursFormat,
        id = _this$props.id,
        label = _this$props.label,
        placeholder = _this$props.placeholder,
        startFromInner = _this$props.startFromInner;
      var inputClasses = classNames("form-control", "timepicker", pickerDialogOpen && "picker__input picker__input--active");
      var clockClasses = classNames("clockpicker", "picker", pickerDialogOpen && "picker--opened");
      var hoursClasses = classNames("clockpicker-hours", unitsMode !== "h" && "clockpicker-dial-out");
      var minutesClasses = classNames("clockpicker-minutes", unitsMode !== "m" && "clockpicker-dial-out");
      return React.createElement("div", {
        className: "md-form"
      }, React.createElement("input", {
        type: "text",
        placeholder: placeholder,
        id: id,
        className: inputClasses,
        value: value,
        onClick: this.handlePickerDialogOpen,
        readOnly: true
      }), React.createElement("label", {
        htmlFor: id,
        className: "active"
      }, label), pickerDialogOpen && React.createElement("div", {
        className: clockClasses
      }, React.createElement("div", {
        className: "picker__holder",
        onClick: this.handleBackdropClick
      }, React.createElement("div", {
        className: "picker__frame"
      }, React.createElement("div", {
        className: "picker__wrap"
      }, React.createElement("div", {
        className: "picker__box"
      }, React.createElement(TimePickerDisplay, {
        color: color,
        hours: computedHours,
        minutes: computedMinutes,
        dayTime: dayTime,
        unitsMode: unitsMode,
        handleModeChange: this.handleModeChange,
        hoursFormat: hoursFormat
      }), React.createElement("div", {
        className: "picker__calendar-container"
      }, React.createElement("div", {
        className: "clockpicker-plate"
      }, unitsMode === 'h' ? React.createElement(TimePickerClock, {
        allowedValues: allowedValues,
        autoSwitch: autoSwitch,
        className: hoursClasses,
        color: color,
        "double": hoursFormat === 24,
        handleChange: this.handleHoursChange,
        handleModeChange: this.handleModeChange,
        min: 1,
        max: hoursFormat,
        step: 1,
        rotate: 30,
        startFromInner: startFromInner,
        value: hours
      }) : React.createElement(TimePickerClock, {
        className: minutesClasses,
        color: color,
        handleChange: this.handleMinutesChange,
        min: 0,
        max: 59,
        step: 5,
        rotate: 0,
        startFromInner: startFromInner,
        value: minutes
      })), hoursFormat === 12 && React.createElement(TimePickerAmPmBlock, {
        color: color,
        dayTime: dayTime,
        handleDayTimeChange: this.handleDayTimeChange
      })), React.createElement(TimePickerFooter, {
        cancelText: cancelText,
        clearText: clearText,
        doneText: doneText,
        cancelable: cancelable,
        clearable: clearable,
        handleCancelClick: this.handleCancelClick,
        handleClearClick: this.handleClearClick,
        handleDoneClick: this.handleDoneClick
      })))))));
    }
  }]);
  return TimePicker;
}(Component);
TimePicker.propTypes = propTypes$7;
TimePicker.defaultProps = defaultProps$1;
export { Alert, Animation, Autocomplete, Avatar, Badge, Breadcrumb, BreadcrumbItem, Button, ButtonFixed, ButtonFixed$1 as ButtonFixedItem, ButtonGroup, ButtonToolbar, Card, CardBody, CardFooter, CardGroup, CardHeader, CardImage, CardText, CardTitle, CardUp, Carousel, CarouselCaption, Control as CarouselControl, CarouselIndicator, CarouselIndicators, CarouselInner, CarouselItem, Chip, ChipsInput, MDBCloseIcon as CloseIcon, Col, Collapse, CollapseHeader, Container, DataTable, DatePicker, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, EdgeHeader, ExportToCSV, Fa, RotatingCard as FlippingCard, Footer, FormInline, FreeBird, HamburgerToggler, Iframe, Input, InputFile, InputGroup, InputNumeric, InputRange, InputSwitch, Jumbotron, LightBox, ListGroup, ListGroupItem, Alert as MDBAlert, Animation as MDBAnimation, Autocomplete as MDBAutocomplete, Avatar as MDBAvatar, Badge as MDBBadge, Breadcrumb as MDBBreadcrumb, BreadcrumbItem as MDBBreadcrumbItem, Button as MDBBtn, ButtonFixed as MDBBtnFixed, ButtonFixed$1 as MDBBtnFixedItem, ButtonGroup as MDBBtnGroup, ButtonToolbar as MDBBtnToolbar, Card as MDBCard, CardBody as MDBCardBody, CardFooter as MDBCardFooter, CardGroup as MDBCardGroup, CardHeader as MDBCardHeader, CardImage as MDBCardImage, CardText as MDBCardText, CardTitle as MDBCardTitle, CardUp as MDBCardUp, Carousel as MDBCarousel, CarouselCaption as MDBCarouselCaption, CarouselIndicator as MDBCarouselIndicator, CarouselIndicators as MDBCarouselIndicators, CarouselInner as MDBCarouselInner, CarouselItem as MDBCarouselItem, Chip as MDBChip, ChipsInput as MDBChipsInput, MDBCloseIcon, Col as MDBCol, Collapse as MDBCollapse, CollapseHeader as MDBCollapseHeader, Container as MDBContainer, Control as MDBControl, DataTable as MDBDataTable, DatePicker as MDBDatePicker, Dropdown as MDBDropdown, DropdownItem as MDBDropdownItem, DropdownMenu as MDBDropdownMenu, DropdownToggle as MDBDropdownToggle, EdgeHeader as MDBEdgeHeader, ExportToCSV as MDBExportToCSV, InputFile as MDBFileInput, Footer as MDBFooter, FormInline as MDBFormInline, FreeBird as MDBFreeBird, HamburgerToggler as MDBHamburgerToggler, Fa as MDBIcon, Iframe as MDBIframe, Input as MDBInput, InputGroup as MDBInputGroup, InputNumeric as MDBInputSelect, Jumbotron as MDBJumbotron, LightBox as MDBLightBox, ListGroup as MDBListGroup, ListGroupItem as MDBListGroupItem, Mask as MDBMask, Media as MDBMedia, Modal as MDBModal, ModalBody as MDBModalBody, ModalFooter as MDBModalFooter, ModalHeader as MDBModalHeader, Nav as MDBNav, NavItem as MDBNavItem, NavLink as MDBNavLink, Navbar as MDBNavbar, NavbarBrand as MDBNavbarBrand, NavbarNav as MDBNavbarNav, NavbarToggler as MDBNavbarToggler, Notification as MDBNotification, PageItem as MDBPageItem, PageLink as MDBPageNav, Pagination as MDBPagination, Popper as MDBPopover, PopoverBody as MDBPopoverBody, PopoverHeader as MDBPopoverHeader, Popper as MDBPopper, Progress as MDBProgress, InputRange as MDBRangeInput, RotatingCard as MDBRotatingCard, Row as MDBRow, ScrollBar as MDBScrollbar, ScrollBox as MDBScrollspyBox, ScrollSpyList as MDBScrollspyList, ScrollSpyListItem as MDBScrollspyListItem, ScrollSpyText as MDBScrollspyText, Select as MDBSelect, SelectInput$1 as MDBSelectInput, SelectOption as MDBSelectOption, Options as MDBSelectOptions, SideNav as MDBSideNav, SideNavCat as MDBSideNavCat, SideNavItem as MDBSideNavItem, SideNavLink as MDBSideNavLink, SideNavNav as MDBSideNavNav, SimpleChart as MDBSimpleChart, SmoothScroll as MDBSmoothScroll, Spinner as MDBSpinner, Step as MDBStep, Stepper as MDBStepper, Sticky as MDBSticky, Container$1 as MDBStickyContent, MDBStreak, InputSwitch as MDBSwitch, TabContent as MDBTabContent, TabPane as MDBTabPane, Table as MDBTable, TableBody as MDBTableBody, TableEditable as MDBTableEditable, TableFoot as MDBTableFoot, TableHead as MDBTableHead, Testimonial as MDBTestimonial, TimePicker as MDBTimePicker, Timeline as MDBTimeline, TimelineStep as MDBTimelineStep, Popper as MDBTooltip, Treeview as MDBTreeview, TreeviewItem as MDBTreeviewItem, TreeviewList as MDBTreeviewList, View as MDBView, Waves as MDBWaves, Mask, Media, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Navbar, NavbarBrand, NavbarNav, NavbarToggler, Notification, PageItem, PageLink, Pagination, ScrollBar as PerfectScrollbar, Popper as Popover, PopoverBody, PopoverHeader, Popper, Progress, Row, ScrollBox as ScrollSpyBox, ScrollSpyList, ScrollSpyListItem, ScrollSpyText, Select, SelectInput$1 as SelectInput, SelectOption, Options as SelectOptions, SideNav, SideNavCat, SideNavItem, SideNavLink, SideNavNav, SimpleChart, SmoothScroll, Spinner, Step, Stepper, Sticky, Container$1 as StickyContainer, MDBStreak as Streak, TabContent, TabPane, Table, TableBody, TableEditable, TableFoot, TableHead, Testimonial, TimePicker, Timeline, TimelineStep, Popper as Tooltip, Treeview, TreeviewItem, TreeviewList, View, Waves };